(function() {
    'use strict';

    angular
        .module('telestatApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            'checklist-model',
            'nvd3',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar'
        ])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler'];

    function run(stateHandler, translationHandler) {
        stateHandler.initialize();
        translationHandler.initialize();
    }
})();

(function () {
    'use strict';

    angular
        .module('telestatApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('telestatApp')
        .factory('UserSearch', UserSearch);

    UserSearch.$inject = ['$resource'];

    function UserSearch ($resource) {
        var resourceUrl =  'api/_search/users-common/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .directive('profileFooter', profileFooter);

    profileFooter.$inject = ['ProfileService', '$rootScope', '$translate'];

    function profileFooter(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="footer" ng-cloak><p id="defaultFooter" class="hidden" data-translate="footer">This is your footer</p><p id="kayanFooter" class="hidden" data-translate="footerKayan">This is your footer</p></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.kayanProfile) {
                    var childs = element.children('[id=kayanFooter]');
                    childs.removeClass('hidden');
                } else {
                    var childs = element.children('[id=defaultFooter]');
                    childs.removeClass('hidden');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        response.kayanProfile = result.data.activeProfiles.indexOf("kayan") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" data-translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('UIFormAccess', UIFormAccess);

    UIFormAccess.$inject = ['Principal', '$state'];

    function UIFormAccess(Principal, $state) {
        var service = {
                checkStateAccess: checkStateAccess
        };

        return service;

        function checkStateAccess (state) {
            var authorities = $state.get(state).data.authorities;
            return Principal.hasAnyAuthority (authorities);
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('Sessions', Sessions);

    Sessions.$inject = ['$resource'];

    function Sessions ($resource) {
        return $resource('api/account/sessions/:series', {}, {
            'getAll': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('telestatApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('Principal', Principal);

    /* Added PhoneCallCheckTrackerService
    Principal.$inject = ['$q', 'Account', 'JhiTrackerService'];

    function Principal ($q, Account, JhiTrackerService) {
     */
    Principal.$inject = ['$q', 'Account', 'JhiTrackerService', 'PhoneCallCheckTrackerService'];

    function Principal ($q, Account, JhiTrackerService, PhoneCallCheckTrackerService) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
                JhiTrackerService.connect();
                // Connect to avoid repeated checks by checkers
                if (hasAnyAuthority(['ROLE_ADMIN','ROLE_DIRECTOR','ROLE_CHECKER'])) {
                    PhoneCallCheckTrackerService.connect();
                }
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('PasswordUpdateByLogin', PasswordUpdateByLogin);

    PasswordUpdateByLogin.$inject = ['$resource'];

    function PasswordUpdateByLogin($resource) {

        var service = {
            changeUserPassword: changeUserPassword
        };
        return service;

        function changeUserPassword(login, password, callback) {
            var cb = callback || angular.noop;
            $resource('api/account/change_user_password', {}, {})
                .save(
                    {login: login, password: password},
                    function() {
                        return cb();
                    }, function(err){
                        return cb(err);
                })
                .$promise;
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset-password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset-password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change-password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('AuthServerProvider', AuthServerProvider);

    /* Added PhoneCallCheckTrackerService
    AuthServerProvider.$inject = ['$http', '$localStorage' , 'JhiTrackerService'];

    function AuthServerProvider ($http, $localStorage , JhiTrackerService) {
    */
    AuthServerProvider.$inject = ['$http', '$localStorage' , 'JhiTrackerService', 'PhoneCallCheckTrackerService'];

    function AuthServerProvider ($http, $localStorage , JhiTrackerService, PhoneCallCheckTrackerService) {
        var service = {
            getToken: getToken,
            hasValidToken: hasValidToken,
            login: login,
            logout: logout
        };

        return service;

        function getToken () {
            var token = $localStorage.authenticationToken;
            return token;
        }

        function hasValidToken () {
            var token = this.getToken();
            return !!token;
        }

        function login (credentials) {
            var data = 'j_username=' + encodeURIComponent(credentials.username) +
                '&j_password=' + encodeURIComponent(credentials.password) +
                '&remember-me=' + credentials.rememberMe + '&submit=Login';

            return $http.post('api/authentication', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).success(function (response) {
                return response;
            });
        }

        function logout () {
            JhiTrackerService.disconnect();
            PhoneCallCheckTrackerService.disconnect();

            
            // logout from the server
            $http.post('api/logout').success(function (response) {
                delete $localStorage.authenticationToken;
                // to get a new csrf token call the api
                $http.get('api/account');
                return response;
            });
            
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish', 'JhiTrackerService'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish, JhiTrackerService) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    JhiTrackerService.sendActivity();
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }


        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('report', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('employee-conversion-report-in-period', {
            parent: 'report',
            url: '/employee-conversion-report-in-period?page&sort&search&searchType&startDate&endDate&divisionId',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR', 'ROLE_MANAGER', 'ROLE_CHECKER'],
                pageTitle: 'telestatApp.employeesConversionReportInPeriod.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reports/employee-conversion-report-in-period/employee-conversion-report-in-period.html',
                    controller: 'EmployeeConversionReportInPeriodController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'employeeName,asc',
                    squash: true
                },
                searchType: {
                    value: 'lastmonth',
                    squash: true
                },
                startDate: null,
                endDate: null,
                divisionId: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        searchType: $stateParams.searchType,
                        startDate: $stateParams.startDate,
                        endDate: $stateParams.endDate,
                        divisionId: $stateParams.divisionId
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reports');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('datefilter');
                    return $translate.refresh();
                }]
            }
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('EmployeeConversionReportInPeriod', EmployeeConversionReportInPeriod);

    EmployeeConversionReportInPeriod.$inject = ['$resource'];

    function EmployeeConversionReportInPeriod ($resource) {
        var resourceUrl =  'api/report/employee-conversion-in-period/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('EmployeeConversionReportInPeriodController', EmployeeConversionReportInPeriodController);

    EmployeeConversionReportInPeriodController.$inject = ['$scope', '$state', '$translate', 'EmployeeConversionReportInPeriod', 'Division', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'UIFormAccess', '$filter'];

    function EmployeeConversionReportInPeriodController ($scope, $state, $translate, EmployeeConversionReportInPeriod, Division, ParseLinks, AlertService, paginationConstants, pagingParams, UIFormAccess, $filter) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerLargePage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.division = {id:pagingParams.divisionId};
        var allDivisionsTranslate = $translate.instant('telestatApp.reportsCommon.allDivisions');
        vm.divisions = [{id:null,actual:1,title: allDivisionsTranslate}];
        Division.query({size: 9999, sort: 'title,asc'},function(data){
            vm.divisions = [{id:null,actual:1,title: allDivisionsTranslate}].concat(data);
        });

        vm.exportLink = '';
        vm.UIFormAccess = UIFormAccess;

        vm.dateFilterData = {
                search: search,
                pagingParams: pagingParams,
                initCallBack: loadAll
        };

        vm.reportClean = [];
        vm.report = [];
        vm.mainIdColumn = 'nameId';
        vm.mainColumn = 'employeeName';
        vm.totalData = {
                uniqueLeadCount: 1,
                targetedCount: 1,
                missedCount: 1,
                productCount: 1
        };
        vm.diagramOptions = {
                chart: {
                    type: 'pieChart',
                    height: 300,
                    x: function(d){if(d[vm.mainIdColumn] != null) return d[vm.mainColumn] + " (" + Math.round(d.uniqueLeadCount) + ")";},
                    y: function(d){if(d[vm.mainIdColumn] != null) return d.uniqueLeadCount;},
                    showLabels: false,
                    showValues: true,
                    duration: 500,
                    legendPosition: false,//'top',
                    labelThreshold: 0.01
                    //labelSunbeamLayout: true,
                }
        };
        vm.diagramOptionsTarg = {
                chart: {
                    type: 'pieChart',
                    height: 300,
                    x: function(d){if(d[vm.mainIdColumn] != null) return d[vm.mainColumn] + " (" + Math.round(d.targetedCount*100/d.uniqueLeadCount) + "%)";},
                    y: function(d){if(d[vm.mainIdColumn] != null) return d.targetedCount;},
                    showLabels: false,
                    showValues: true,
                    duration: 500,
                    legendPosition: false,//'top',
                    labelThreshold: 0.01
                    //labelSunbeamLayout: true,
                }
        };
        vm.diagramOptionsMissed = {
                chart: {
                    type: 'pieChart',
                    height: 300,
                    x: function(d){if(d[vm.mainIdColumn] != null) return d[vm.mainColumn] + " (" + Math.round(d.missedCount*100/d.targetedCount) + "%)";},
                    y: function(d){if(d[vm.mainIdColumn] != null) return d.missedCount;},
                    showLabels: false,
                    showValues: true,
                    duration: 500,
                    legendPosition: false,//'top',
                    labelThreshold: 0.01
                    //labelSunbeamLayout: true,
                }
        };
        vm.diagramOptionsProd = {
                chart: {
                    type: 'pieChart',
                    height: 300,
                    x: function(d){if(d[vm.mainIdColumn] != null) return d[vm.mainColumn] + " (" + Math.round(d.productCount*100/d.targetedCount) + "%)";},
                    y: function(d){if(d[vm.mainIdColumn] != null) return d.productCount;},
                    showLabels: false,
                    showValues: true,
                    duration: 500,
                    legendPosition: false,//'top',
                    labelThreshold: 0.01
                    //labelSunbeamLayout: true,
                }
        };

        function makeLink() {
            var sortResult = vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc');
            vm.exportLink = "sort=" + sortResult
                    + (vm.dateFilterData.dateFilterType == 'all' ? '' : '&startDate=' + $filter('date')(vm.dateFilterData.startDate, "yyyy-MM-dd", 0))
                    + (vm.dateFilterData.dateFilterType == 'all' ? '' : '&endDate=' + $filter('date')(vm.dateFilterData.endDate, "yyyy-MM-dd", 0))
                    + (vm.division == null || vm.division.id == null ? '' : '&divisionId=' + vm.division.id);
        }
        makeLink();

        function loadAll () {
            makeLink();
            EmployeeConversionReportInPeriod.query({
                query: pagingParams.search,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                // search with time limits
                startDate: vm.dateFilterData.dateFilterType == 'all' ? null : $filter('date')(vm.dateFilterData.startDate, "yyyy-MM-dd", 0),
                endDate: vm.dateFilterData.dateFilterType == 'all' ? null : $filter('date')(vm.dateFilterData.endDate, "yyyy-MM-dd", 0),
                divisionId: vm.division == null ? null : vm.division.id
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.report = data;
                vm.minData = {};
                vm.maxData = {};
                getMinMax(vm.minData, vm.maxData, data);
                for(var i = 0 ; i < vm.report.length ; i++ ) {
                    if(vm.report[i][vm.mainIdColumn] == -1) {
                        vm.totalData = vm.report[i];
                        break;
                    }
                }
            }
            function onError(error) {
                var headers = Object.keys(error.headers()).filter(function (header) {
                    return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var alertKey = error.headers(headers[0]);
                if (angular.isString(alertKey)) {
                    AlertService.warning(alertKey, { param : error.headers(headers[1])});
                }
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            vm.dateFilterData.updateDateFilterType();
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                // search with time limits
                searchType: vm.dateFilterData.dateFilterType,
                startDate: vm.dateFilterData.dateFilterType == 'day' || vm.dateFilterData.dateFilterType == 'range' ? $filter('date')(vm.dateFilterData.startDate, "yyyy-MM-dd", 0) : null,
                endDate: vm.dateFilterData.dateFilterType == 'day' || vm.dateFilterData.dateFilterType == 'range' ? $filter('date')(vm.dateFilterData.endDate, "yyyy-MM-dd", 0) : null,
                divisionId: vm.division == null ? null : vm.division.id
            });
        }

        function search(searchQuery) {
            if (!searchQuery && vm.dateFilterData.dateFilterType == 'all') {
                return vm.clear();
            } else if(!searchQuery) {
                vm.currentSearch = null;
            } else {
                vm.predicate = 'employeeName';
                vm.reverse = false;
                vm.currentSearch = searchQuery;
            }
            vm.links = null;
            vm.page = 1;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'employeeName';
            vm.reverse = false;
            vm.currentSearch = null;
            vm.dateFilterData.setFilterType('all');
            vm.transition();
        }

        // Main columns list
        vm.columns = [
            'employeeName',
            'divisionName',
            'callsCount',
            //'uniqueLeadCount',
            'targetedCount',
            'missedCount',
            'uselessCount',
            'productCount',
            'avgTalkQuality',
            'avgServiceQuality'
        ];
        // Paired columns
        vm.addcolumns = [];
        vm.addcolumns['missedCount'] = 'missedPercent';
        vm.addcolumns['uselessCount']  = 'uselessPercent';
        vm.addcolumns['productCount']  = 'productPercent';
        // Highlighting columns by min/max
        vm.columnsMinMax = [
            'callsCount','uniqueLeadCount',
            'targetedCount','targetedPercent',
            'missedCount','missedPercent',
            'uselessCount','uselessPercent',
            'productCount','productPercent',
            'avgTalkQuality', 'avgServiceQuality'
        ];
        // Inverse min/max on next columns.
        vm.inverseColumns = {'uselessCount':1,'uselessPercent':1,'missedCount':1,'missedPercent':1};

        function getMinMax(min, max, rows) {
            var val = 0;
            vm.reportClean = [];
            for(var i = 0 ; i < rows.length ; i++ ) {
                var row = rows[i];
                if(row[vm.mainIdColumn] == -1) continue;
                vm.reportClean.push(row);
                if(val == 0) {
                    val = 1;
                    vm.columnsMinMax.forEach(function(name){
                        min[name] = row[name];
                        max[name] = row[name];
                    });
                    continue;
                }
                vm.columnsMinMax.forEach(function(name) {
                    if(row[name] !== null) {
                        if(max[name] === null) max[name] = row[name];
                        if(min[name] === null) min[name] = row[name];
                        if(vm.inverseColumns[name] === 1) {
                            if(max[name] > row[name]) max[name] = row[name];
                            if(min[name] < row[name]) min[name] = row[name];
                        } else {
                            if(max[name] < row[name]) max[name] = row[name];
                            if(min[name] > row[name]) min[name] = row[name];
                        }
                    }
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('employee-conversion-report', {
            parent: 'report',
            url: '/employee-conversion-report?page&sort&search&searchType&startDate&endDate&divisionId',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR', 'ROLE_MANAGER', 'ROLE_CHECKER'],
                pageTitle: 'telestatApp.employeesConversionReport.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reports/employee-conversion-report/employee-conversion-report.html',
                    controller: 'EmployeeConversionReportController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'employeeName,asc',
                    squash: true
                },
                searchType: {
                    value: 'lastmonth',
                    squash: true
                },
                startDate: null,
                endDate: null,
                divisionId: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        searchType: $stateParams.searchType,
                        startDate: $stateParams.startDate,
                        endDate: $stateParams.endDate,
                        divisionId: $stateParams.divisionId
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reports');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('datefilter');
                    return $translate.refresh();
                }]
            }
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('EmployeeConversionReport', EmployeeConversionReport);

    EmployeeConversionReport.$inject = ['$resource'];

    function EmployeeConversionReport ($resource) {
        var resourceUrl =  'api/report/employee-conversion/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
	'use strict';

	angular.module('telestatApp').controller(
			'EmployeeConversionReportController',
			EmployeeConversionReportController);

	EmployeeConversionReportController.$inject = [ '$scope', '$state',
			'$translate', 'EmployeeConversionReport', 'Division', 'ParseLinks',
			'AlertService', 'paginationConstants', 'pagingParams',
			'UIFormAccess', '$filter' ];

	function EmployeeConversionReportController($scope, $state, $translate,
			EmployeeConversionReport, Division, ParseLinks, AlertService,
			paginationConstants, pagingParams, UIFormAccess, $filter) {
		var vm = this;

		vm.loadPage = loadPage;
		vm.predicate = pagingParams.predicate;
		vm.reverse = pagingParams.ascending;
		vm.transition = transition;
		vm.itemsPerPage = paginationConstants.itemsPerLargePage;
		vm.clear = clear;
		vm.search = search;
		vm.loadAll = loadAll;
		vm.searchQuery = pagingParams.search;
		vm.currentSearch = pagingParams.search;
		vm.division = {
			id : pagingParams.divisionId
		};
		var allDivisionsTranslate = $translate
				.instant('telestatApp.reportsCommon.allDivisions');
		vm.divisions = [ {
			id : null,
			actual : 1,
			title : allDivisionsTranslate
		} ];
		Division.getforselect({}, function(data) {
			vm.divisions = [ {
				id : null,
				actual : 1,
				title : allDivisionsTranslate
			} ].concat(makeFlatDivisionList(data, 0));
		});

		vm.exportLink = '';
		vm.UIFormAccess = UIFormAccess;

		vm.dateFilterData = {
			search : search,
			pagingParams : pagingParams,
			initCallBack : loadAll
		};

		vm.reportClean = [];
		vm.report = [];
		vm.mainIdColumn = 'nameId';
		vm.mainColumn = 'employeeName';
		vm.totalData = {
			uniqueLeadCount : 1,
			targetedCount : 1,
			missedCount : 1,
			productCount : 1
		};
		vm.diagramOptions = {
			chart : {
				type : 'pieChart',
				height : 300,
				x : function(d) {
					if (d[vm.mainIdColumn] != null)
						return d[vm.mainColumn] + " ("
								+ Math.round(d.uniqueLeadCount) + ")";
				},
				y : function(d) {
					if (d[vm.mainIdColumn] != null)
						return d.uniqueLeadCount;
				},
				showLabels : false,
				showValues : true,
				duration : 500,
				legendPosition : false,// 'top',
				labelThreshold : 0.01
			// labelSunbeamLayout: true,
			}
		};
		vm.diagramOptionsTarg = {
			chart : {
				type : 'pieChart',
				height : 300,
				x : function(d) {
					if (d[vm.mainIdColumn] != null)
						return d[vm.mainColumn]
								+ " ("
								+ Math.round(d.targetedCount * 100
										/ d.uniqueLeadCount) + "%)";
				},
				y : function(d) {
					if (d[vm.mainIdColumn] != null)
						return d.targetedCount;
				},
				showLabels : false,
				showValues : true,
				duration : 500,
				legendPosition : false,// 'top',
				labelThreshold : 0.01
			// labelSunbeamLayout: true,
			}
		};
		vm.diagramOptionsMissed = {
			chart : {
				type : 'pieChart',
				height : 300,
				x : function(d) {
					if (d[vm.mainIdColumn] != null)
						return d[vm.mainColumn]
								+ " ("
								+ Math.round(d.missedCount * 100
										/ d.targetedCount) + "%)";
				},
				y : function(d) {
					if (d[vm.mainIdColumn] != null)
						return d.missedCount;
				},
				showLabels : false,
				showValues : true,
				duration : 500,
				legendPosition : false,// 'top',
				labelThreshold : 0.01
			// labelSunbeamLayout: true,
			}
		};
		vm.diagramOptionsProd = {
			chart : {
				type : 'pieChart',
				height : 300,
				x : function(d) {
					if (d[vm.mainIdColumn] != null)
						return d[vm.mainColumn]
								+ " ("
								+ Math.round(d.productCount * 100
										/ d.targetedCount) + "%)";
				},
				y : function(d) {
					if (d[vm.mainIdColumn] != null)
						return d.productCount;
				},
				showLabels : false,
				showValues : true,
				duration : 500,
				legendPosition : false,// 'top',
				labelThreshold : 0.01
			// labelSunbeamLayout: true,
			}
		};

		function makeLink() {
			var sortResult = vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc');
			vm.exportLink = "sort="
					+ sortResult
					+ (vm.dateFilterData.dateFilterType == 'all' ? ''
							: '&startDate='
									+ $filter('date')(
											vm.dateFilterData.startDate,
											"yyyy-MM-dd", 0))
					+ (vm.dateFilterData.dateFilterType == 'all' ? ''
							: '&endDate='
									+ $filter('date')(
											vm.dateFilterData.endDate,
											"yyyy-MM-dd", 0))
					+ (vm.division == null || vm.division.id == null ? ''
							: '&divisionId=' + vm.division.id);
		}
		makeLink();

		function loadAll() {
			makeLink();
			EmployeeConversionReport.query({
				query : pagingParams.search,
				page : pagingParams.page - 1,
				size : vm.itemsPerPage,
				sort : sort(),
				// search with time limits
				startDate : vm.dateFilterData.dateFilterType == 'all' ? null
						: $filter('date')(vm.dateFilterData.startDate,
								"yyyy-MM-dd", 0),
				endDate : vm.dateFilterData.dateFilterType == 'all' ? null
						: $filter('date')(vm.dateFilterData.endDate,
								"yyyy-MM-dd", 0),
				divisionId : vm.division == null ? null : vm.division.id
			}, onSuccess, onError);

			function sort() {
				var result = [ vm.predicate + ','
						+ (vm.reverse ? 'asc' : 'desc') ];
				if (vm.predicate !== 'id') {
					result.push('id');
				}
				return result;
			}
			function onSuccess(data, headers) {
				vm.report = data;
				vm.minData = {};
				vm.maxData = {};
				getMinMax(vm.minData, vm.maxData, data);
				for (var i = 0; i < vm.report.length; i++) {
					if (vm.report[i][vm.mainIdColumn] == -1) {
						vm.totalData = vm.report[i];
						break;
					}
				}
			}
			function onError(error) {
				var headers = Object
						.keys(error.headers())
						.filter(
								function(header) {
									return header.indexOf('app-alert',
											header.length - 'app-alert'.length) !== -1
											|| header
													.indexOf(
															'app-params',
															header.length
																	- 'app-params'.length) !== -1;
								}).sort();
				var alertKey = error.headers(headers[0]);
				if (angular.isString(alertKey)) {
					AlertService.warning(alertKey, {
						param : error.headers(headers[1])
					});
				}
			}
		}

		function loadPage(page) {
			vm.page = page;
			vm.transition();
		}

		function transition() {
			vm.dateFilterData.updateDateFilterType();
			$state
					.transitionTo(
							$state.$current,
							{
								page : vm.page,
								sort : vm.predicate + ','
										+ (vm.reverse ? 'asc' : 'desc'),
								search : vm.currentSearch,
								// search with time limits
								searchType : vm.dateFilterData.dateFilterType,
								startDate : vm.dateFilterData.dateFilterType == 'day'
										|| vm.dateFilterData.dateFilterType == 'range' ? $filter(
										'date')(vm.dateFilterData.startDate,
										"yyyy-MM-dd", 0)
										: null,
								endDate : vm.dateFilterData.dateFilterType == 'day'
										|| vm.dateFilterData.dateFilterType == 'range' ? $filter(
										'date')(vm.dateFilterData.endDate,
										"yyyy-MM-dd", 0)
										: null,
								divisionId : vm.division == null ? null
										: vm.division.id
							});
		}

		function search(searchQuery) {
			if (!searchQuery && vm.dateFilterData.dateFilterType == 'all') {
				return vm.clear();
			} else if (!searchQuery) {
				vm.currentSearch = null;
			} else {
				vm.predicate = 'employeeName';
				vm.reverse = false;
				vm.currentSearch = searchQuery;
			}
			vm.links = null;
			vm.page = 1;
			vm.transition();
		}

		function clear() {
			vm.links = null;
			vm.page = 1;
			vm.predicate = 'employeeName';
			vm.reverse = false;
			vm.currentSearch = null;
			vm.dateFilterData.setFilterType('all');
			vm.transition();
		}

		// Main columns list
		vm.columns = [ 'employeeName', 'divisionName', 'callsCount',
				'uniqueLeadCount', 'targetedCount', 'missedCount',
				'uselessCount', 'productCount', 'avgTalkQuality',
				'avgServiceQuality' ];
		// Paired columns
		vm.addcolumns = [];
		vm.addcolumns['missedCount'] = 'missedPercent';
		vm.addcolumns['uselessCount'] = 'uselessPercent';
		vm.addcolumns['productCount'] = 'productPercent';
		// Highlighting columns by min/max
		vm.columnsMinMax = [ 'callsCount', 'uniqueLeadCount', 'targetedCount',
				'targetedPercent', 'missedCount', 'missedPercent',
				'uselessCount', 'uselessPercent', 'productCount',
				'productPercent', 'avgTalkQuality', 'avgServiceQuality' ];
		// Inverse min/max on next columns.
		vm.inverseColumns = {
			'uselessCount' : 1,
			'uselessPercent' : 1,
			'missedCount' : 1,
			'missedPercent' : 1
		};

		function getMinMax(min, max, rows) {
			var val = 0;
			vm.reportClean = [];
			for (var i = 0; i < rows.length; i++) {
				var row = rows[i];
				if (row[vm.mainIdColumn] == -1)
					continue;
				vm.reportClean.push(row);
				if (val == 0) {
					val = 1;
					vm.columnsMinMax.forEach(function(name) {
						min[name] = row[name];
						max[name] = row[name];
					});
					continue;
				}
				vm.columnsMinMax.forEach(function(name) {
					if (row[name] !== null) {
						if (max[name] === null)
							max[name] = row[name];
						if (min[name] === null)
							min[name] = row[name];
						if (vm.inverseColumns[name] === 1) {
							if (max[name] > row[name])
								max[name] = row[name];
							if (min[name] < row[name])
								min[name] = row[name];
						} else {
							if (max[name] < row[name])
								max[name] = row[name];
							if (min[name] > row[name])
								min[name] = row[name];
						}
					}
				});
			}
		}
		function makeFlatDivisionList(data, level) {
			var divFlatListArr = [];
			for (var i = 0; i < data.length; i++) {
				divFlatListArr.push({
					id : data[i].id,
					actual : true,
					title : ' - '.repeat(level) + data[i].title
				});

				if (data[i].divisions !== undefined
						&& data[i].divisions.length > 0) {
					var t = makeFlatDivisionList(data[i].divisions, level + 1);
					divFlatListArr = divFlatListArr.concat(t);
				}
			}
			return divFlatListArr;
		}
	}
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('employee-advertising-source-report', {
            parent: 'report',
            url: '/employee-advertising-source-report?page&sort&search&searchType&startDate&endDate&divisionId',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR', 'ROLE_MANAGER', 'ROLE_CHECKER'],
                pageTitle: 'telestatApp.employeesAdvertisingSourcesReport.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reports/employee-advertising-source-report/employee-advertising-source-report.html',
                    controller: 'EmployeeAdvertisingSourceReportController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'employeeName,asc',
                    squash: true
                },
                searchType: {
                    value: 'lastmonth',
                    squash: true
                },
                startDate: null,
                endDate: null,
                divisionId: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        searchType: $stateParams.searchType,
                        startDate: $stateParams.startDate,
                        endDate: $stateParams.endDate,
                        divisionId: $stateParams.divisionId
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reports');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('datefilter');
                    return $translate.refresh();
                }]
            }
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('EmployeeAdvertisingSourceReport', EmployeeAdvertisingSourceReport);

    EmployeeAdvertisingSourceReport.$inject = ['$resource'];

    function EmployeeAdvertisingSourceReport ($resource) {
        var resourceUrl =  'api/report/employee-advertising-source/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('EmployeeAdvertisingSourceReportController', EmployeeAdvertisingSourceReportController);

    EmployeeAdvertisingSourceReportController.$inject = ['$scope', '$state', '$translate', 'EmployeeAdvertisingSourceReport', 'Division', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'UIFormAccess', '$filter'];

    function EmployeeAdvertisingSourceReportController ($scope, $state, $translate, EmployeeAdvertisingSourceReport, Division, ParseLinks, AlertService, paginationConstants, pagingParams, UIFormAccess, $filter) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerLargePage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.division = {id:pagingParams.divisionId};
        var allDivisionsTranslate = $translate.instant('telestatApp.reportsCommon.allDivisions');
        vm.divisions = [{id:null,actual:1,title: allDivisionsTranslate}];
        Division.getforselect({},function(data){
            vm.divisions = [{id:null,actual:1,title: allDivisionsTranslate}].concat(makeFlatDivisionList(data, 0));
        });

        vm.exportLink = '';
        vm.UIFormAccess = UIFormAccess;

        vm.dateFilterData = {
                search: search,
                pagingParams: pagingParams,
                initCallBack: loadAll
        };

        vm.reportClean = [];
        vm.report = [];
        vm.mainIdColumn = 'nameId';
        // Centered columns
        vm.mainColumn = {'employeeName':1, 'divisionName':1, 'advertisingSourceName':1};
        vm.totalData = {
                uniqueLeadCount: 1,
                targetedCount: 1,
                missedCount: 1,
                productCount: 1
        };

        function makeLink() {
            var sortResult = vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc');
            vm.exportLink = "sort=" + sortResult
                    + (vm.dateFilterData.dateFilterType == 'all' ? '' : '&startDate=' + $filter('date')(vm.dateFilterData.startDate, "yyyy-MM-dd", 0))
                    + (vm.dateFilterData.dateFilterType == 'all' ? '' : '&endDate=' + $filter('date')(vm.dateFilterData.endDate, "yyyy-MM-dd", 0))
                    + (vm.division == null || vm.division.id == null ? '' : '&divisionId=' + vm.division.id);
        }
        makeLink();

        function loadAll() {
            makeLink();
            EmployeeAdvertisingSourceReport.query({
                query: pagingParams.search,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                // search with time limits
                startDate: vm.dateFilterData.dateFilterType == 'all' ? null : $filter('date')(vm.dateFilterData.startDate, "yyyy-MM-dd", 0),
                endDate: vm.dateFilterData.dateFilterType == 'all' ? null : $filter('date')(vm.dateFilterData.endDate, "yyyy-MM-dd", 0),
                divisionId: vm.division == null ? null : vm.division.id
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'employeeName') {
                    result.push('employeeName');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.report = data;
                vm.minData = {};
                vm.maxData = {};
                vm.enableGroupping = (vm.predicate == "employeeName" || vm.predicate == "divisionName");
                getMinMax(vm.minData, vm.maxData, data);
                for (var i = 0 ; i < vm.report.length ; i++ ) {
                    if (vm.report[i][vm.mainIdColumn] == -1) {
                        vm.totalData = vm.report[i];
                        break;
                    }
                }
            }
            function onError(error) {
                var headers = Object.keys(error.headers()).filter(function (header) {
                    return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var alertKey = error.headers(headers[0]);
                if (angular.isString(alertKey)) {
                    AlertService.warning(alertKey, { param : error.headers(headers[1])});
                }
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            vm.dateFilterData.updateDateFilterType();
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                // search with time limits
                searchType: vm.dateFilterData.dateFilterType,
                startDate: vm.dateFilterData.dateFilterType == 'day' || vm.dateFilterData.dateFilterType == 'range' ? $filter('date')(vm.dateFilterData.startDate, "yyyy-MM-dd", 0) : null,
                endDate: vm.dateFilterData.dateFilterType == 'day' || vm.dateFilterData.dateFilterType == 'range' ? $filter('date')(vm.dateFilterData.endDate, "yyyy-MM-dd", 0) : null,
                divisionId: vm.division == null ? null : vm.division.id
            });
        }

        function search(searchQuery) {
            if (!searchQuery && vm.dateFilterData.dateFilterType == 'all') {
                return vm.clear();
            } else if(!searchQuery) {
                vm.currentSearch = null;
            } else {
                vm.predicate = 'employeeName';
                vm.reverse = false;
                vm.currentSearch = searchQuery;
            }
            vm.links = null;
            vm.page = 1;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'employeeName';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.dateFilterData.setFilterType('all');
            vm.transition();
        }

        vm.columnsRowSpan = [
            'advertisingSourceName',
            'callsCount',
            'uniqueLeadCount',
            'targetedCount',
            'missedCount',
            'uselessCount',
            'productCount'
        ];
        // Main columns list
        vm.columns = ['employeeName'];
        if (vm.division.id == null) {
            vm.columns = vm.columns.concat(['divisionName']);
        }
        vm.columns = vm.columns.concat(vm.columnsRowSpan);
        // Paired columns
        vm.addcolumns = [];
        // Highlighting columns by min/max
        vm.columnsMinMax = [
            'callsCount', 'uniqueLeadCount',
            'targetedCount', 'missedCount',
            'uselessCount', 'productCount'
        ];
        // Inverse min/max on next columns.
        vm.inverseColumns = {'missedCount':1, 'uselessCount':1};

        function getMinMax(min, max, rows) {
            var val = 0;
            var rowspanRow = null;
            var rowspanRowI = -1;
            vm.reportClean = [];
            for (var i = 0 ; i < rows.length ; i++ ) {
                var row = rows[i];
                if (vm.enableGroupping) {
                    if (rowspanRow != null && rowspanRowI != i && rowspanRow['employeeName'] == row['employeeName'] && rowspanRow['divisionName'] == row['divisionName']) {
                        rowspanRow['rowspan'] ++;
                        row['rowspan'] = 'X';
                    } else {
                        rowspanRow = row;
                        rowspanRowI = i;
                        rowspanRow['rowspan'] = 1;
                    }
                } else {
                    row['rowspan'] = 1;
                }
                if (row[vm.mainIdColumn] == -1) continue;
                vm.reportClean.push(row);
                if (val == 0) {
                    val = 1;
                    vm.columnsMinMax.forEach(function (name) {
                        min[name] = row[name];
                        max[name] = row[name];
                    });
                    continue;
                }
                vm.columnsMinMax.forEach(function (name) {
                    if (row[name] !== null) {
                        if (max[name] === null) max[name] = row[name];
                        if (min[name] === null) min[name] = row[name];
                        if (vm.inverseColumns[name] === 1) {
                            if (max[name] > row[name]) max[name] = row[name];
                            if (min[name] < row[name]) min[name] = row[name];
                        } else {
                            if (max[name] < row[name]) max[name] = row[name];
                            if (min[name] > row[name]) min[name] = row[name];
                        }
                    }
                });
            }
        }
        function makeFlatDivisionList(data, level) {
			var divFlatListArr = [];
			for (var i = 0; i < data.length; i++) {
				divFlatListArr.push({
					id : data[i].id,
					actual : true,
					title : ' - '.repeat(level) + data[i].title
				});

				if (data[i].divisions !== undefined
						&& data[i].divisions.length > 0) {
					var t = makeFlatDivisionList(data[i].divisions, level + 1);
					divFlatListArr = divFlatListArr.concat(t);
				}
			}
			return divFlatListArr;
		}
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('division-conversion-report', {
            parent: 'report',
            url: '/division-conversion-report?page&sort&search&searchType&startDate&endDate&insignificantFilter',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR', 'ROLE_MANAGER', 'ROLE_CHECKER'],
                pageTitle: 'telestatApp.divisionsConversionReport.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reports/division-conversion-report/division-conversion-report.html',
                    controller: 'DivisionConversionReportController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'divisionName,desc',
                    squash: true
                },
                searchType: {
                    value: 'lastmonth',
                    squash: true
                },
                startDate: null,
                endDate: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        searchType: $stateParams.searchType,
                        startDate: $stateParams.startDate,
                        endDate: $stateParams.endDate,
                        insignificantFilter: $stateParams.insignificantFilter
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reports');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('datefilter');
                    return $translate.refresh();
                }]
            }
        })
        .state('division-conversion-dynamic-report', {
            parent: 'report',
            url: '/division-conversion-dynamic-report?page&sort&search&searchType&startDate&endDate&insignificantFilter',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR', 'ROLE_MANAGER', 'ROLE_CHECKER'],
                pageTitle: 'telestatApp.divisionsConversionReport.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reports/division-conversion-report/division-conversion-dynamic-report.html',
                    controller: 'DivisionConversionDynamicReportController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'nameId,desc',
                    squash: true
                },
                searchType: {
                    value: 'lastmonth',
                    squash: true
                },
                startDate: null,
                endDate: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        searchType: $stateParams.searchType,
                        startDate: $stateParams.startDate,
                        endDate: $stateParams.endDate,
                        insignificantFilter: $stateParams.insignificantFilter
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reports');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('datefilter');
                    return $translate.refresh();
                }]
            }
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('DivisionConversionReport', DivisionConversionReport);

    DivisionConversionReport.$inject = ['$resource'];

    function DivisionConversionReport ($resource) {
        var resourceUrl =  'api/report/division-conversion/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('DivisionConversionReportController', DivisionConversionReportController);

    DivisionConversionReportController.$inject = ['$scope', '$state', 'DivisionConversionReport', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'UIFormAccess', '$filter'];

    function DivisionConversionReportController ($scope, $state, DivisionConversionReport, ParseLinks, AlertService, paginationConstants, pagingParams, UIFormAccess, $filter) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerLargePage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        vm.exportLink = '';
        vm.UIFormAccess = UIFormAccess;

        vm.dateFilterData = {
                search: search,
                pagingParams: pagingParams,
                initCallBack: loadAll
        };

        vm.reportClean = [];
        vm.report = [];
        vm.mainIdColumn = 'nameId';
        vm.mainColumn = 'divisionName';
        vm.totalData = {
                uniqueLeadCount: 1,
                targetedCount: 1,
                missedCount: 1,
                productCount: 1
        };
        vm.diagramOptions = {
                chart: {
                    type: 'pieChart',
                    height: 500,
                    x: function(d){if(d[vm.mainIdColumn] != null) return d[vm.mainColumn] + " (" + Math.round(d.uniqueLeadCount*100/vm.totalData.uniqueLeadCount) + "%)";},
                    y: function(d){if(d[vm.mainIdColumn] != null) return d.uniqueLeadCount;},
                    showLabels: false,
                    showValues: true,
                    duration: 500,
                    legendPosition: 'top',
                    labelThreshold: 0.01
                    //labelSunbeamLayout: true,
                }
        };
        vm.diagramOptionsTarg = {
                chart: {
                    type: 'pieChart',
                    height: 500,
                    x: function(d){if(d[vm.mainIdColumn] != null) return d[vm.mainColumn] + " (" + Math.round(d.targetedCount*100/vm.totalData.targetedCount) + "%)";},
                    y: function(d){if(d[vm.mainIdColumn] != null) return d.targetedCount;},
                    showLabels: false,
                    showValues: true,
                    duration: 500,
                    legendPosition: 'top',
                    labelThreshold: 0.01
                    //labelSunbeamLayout: true,
                }
        };
        vm.diagramOptionsMissed = {
                chart: {
                    type: 'pieChart',
                    height: 500,
                    x: function(d){if(d[vm.mainIdColumn] != null) return d[vm.mainColumn] + " (" + Math.round(d.missedCount*100/vm.totalData.missedCount) + "%)";},
                    y: function(d){if(d[vm.mainIdColumn] != null) return d.missedCount;},
                    showLabels: false,
                    showValues: true,
                    duration: 500,
                    legendPosition: 'top',
                    labelThreshold: 0.01
                    //labelSunbeamLayout: true,
                }
        };
        vm.diagramOptionsProd = {
                chart: {
                    type: 'pieChart',
                    height: 500,
                    x: function(d){if(d[vm.mainIdColumn] != null) return d[vm.mainColumn] + " (" + Math.round(d.productCount*100/vm.totalData.productCount) + "%)";},
                    y: function(d){if(d[vm.mainIdColumn] != null) return d.productCount;},
                    showLabels: false,
                    showValues: true,
                    duration: 500,
                    legendPosition: 'top',
                    labelThreshold: 0.01
                    //labelSunbeamLayout: true,
                }
        };

        function makeLink() {
            var sortResult = vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc');
            vm.exportLink = "sort=" + sortResult
                    + (vm.dateFilterData.dateFilterType == 'all' ? '' : '&startDate=' + $filter('date')(vm.dateFilterData.startDate, "yyyy-MM-dd", 0))
                    + (vm.dateFilterData.dateFilterType == 'all' ? '' : '&endDate=' + $filter('date')(vm.dateFilterData.endDate, "yyyy-MM-dd", 0))
                    + (vm.division == null || vm.division.id == null ? '' : '&divisionId=' + vm.division.id);
        }
        makeLink();

        function loadAll () {
            makeLink();
            DivisionConversionReport.query({
                query: pagingParams.search,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                // search with time limits
                startDate: vm.dateFilterData.dateFilterType == 'all' ? null : $filter('date')(vm.dateFilterData.startDate, "yyyy-MM-dd", 0),
                endDate: vm.dateFilterData.dateFilterType == 'all' ? null : $filter('date')(vm.dateFilterData.endDate, "yyyy-MM-dd", 0)
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.report = data;
                vm.minData = {};
                vm.maxData = {};
                getMinMax(vm.minData, vm.maxData, data);
                for(var i = 0 ; i < vm.report.length ; i++ ) {
                    if(vm.report[i][vm.mainIdColumn] == -1) {
                        vm.totalData = vm.report[i];
                        break;
                    }
                }
            }
            function onError(error) {
                var headers = Object.keys(error.headers()).filter(function (header) {
                    return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var alertKey = error.headers(headers[0]);
                if (angular.isString(alertKey)) {
                    AlertService.warning(alertKey, { param : error.headers(headers[1])});
                }
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            vm.dateFilterData.updateDateFilterType();
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                // search with time limits
                searchType: vm.dateFilterData.dateFilterType,
                startDate: vm.dateFilterData.dateFilterType == 'day' || vm.dateFilterData.dateFilterType == 'range' ? $filter('date')(vm.dateFilterData.startDate, "yyyy-MM-dd", 0) : null,
                endDate: vm.dateFilterData.dateFilterType == 'day' || vm.dateFilterData.dateFilterType == 'range' ? $filter('date')(vm.dateFilterData.endDate, "yyyy-MM-dd", 0) : null
            });
        }

        function search(searchQuery) {
            if (!searchQuery && vm.dateFilterData.dateFilterType == 'all') {
                return vm.clear();
            } else if(!searchQuery) {
                vm.currentSearch = null;
            } else {
                vm.predicate = 'divisionName';
                vm.reverse = false;
                vm.currentSearch = searchQuery;
            }
            vm.links = null;
            vm.page = 1;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'divisionName';
            vm.reverse = false;
            vm.currentSearch = null;
            vm.dateFilterData.setFilterType('all');
            vm.transition();
        }

        // Main columns list
        vm.columns = [
            'divisionName',
            'callsCount',
            'uniqueLeadCount',
            'targetedCount',
            'employeeCount',
            'targetedOnEmployee',
            'missedCount',
            'uselessCount',
            'productCount',
            'avgTalkQuality',
            'avgServiceQuality'
        ];
        // Paired columns
        vm.addcolumns = [];
        vm.addcolumns['uniqueLeadCount'] = 'uniqueLeadPercent';
        vm.addcolumns['targetedCount'] = 'targetedPercent';
        vm.addcolumns['missedCount'] = 'missedPercent';
        vm.addcolumns['uselessCount']  = 'uselessPercent';
        vm.addcolumns['productCount']  = 'productPercent';
        // Highlighting columns by min/max
        vm.columnsMinMax = [
            'callsCount','uniqueLeadCount',
            'targetedCount','targetedPercent',
            'missedCount','missedPercent',
            'uselessCount','uselessPercent',
            'productCount','productPercent',
            'avgTalkQuality', 'avgServiceQuality',
            'employeeCount', 'uniqueLeadPercent',
            'targetedOnEmployee'
        ];
        // Inverse min/max on next columns.
        vm.inverseColumns = {'undefCount':1,'undefPercent':1,'insignifCount':1,'insignifPercent':1,'uselessCount':1,'uselessPercent':1,'missedCount':1,'missedPercent':1};

        function getMinMax(min, max, rows) {
            var val = 0;
            vm.reportClean = [];
            for(var i = 0 ; i < rows.length ; i++ ) {
                var row = rows[i];
                if(row[vm.mainIdColumn] == -1) continue;
                vm.reportClean.push(row);
                if(val == 0) {
                    val = 1;
                    vm.columnsMinMax.forEach(function(name){
                        min[name] = row[name];
                        max[name] = row[name];
                    });
                    continue;
                }
                vm.columnsMinMax.forEach(function(name) {
                    if(row[name] !== null) {
                        if(max[name] === null) max[name] = row[name];
                        if(min[name] === null) min[name] = row[name];
                        if(vm.inverseColumns[name] === 1) {
                            if(max[name] > row[name]) max[name] = row[name];
                            if(min[name] < row[name]) min[name] = row[name];
                        } else {
                            if(max[name] < row[name]) max[name] = row[name];
                            if(min[name] > row[name]) min[name] = row[name];
                        }
                    }
                });
            }
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('DivisionConversionDynamicReport', DivisionConversionDynamicReport);

    DivisionConversionDynamicReport.$inject = ['$resource'];

    function DivisionConversionDynamicReport ($resource) {
        var resourceUrl =  'api/report/division-conversion-dynamic/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('DivisionConversionDynamicReportController', DivisionConversionDynamicReportController);

    DivisionConversionDynamicReportController.$inject = ['$scope', '$state', 'DivisionConversionDynamicReport', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'UIFormAccess', '$filter'];

    function DivisionConversionDynamicReportController ($scope, $state, DivisionConversionDynamicReport, ParseLinks, AlertService, paginationConstants, pagingParams, UIFormAccess, $filter) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerLargePage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.resetLegends = resetLegends;

        vm.exportLink = '';
        vm.UIFormAccess = UIFormAccess;

        vm.dateFilterData = {
                search: search,
                pagingParams: pagingParams,
                initCallBack: loadAll
        };

        vm.reportClean = [];
        vm.report = [];
        vm.report1 = [];
        vm.mainIdColumn = 'divisionId';
        vm.mainColumn = 'key';
        vm.totalData = {
                uniqueLeadCount: 1,
                targetedCount: 1,
                missedCount: 1,
                productCount: 1
        };

        vm.diagramOptions = {
                chart: {
                    type: 'lineChart',
                    height: 500,
                    x: function(d){return d[0];},
                    y: function(d){return d[1];},
                    duration: 300,
                    clipVoronoi: false,
                    interpolate: 'cardinal',
                    xAxis: {
                        axisLabel: 'Дата',
                        tickFormat: function(d) {
                            return d3.time.format('%d.%m.%y')(new Date(d));
                        },
                        showMaxMin: false,
                        staggerLabels: true
                    },
                    forceY: [0, 100],

                    yAxis: {
                        axisLabel: '%',
                        tickFormat: function(d){
                            return d3.format('.02f')(d);
                        },
                        axisLabelDistance: 20
                    }
                }
        };

        function makeLink() {
            var sortResult = vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc');
            vm.exportLink = "sort=" + sortResult
                    + (vm.dateFilterData.dateFilterType == 'all' ? '' : '&startDate=' + $filter('date')(vm.dateFilterData.startDate, "yyyy-MM-dd", 0))
                    + (vm.dateFilterData.dateFilterType == 'all' ? '' : '&endDate=' + $filter('date')(vm.dateFilterData.endDate, "yyyy-MM-dd", 0))
                    + (vm.division == null || vm.division.id == null ? '' : '&divisionId=' + vm.division.id);
        }
        makeLink();

        function loadAll () {
            makeLink();
            DivisionConversionDynamicReport.query({
                query: pagingParams.search,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                // search with time limits
                startDate: vm.dateFilterData.dateFilterType == 'all' ? null : $filter('date')(vm.dateFilterData.startDate, "yyyy-MM-dd", 0),
                endDate: vm.dateFilterData.dateFilterType == 'all' ? null : $filter('date')(vm.dateFilterData.endDate, "yyyy-MM-dd", 0)
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.report = data;
                vm.minData = {};
                vm.maxData = {};
                getMinMax(vm.minData, vm.maxData, data);
                for(var i = 0 ; i < vm.report.length ; i++ ) {
                    if(vm.report[i][vm.mainIdColumn] == -1) {
                        vm.totalData = vm.report[i];
                        break;
                    }
                }
            }
            function onError(error) {
                var headers = Object.keys(error.headers()).filter(function (header) {
                    return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var alertKey = error.headers(headers[0]);
                if (angular.isString(alertKey)) {
                    AlertService.warning(alertKey, { param : error.headers(headers[1])});
                }
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            vm.dateFilterData.updateDateFilterType();
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                // search with time limits
                searchType: vm.dateFilterData.dateFilterType,
                startDate: vm.dateFilterData.dateFilterType == 'day' || vm.dateFilterData.dateFilterType == 'range' ? $filter('date')(vm.dateFilterData.startDate, "yyyy-MM-dd", 0) : null,
                endDate: vm.dateFilterData.dateFilterType == 'day' || vm.dateFilterData.dateFilterType == 'range' ? $filter('date')(vm.dateFilterData.endDate, "yyyy-MM-dd", 0) : null
            });
        }

        function search(searchQuery) {
            if (!searchQuery && vm.dateFilterData.dateFilterType == 'all') {
                return vm.clear();
            } else if(!searchQuery) {
                vm.currentSearch = null;
            } else {
                vm.predicate = 'name';
                vm.reverse = false;
                vm.currentSearch = searchQuery;
            }
            vm.links = null;
            vm.page = 1;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'name';
            vm.reverse = false;
            vm.currentSearch = null;
            vm.dateFilterData.setFilterType('all');
            vm.transition();
        }

        function resetLegends() {
            for(var i=0;i<vm.report1.length;i++) {
                if (vm.report1[i].best) {
                    vm.report1[i].disabled = false;
                } else {
                    vm.report1[i].disabled = true;
                }
            }
            vm.api.refresh();
        }
        // predefined 20 colors
        // http://tools.medialab.sciences-po.fr/iwanthue/
        // Settings: all colors + 20 colors + hard
        var colors = [[255,141,135],
            [2,195,108],
            [255,40,102],
            [1,227,206],
            [112,0,100],
            [187,255,158],
            [95,125,255],
            [255,169,4],
            [0,43,109],
            [255,140,66],
            [81,181,255],
            [155,104,0],
            [1,121,147],
            [255,197,113],
            [0,13,17],
            [211,224,255],
            [131,48,0],
            [121,112,0],
            [133,0,55],
            [68,15,0]];
        // color index
        var ci = 0;
        function getMinMax(min, max, rows) {
            // divisionId => value
            var map = new Map();
            var depMap = new Map();
            for(var i = 0 ; i < rows.length ; i++ ) {
                var row = rows[i];
                var obj = depMap.get(row['divisionId']);
                if (obj == null) {
                    obj = {
                            "key": row['name'],
                            "nameId": row['divisionId'],
                            "values": [ [ Date.parse(row['periodEnd']), row['value'], row['periodEnd'] ] ],
                            "disabled": true,
                            "best": false,
                            "color": 'rgb('+(ci < 20 ? colors[ci][0]+','+colors[ci][1]+','+colors[ci][2] : Math.floor(Math.random() * 255)+','+Math.floor(Math.random() * 255)+','+Math.floor(Math.random() * 255))+')',
                            "maxValue": row['value']
                    };
                    ci++;
                    obj.maxValue = row['value'];
                    map.set(row['divisionId'], row['value']);
                    vm.report1.push(obj);
                    depMap.set(row['divisionId'], obj)
                } else {
                    obj["values"].push([ Date.parse(row['periodEnd']), row['value'], row['periodEnd'] ]);
                    if (obj.maxValue < row['value']) {
                        map.set(row['divisionId'], row['value']);
                        obj.maxValue = row['value'];
                    }
                }
            }
            // value
            var data = [];
            // value => [divisionId,...]
            var revMap = new Map();
            map.forEach(function(v,k){
                data.push(v);
                var rk = revMap.get(k);
                if(rk == null){
                    revMap.set(v,[k]);
                } else {
                    rk.push(k);
                }
            });
            // setup max values first
            data = data.sort(function(a,b){ return b-a;});
            // show first 4 divisions
            for(var i=0;i < 4;i++) {
                revMap.get(data[i]).forEach(
                        function(dataRec){
                            var t = depMap.get(dataRec);
                            t.disabled = false;
                            t.best = true;
                        }
                );
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('checker-statistics-report', {
            parent: 'report',
            url: '/checker-statistics-report?page&sort&search&searchType&startDate&endDate',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR', 'ROLE_MANAGER', 'ROLE_CHECKER'],
                pageTitle: 'telestatApp.checkersStatisticReport.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reports/checker-statistics-report/checker-statistics-report.html',
                    controller: 'CheckerStatisticsReportController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'employeeName,desc',
                    squash: true
                },
                searchType: {
                    value: 'thismonth',
                    squash: true
                },
                startDate: null,
                endDate: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        searchType: $stateParams.searchType,
                        startDate: $stateParams.startDate,
                        endDate: $stateParams.endDate,
                        insignificantFilter: $stateParams.insignificantFilter
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reports');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('datefilter');
                    return $translate.refresh();
                }]
            }
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('CheckerStatisticsReport', CheckerStatisticsReport);

    CheckerStatisticsReport.$inject = ['$resource'];

    function CheckerStatisticsReport ($resource) {
        var resourceUrl =  'api/report/phone-call-checks-checker-statistics/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    // filter HHHMM
    angular
        .module('telestatApp')
        .filter('HHHMM', function () {
            return function (sec) {
                if (sec == null) {
                    return '-';
                }
                console.log(sec);
                var allminutes = Math.floor(sec / 60);
                var seconds = sec - allminutes * 60;
                if (seconds < 10) {seconds = "0" + seconds;}
                var allhours = Math.floor(allminutes / 60);
                var minutes = allminutes - allhours * 60;
                if (minutes < 10) {minutes = "0" + minutes;}
                return allhours + ':' + minutes;
            };
        });

    angular
        .module('telestatApp')
        .controller('CheckerStatisticsReportController', CheckerStatisticsReportController);

    CheckerStatisticsReportController.$inject = ['$scope', '$state', 'CheckerStatisticsReport', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'UIFormAccess', '$filter'];

    function CheckerStatisticsReportController ($scope, $state, CheckerStatisticsReport, ParseLinks, AlertService, paginationConstants, pagingParams, UIFormAccess, $filter) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerLargePage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        vm.exportLink = '';
        vm.UIFormAccess = UIFormAccess;

        vm.dateFilterData = {
                search: search,
                pagingParams: pagingParams,
                initCallBack: loadAll
        };

        vm.reportClean = [];
        vm.report = [];
        vm.mainIdColumn = 'nameId';
        vm.mainColumn = 'employeeName';
        vm.totalData = {
                checksCount: 1,
        };
        vm.diagramOptions = {
                chart: {
                    type: 'pieChart',
                    height: 500,
                    x: function(d){if(d[vm.mainIdColumn] != -1) return d.employeeName + " (" + Math.round(d.checksCount*100/vm.totalData.checksCount) + "%)";},
                    y: function(d){if(d[vm.mainIdColumn] != -1) return d.checksCount;},
                    showLabels: false,
                    showValues: true,
                    duration: 500,
                    legendPosition: 'top',
                    labelThreshold: 0.01
                    //labelSunbeamLayout: true,
                }
        };

        function makeLink() {
            var sortResult = vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc');
            vm.exportLink = "sort=" + sortResult
                    + (vm.dateFilterData.dateFilterType == 'all' ? '' : '&startDate=' + $filter('date')(vm.dateFilterData.startDate, "yyyy-MM-dd", 0))
                    + (vm.dateFilterData.dateFilterType == 'all' ? '' : '&endDate=' + $filter('date')(vm.dateFilterData.endDate, "yyyy-MM-dd", 0))
                    + (vm.division == null || vm.division.id == null ? '' : '&divisionId=' + vm.division.id);
        }
        makeLink();

        function loadAll () {
            makeLink();
            CheckerStatisticsReport.query({
                query: pagingParams.search,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                // search with time limits
                startDate: vm.dateFilterData.dateFilterType == 'all' ? null : $filter('date')(vm.dateFilterData.startDate, "yyyy-MM-dd", 0),
                endDate: vm.dateFilterData.dateFilterType == 'all' ? null : $filter('date')(vm.dateFilterData.endDate, "yyyy-MM-dd", 0)
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.report = data;
                vm.minData = {};
                vm.maxData = {};
                getMinMax(vm.minData, vm.maxData, data);
                for(var i = 0 ; i < vm.report.length ; i++ ) {
                    if(vm.report[i][vm.mainIdColumn] == -1) {
                        vm.totalData = vm.report[i];
                        break;
                    }
                }
            }
            function onError(error) {
                var headers = Object.keys(error.headers()).filter(function (header) {
                    return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var alertKey = error.headers(headers[0]);
                if (angular.isString(alertKey)) {
                    AlertService.warning(alertKey, { param : error.headers(headers[1])});
                }
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            vm.dateFilterData.updateDateFilterType();
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                // search with time limits
                searchType: vm.dateFilterData.dateFilterType,
                startDate: vm.dateFilterData.dateFilterType == 'day' || vm.dateFilterData.dateFilterType == 'range' ? $filter('date')(vm.dateFilterData.startDate, "yyyy-MM-dd", 0) : null,
                endDate: vm.dateFilterData.dateFilterType == 'day' || vm.dateFilterData.dateFilterType == 'range' ? $filter('date')(vm.dateFilterData.endDate, "yyyy-MM-dd", 0) : null
            });
        }

        function search(searchQuery) {
            if (!searchQuery && vm.dateFilterData.dateFilterType == 'all') {
                return vm.clear();
            } else if(!searchQuery) {
                vm.currentSearch = null;
            } else {
                vm.predicate = 'employeeName';
                vm.reverse = false;
                vm.currentSearch = searchQuery;
            }
            vm.links = null;
            vm.page = 1;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'employeeName';
            vm.reverse = false;
            vm.currentSearch = null;
            vm.dateFilterData.setFilterType('all');
            vm.transition();
        }

        // Main columns list
        vm.columns = [
            'employeeName',
            'talksDuration',
            'checksCount'
        ];
        vm.columnsFilter = {};
        vm.columnsFilter['talksDuration'] = 'HHHMM';
        // Paired columns
        vm.addcolumns = [];
        // Highlighting columns by min/max
        vm.columnsMinMax = [
            'talksDuration',
            'checksCount'
        ];
        // Inverse min/max on next columns.
        vm.inverseColumns = {};

        function getMinMax(min, max, rows) {
            var val = 0;
            var totalChecksCount = 0;
            var totalTalkDuration = 0;
            vm.reportClean = [];
            for(var i = 0 ; i < rows.length ; i++ ) {
                var row = rows[i];
                // Prepare for total counting
                row[vm.mainIdColumn] = 1;
                totalChecksCount += row['checksCount'];
                totalTalkDuration += row['talksDuration'];
                if(row[vm.mainIdColumn] == -1) continue;
                vm.reportClean.push(row);
                if(val == 0) {
                    val = 1;
                    vm.columnsMinMax.forEach(function(name){
                        min[name] = row[name];
                        max[name] = row[name];
                    });
                    continue;
                }
                vm.columnsMinMax.forEach(function(name) {
                    if(row[name] !== null) {
                        if(max[name] === null) max[name] = row[name];
                        if(min[name] === null) min[name] = row[name];
                        if(vm.inverseColumns[name] === 1) {
                            if(max[name] > row[name]) max[name] = row[name];
                            if(min[name] < row[name]) min[name] = row[name];
                        } else {
                            if(max[name] < row[name]) max[name] = row[name];
                            if(min[name] > row[name]) min[name] = row[name];
                        }
                    }
                });
            }
            rows.push({employeeName: 'ИТОГО', nameId: -1, 'checksCount': totalChecksCount, 'talksDuration': totalTalkDuration});
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('advertising-source-financial-report', {
            parent: 'report',
            url: '/advertising-source-financial-report?page&sort&search&searchType&startDate&endDate&insignificantFilter',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR', 'ROLE_MANAGER', 'ROLE_CHECKER'],
                pageTitle: 'telestatApp.advertisingSourcesFinancialReport.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reports/advertising-source-financial-report/advertising-source-financial-report.html',
                    controller: 'AdvertisingSourceFinancialReportController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'advertisingSourceName,asc',
                    squash: true
                },
                searchType: {
                    value: 'lastmonth',
                    squash: true
                },
                startDate: null,
                endDate: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        searchType: $stateParams.searchType,
                        startDate: $stateParams.startDate,
                        endDate: $stateParams.endDate,
                        insignificantFilter: $stateParams.insignificantFilter
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reports');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('datefilter');
                    return $translate.refresh();
                }]
            }
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('AdvertisingSourceFinancialReport', AdvertisingSourceFinancialReport);

    AdvertisingSourceFinancialReport.$inject = ['$resource'];

    function AdvertisingSourceFinancialReport ($resource) {
        var resourceUrl =  'api/report/advertising-source-financial/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('AdvertisingSourceFinancialReportController', AdvertisingSourceFinancialReportController);

    AdvertisingSourceFinancialReportController.$inject = ['$scope', '$state', 'AdvertisingSourceFinancialReport', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'UIFormAccess', '$filter', '$translate'];

    function AdvertisingSourceFinancialReportController ($scope, $state, AdvertisingSourceFinancialReport, ParseLinks, AlertService, paginationConstants, pagingParams, UIFormAccess, $filter, $translate) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerLargePage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        vm.exportLink = '';
        vm.UIFormAccess = UIFormAccess;

        vm.dateFilterData = {
                search: search,
                pagingParams: pagingParams,
                initCallBack: loadAll
        };

        vm.reportCleanForBarChart = [];
        vm.reportCleanForMultiBarChart = [];
        vm.report = [];
        vm.mainIdColumn = 'nameId';
        vm.mainColumn = 'advertisingSourceName';
        vm.totalData = {
                uniqueLeadCount: 1,
                targetedCount: 1,
                missedCount: 1,
                productCount: 1
        };
        vm.diagram3 = {
                chart: {
                    type: 'multiBarHorizontalChart',
                    height: 300,
                    showXAxis: true,
                    showYAxis: true,
                    duration: 500,
                    margin : {
                        top: 0,
                        right: 60,
                        bottom: 20,
                        left: 120
                    },
                    showLegend: true,
                    showValues: true,
                    stacked: true,
                    showControls: true,
                    controlLabels: {
                        grouped: 'Отдельно',
                        stacked: 'Суммировать'
                    }
                }
        };
        vm.diagram4 = {
                chart: {
                    type: 'multiBarHorizontalChart',
                    height: 300,
                    showXAxis: true,
                    showYAxis: true,
                    duration: 500,
                    margin : {
                        top: 0,
                        right: 60,
                        bottom: 20,
                        left: 120
                    },
                    showLegend: true,
                    showValues: true,
                    stacked: false,
                    showControls: false
                }
        };

        function makeLink() {
            var sortResult = vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc');
            vm.exportLink = "sort=" + sortResult
                    + (vm.dateFilterData.dateFilterType == 'all' ? '' : '&startDate=' + $filter('date')(vm.dateFilterData.startDate, "yyyy-MM-dd", 0))
                    + (vm.dateFilterData.dateFilterType == 'all' ? '' : '&endDate=' + $filter('date')(vm.dateFilterData.endDate, "yyyy-MM-dd", 0))
                    + (vm.division == null || vm.division.id == null ? '' : '&divisionId=' + vm.division.id);
        }
        makeLink();

        function loadAll () {
            makeLink();
            AdvertisingSourceFinancialReport.query({
                query: pagingParams.search,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                // search with time limits
                startDate: vm.dateFilterData.dateFilterType == 'all' ? null : $filter('date')(vm.dateFilterData.startDate, "yyyy-MM-dd", 0),
                endDate: vm.dateFilterData.dateFilterType == 'all' ? null : $filter('date')(vm.dateFilterData.endDate, "yyyy-MM-dd", 0)
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.report = data;
                vm.minData = {};
                vm.maxData = {};
                getMinMax(vm.minData, vm.maxData, data);
                for(var i = 0 ; i < vm.report.length ; i++ ) {
                    if(vm.report[i][vm.mainIdColumn] == -1) {
                        vm.totalData = vm.report[i];
                        break;
                    }
                }
            }
            function onError(error) {
                var headers = Object.keys(error.headers()).filter(function (header) {
                    return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var alertKey = error.headers(headers[0]);
                if (angular.isString(alertKey)) {
                    AlertService.warning(alertKey, { param : error.headers(headers[1])});
                }
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            vm.dateFilterData.updateDateFilterType();
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                // search with time limits
                searchType: vm.dateFilterData.dateFilterType,
                startDate: vm.dateFilterData.dateFilterType == 'day' || vm.dateFilterData.dateFilterType == 'range' ? $filter('date')(vm.dateFilterData.startDate, "yyyy-MM-dd", 0) : null,
                endDate: vm.dateFilterData.dateFilterType == 'day' || vm.dateFilterData.dateFilterType == 'range' ? $filter('date')(vm.dateFilterData.endDate, "yyyy-MM-dd", 0) : null
            });
        }

        function search(searchQuery) {
            if (!searchQuery && vm.dateFilterData.dateFilterType == 'all') {
                return vm.clear();
            } else if(!searchQuery) {
                vm.currentSearch = null;
            } else {
                vm.predicate = 'callTime';
                vm.reverse = false;
                vm.currentSearch = searchQuery;
            }
            vm.links = null;
            vm.page = 1;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'callTime';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.dateFilterData.setFilterType('all');
            vm.transition();
        }

        // Main columns list
        vm.columns = [
            'advertisingSourceName',
            'budget',
            'callsCount',
            'callPrice',
            'uniqueLeadCount',
            'contactPrice',
            'targetedCount',
            'targetedPrice',
            'productCount',
            'productPrice',
            'avgServiceQuality',
            'losses'
        ];
        // Paired columns
        vm.addcolumns = [];
        vm.addcolumns['losses'] = 'lossesPercent';
        // Highlighting columns by min/max
        vm.columnsMinMax = [
            'budget','callsCount',
            'callPrice','uniqueLeadCount',
            'contactPrice','targetedCount',
            'targetedPrice','productCount',
            'productPrice', 'avgServiceQuality',
            'lossesPercent'
        ];
        // Inverse min/max on next columns.
        vm.inverseColumns = {'budget':1, 'productPrice':1,
                'targetedPrice':1, 'contactPrice':1,
                'callPrice':1, 'lossesPercent': 1};

        function getMinMax(min, max, rows) {
            var val = 0;
            var reportCleanForMultiBarChartSort = [];
            for(var i = 0 ; i < rows.length ; i++ ) {
                var row = rows[i];
                if(row[vm.mainIdColumn] == -1) continue;
                reportCleanForMultiBarChartSort.push(row);
                if(val == 0) {
                    val = 1;
                    vm.columnsMinMax.forEach(function(name){
                        min[name] = row[name];
                        max[name] = row[name];
                    });
                    continue;
                }
                vm.columnsMinMax.forEach(function(name) {
                    if(row[name] !== null) {
                        if(max[name] === null) max[name] = row[name];
                        if(min[name] === null) min[name] = row[name];
                        if(vm.inverseColumns[name] === 1) {
                            if(max[name] > row[name]) max[name] = row[name];
                            if(min[name] < row[name]) min[name] = row[name];
                        } else {
                            if(max[name] < row[name]) max[name] = row[name];
                            if(min[name] > row[name]) min[name] = row[name];
                        }
                    }
                });
            }
            // % Потерь
            reportCleanForMultiBarChartSort.sort(
                    function (a, b) {
                        return a.lossesPercent - b.lossesPercent;
                    }
            );
            vm.reportCleanForBarChart = [];
            for(var i = 0 ; i < reportCleanForMultiBarChartSort.length ; i++ ) {
                var row = reportCleanForMultiBarChartSort[i];
                vm.reportCleanForBarChart.push({key: row[vm.mainColumn], values: [{x:row[vm.mainColumn],y:row['lossesPercent']}]});
            }
            // Цена звонка, ₽ / Цена контакта, ₽ / Цена продуктивн., ₽
            reportCleanForMultiBarChartSort.sort(
                    function (a, b) {
                        return (a.callPrice+a.contactPrice+a.productPrice)-(b.callPrice+b.contactPrice+b.productPrice);
                    }
            );
            vm.reportCleanForMultiBarChart = [];
            vm.reportCleanForMultiBarChart.push({key: $translate.instant('telestatApp.reportsCommon.tablesHeaders.callPrice'), values: []});
            vm.reportCleanForMultiBarChart.push({key: $translate.instant('telestatApp.reportsCommon.tablesHeaders.contactPrice'), values: []});
            vm.reportCleanForMultiBarChart.push({key: $translate.instant('telestatApp.reportsCommon.tablesHeaders.productPrice'), values: []});
            for(var i=0;i<reportCleanForMultiBarChartSort.length;i++) {
                var row = reportCleanForMultiBarChartSort[i];
                vm.reportCleanForMultiBarChart[0].values.push({x:row[vm.mainColumn],y:row['callPrice']});
                vm.reportCleanForMultiBarChart[1].values.push({x:row[vm.mainColumn],y:row['contactPrice']});
                vm.reportCleanForMultiBarChart[2].values.push({x:row[vm.mainColumn],y:row['productPrice']});
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('advertising-source-conversion-report', {
            parent: 'report',
            url: '/advertising-source-conversion-report?page&sort&search&searchType&startDate&endDate&divisionId',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR', 'ROLE_MANAGER', 'ROLE_CHECKER'],
                pageTitle: 'telestatApp.advertisingSourcesConversionReport.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reports/advertising-source-conversion-report/advertising-source-conversion-report.html',
                    controller: 'AdvertisingSourceConversionReportController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'advertisingSourceName,desc',
                    squash: true
                },
                searchType: {
                    value: 'lastmonth',
                    squash: true
                },
                startDate: null,
                endDate: null,
                divisionId: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        searchType: $stateParams.searchType,
                        startDate: $stateParams.startDate,
                        endDate: $stateParams.endDate,
                        divisionId: $stateParams.divisionId
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reports');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('datefilter');
                    return $translate.refresh();
                }]
            }
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('AdvertisingSourceConversionReport', AdvertisingSourceConversionReport);

    AdvertisingSourceConversionReport.$inject = ['$resource'];

    function AdvertisingSourceConversionReport ($resource) {
        var resourceUrl =  'api/report/advertising-source-conversion/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
	'use strict';

	angular.module('telestatApp').controller(
			'AdvertisingSourceConversionReportController',
			AdvertisingSourceConversionReportController);

	AdvertisingSourceConversionReportController.$inject = [ '$scope', '$state',
			'$sce', '$translate', 'AdvertisingSourceConversionReport',
			'Division', 'ParseLinks', 'AlertService', 'paginationConstants',
			'pagingParams', 'UIFormAccess', '$filter' ];

	function AdvertisingSourceConversionReportController($scope, $state, $sce,
			$translate, AdvertisingSourceConversionReport, Division,
			ParseLinks, AlertService, paginationConstants, pagingParams,
			UIFormAccess, $filter) {
		var vm = this;

		vm.loadPage = loadPage;
		vm.predicate = pagingParams.predicate;
		vm.reverse = pagingParams.ascending;
		vm.transition = transition;
		vm.itemsPerPage = paginationConstants.itemsPerLargePage;
		vm.clear = clear;
		vm.search = search;
		vm.loadAll = loadAll;
		vm.searchQuery = pagingParams.search;
		vm.currentSearch = pagingParams.search;

		vm.division = {
			id : pagingParams.divisionId
		};

		var allDivisionsTranslate = $translate
				.instant('telestatApp.reportsCommon.allDivisions');
		vm.divisions = [ {
			id : null,
			actual : 1,
			title : allDivisionsTranslate
		} ];
		Division.getforselect({}, function(data) {
			var divTree = makeFlatDivisionList(data, 0);
			vm.divisions = vm.divisions.concat(divTree);
		});

		vm.exportLink = '';
		vm.UIFormAccess = UIFormAccess;

		vm.dateFilterData = {
			search : search,
			pagingParams : pagingParams,
			initCallBack : loadAll
		};

		vm.reportClean = [];
		vm.report = [];
		vm.mainIdColumn = 'nameId';
		vm.mainColumn = 'advertisingSourceName';
		vm.totalData = {
			uniqueLeadCount : 1,
			targetedCount : 1,
			missedCount : 1,
			productCount : 1
		};
		vm.diagramOptions = {
			chart : {
				type : 'pieChart',
				height : 300,
				x : function(d) {
					if (d[vm.mainIdColumn] != null)
						return d[vm.mainColumn]
								+ " ("
								+ Math.round(d.uniqueLeadCount * 100
										/ vm.totalData.uniqueLeadCount) + "%)";
				},
				y : function(d) {
					if (d[vm.mainIdColumn] != null)
						return d.uniqueLeadCount;
				},
				showLabels : false,
				showValues : true,
				duration : 500,
				legendPosition : 'top',
				labelThreshold : 0.01
			// labelSunbeamLayout: true,
			}
		};
		vm.diagramOptionsTarg = {
			chart : {
				type : 'pieChart',
				height : 300,
				x : function(d) {
					if (d[vm.mainIdColumn] != null)
						return d[vm.mainColumn]
								+ " ("
								+ Math.round(d.targetedCount * 100
										/ vm.totalData.targetedCount) + "%)";
				},
				y : function(d) {
					if (d[vm.mainIdColumn] != null)
						return d.targetedCount;
				},
				showLabels : false,
				showValues : true,
				duration : 500,
				legendPosition : 'top',
				labelThreshold : 0.01
			// labelSunbeamLayout: true,
			}
		};
		vm.diagramOptionsMissed = {
			chart : {
				type : 'pieChart',
				height : 300,
				x : function(d) {
					if (d[vm.mainIdColumn] != null)
						return d[vm.mainColumn]
								+ " ("
								+ Math.round(d.missedCount * 100
										/ vm.totalData.missedCount) + "%)";
				},
				y : function(d) {
					if (d[vm.mainIdColumn] != null)
						return d.missedCount;
				},
				showLabels : false,
				showValues : true,
				duration : 500,
				legendPosition : 'top',
				labelThreshold : 0.01
			// labelSunbeamLayout: true,
			}
		};
		vm.diagramOptionsProd = {
			chart : {
				type : 'pieChart',
				height : 300,
				x : function(d) {
					if (d[vm.mainIdColumn] != null)
						return d[vm.mainColumn]
								+ " ("
								+ Math.round(d.productCount * 100
										/ vm.totalData.productCount) + "%)";
				},
				y : function(d) {
					if (d[vm.mainIdColumn] != null)
						return d.productCount;
				},
				showLabels : false,
				showValues : true,
				duration : 500,
				legendPosition : 'top',
				labelThreshold : 0.01
			// labelSunbeamLayout: true,
			}
		};

		function makeLink() {
			var sortResult = vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc');
			vm.exportLink = "sort="
					+ sortResult
					+ (vm.dateFilterData.dateFilterType == 'all' ? ''
							: '&startDate='
									+ $filter('date')(
											vm.dateFilterData.startDate,
											"yyyy-MM-dd", 0))
					+ (vm.dateFilterData.dateFilterType == 'all' ? ''
							: '&endDate='
									+ $filter('date')(
											vm.dateFilterData.endDate,
											"yyyy-MM-dd", 0))
					+ (vm.division == null || vm.division.id == null ? ''
							: '&divisionId=' + vm.division.id);
		}
		makeLink();

		function loadAll() {
			makeLink();
			AdvertisingSourceConversionReport.query({
				query : pagingParams.search,
				page : pagingParams.page - 1,
				size : vm.itemsPerPage,
				sort : sort(),
				// search with time limits
				startDate : vm.dateFilterData.dateFilterType == 'all' ? null
						: $filter('date')(vm.dateFilterData.startDate,
								"yyyy-MM-dd", 0),
				endDate : vm.dateFilterData.dateFilterType == 'all' ? null
						: $filter('date')(vm.dateFilterData.endDate,
								"yyyy-MM-dd", 0),
				divisionId : vm.division == null ? null : vm.division.id
			}, onSuccess, onError);

			function sort() {
				var result = [ vm.predicate + ','
						+ (vm.reverse ? 'asc' : 'desc') ];
				if (vm.predicate !== 'id') {
					result.push('id');
				}
				return result;
			}
			function onSuccess(data, headers) {
				vm.report = data;
				vm.minData = {};
				vm.maxData = {};
				getMinMax(vm.minData, vm.maxData, data);
				for (var i = 0; i < vm.report.length; i++) {
					if (vm.report[i][vm.mainIdColumn] == -1) {
						vm.totalData = vm.report[i];
						break;
					}
				}
				postMinMax();
			}
			function onError(error) {
				var headers = Object
						.keys(error.headers())
						.filter(
								function(header) {
									return header.indexOf('app-alert',
											header.length - 'app-alert'.length) !== -1
											|| header
													.indexOf(
															'app-params',
															header.length
																	- 'app-params'.length) !== -1;
								}).sort();
				var alertKey = error.headers(headers[0]);
				if (angular.isString(alertKey)) {
					AlertService.warning(alertKey, {
						param : error.headers(headers[1])
					});
				}
			}
		}

		function loadPage(page) {
			vm.page = page;
			vm.transition();
		}

		function transition() {

			vm.dateFilterData.updateDateFilterType();
			$state
					.transitionTo(
							$state.$current,
							{
								page : vm.page,
								sort : vm.predicate + ','
										+ (vm.reverse ? 'asc' : 'desc'),
								search : vm.currentSearch,
								// search with time limits
								searchType : vm.dateFilterData.dateFilterType,
								startDate : vm.dateFilterData.dateFilterType == 'day'
										|| vm.dateFilterData.dateFilterType == 'range' ? $filter(
										'date')(vm.dateFilterData.startDate,
										"yyyy-MM-dd", 0)
										: null,
								endDate : vm.dateFilterData.dateFilterType == 'day'
										|| vm.dateFilterData.dateFilterType == 'range' ? $filter(
										'date')(vm.dateFilterData.endDate,
										"yyyy-MM-dd", 0)
										: null,
								divisionId : vm.division == null ? null
										: vm.division.id
							});
		}

		function search(searchQuery) {
			if (!searchQuery && vm.dateFilterData.dateFilterType == 'all') {
				return vm.clear();
			} else if (!searchQuery) {
				vm.currentSearch = null;
			} else {
				vm.predicate = 'advertisingSourceName';
				vm.reverse = false;
				vm.currentSearch = searchQuery;
			}
			vm.links = null;
			vm.page = 1;
			vm.transition();
		}

		function clear() {
			vm.links = null;
			vm.page = 1;
			vm.predicate = 'advertisingSourceName';
			vm.reverse = false;
			vm.currentSearch = null;
			vm.dateFilterData.setFilterType('all');
			vm.transition();
		}

		// Main columns list
		vm.columns = [ 'advertisingSourceName', 'callsCount',
				'uniqueLeadCount', 'undefCount', 'insignifCount',
				'targetedCount', 'missedCount', 'uselessCount', 'productCount',
				'avgTalkQuality', 'avgServiceQuality' ];
		// Paired columns
		vm.addcolumns = [];
		vm.addcolumns['uniqueLeadCount'] = 'uniqueLeadPercent';
		vm.addcolumns['undefCount'] = 'undefPercent';
		vm.addcolumns['insignifCount'] = 'insignifPercent';
		vm.addcolumns['targetedCount'] = 'targetedPercent';
		vm.addcolumns['missedCount'] = 'missedPercent';
		vm.addcolumns['uselessCount'] = 'uselessPercent';
		vm.addcolumns['productCount'] = 'productPercent';
		// Percent columns value for css
		vm.pColumn = [];
		vm.pColumn['uniqueLeadCount'] = 'uniqueLeadPercent';
		vm.pColumn['undefCount'] = 'undefPercent';
		vm.pColumn['insignifCount'] = 'insignifPercent';
		vm.pColumn['targetedCount'] = 'targetedPercent';
		vm.pColumn['missedCount'] = 'missedPercent';
		vm.pColumn['uselessCount'] = 'uselessPercent';
		vm.pColumn['productCount'] = 'productPercent';
		vm.pColumn['avgTalkQuality'] = 'avgTalkQuality';
		vm.pColumn['avgServiceQuality'] = 'avgServiceQuality';
		vm.pColumn['callsCount'] = 'callsCountP';// Special column name

		// Highlighting columns by min/max
		vm.columnsMinMax = [ 'callsCount', 'uniqueLeadCount', 'undefCount',
				'undefPercent', 'insignifCount', 'insignifPercent',
				'targetedCount', 'targetedPercent', 'missedCount',
				'missedPercent', 'uselessCount', 'uselessPercent',
				'productCount', 'productPercent', 'uniqueLeadPercent',
				'avgTalkQuality', 'avgServiceQuality' ];
		// Inverse min/max on next columns.
		vm.inverseColumns = {
			'undefCount' : 1,
			'undefPercent' : 1,
			'insignifCount' : 1,
			'insignifPercent' : 1,
			'uselessCount' : 1,
			'uselessPercent' : 1,
			'missedCount' : 1,
			'missedPercent' : 1
		};

		function getMinMax(min, max, rows) {
			var val = 0;
			vm.reportClean = [];
			for (var i = 0; i < rows.length; i++) {
				var row = rows[i];
				if (row[vm.mainIdColumn] == -1)
					continue;
				vm.reportClean.push(row);
				if (val == 0) {
					val = 1;
					vm.columnsMinMax.forEach(function(name) {
						min[name] = row[name];
						max[name] = row[name];
					});
					continue;
				}
				vm.columnsMinMax.forEach(function(name) {
					if (row[name] !== null) {
						if (max[name] === null)
							max[name] = row[name];
						if (min[name] === null)
							min[name] = row[name];
						if (vm.inverseColumns[name] === 1) {
							if (max[name] > row[name])
								max[name] = row[name];
							if (min[name] < row[name])
								min[name] = row[name];
						} else {
							if (max[name] < row[name])
								max[name] = row[name];
							if (min[name] > row[name])
								min[name] = row[name];
						}
					}
				});
			}
		}
		function postMinMax() {
			for (var i = 0; i < vm.report.length; i++) {
				var row = vm.report[i];
				row['callsCountP'] = row['callsCount'] * 100
						/ vm.maxData['callsCount'];
			}
		}

		function makeFlatDivisionList(data, level) {
			var divFlatListArr = [];
			for (var i = 0; i < data.length; i++) {
				divFlatListArr.push({
					id : data[i].id,
					actual : true,
					title : ' - '.repeat(level) + data[i].title
				});

				if (data[i].divisions !== undefined
						&& data[i].divisions.length > 0) {
					var t = makeFlatDivisionList(data[i].divisions, level + 1);
					divFlatListArr = divFlatListArr.concat(t);
				}
			}
			return divFlatListArr;
		}

	}
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService'];

    function NavbarController ($state, Auth, Principal, ProfileService, LoginService) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;
        vm.unlockKayanReports = false;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
            if (response.kayanProfile) {
                vm.unlockKayanReports = true;
            }
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('HomeTest', HomeTest);

    HomeTest.$inject = ['$resource'];

    function HomeTest ($resource) {
        var resourceUrl =  'api/advertising-test';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data, headersGetter, status) {
                    if (data && status != 502) {
                        data = angular.fromJson(data);
                    } else {
                        data = {data: '', status: status};
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('HomeController', HomeController);

/* Added 'ProfileService', 'HomeTest'
    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state'];

    function HomeController ($scope, Principal, LoginService, $state) {
*/
    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state', 'ProfileService', 'HomeTest'];
    
    function HomeController ($scope, Principal, LoginService, $state, ProfileService, HomeTest) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        vm.firmProfile = 'default';
        
        vm.testResult = 'unk';
        HomeTest.get({},testOk,testFail);
        function testOk() {
        	vm.testResult = 'ok';
        }
        function testFail(res) {
            if (res.status === 0 || res.status === -1) {
                vm.testResult = 'fail';
            } else if (res.status === 502) {
                vm.testResult = 'offline';
            }
            
        }
        
        
        ProfileService.getProfileInfo().then(function(response) {
            if (response.kayanProfile) {
                vm.firmProfile = 'kayan';
            }
        });
        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('VirtualNumberDialogController', VirtualNumberDialogController);

    VirtualNumberDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'VirtualNumber', 'CloudPBX'];

    function VirtualNumberDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, VirtualNumber, CloudPBX) {
        var vm = this;

        vm.virtualNumber = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.cloudpbxes = CloudPBX.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.virtualNumber.id !== null) {
                VirtualNumber.update(vm.virtualNumber, onSaveSuccess, onSaveError);
            } else {
                VirtualNumber.save(vm.virtualNumber, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('telestatApp:virtualNumberUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.lastActionTime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('VirtualNumberDetailController', VirtualNumberDetailController);

    VirtualNumberDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'VirtualNumber', 'CloudPBX'];

    function VirtualNumberDetailController($scope, $rootScope, $stateParams, previousState, entity, VirtualNumber, CloudPBX) {
        var vm = this;

        vm.virtualNumber = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('telestatApp:virtualNumberUpdate', function(event, result) {
            vm.virtualNumber = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('VirtualNumberDeleteController',VirtualNumberDeleteController);

    VirtualNumberDeleteController.$inject = ['$uibModalInstance', 'entity', 'VirtualNumber'];

    function VirtualNumberDeleteController($uibModalInstance, entity, VirtualNumber) {
        var vm = this;

        vm.virtualNumber = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            VirtualNumber.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('virtual-number', {
            /*
            parent: 'entity',
            */
            parent: 'dictionary',
            url: '/virtual-number?page&sort&search',
            data: {
                /*
                authorities: ['ROLE_USER'],
                */
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_DIRECTOR'],
                pageTitle: 'telestatApp.virtualNumber.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/virtual-number/virtual-numbers.html',
                    controller: 'VirtualNumberController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('virtualNumber');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('virtual-number-detail', {
            parent: 'virtual-number',
            url: '/virtual-number/{id}',
            data: {
                /*
                authorities: ['ROLE_USER'],
                */
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_DIRECTOR'],
                pageTitle: 'telestatApp.virtualNumber.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/virtual-number/virtual-number-detail.html',
                    controller: 'VirtualNumberDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('virtualNumber');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'VirtualNumber', function($stateParams, VirtualNumber) {
                    return VirtualNumber.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'virtual-number',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('virtual-number-detail.edit', {
            parent: 'virtual-number-detail',
            url: '/detail/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/virtual-number/virtual-number-dialog.html',
                    controller: 'VirtualNumberDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['VirtualNumber', function(VirtualNumber) {
                            return VirtualNumber.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('virtual-number.new', {
            parent: 'virtual-number',
            url: '/new',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/virtual-number/virtual-number-dialog.html',
                    controller: 'VirtualNumberDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                locked: false,
                                number: null,
                                source: null,
                                lastActionTime: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('virtual-number', null, { reload: 'virtual-number' });
                }, function() {
                    $state.go('virtual-number');
                });
            }]
        })
        .state('virtual-number.edit', {
            parent: 'virtual-number',
            url: '/{id}/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/virtual-number/virtual-number-dialog.html',
                    controller: 'VirtualNumberDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['VirtualNumber', function(VirtualNumber) {
                            return VirtualNumber.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('virtual-number', null, { reload: 'virtual-number' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('virtual-number.delete', {
            parent: 'virtual-number',
            url: '/{id}/delete',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/virtual-number/virtual-number-delete-dialog.html',
                    controller: 'VirtualNumberDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['VirtualNumber', function(VirtualNumber) {
                            return VirtualNumber.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('virtual-number', null, { reload: 'virtual-number' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('VirtualNumber', VirtualNumber);

    VirtualNumber.$inject = ['$resource', 'DateUtils'];

    function VirtualNumber ($resource, DateUtils) {
        var resourceUrl =  'api/virtual-numbers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.lastActionTime = DateUtils.convertDateTimeFromServer(data.lastActionTime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('VirtualNumberSearch', VirtualNumberSearch);

    VirtualNumberSearch.$inject = ['$resource'];

    function VirtualNumberSearch($resource) {
        var resourceUrl =  'api/_search/virtual-numbers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('VirtualNumberController', VirtualNumberController);

    VirtualNumberController.$inject = ['$state', 'VirtualNumber', 'VirtualNumberSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function VirtualNumberController($state, VirtualNumber, VirtualNumberSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = 10;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.activate = activate;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                VirtualNumberSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                VirtualNumber.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                data.forEach(function(a){
                    a.disabledInList = a.locked == false || (a.locked == true && a.source != '' && a.source != null && a.source != undefined);
                });
                vm.virtualNumbers = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function activate(vn) {
            vn.locked = false;
            vn.disabledInList = true;
            VirtualNumber.update(vn, onSuccess, onError);
            function onSuccess(data, headers) {
                loadAll();
            }
            function onError(error) {
                vn.locked = true;
                AlertService.error(error.data.message);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('SimPhoneDialogController', SimPhoneDialogController);

    SimPhoneDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SimPhone', 'CloudPBX'];

    function SimPhoneDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SimPhone, CloudPBX) {
        var vm = this;

        vm.simPhone = entity;
        vm.clear = clear;
        vm.save = save;
        vm.cloudpbxes = CloudPBX.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.simPhone.id !== null) {
                SimPhone.update(vm.simPhone, onSaveSuccess, onSaveError);
            } else {
                SimPhone.save(vm.simPhone, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('telestatApp:simPhoneUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('SimPhoneDetailController', SimPhoneDetailController);

    /* Added UIFormAccess, EmployeePhoneSearch
    SimPhoneDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SimPhone', 'CloudPBX'];

    function SimPhoneDetailController($scope, $rootScope, $stateParams, previousState, entity, SimPhone, CloudPBX) {
    */
    SimPhoneDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SimPhone', 'CloudPBX', 'UIFormAccess', 'EmployeePhoneSearch'];

    function SimPhoneDetailController($scope, $rootScope, $stateParams, previousState, entity, SimPhone, CloudPBX, UIFormAccess, EmployeePhoneSearch) {
        var vm = this;

        vm.simPhone = entity;
        vm.previousState = previousState.name;
        vm.UIFormAccess = UIFormAccess;
        vm.employeePhones = [];

        vm.employees = EmployeePhoneSearch.query({query: vm.simPhone.number, actual: false}, onSuccess, onError);
        function onSuccess(data, headers) {
            vm.employeePhones = data;
        }
        function onError(error) {
            AlertService.error(error.data.message);
        }

        var unsubscribe = $rootScope.$on('telestatApp:simPhoneUpdate', function(event, result) {
            vm.simPhone = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('SimPhoneDeleteController',SimPhoneDeleteController);

    SimPhoneDeleteController.$inject = ['$uibModalInstance', 'entity', 'SimPhone'];

    function SimPhoneDeleteController($uibModalInstance, entity, SimPhone) {
        var vm = this;

        vm.simPhone = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SimPhone.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('sim-phone', {
            /*
            parent: 'entity',
            url: '/sim-phone?page&sort&search',
            */
            parent: 'dictionary',
            url: '/sim-phone?page&sort&search&actualFilter',
            data: {
                /*
                authorities: ['ROLE_USER'],
                */
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_DIRECTOR'],
                pageTitle: 'telestatApp.simPhone.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sim-phone/sim-phones.html',
                    controller: 'SimPhoneController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                actualFilter: {
                    value: 'true',
                    squash: true
                },
                sort: {
                    /*
                    value: 'id,asc',
                    */
                    value: 'number,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        actualFilter: $stateParams.actualFilter,
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('simPhone');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('sim-phone-detail', {
            parent: 'sim-phone',
            url: '/sim-phone/{id}',
            data: {
                /*
                authorities: ['ROLE_USER'],
                */
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_DIRECTOR'],
                pageTitle: 'telestatApp.simPhone.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sim-phone/sim-phone-detail.html',
                    controller: 'SimPhoneDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('simPhone');
                    // additional translations
                    $translatePartialLoader.addPart('employee');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SimPhone', function($stateParams, SimPhone) {
                    return SimPhone.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'sim-phone',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('sim-phone-detail.edit', {
            parent: 'sim-phone-detail',
            url: '/detail/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sim-phone/sim-phone-dialog.html',
                    controller: 'SimPhoneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SimPhone', function(SimPhone) {
                            return SimPhone.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('sim-phone.new', {
            parent: 'sim-phone',
            url: '/new',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sim-phone/sim-phone-dialog.html',
                    controller: 'SimPhoneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                number: null,
                                /*
                                actual: false,
                                */
                                actual: true,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('sim-phone', null, { reload: 'sim-phone' });
                }, function() {
                    $state.go('sim-phone');
                });
            }]
        })
        .state('sim-phone.edit', {
            parent: 'sim-phone',
            url: '/{id}/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sim-phone/sim-phone-dialog.html',
                    controller: 'SimPhoneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SimPhone', function(SimPhone) {
                            return SimPhone.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('sim-phone', null, { reload: 'sim-phone' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('sim-phone.delete', {
            parent: 'sim-phone',
            url: '/{id}/delete',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sim-phone/sim-phone-delete-dialog.html',
                    controller: 'SimPhoneDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SimPhone', function(SimPhone) {
                            return SimPhone.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('sim-phone', null, { reload: 'sim-phone' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('SimPhone', SimPhone);

    SimPhone.$inject = ['$resource'];

    function SimPhone ($resource) {
        var resourceUrl =  'api/sim-phones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('SimPhoneSearch', SimPhoneSearch);

    SimPhoneSearch.$inject = ['$resource'];

    function SimPhoneSearch($resource) {
        var resourceUrl =  'api/_search/sim-phones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('SimPhoneController', SimPhoneController);

    /* Added UIFormAccess
    SimPhoneController.$inject = ['$state', 'SimPhone', 'SimPhoneSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function SimPhoneController($state, SimPhone, SimPhoneSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {
    */
    SimPhoneController.$inject = ['$state', 'SimPhone', 'SimPhoneSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'UIFormAccess'];

    function SimPhoneController($state, SimPhone, SimPhoneSearch, ParseLinks, AlertService, paginationConstants, pagingParams, UIFormAccess) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.actualFilter = pagingParams.actualFilter == 'true';
        vm.UIFormAccess = UIFormAccess;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                SimPhoneSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    actual: vm.actualFilter,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                SimPhone.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    actual: vm.actualFilter,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.simPhones = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                actualFilter: vm.actualFilter,
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            /*
            vm.predicate = 'id';
            */
            vm.predicate = 'number';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('SettingDialogController', SettingDialogController);

    SettingDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Setting'];

    function SettingDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Setting) {
        var vm = this;

        vm.setting = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.setting.id !== null) {
                Setting.update(vm.setting, onSaveSuccess, onSaveError);
            } else {
                Setting.save(vm.setting, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('telestatApp:settingUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('SettingDetailController', SettingDetailController);

    SettingDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Setting'];

    function SettingDetailController($scope, $rootScope, $stateParams, previousState, entity, Setting) {
        var vm = this;

        vm.setting = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('telestatApp:settingUpdate', function(event, result) {
            vm.setting = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('SettingDeleteController',SettingDeleteController);

    SettingDeleteController.$inject = ['$uibModalInstance', 'entity', 'Setting'];

    function SettingDeleteController($uibModalInstance, entity, Setting) {
        var vm = this;

        vm.setting = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Setting.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('setting', {
            /*
            parent: 'entity',
            */
            parent: 'admin',
            url: '/setting?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.setting.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/setting/settings.html',
                    controller: 'SettingController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('setting');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('setting-detail', {
            parent: 'setting',
            url: '/setting/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.setting.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/setting/setting-detail.html',
                    controller: 'SettingDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('setting');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Setting', function($stateParams, Setting) {
                    return Setting.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'setting',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('setting-detail.edit', {
            parent: 'setting-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/setting/setting-dialog.html',
                    controller: 'SettingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Setting', function(Setting) {
                            return Setting.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('setting.new', {
            parent: 'setting',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/setting/setting-dialog.html',
                    controller: 'SettingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                code: null,
                                name: null,
                                value: null,
                                unit: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('setting', null, { reload: 'setting' });
                }, function() {
                    $state.go('setting');
                });
            }]
        })
        .state('setting.edit', {
            parent: 'setting',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/setting/setting-dialog.html',
                    controller: 'SettingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Setting', function(Setting) {
                            return Setting.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('setting', null, { reload: 'setting' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('setting.delete', {
            parent: 'setting',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/setting/setting-delete-dialog.html',
                    controller: 'SettingDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Setting', function(Setting) {
                            return Setting.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('setting', null, { reload: 'setting' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('Setting', Setting);

    Setting.$inject = ['$resource'];

    function Setting ($resource) {
        var resourceUrl =  'api/settings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('SettingSearch', SettingSearch);

    SettingSearch.$inject = ['$resource'];

    function SettingSearch($resource) {
        var resourceUrl =  'api/_search/settings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('SettingController', SettingController);

    SettingController.$inject = ['$state', 'Setting', 'SettingSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function SettingController($state, Setting, SettingSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                SettingSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Setting.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.settings = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('RealtyTypeDialogController', RealtyTypeDialogController);

    RealtyTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'RealtyType'];

    function RealtyTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, RealtyType) {
        var vm = this;

        vm.realtyType = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.realtyType.id !== null) {
                RealtyType.update(vm.realtyType, onSaveSuccess, onSaveError);
            } else {
                RealtyType.save(vm.realtyType, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('telestatApp:realtyTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('RealtyTypeDetailController', RealtyTypeDetailController);

    RealtyTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'RealtyType'];

    function RealtyTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, RealtyType) {
        var vm = this;

        vm.realtyType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('telestatApp:realtyTypeUpdate', function(event, result) {
            vm.realtyType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('RealtyTypeDeleteController',RealtyTypeDeleteController);

    RealtyTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'RealtyType'];

    function RealtyTypeDeleteController($uibModalInstance, entity, RealtyType) {
        var vm = this;

        vm.realtyType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            RealtyType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('realty-type', {
            /*
            parent: 'entity',
            */
            parent: 'dictionary',
            url: '/realty-type?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.realtyType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/realty-type/realty-types.html',
                    controller: 'RealtyTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('realtyType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('realty-type-detail', {
            parent: 'realty-type',
            url: '/realty-type/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.realtyType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/realty-type/realty-type-detail.html',
                    controller: 'RealtyTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('realtyType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'RealtyType', function($stateParams, RealtyType) {
                    return RealtyType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'realty-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('realty-type-detail.edit', {
            parent: 'realty-type-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/realty-type/realty-type-dialog.html',
                    controller: 'RealtyTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RealtyType', function(RealtyType) {
                            return RealtyType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('realty-type.new', {
            parent: 'realty-type',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/realty-type/realty-type-dialog.html',
                    controller: 'RealtyTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                caption: null,
                                code: null,
                                externalId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('realty-type', null, { reload: 'realty-type' });
                }, function() {
                    $state.go('realty-type');
                });
            }]
        })
        .state('realty-type.edit', {
            parent: 'realty-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/realty-type/realty-type-dialog.html',
                    controller: 'RealtyTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RealtyType', function(RealtyType) {
                            return RealtyType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('realty-type', null, { reload: 'realty-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('realty-type.delete', {
            parent: 'realty-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/realty-type/realty-type-delete-dialog.html',
                    controller: 'RealtyTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RealtyType', function(RealtyType) {
                            return RealtyType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('realty-type', null, { reload: 'realty-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('RealtyType', RealtyType);

    RealtyType.$inject = ['$resource'];

    function RealtyType ($resource) {
        var resourceUrl =  'api/realty-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('RealtyTypeSearch', RealtyTypeSearch);

    RealtyTypeSearch.$inject = ['$resource'];

    function RealtyTypeSearch($resource) {
        var resourceUrl =  'api/_search/realty-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('RealtyTypeController', RealtyTypeController);

    RealtyTypeController.$inject = ['$state', 'RealtyType', 'RealtyTypeSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function RealtyTypeController($state, RealtyType, RealtyTypeSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                RealtyTypeSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                RealtyType.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.realtyTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneTypeDialogController', PhoneTypeDialogController);

    PhoneTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PhoneType'];

    function PhoneTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PhoneType) {
        var vm = this;

        vm.phoneType = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.phoneType.id !== null) {
                PhoneType.update(vm.phoneType, onSaveSuccess, onSaveError);
            } else {
                PhoneType.save(vm.phoneType, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('telestatApp:phoneTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneTypeDetailController', PhoneTypeDetailController);

    PhoneTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PhoneType'];

    function PhoneTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, PhoneType) {
        var vm = this;

        vm.phoneType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('telestatApp:phoneTypeUpdate', function(event, result) {
            vm.phoneType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneTypeDeleteController',PhoneTypeDeleteController);

    PhoneTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'PhoneType'];

    function PhoneTypeDeleteController($uibModalInstance, entity, PhoneType) {
        var vm = this;

        vm.phoneType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PhoneType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('phone-type', {
            parent: 'entity',
            url: '/phone-type',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.phoneType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/phone-type/phone-types.html',
                    controller: 'PhoneTypeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('phoneType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('phone-type-detail', {
            parent: 'phone-type',
            url: '/phone-type/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.phoneType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/phone-type/phone-type-detail.html',
                    controller: 'PhoneTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('phoneType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PhoneType', function($stateParams, PhoneType) {
                    return PhoneType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'phone-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('phone-type-detail.edit', {
            parent: 'phone-type-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-type/phone-type-dialog.html',
                    controller: 'PhoneTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PhoneType', function(PhoneType) {
                            return PhoneType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('phone-type.new', {
            parent: 'phone-type',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-type/phone-type-dialog.html',
                    controller: 'PhoneTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                caption: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('phone-type', null, { reload: 'phone-type' });
                }, function() {
                    $state.go('phone-type');
                });
            }]
        })
        .state('phone-type.edit', {
            parent: 'phone-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-type/phone-type-dialog.html',
                    controller: 'PhoneTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PhoneType', function(PhoneType) {
                            return PhoneType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('phone-type', null, { reload: 'phone-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('phone-type.delete', {
            parent: 'phone-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-type/phone-type-delete-dialog.html',
                    controller: 'PhoneTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PhoneType', function(PhoneType) {
                            return PhoneType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('phone-type', null, { reload: 'phone-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('PhoneType', PhoneType);

    PhoneType.$inject = ['$resource'];

    function PhoneType ($resource) {
        var resourceUrl =  'api/phone-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('PhoneTypeSearch', PhoneTypeSearch);

    PhoneTypeSearch.$inject = ['$resource'];

    function PhoneTypeSearch($resource) {
        var resourceUrl =  'api/_search/phone-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneTypeController', PhoneTypeController);

    PhoneTypeController.$inject = ['PhoneType', 'PhoneTypeSearch'];

    function PhoneTypeController(PhoneType, PhoneTypeSearch) {

        var vm = this;

        vm.phoneTypes = [];
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            PhoneType.query(function(result) {
                vm.phoneTypes = result;
                vm.searchQuery = null;
            });
        }

        function search() {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            PhoneTypeSearch.query({query: vm.searchQuery}, function(result) {
                vm.phoneTypes = result;
                vm.currentSearch = vm.searchQuery;
            });
        }

        function clear() {
            vm.searchQuery = null;
            loadAll();
        }    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallStatusDialogController', PhoneCallStatusDialogController);

    PhoneCallStatusDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PhoneCallStatus'];

    function PhoneCallStatusDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PhoneCallStatus) {
        var vm = this;

        vm.phoneCallStatus = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.phoneCallStatus.id !== null) {
                PhoneCallStatus.update(vm.phoneCallStatus, onSaveSuccess, onSaveError);
            } else {
                PhoneCallStatus.save(vm.phoneCallStatus, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('telestatApp:phoneCallStatusUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallStatusDetailController', PhoneCallStatusDetailController);

    /* Added UIFormAccess
    PhoneCallStatusDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PhoneCallStatus'];

    function PhoneCallStatusDetailController($scope, $rootScope, $stateParams, previousState, entity, PhoneCallStatus) {
    */
    PhoneCallStatusDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PhoneCallStatus', 'UIFormAccess'];

    function PhoneCallStatusDetailController($scope, $rootScope, $stateParams, previousState, entity, PhoneCallStatus, UIFormAccess) {
        var vm = this;

        vm.phoneCallStatus = entity;
        vm.previousState = previousState.name;
        vm.UIFormAccess = UIFormAccess;

        var unsubscribe = $rootScope.$on('telestatApp:phoneCallStatusUpdate', function(event, result) {
            vm.phoneCallStatus = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallStatusDeleteController',PhoneCallStatusDeleteController);

    PhoneCallStatusDeleteController.$inject = ['$uibModalInstance', 'entity', 'PhoneCallStatus'];

    function PhoneCallStatusDeleteController($uibModalInstance, entity, PhoneCallStatus) {
        var vm = this;

        vm.phoneCallStatus = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PhoneCallStatus.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('phone-call-status', {
            /*
            parent: 'entity',
            */
            parent: 'dictionary',
            url: '/phone-call-status?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.phoneCallStatus.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/phone-call-status/phone-call-statuses.html',
                    controller: 'PhoneCallStatusController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    /*
                    value: 'id,asc',
                    */
                    value: 'name,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('phoneCallStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('phone-call-status-detail', {
            parent: 'phone-call-status',
            url: '/phone-call-status/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.phoneCallStatus.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/phone-call-status/phone-call-status-detail.html',
                    controller: 'PhoneCallStatusDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('phoneCallStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PhoneCallStatus', function($stateParams, PhoneCallStatus) {
                    return PhoneCallStatus.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'phone-call-status',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('phone-call-status-detail.edit', {
            parent: 'phone-call-status-detail',
            url: '/detail/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call-status/phone-call-status-dialog.html',
                    controller: 'PhoneCallStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PhoneCallStatus', function(PhoneCallStatus) {
                            return PhoneCallStatus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('phone-call-status.new', {
            parent: 'phone-call-status',
            url: '/new',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call-status/phone-call-status-dialog.html',
                    controller: 'PhoneCallStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                caption: null,
                                code: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('phone-call-status', null, { reload: 'phone-call-status' });
                }, function() {
                    $state.go('phone-call-status');
                });
            }]
        })
        .state('phone-call-status.edit', {
            parent: 'phone-call-status',
            url: '/{id}/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call-status/phone-call-status-dialog.html',
                    controller: 'PhoneCallStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PhoneCallStatus', function(PhoneCallStatus) {
                            return PhoneCallStatus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('phone-call-status', null, { reload: 'phone-call-status' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('phone-call-status.delete', {
            parent: 'phone-call-status',
            url: '/{id}/delete',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call-status/phone-call-status-delete-dialog.html',
                    controller: 'PhoneCallStatusDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PhoneCallStatus', function(PhoneCallStatus) {
                            return PhoneCallStatus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('phone-call-status', null, { reload: 'phone-call-status' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('PhoneCallStatus', PhoneCallStatus);

    PhoneCallStatus.$inject = ['$resource'];

    function PhoneCallStatus ($resource) {
        var resourceUrl =  'api/phone-call-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('PhoneCallStatusSearch', PhoneCallStatusSearch);

    PhoneCallStatusSearch.$inject = ['$resource'];

    function PhoneCallStatusSearch($resource) {
        var resourceUrl =  'api/_search/phone-call-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallStatusController', PhoneCallStatusController);

    /* Added UIFormAccess
    PhoneCallStatusController.$inject = ['$state', 'PhoneCallStatus', 'PhoneCallStatusSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function PhoneCallStatusController($state, PhoneCallStatus, PhoneCallStatusSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {
    */
    PhoneCallStatusController.$inject = ['$state', 'PhoneCallStatus', 'PhoneCallStatusSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'UIFormAccess'];

    function PhoneCallStatusController($state, PhoneCallStatus, PhoneCallStatusSearch, ParseLinks, AlertService, paginationConstants, pagingParams, UIFormAccess) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.UIFormAccess = UIFormAccess;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                PhoneCallStatusSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                PhoneCallStatus.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                /*
                if (vm.predicate !== 'id') {
                    result.push('id');
                */
                if (vm.predicate !== 'name') {
                    result.push('name');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.phoneCallStatuses = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            /*
            vm.predicate = 'id';
            */
            vm.predicate = 'name';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallResultGroupDialogController', PhoneCallResultGroupDialogController);

    PhoneCallResultGroupDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PhoneCallResultGroup', 'PhoneCallResult'];

    function PhoneCallResultGroupDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PhoneCallResultGroup, PhoneCallResult) {
        var vm = this;

        vm.phoneCallResultGroup = entity;
        vm.clear = clear;
        vm.save = save;
        vm.phonecallresults = PhoneCallResult.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.phoneCallResultGroup.id !== null) {
                PhoneCallResultGroup.update(vm.phoneCallResultGroup, onSaveSuccess, onSaveError);
            } else {
                PhoneCallResultGroup.save(vm.phoneCallResultGroup, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('telestatApp:phoneCallResultGroupUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallResultGroupDetailController', PhoneCallResultGroupDetailController);

    /* Added UIFormAccess
    PhoneCallResultGroupDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PhoneCallResultGroup', 'PhoneCallResult'];

    function PhoneCallResultGroupDetailController($scope, $rootScope, $stateParams, previousState, entity, PhoneCallResultGroup, PhoneCallResult) {
    */
    PhoneCallResultGroupDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PhoneCallResultGroup', 'PhoneCallResult', 'UIFormAccess'];

    function PhoneCallResultGroupDetailController($scope, $rootScope, $stateParams, previousState, entity, PhoneCallResultGroup, PhoneCallResult, UIFormAccess) {
        var vm = this;

        vm.phoneCallResultGroup = entity;
        vm.previousState = previousState.name;
        vm.UIFormAccess = UIFormAccess;

        var unsubscribe = $rootScope.$on('telestatApp:phoneCallResultGroupUpdate', function(event, result) {
            vm.phoneCallResultGroup = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallResultGroupDeleteController',PhoneCallResultGroupDeleteController);

    PhoneCallResultGroupDeleteController.$inject = ['$uibModalInstance', 'entity', 'PhoneCallResultGroup'];

    function PhoneCallResultGroupDeleteController($uibModalInstance, entity, PhoneCallResultGroup) {
        var vm = this;

        vm.phoneCallResultGroup = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PhoneCallResultGroup.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('phone-call-result-group', {
            /*
            parent: 'entity',
            */
            parent: 'dictionary',
            url: '/phone-call-result-group?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.phoneCallResultGroup.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/phone-call-result-group/phone-call-result-groups.html',
                    controller: 'PhoneCallResultGroupController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    /*
                    value: 'id,asc',
                    */
                    value: 'name,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('phoneCallResultGroup');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('phone-call-result-group-detail', {
            parent: 'phone-call-result-group',
            url: '/phone-call-result-group/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.phoneCallResultGroup.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/phone-call-result-group/phone-call-result-group-detail.html',
                    controller: 'PhoneCallResultGroupDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('phoneCallResultGroup');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PhoneCallResultGroup', function($stateParams, PhoneCallResultGroup) {
                    return PhoneCallResultGroup.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'phone-call-result-group',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('phone-call-result-group-detail.edit', {
            parent: 'phone-call-result-group-detail',
            url: '/detail/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call-result-group/phone-call-result-group-dialog.html',
                    controller: 'PhoneCallResultGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PhoneCallResultGroup', function(PhoneCallResultGroup) {
                            return PhoneCallResultGroup.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('phone-call-result-group.new', {
            parent: 'phone-call-result-group',
            url: '/new',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call-result-group/phone-call-result-group-dialog.html',
                    controller: 'PhoneCallResultGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                caption: null,
                                purposeful: false,
                                effect: null,
                                style: null,
                                code: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('phone-call-result-group', null, { reload: 'phone-call-result-group' });
                }, function() {
                    $state.go('phone-call-result-group');
                });
            }]
        })
        .state('phone-call-result-group.edit', {
            parent: 'phone-call-result-group',
            url: '/{id}/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call-result-group/phone-call-result-group-dialog.html',
                    controller: 'PhoneCallResultGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PhoneCallResultGroup', function(PhoneCallResultGroup) {
                            return PhoneCallResultGroup.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('phone-call-result-group', null, { reload: 'phone-call-result-group' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('phone-call-result-group.delete', {
            parent: 'phone-call-result-group',
            url: '/{id}/delete',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call-result-group/phone-call-result-group-delete-dialog.html',
                    controller: 'PhoneCallResultGroupDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PhoneCallResultGroup', function(PhoneCallResultGroup) {
                            return PhoneCallResultGroup.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('phone-call-result-group', null, { reload: 'phone-call-result-group' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('PhoneCallResultGroup', PhoneCallResultGroup);

    PhoneCallResultGroup.$inject = ['$resource'];

    function PhoneCallResultGroup ($resource) {
        var resourceUrl =  'api/phone-call-result-groups/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('PhoneCallResultGroupSearch', PhoneCallResultGroupSearch);

    PhoneCallResultGroupSearch.$inject = ['$resource'];

    function PhoneCallResultGroupSearch($resource) {
        var resourceUrl =  'api/_search/phone-call-result-groups/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallResultGroupController', PhoneCallResultGroupController);

    /* Added UIFormAccess
    PhoneCallResultGroupController.$inject = ['$state', 'PhoneCallResultGroup', 'PhoneCallResultGroupSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function PhoneCallResultGroupController($state, PhoneCallResultGroup, PhoneCallResultGroupSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {
    */
    PhoneCallResultGroupController.$inject = ['$state', 'PhoneCallResultGroup', 'PhoneCallResultGroupSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'UIFormAccess'];

    function PhoneCallResultGroupController($state, PhoneCallResultGroup, PhoneCallResultGroupSearch, ParseLinks, AlertService, paginationConstants, pagingParams, UIFormAccess) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.UIFormAccess = UIFormAccess;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                PhoneCallResultGroupSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                PhoneCallResultGroup.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                /*
                if (vm.predicate !== 'id') {
                    result.push('id');
                */
                if (vm.predicate !== 'name') {
                    result.push('name');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.phoneCallResultGroups = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            /*
            vm.predicate = 'id';
            */
            vm.predicate = 'name';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallResultDialogController', PhoneCallResultDialogController);

    PhoneCallResultDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PhoneCallResult', 'PhoneCallResultGroup'];

    function PhoneCallResultDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PhoneCallResult, PhoneCallResultGroup) {
        var vm = this;

        vm.phoneCallResult = entity;
        vm.clear = clear;
        vm.save = save;
        vm.phonecallresultgroups = PhoneCallResultGroup.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.phoneCallResult.id !== null) {
                PhoneCallResult.update(vm.phoneCallResult, onSaveSuccess, onSaveError);
            } else {
                PhoneCallResult.save(vm.phoneCallResult, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('telestatApp:phoneCallResultUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallResultDetailController', PhoneCallResultDetailController);

    /* Added UIFormAccess
    PhoneCallResultDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PhoneCallResult', 'PhoneCallResultGroup'];

    function PhoneCallResultDetailController($scope, $rootScope, $stateParams, previousState, entity, PhoneCallResult, PhoneCallResultGroup) {
    */
    PhoneCallResultDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PhoneCallResult', 'PhoneCallResultGroup', 'UIFormAccess'];

    function PhoneCallResultDetailController($scope, $rootScope, $stateParams, previousState, entity, PhoneCallResult, PhoneCallResultGroup, UIFormAccess) {
        var vm = this;

        vm.phoneCallResult = entity;
        vm.previousState = previousState.name;
        vm.UIFormAccess = UIFormAccess;

        var unsubscribe = $rootScope.$on('telestatApp:phoneCallResultUpdate', function(event, result) {
            vm.phoneCallResult = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallResultDeleteController',PhoneCallResultDeleteController);

    PhoneCallResultDeleteController.$inject = ['$uibModalInstance', 'entity', 'PhoneCallResult'];

    function PhoneCallResultDeleteController($uibModalInstance, entity, PhoneCallResult) {
        var vm = this;

        vm.phoneCallResult = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PhoneCallResult.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('phone-call-result', {
            /*
            parent: 'entity',
            */
            parent: 'dictionary',
            url: '/phone-call-result?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.phoneCallResult.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/phone-call-result/phone-call-results.html',
                    controller: 'PhoneCallResultController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    /*
                    value: 'id,asc',
                    */
                    value: 'name,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('phoneCallResult');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('phone-call-result-detail', {
            parent: 'phone-call-result',
            url: '/phone-call-result/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.phoneCallResult.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/phone-call-result/phone-call-result-detail.html',
                    controller: 'PhoneCallResultDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('phoneCallResult');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PhoneCallResult', function($stateParams, PhoneCallResult) {
                    return PhoneCallResult.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'phone-call-result',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('phone-call-result-detail.edit', {
            parent: 'phone-call-result-detail',
            url: '/detail/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call-result/phone-call-result-dialog.html',
                    controller: 'PhoneCallResultDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PhoneCallResult', function(PhoneCallResult) {
                            return PhoneCallResult.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('phone-call-result.new', {
            parent: 'phone-call-result',
            url: '/new',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call-result/phone-call-result-dialog.html',
                    controller: 'PhoneCallResultDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                caption: null,
                                blockingCount: null,
                                systemic: false,
                                code: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('phone-call-result', null, { reload: 'phone-call-result' });
                }, function() {
                    $state.go('phone-call-result');
                });
            }]
        })
        .state('phone-call-result.edit', {
            parent: 'phone-call-result',
            url: '/{id}/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call-result/phone-call-result-dialog.html',
                    controller: 'PhoneCallResultDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PhoneCallResult', function(PhoneCallResult) {
                            return PhoneCallResult.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('phone-call-result', null, { reload: 'phone-call-result' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('phone-call-result.delete', {
            parent: 'phone-call-result',
            url: '/{id}/delete',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call-result/phone-call-result-delete-dialog.html',
                    controller: 'PhoneCallResultDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PhoneCallResult', function(PhoneCallResult) {
                            return PhoneCallResult.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('phone-call-result', null, { reload: 'phone-call-result' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('PhoneCallResult', PhoneCallResult);

    PhoneCallResult.$inject = ['$resource'];

    function PhoneCallResult ($resource) {
        var resourceUrl =  'api/phone-call-results/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('PhoneCallResultSearch', PhoneCallResultSearch);

    PhoneCallResultSearch.$inject = ['$resource'];

    function PhoneCallResultSearch($resource) {
        var resourceUrl =  'api/_search/phone-call-results/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallResultController', PhoneCallResultController);

    /* Added UIFormAccess
    PhoneCallResultController.$inject = ['$state', 'PhoneCallResult', 'PhoneCallResultSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function PhoneCallResultController($state, PhoneCallResult, PhoneCallResultSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {
    */
    PhoneCallResultController.$inject = ['$state', 'PhoneCallResult', 'PhoneCallResultSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'UIFormAccess'];

    function PhoneCallResultController($state, PhoneCallResult, PhoneCallResultSearch, ParseLinks, AlertService, paginationConstants, pagingParams, UIFormAccess) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.UIFormAccess = UIFormAccess;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                PhoneCallResultSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                PhoneCallResult.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                /*
                if (vm.predicate !== 'id') {
                    result.push('id');
                */
                if (vm.predicate !== 'name') {
                    result.push('name');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.phoneCallResults = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            /*
            vm.predicate = 'id';
            */
            vm.predicate = 'name';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallPurposeDialogController', PhoneCallPurposeDialogController);

    PhoneCallPurposeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PhoneCallPurpose'];

    function PhoneCallPurposeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PhoneCallPurpose) {
        var vm = this;

        vm.phoneCallPurpose = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.phoneCallPurpose.id !== null) {
                PhoneCallPurpose.update(vm.phoneCallPurpose, onSaveSuccess, onSaveError);
            } else {
                PhoneCallPurpose.save(vm.phoneCallPurpose, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('telestatApp:phoneCallPurposeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallPurposeDetailController', PhoneCallPurposeDetailController);

    /* Added UIFormAccess
    PhoneCallPurposeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PhoneCallPurpose'];

    function PhoneCallPurposeDetailController($scope, $rootScope, $stateParams, previousState, entity, PhoneCallPurpose) {
    */
    PhoneCallPurposeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PhoneCallPurpose', 'UIFormAccess'];

    function PhoneCallPurposeDetailController($scope, $rootScope, $stateParams, previousState, entity, PhoneCallPurpose, UIFormAccess) {
        var vm = this;

        vm.phoneCallPurpose = entity;
        vm.previousState = previousState.name;
        vm.UIFormAccess = UIFormAccess;

        var unsubscribe = $rootScope.$on('telestatApp:phoneCallPurposeUpdate', function(event, result) {
            vm.phoneCallPurpose = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallPurposeDeleteController',PhoneCallPurposeDeleteController);

    PhoneCallPurposeDeleteController.$inject = ['$uibModalInstance', 'entity', 'PhoneCallPurpose'];

    function PhoneCallPurposeDeleteController($uibModalInstance, entity, PhoneCallPurpose) {
        var vm = this;

        vm.phoneCallPurpose = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PhoneCallPurpose.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('phone-call-purpose', {
            /*
            parent: 'entity',
            */
            parent: 'dictionary',
            url: '/phone-call-purpose?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.phoneCallPurpose.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/phone-call-purpose/phone-call-purposes.html',
                    controller: 'PhoneCallPurposeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    /*
                    value: 'id,asc',
                    */
                    value: 'checkOrder,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('phoneCallPurpose');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('phone-call-purpose-detail', {
            parent: 'phone-call-purpose',
            url: '/phone-call-purpose/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.phoneCallPurpose.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/phone-call-purpose/phone-call-purpose-detail.html',
                    controller: 'PhoneCallPurposeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('phoneCallPurpose');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PhoneCallPurpose', function($stateParams, PhoneCallPurpose) {
                    return PhoneCallPurpose.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'phone-call-purpose',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('phone-call-purpose-detail.edit', {
            parent: 'phone-call-purpose-detail',
            url: '/detail/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call-purpose/phone-call-purpose-dialog.html',
                    controller: 'PhoneCallPurposeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PhoneCallPurpose', function(PhoneCallPurpose) {
                            return PhoneCallPurpose.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('phone-call-purpose.new', {
            parent: 'phone-call-purpose',
            url: '/new',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call-purpose/phone-call-purpose-dialog.html',
                    controller: 'PhoneCallPurposeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                caption: null,
                                worth: null,
                                checkOrder: null,
                                code: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('phone-call-purpose', null, { reload: 'phone-call-purpose' });
                }, function() {
                    $state.go('phone-call-purpose');
                });
            }]
        })
        .state('phone-call-purpose.edit', {
            parent: 'phone-call-purpose',
            url: '/{id}/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call-purpose/phone-call-purpose-dialog.html',
                    controller: 'PhoneCallPurposeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PhoneCallPurpose', function(PhoneCallPurpose) {
                            return PhoneCallPurpose.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('phone-call-purpose', null, { reload: 'phone-call-purpose' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('phone-call-purpose.delete', {
            parent: 'phone-call-purpose',
            url: '/{id}/delete',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call-purpose/phone-call-purpose-delete-dialog.html',
                    controller: 'PhoneCallPurposeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PhoneCallPurpose', function(PhoneCallPurpose) {
                            return PhoneCallPurpose.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('phone-call-purpose', null, { reload: 'phone-call-purpose' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('PhoneCallPurpose', PhoneCallPurpose);

    PhoneCallPurpose.$inject = ['$resource'];

    function PhoneCallPurpose ($resource) {
        var resourceUrl =  'api/phone-call-purposes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('PhoneCallPurposeSearch', PhoneCallPurposeSearch);

    PhoneCallPurposeSearch.$inject = ['$resource'];

    function PhoneCallPurposeSearch($resource) {
        var resourceUrl =  'api/_search/phone-call-purposes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallPurposeController', PhoneCallPurposeController);

    /* Added UIFormAccess
    PhoneCallPurposeController.$inject = ['$state', 'PhoneCallPurpose', 'PhoneCallPurposeSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function PhoneCallPurposeController($state, PhoneCallPurpose, PhoneCallPurposeSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {
    */
    PhoneCallPurposeController.$inject = ['$state', 'PhoneCallPurpose', 'PhoneCallPurposeSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'UIFormAccess'];

    function PhoneCallPurposeController($state, PhoneCallPurpose, PhoneCallPurposeSearch, ParseLinks, AlertService, paginationConstants, pagingParams, UIFormAccess) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.UIFormAccess = UIFormAccess;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                PhoneCallPurposeSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                PhoneCallPurpose.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                /*
                if (vm.predicate !== 'id') {
                    result.push('id');
                */
                if (vm.predicate !== 'checkOrder') {
                    result.push('checkOrder');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.phoneCallPurposes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            /*
            vm.predicate = 'id';
            */
            vm.predicate = 'checkOrder';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';
    /* globals SockJS, Stomp */

    angular
        .module('telestatApp')
        .factory('PhoneCallCheckTrackerService', PhoneCallCheckTrackerService);

    PhoneCallCheckTrackerService.$inject = ['$rootScope', '$window', '$cookies', '$http', '$q', 'DEBUG_INFO_ENABLED'];

    function PhoneCallCheckTrackerService ($rootScope, $window, $cookies, $http, $q, DEBUG_INFO_ENABLED) {
        var stompClient = null;
        var subscriber = null;
        var subscriberU = null;
        var listener = $q.defer();
        var listenerEdit = $q.defer();
        var connected = $q.defer();
        var alreadyConnectedOnce = false;
        // Main subscription flash, once activated - always active
        var subscribed = false;
        var subscribeState = false;
        var dtoStatus = {};
        var currentSessionId;

        var service = {
            connect: connect,
            disconnect: disconnect,
            sendSavePhoneCallId: sendSavePhoneCallId,
            sendEditPhoneCallId: sendEditPhoneCallId,
            sendCloseEditPhoneCallId: sendCloseEditPhoneCallId,
            subscribe: subscribe,
            //unsubscribe: unsubscribe,
            checkPhoneCallId: checkPhoneCallId,
            setListener: setListener,
            cleanListener: cleanListener,
            setEditListener: setEditListener,
            cleanEditListener: cleanEditListener
        };

        return service;

        function process(dto) {
            if (DEBUG_INFO_ENABLED) {
                console.log("Process: ");
                console.log(dto);
            }
            if (dto.action == 'disconnect') {
                for(var valueId in dtoStatus) {
                    if (dto.sessionId == dtoStatus[valueId]['sessionId']) {
                        //console.log(':: disconnect --> close');
                        dtoStatus[valueId]['action'] = 'close';
                        listener.notify(dtoStatus[valueId]);
                        delete dtoStatus[valueId];
                    }
                }
            } else if (dto.phoneCallId != null) {
                if (dto.action == 'close' && dtoStatus[dto.phoneCallId] != null && dto.sessionId == dtoStatus[dto.phoneCallId].sessionId) {
                    listener.notify(dto);
                    if (dto.sessionId != currentSessionId) {
                        listenerEdit.notify(dto);
                    }
                    delete dtoStatus[dto.phoneCallId];
                } else if (dto.action == 'edit') {
                    listener.notify(dto);
                    if (dto.sessionId != currentSessionId) {
                        listenerEdit.notify(dto);
                    }
                    if (dtoStatus[dto.phoneCallId] == null) {
                        dtoStatus[dto.phoneCallId] = dto;
                    } else {
                        if (DEBUG_INFO_ENABLED) {
                            console.log(':: parallel edit received');
                        }
                    }
                } else if (dto.action == 'save') {
                    listener.notify(dto);
                    if (dtoStatus[dto.phoneCallId] != null) {
                        if (dto.sessionId != currentSessionId) {
                            listenerEdit.notify(dto);
                        }
                        delete dtoStatus[dto.phoneCallId];
                    }
                } else {
                    if (dto.sessionId != currentSessionId) {
                        listenerEdit.notify(dto);
                    }
                }
                // Cleanup
                for(var valueId in dtoStatus) {
                    if (dto.sessionId == dtoStatus[valueId]['sessionId'] && dto.phoneCallId != dtoStatus[valueId]['phoneCallId']) {
                        dtoStatus[valueId]['action'] = 'close';
                        listener.notify(dtoStatus[valueId]);
                        if (dto.sessionId != currentSessionId) {
                            listenerEdit.notify(dto);
                        }
                        delete dtoStatus[valueId];
                    }
                }
            } else {
                console.log("Unknown DTO:");
                console.log(dto);
            }
            //console.log("On exit from process call: dtoStatus=");
            //console.log(dtoStatus);
        }

        function checkPhoneCallId(id) {
            //console.log("checkPhoneCallId: " + id);
            if (dtoStatus[id] != null && dtoStatus[id].action == 'edit') {
                //console.log("checkPhoneCallId: " + id + " result: editing");
                return dtoStatus[id];
            }
            return null;
        }

        function makeid() {
            var text = "";
            var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

            for (var i = 0; i < 8; i++)
              text += possible.charAt(Math.floor(Math.random() * possible.length));

            return text;
        }

        function connect () {
            //building absolute path so that websocket doesn't fail when deploying with a context path
            var loc = $window.location;
            var url = '//' + loc.host + loc.pathname + 'websocket/phoneCall';
            currentSessionId = makeid();
            var socket = new SockJS(url, [], {
                sessionId: function() {
                    return currentSessionId
                 }
            });
            disconnect ();
            stompClient = Stomp.over(socket);
            if (!DEBUG_INFO_ENABLED) {
                stompClient.debug = null;
            }
            var headers = {};
            headers[$http.defaults.xsrfHeaderName] = $cookies.get($http.defaults.xsrfCookieName);
            stompClient.connect(headers, function() {
                connected.resolve('success');
                if (subscribed) {
                    subscribe();
                }
                listener.notify({action:'clean'});
            }, function() {
                setTimeout(function(){
                    connect();
                }, 10000);
                console.log('Can`t connect, reconnecting in 10 seconds...');
            });
        }

        function disconnect () {
            subscribeState = false;
            if (stompClient !== null) {
                stompClient.disconnect();
                stompClient = null;
            }
            dtoStatus = {};
        }

        function setEditListener () {
            listenerEdit = $q.defer();
            return listenerEdit.promise;
        }

        function cleanEditListener () {
            listenerEdit = $q.defer();
        }

        function setListener () {
            listener = $q.defer();
            return listener.promise;
        }

        function cleanListener () {
            listener = $q.defer();
        }

        function sendSavePhoneCallId(phoneCallId) {
            sendActionPhoneCallId(phoneCallId, 'save');
        }

        function sendEditPhoneCallId(phoneCallId) {
            sendActionPhoneCallId(phoneCallId, 'edit');
        }

        function sendCloseEditPhoneCallId(phoneCallId) {
            sendActionPhoneCallId(phoneCallId, 'close');
        }

        function sendActionPhoneCallId(phoneCallId, action) {
            if (stompClient !== null && stompClient.connected) {
                stompClient
                    .send('/topic/phoneCallCheck',
                    {},
                    angular.toJson({'phoneCallId': phoneCallId, 'action': action}));
            }
        }

        function subscribe () {
            if (!subscribeState) {
                console.log("Make new subscribe");
                connected.promise.then(function() {
                    dtoStatus = {};
                    subscribed = true;
                    subscribeState = true;
                    subscriber = stompClient.subscribe('/topic/phoneCall', function(data) {
                        process(angular.fromJson(data.body));
                    });
                    subscriberU = stompClient.subscribe('/user/topic/phoneCall', function(data) {
                        process(angular.fromJson(data.body));
                    });
                }, null, null);
            }
        }

        /*function unsubscribe () {
            subscribed = false;
            if (subscriber !== null) {
                subscriber.unsubscribe();
            }
            if (subscriberU !== null) {
                subscriberU.unsubscribe();
            }
            listener = $q.defer();
            listenerEdit = $q.defer();
            dtoStatus = {};
        }*/
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallCheckDialogController', PhoneCallCheckDialogController);

    /* Added AdvertisingSource, $locale, Principal, $filter, PhoneCallCheckTrackerService, AlertService, $translate
    PhoneCallCheckDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'PhoneCallCheck', 'PhoneCall', 'RealtyType', 'PhoneCallResult', 'User', 'Employee', 'PhoneCallPurpose'];

    function PhoneCallCheckDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, PhoneCallCheck, PhoneCall, RealtyType, PhoneCallResult, User, Employee, PhoneCallPurpose) {
    */
    PhoneCallCheckDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'PhoneCallCheck', 'PhoneCall', 'RealtyType', 'PhoneCallResult', 'User', 'Employee', 'PhoneCallPurpose', 'AdvertisingSource', '$locale', 'Principal', '$filter', 'PhoneCallCheckTrackerService', 'AlertService', '$translate'];

    function PhoneCallCheckDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, PhoneCallCheck, PhoneCall, RealtyType, PhoneCallResult, User, Employee, PhoneCallPurpose, AdvertisingSource, $locale, Principal, $filter, PhoneCallCheckTrackerService, AlertService, $translate) {
        var vm = this;

        vm.infoCallBack = infoCallBack;
        if (Principal.hasAnyAuthority(['ROLE_ADMIN','ROLE_DIRECTOR','ROLE_CHECKER'])) {
            PhoneCallCheckTrackerService.setEditListener().then(
                null, null,
                function (dto) {
                    infoCallBack(dto);
                }
            );
        }

        vm.otherInfo = '';
        vm.fatalInfo = '';
        vm.warnSuppress = {};

        vm.phoneCallCheck = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.playerSetSpeed = playerSetSpeed;
        vm.save = save;
        /* -- Начало удаленного куска
        // Удалено из-за отсутствия необходимости выбора/смены phone-call в phone-call-check,
        // т.к. phone-call связывается с phone-call-check либо при создании новой связки на странице phone-call,
        // либо со стороны сервера приходит готовый объект.
        vm.phonecalls = PhoneCall.query({filter: 'phonecallcheck-is-null'});
        $q.all([vm.phoneCallCheck.$promise, vm.phonecalls.$promise]).then(function() {
            if (!vm.phoneCallCheck.phoneCall || !vm.phoneCallCheck.phoneCall.id) {
                return $q.reject();
            }
            return PhoneCall.get({id : vm.phoneCallCheck.phoneCall.id}).$promise;
        }).then(function(phoneCall) {
            vm.phonecalls.push(phoneCall);
        });
        -- Конец удаленного куска */

        vm.realtytypes = RealtyType.query();
        vm.phonecallresults = PhoneCallResult.query();
        /* ненужные тяжелые вызовы к API
        vm.users = User.query();
        vm.employees = Employee.query();
        */
        /*
        vm.phonecallpurposes = PhoneCallPurpose.query();
        */
        vm.phonecallpurposes = PhoneCallPurpose.query({sort: 'checkOrder,asc'});
        vm.advertisingsources = AdvertisingSource.query({size: 9999, sort: 'name,asc', actual: false});
        vm.dateformat = $locale.DATETIME_FORMATS.short;
        vm.calcProps = calcProps;
        if(vm.phoneCallCheck.id == null) {
            vm.phoneCallId = $stateParams.id;
            calcProps(true);
        } else {
            vm.phoneCallId = vm.phoneCallCheck.phoneCall.id;
        }
        $q.all([vm.phoneCallCheck.phoneCall.$promise]).then(function(){
            vm.phoneCallId = vm.phoneCallCheck.phoneCall.id;
            calcTitle();
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.phoneCallCheck.id !== null) {
                PhoneCallCheck.update(vm.phoneCallCheck, onSaveSuccess, onSaveError);
            } else {
                PhoneCallCheck.save(vm.phoneCallCheck, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('telestatApp:phoneCallCheckUpdate', result);
            PhoneCallCheckTrackerService.sendSavePhoneCallId(vm.phoneCallId);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.checkTime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function playerSetSpeed(id, speed) {
            var audio = document.getElementById(id);
	    audio.playbackRate = speed; 
        }

        // Refers to ru.inquarta.telestat.domain.PhoneCallCheckExtender
        function calcProps(firstRun) {
            if (firstRun != true) {
                PhoneCallCheckTrackerService.sendEditPhoneCallId(vm.phoneCallId);
            }
            // assessment
            if (vm.phoneCallCheck.phoneCallPurposes != null) {
                vm.phoneCallCheck.assessment = vm.phoneCallCheck.phoneCallPurposes.reduce(
                    function (sum, current) {
                        return sum + current.worth;
                    }, 0);
            } else {
                vm.phoneCallCheck.assessment = 0;
            }
            if(vm.phoneCallCheck.phoneCallResult != null) {
                switch (vm.phoneCallCheck.phoneCallResult.phoneCallResultGroup.code) {
                    case 'missed'://MISSED_CODE
                        vm.phoneCallCheck.assessment = 0;
                        break;
                    case 'indefin'://INDEFINITE_CODE
                    case 'insignif'://INSIGNIFICANT_CODE
                        vm.phoneCallCheck.assessment = null;
                        break;
                    case 'product'://PRODUCTIVE_CODE
                    case 'useless'://USELESS_CODE
                    default:
                }
            }
            // checkerCaption
            Principal
                .identity()
                .then(function(account) {
                    var caption = "";
                    if(account.lastName != '') {
                        caption += account.lastName;
                    }
                    if(account.firstName != '' && account.firstName != account.lastName) {
                        if(caption.length > 0) {
                            caption += " ";
                        }
                        caption += account.firstName;
                    }
                    if(caption.length == 0) {
                        caption = account.login;
                    }
                    vm.phoneCallCheck.checkerCaption = caption;
                });
            // checkTime
            if(vm.phoneCallCheck.checkTime == null) {
                vm.phoneCallCheck.checkTime = new Date();
            }
        }

        function calcTitle() {
            var title = $filter('date')(vm.phoneCallCheck.phoneCall.callTime, 'dd.MM.yy HH:mm') + " " + vm.phoneCallCheck.phoneCall.callingCaption + " → " + vm.phoneCallCheck.phoneCall.calledCaption;
            if (vm.phoneCallCheck.phoneCall.calledEmployee != null) {
                title += " (" + vm.phoneCallCheck.phoneCall.calledEmployee.division.name + ")";
            }
            vm.phoneCallCheck.phoneCall.title = title;
        }

        function infoCallBack(dto) {
            //console.log("EDIT INFO CALL BACK:");
            //console.log(dto);
            if (vm.phoneCallId == dto.phoneCallId) {
                if (dto.action == 'edit') {
                    if (vm.warnSuppress[dto.sessionId] == null) {
                        vm.otherInfo = $translate.instant('global.concurrentEdit', dto);
                        vm.warnSuppress[dto.sessionId] = 1;
                    }
                } else if (dto.action == 'close') {
                    if ($translate.instant('global.concurrentEdit', dto) == vm.otherInfo) {
                        vm.otherInfo = '';
                    }
                    delete vm.warnSuppress[dto.sessionId];
                } else if (dto.action == 'save') {
                    vm.fatalInfo = $translate.instant('global.concurrentSave', dto);
                    delete vm.warnSuppress[dto.sessionId];
                }
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallCheckDetailController', PhoneCallCheckDetailController);

    /* Added UIFormAccess
    PhoneCallCheckDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PhoneCallCheck', 'PhoneCall', 'RealtyType', 'PhoneCallResult', 'User', 'Employee', 'PhoneCallPurpose'];

    function PhoneCallCheckDetailController($scope, $rootScope, $stateParams, previousState, entity, PhoneCallCheck, PhoneCall, RealtyType, PhoneCallResult, User, Employee, PhoneCallPurpose) {
    */
    PhoneCallCheckDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PhoneCallCheck', 'PhoneCall', 'RealtyType', 'PhoneCallResult', 'User', 'Employee', 'PhoneCallPurpose', 'UIFormAccess'];

    function PhoneCallCheckDetailController($scope, $rootScope, $stateParams, previousState, entity, PhoneCallCheck, PhoneCall, RealtyType, PhoneCallResult, User, Employee, PhoneCallPurpose, UIFormAccess) {
        var vm = this;

        vm.phoneCallCheck = entity;
        vm.previousState = previousState.name;
        vm.UIFormAccess = UIFormAccess;

        var unsubscribe = $rootScope.$on('telestatApp:phoneCallCheckUpdate', function(event, result) {
            vm.phoneCallCheck = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallCheckDeleteController',PhoneCallCheckDeleteController);

    PhoneCallCheckDeleteController.$inject = ['$uibModalInstance', 'entity', 'PhoneCallCheck'];

    function PhoneCallCheckDeleteController($uibModalInstance, entity, PhoneCallCheck) {
        var vm = this;

        vm.phoneCallCheck = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PhoneCallCheck.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('phone-call-check', {
            parent: 'entity',
            url: '/phone-call-check?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.phoneCallCheck.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/phone-call-check/phone-call-checks.html',
                    controller: 'PhoneCallCheckController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    /*
                    value: 'id,asc',
                    */
                    value: 'checkTime,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('phoneCallCheck');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('phone-call-check-detail', {
            parent: 'phone-call-check',
            url: '/phone-call-check/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.phoneCallCheck.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/phone-call-check/phone-call-check-detail.html',
                    controller: 'PhoneCallCheckDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('phoneCallCheck');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PhoneCallCheck', function($stateParams, PhoneCallCheck) {
                    return PhoneCallCheck.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'phone-call-check',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('phone-call-check-detail.edit', {
            parent: 'phone-call-check-detail',
            url: '/detail/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR', 'ROLE_CHECKER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call-check/phone-call-check-dialog.html',
                    controller: 'PhoneCallCheckDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        // Need in phone-call-check/phone-call-check/{id}/detail/edit
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('phoneCall');
                            $translatePartialLoader.addPart('phoneCallCheck');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }],
                        entity: ['PhoneCallCheck', function(PhoneCallCheck) {
                            return PhoneCallCheck.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('phone-call-check.new', {
            parent: 'phone-call-check',
            url: '/new',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR', 'ROLE_CHECKER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call-check/phone-call-check-dialog.html',
                    controller: 'PhoneCallCheckDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        // Need in phone-call-check/new, but not applied in our case.
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('phoneCall');
                            $translatePartialLoader.addPart('phoneCallCheck');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }],
                        entity: function () {
                            return {
                                dummy: false,
                                assessment: null,
                                comment: null,
                                checkerCaption: null,
                                checkTime: null,
                                systemic: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('phone-call-check', null, { reload: 'phone-call-check' });
                }, function() {
                    $state.go('phone-call-check');
                });
            }]
        })
        .state('phone-call-check.edit', {
            parent: 'phone-call-check',
            url: '/{id}/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR', 'ROLE_CHECKER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call-check/phone-call-check-dialog.html',
                    controller: 'PhoneCallCheckDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        // Need in phone-call-check/{id}/edit
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('phoneCall');
                            $translatePartialLoader.addPart('phoneCallCheck');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }],
                        entity: ['PhoneCallCheck', function(PhoneCallCheck) {
                            return PhoneCallCheck.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('phone-call-check', null, { reload: 'phone-call-check' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('phone-call-check.delete', {
            parent: 'phone-call-check',
            url: '/{id}/delete',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR', 'ROLE_CHECKER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call-check/phone-call-check-delete-dialog.html',
                    controller: 'PhoneCallCheckDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PhoneCallCheck', function(PhoneCallCheck) {
                            return PhoneCallCheck.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('phone-call-check', null, { reload: 'phone-call-check' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('PhoneCallCheck', PhoneCallCheck);

    PhoneCallCheck.$inject = ['$resource', 'DateUtils'];

    function PhoneCallCheck ($resource, DateUtils) {
        var resourceUrl =  'api/phone-call-checks/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.checkTime = DateUtils.convertDateTimeFromServer(data.checkTime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('PhoneCallCheckSearch', PhoneCallCheckSearch);

    PhoneCallCheckSearch.$inject = ['$resource'];

    function PhoneCallCheckSearch($resource) {
        var resourceUrl =  'api/_search/phone-call-checks/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallCheckController', PhoneCallCheckController);

    /* Added UIFormAccess
    PhoneCallCheckController.$inject = ['$state', 'PhoneCallCheck', 'PhoneCallCheckSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function PhoneCallCheckController($state, PhoneCallCheck, PhoneCallCheckSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {
    */
    PhoneCallCheckController.$inject = ['$state', 'PhoneCallCheck', 'PhoneCallCheckSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'UIFormAccess'];

    function PhoneCallCheckController($state, PhoneCallCheck, PhoneCallCheckSearch, ParseLinks, AlertService, paginationConstants, pagingParams, UIFormAccess) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        /*
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        */
        vm.itemsPerPage = paginationConstants.itemsPerLargePage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.UIFormAccess = UIFormAccess;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                PhoneCallCheckSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                PhoneCallCheck.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                /*
                if (vm.predicate !== 'id') {
                    result.push('id');
                */
                if (vm.predicate !== 'checkTime') {
                    result.push('checkTime,desc');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.phoneCallChecks = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            /*
            vm.predicate = 'id';
            vm.reverse = true;
            */
            vm.predicate = 'checkTime';
            vm.reverse = false;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        // Редактирование проверки звонка не покидая списка звонков
        .state('phone-call.editPhoneCallCheck', {
            parent: 'phone-call',
            url: '/phone-call-check/edit/{id}/{phoneCallId}',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR', 'ROLE_CHECKER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'PhoneCallCheckTrackerService', '$translate', '$filter', function($stateParams, $state, $uibModal, PhoneCallCheckTrackerService, $translate, $filter) {
                var dto = PhoneCallCheckTrackerService.checkPhoneCallId($stateParams.phoneCallId);
                if (dto != null && dto['action'] == 'edit') {
                    var time = $filter('date')(dto['time'], 'dd.MM.yy HH:mm')
                    if (!confirm($translate.instant('global.editInParallel', {'param': time, 'user': dto['userLogin']}))) {
                        $state.go('phone-call', null, null);
                        return;
                    }
                }
                PhoneCallCheckTrackerService.sendEditPhoneCallId($stateParams.phoneCallId);
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call-check/phone-call-check-dialog.html',
                    controller: 'PhoneCallCheckDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PhoneCallCheck', function(PhoneCallCheck) {
                            return PhoneCallCheck.get({id : $stateParams.id}).$promise;
                        }],
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('phoneCallCheck');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('phone-call', null, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }],
            onExit: ['$stateParams', 'PhoneCallCheckTrackerService', function($stateParams, PhoneCallCheckTrackerService){
                PhoneCallCheckTrackerService.sendCloseEditPhoneCallId($stateParams.phoneCallId);
                PhoneCallCheckTrackerService.cleanEditListener();
            }]
        })
        // Создание проверки звонка не покидая списка звонков
        .state('phone-call.newPhoneCallCheck', {
            parent: 'phone-call',
            url: '/phone-call-check/new/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR', 'ROLE_CHECKER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'PhoneCall', 'Principal', 'PhoneCallCheckTrackerService', '$translate', '$filter', function($stateParams, $state, $uibModal, PhoneCall, Principal, PhoneCallCheckTrackerService, $translate, $filter) {
                var dto = PhoneCallCheckTrackerService.checkPhoneCallId($stateParams.id);
                if (dto != null && dto['action'] == 'edit') {
                    var time = $filter('date')(dto['time'], 'dd.MM.yy HH:mm')
                    if (!confirm($translate.instant('global.editInParallel', {'param': time, 'user': dto['userLogin']}))) {
                        $state.go('phone-call', null, null);
                        return;
                    }
                }
                PhoneCallCheckTrackerService.sendEditPhoneCallId($stateParams.id);
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call-check/phone-call-check-dialog.html',
                    controller: 'PhoneCallCheckDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                assessment: null,
                                id: null,
                                phoneCall: PhoneCall.get({id : $stateParams.id}),
                                checkTime: new Date(),
                                systemic: false,
                                dummy: false
                            };
                        },
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('phoneCallCheck');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('phone-call', null, { reload: false });
                }, function() {
                    $state.go('phone-call');
                });
            }],
            onExit: ['$stateParams', 'PhoneCallCheckTrackerService', function($stateParams, PhoneCallCheckTrackerService){
                PhoneCallCheckTrackerService.sendCloseEditPhoneCallId($stateParams.id);
                PhoneCallCheckTrackerService.cleanEditListener();
            }]
        })
        // Просмотр проверки звонка не покидая списка звонков
        .state('phone-call.viewPhoneCallCheck', {
            parent: 'phone-call',
            url: '/phone-call-check-detail/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR', 'ROLE_CHECKER', 'ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call/phone-call-check-ext-detail.html',
                    controller: 'PhoneCallCheckDetailExtController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PhoneCallCheck', function(PhoneCallCheck) {
                            return PhoneCallCheck.get({id : $stateParams.id}).$promise;
                        }],
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('phoneCallCheck');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }],
                        previousState: ["$state", function ($state) {
                            var currentStateData = {
                                name: $state.current.name || 'phone-call',
                                params: $state.params,
                                url: $state.href($state.current.name, $state.params)
                            };
                            return currentStateData;
                        }]
                    }
                }).result.then(function() {
                    $state.go('phone-call', null, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallDialogController', PhoneCallDialogController);

    /* Added $locale, $filter
    PhoneCallDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PhoneCall', 'CloudPBX', 'PhoneCallStatus', 'AdvertisingSource', 'Employee', 'OfficePhone', 'Division', 'User', 'PhoneCallCheck'];

    function PhoneCallDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PhoneCall, CloudPBX, PhoneCallStatus, AdvertisingSource, Employee, OfficePhone, Division, User, PhoneCallCheck) {
    */
    PhoneCallDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PhoneCall', 'CloudPBX', 'PhoneCallStatus', 'AdvertisingSource', 'Employee', 'OfficePhone', 'Division', 'User', 'PhoneCallCheck', '$locale', '$filter'];

    function PhoneCallDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PhoneCall, CloudPBX, PhoneCallStatus, AdvertisingSource, Employee, OfficePhone, Division, User, PhoneCallCheck, $locale, $filter) {
        var vm = this;

        vm.phoneCall = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.cloudpbxes = CloudPBX.query();
        vm.phonecallstatuses = PhoneCallStatus.query();
        /*
        vm.advertisingsources = AdvertisingSource.query();
        vm.employees = Employee.query();
        vm.officephones = OfficePhone.query();
        vm.divisions = Division.query();
        */
        vm.advertisingsources = AdvertisingSource.query({size: 9999, sort: 'name,asc', actual: false});
        vm.employees = Employee.query({size:9999, sort: 'fullname,asc', actual: false});
        vm.officephones = OfficePhone.query({size:9999, sort: 'title,asc', actual: false});
        vm.divisions = Division.query({size:9999, sort: 'title,asc', actual: false});
        vm.users = User.query();
        vm.phonecallchecks = PhoneCallCheck.query();
        vm.dateformat = $locale.DATETIME_FORMATS.medium;
        calcTitle();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.phoneCall.id !== null) {
                PhoneCall.update(vm.phoneCall, onSaveSuccess, onSaveError);
            } else {
                PhoneCall.save(vm.phoneCall, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('telestatApp:phoneCallUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.callTime = false;
        vm.datePickerOpenStatus.createTime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function calcTitle() {
            var title = $filter('date')(vm.phoneCall.callTime, 'dd.MM.yy HH:mm') + " " + vm.phoneCall.callingCaption + " → " + vm.phoneCall.calledCaption;
            if (vm.phoneCall.calledEmployee != null) {
                title += " (" + vm.phoneCall.calledEmployee.division.name + ")";
            }
            vm.phoneCall.title = title;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallDetailController', PhoneCallDetailController);

    /* Added UIFormAccess, $filter
    PhoneCallDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PhoneCall', 'CloudPBX', 'PhoneCallStatus', 'AdvertisingSource', 'Employee', 'OfficePhone', 'Division', 'User', 'PhoneCallCheck'];

    function PhoneCallDetailController($scope, $rootScope, $stateParams, previousState, entity, PhoneCall, CloudPBX, PhoneCallStatus, AdvertisingSource, Employee, OfficePhone, Division, User, PhoneCallCheck) {
    */
    PhoneCallDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PhoneCall', 'CloudPBX', 'PhoneCallStatus', 'AdvertisingSource', 'Employee', 'OfficePhone', 'Division', 'User', 'PhoneCallCheck', 'UIFormAccess', '$filter'];

    function PhoneCallDetailController($scope, $rootScope, $stateParams, previousState, entity, PhoneCall, CloudPBX, PhoneCallStatus, AdvertisingSource, Employee, OfficePhone, Division, User, PhoneCallCheck, UIFormAccess, $filter) {
        var vm = this;

        vm.phoneCall = entity;
        vm.previousState = previousState.name;
        vm.UIFormAccess = UIFormAccess;
        calcTitle();

        var unsubscribe = $rootScope.$on('telestatApp:phoneCallUpdate', function(event, result) {
            vm.phoneCall = result;
        });
        $scope.$on('$destroy', unsubscribe);

        function calcTitle() {
            var title = $filter('date')(vm.phoneCall.callTime, 'dd.MM.yy HH:mm') + " " + vm.phoneCall.callingCaption + " → " + vm.phoneCall.calledCaption;
            if (vm.phoneCall.calledEmployee != null) {
                title += " (" + vm.phoneCall.calledEmployee.division.name + ")";
            }
            vm.phoneCall.title = title;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallDeleteController',PhoneCallDeleteController);

    PhoneCallDeleteController.$inject = ['$uibModalInstance', 'entity', 'PhoneCall'];

    function PhoneCallDeleteController($uibModalInstance, entity, PhoneCall) {
        var vm = this;

        vm.phoneCall = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PhoneCall.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallCheckDetailExtController', PhoneCallCheckDetailExtController);

    PhoneCallCheckDetailExtController.$inject = ['entity', '$uibModalInstance'];

    function PhoneCallCheckDetailExtController(entity, $uibModalInstance) {
        var vm = this;

        vm.phoneCallCheck = entity;
        vm.clear = clear;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('phone-call', {
            parent: 'entity',
            /*
            url: '/phone-call?page&sort&search',
            */
            url: '/phone-call?page&sort&search&searchType&startDate&endDate&insignificantFilter&inCallsHideFilter&outCallsHideFilter&missedCallsHideFilter&uncheckedOnlyFilter&repeatedCallsFilter&divisionId',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.phoneCall.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/phone-call/phone-calls.html',
                    controller: 'PhoneCallController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    /*
                    value: 'id,asc',
                    */
                    value: 'callTime,desc',
                    squash: true
                },
                /*
                search: null
                */
                search: null,
                searchType: {
                    value: 'all',
                    squash: true
                },
                divisionId: {
                    value: null,
                    squash: true
                },
                startDate: null,
                endDate: null,
                inCallsHideFilter: {
                    value: 'false',
                    squash: true
                },
                outCallsHideFilter: {
                    value: 'false',
                    squash: true
                },
                missedCallsHideFilter: {
                    value: 'false',
                    squash: true
                },
                insignificantFilter: {
                    value: 'true',
                    squash: true
                },
                uncheckedOnlyFilter: {
                    value: 'false',
                    squash: true
                },
                repeatedCallsFilter: {
                    value: 'true',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        /*
                        search: $stateParams.search
                        */
                        search: $stateParams.search,
                        searchType: $stateParams.searchType,
                        startDate: $stateParams.startDate,
                        endDate: $stateParams.endDate,
                        inCallsHideFilter: $stateParams.inCallsHideFilter,
                        outCallsHideFilter: $stateParams.outCallsHideFilter,
                        missedCallsHideFilter: $stateParams.missedCallsHideFilter,
                        insignificantFilter: $stateParams.insignificantFilter,
                        uncheckedOnlyFilter: $stateParams.uncheckedOnlyFilter,
                        repeatedCallsFilter: $stateParams.repeatedCallsFilter,
                        divisionId: $stateParams.divisionId
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('phoneCall');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('datefilter');
                    $translatePartialLoader.addPart('reports');
                    return $translate.refresh();
                }]
            },
            onEnter: ['PhoneCallCheckTrackerService', 'Principal', function(PhoneCallCheckTrackerService, Principal) {
                if (Principal.hasAnyAuthority(['ROLE_ADMIN','ROLE_DIRECTOR','ROLE_CHECKER'])) {
                    PhoneCallCheckTrackerService.subscribe();
                }
            }],
            onExit: ['PhoneCallCheckTrackerService', 'Principal', function(PhoneCallCheckTrackerService, Principal) {
                if (Principal.hasAnyAuthority(['ROLE_ADMIN','ROLE_DIRECTOR','ROLE_CHECKER'])) {
                    PhoneCallCheckTrackerService.cleanListener();
                }
            }]
        })
        .state('phone-call-detail', {
            parent: 'phone-call',
            url: '/phone-call/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.phoneCall.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/phone-call/phone-call-detail.html',
                    controller: 'PhoneCallDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('phoneCall');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PhoneCall', function($stateParams, PhoneCall) {
                    return PhoneCall.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'phone-call',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('phone-call-detail.edit', {
            parent: 'phone-call-detail',
            url: '/detail/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR', 'ROLE_CHECKER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call/phone-call-dialog.html',
                    controller: 'PhoneCallDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PhoneCall', function(PhoneCall) {
                            return PhoneCall.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('phone-call.new', {
            parent: 'phone-call',
            url: '/new',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_NO_SUCH_ROLE'] // никто не должен создавать запись с формы
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call/phone-call-dialog.html',
                    controller: 'PhoneCallDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                callId: null,
                                callTime: null,
                                callingNumber: null,
                                user: null,
                                calledNumber: null,
                                callingCaption: null,
                                calledCaption: null,
                                waitDuration: null,
                                realWaitDuration: null,
                                talkDuration: null,
                                recordURL: null,
                                modifierCaption: null,
                                createTime: null,
                                notFinal: false,
                                sequenceCallId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('phone-call', null, { reload: 'phone-call' });
                }, function() {
                    $state.go('phone-call');
                });
            }]
        })
        .state('phone-call.edit', {
            parent: 'phone-call',
            url: '/{id}/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR', 'ROLE_CHECKER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call/phone-call-dialog.html',
                    controller: 'PhoneCallDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PhoneCall', function(PhoneCall) {
                            return PhoneCall.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('phone-call', null, { reload: 'phone-call' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('phone-call.delete', {
            parent: 'phone-call',
            url: '/{id}/delete',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call/phone-call-delete-dialog.html',
                    controller: 'PhoneCallDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PhoneCall', function(PhoneCall) {
                            return PhoneCall.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('phone-call', null, { reload: 'phone-call' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('PhoneCall', PhoneCall);

    PhoneCall.$inject = ['$resource', 'DateUtils'];

    function PhoneCall ($resource, DateUtils) {
        var resourceUrl =  'api/phone-calls/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.callTime = DateUtils.convertDateTimeFromServer(data.callTime);
                        data.createTime = DateUtils.convertDateTimeFromServer(data.createTime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('PhoneCallSearch', PhoneCallSearch);

    PhoneCallSearch.$inject = ['$resource'];

    function PhoneCallSearch($resource) {
        var resourceUrl =  'api/_search/phone-calls/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        /*
         * Фильтр используется в phone-calls.html, phone-call-dialog.html
         * позволяет загрузку phoneCall.recordURL (mp3) с внешнего ресурса.
         */
        .filter('trusted', ['$sce', function ($sce) {
            return function(url) {
                return $sce.trustAsResourceUrl(url);
            };
        }])
        .filter('MMss', function () {
            return function (sec) {
                if (sec == null) {
                    return '-';
                }
                var sec_num = parseInt(sec, 10);
                var minutes = Math.floor(sec_num / 60);
                var seconds = sec_num - minutes * 60;
                if (minutes < 10) {minutes = "0" + minutes;}
                if (seconds < 10) {seconds = "0" + seconds;}
                return minutes + ':' + seconds;
            };
        });
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallController', PhoneCallController);

    /* Added $scope, UIFormAccess, $filter, Principal, PhoneCallCheckTrackerService, Division, $translate
    PhoneCallController.$inject = ['$state', 'PhoneCall', 'PhoneCallSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function PhoneCallController($state, PhoneCall, PhoneCallSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {
    */
    PhoneCallController.$inject = ['$scope', '$state', 'PhoneCall', 'PhoneCallSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'UIFormAccess', '$filter', 'Principal', 'PhoneCallCheckTrackerService', 'Division', '$translate', '$timeout'];

    function PhoneCallController ($scope, $state, PhoneCall, PhoneCallSearch, ParseLinks, AlertService, paginationConstants, pagingParams, UIFormAccess, $filter, Principal, PhoneCallCheckTrackerService, Division, $translate, $timeout) {
        var vm = this;
        vm.timer = null;

        vm.divisionsFilterData = {
                pagingParams: pagingParams,
                division: {id:pagingParams.divisionId},
                divisions: null,
                loadAll: transition
        };

        vm.infoCallBack = infoCallBack;
        if (Principal.hasAnyAuthority(['ROLE_ADMIN','ROLE_DIRECTOR','ROLE_CHECKER'])) {
            PhoneCallCheckTrackerService.setListener().then(
                null, null,
                function (dto) {
                    infoCallBack(dto);
                }
            );
        }

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        /*
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        */
        vm.itemsPerPage = paginationConstants.itemsPerLargePage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        vm.UIFormAccess = UIFormAccess;
        /*
        loadAll();
        */
        // search with time limits
        vm.inCallsHideFilter = pagingParams.inCallsHideFilter == 'true';
        vm.outCallsHideFilter = pagingParams.outCallsHideFilter == 'true';
        vm.missedCallsHideFilter = pagingParams.missedCallsHideFilter == 'true';
        vm.insignificantFilter = pagingParams.insignificantFilter == 'true';
        vm.uncheckedOnlyFilter = pagingParams.uncheckedOnlyFilter == 'true';
        vm.repeatedCallsFilter = pagingParams.repeatedCallsFilter == 'true';
        vm.dateFilterData = {
                allActive: true,
                search: search,
                searchQuery: vm.searchQuery,
                setFilterType: function(){},
                pagingParams: pagingParams,
                initCallBack: loadAll
        };


        vm.PrincipalIsAdmin = false;
        Principal.hasAuthority('ROLE_ADMIN').then(function (result) {
            if (result) {
                vm.PrincipalIsAdmin = true;
            }
        });

        vm.PrincipalIsManager = false;
        Principal.hasAuthority('ROLE_MANAGER').then(function (result) {
            if (result) {
                vm.PrincipalIsManager = true;
            }
        });

        vm.accessToStateEditPhoneCallCheck = UIFormAccess.checkStateAccess('phone-call.editPhoneCallCheck');
        vm.accessToStateNewPhoneCallCheck = UIFormAccess.checkStateAccess('phone-call.newPhoneCallCheck');
        vm.accessToStateEdit = UIFormAccess.checkStateAccess('phone-call.edit');

        $scope.dynamicPopover = {
            //---This is need to load tooltip from template--//
            content: 'player',
            templateUrl: 'popoverTemplateId',
            title: 'Records'
        };

        $scope.openPlayer = function(phoneCall, autoplay) {
            if(autoplay) {
                phoneCall.isPopoverPlaying = false;
            }
            var audio = $('audio#audio-'+phoneCall.id);
            if(audio.length > 0) {
                phoneCall.isPopoverPlaying = !audio[0].paused;
            }
        };

        $scope.playerSetSpeed = function(elID, speed) {
            var audio = document.getElementById('audio-'+elID);
	    audio.playbackRate = speed; 
        };

        function preLoadAll () {
            var t = vm.timer;
            vm.timer = null;
            if (t != null) {
                $timeout.cancel(t);
                loadAll();
            }
        }
        vm.lastLoaded = 0;

        function loadAll () {
            var now = (new Date()).getTime();
            if (vm.lastLoaded + 2000 > now) {
                console.log('Protection from game: lastLoaded=' + vm.lastLoaded + ', now=' + now);
                return;
            }
            vm.lastLoaded = now;
            console.log('LOADING: lastLoaded=' + vm.lastLoaded);
            console.log($scope);
            if (pagingParams.search) {
                PhoneCallSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    /*
                    sort: sort()
                    */
                    sort: sort(),
                    // search with time limits
                    startDate: vm.dateFilterData.dateFilterType == 'all' ? null : $filter('date')(vm.dateFilterData.startDate, "yyyy-MM-dd", 0),
                    endDate: vm.dateFilterData.dateFilterType == 'all' ? null : $filter('date')(vm.dateFilterData.endDate, "yyyy-MM-dd", 0),
                    statusInHide: vm.inCallsHideFilter,
                    statusOutHide: vm.outCallsHideFilter,
                    statusMissedHide: vm.missedCallsHideFilter,
                    insignificant: vm.insignificantFilter,
                    unchecked: vm.uncheckedOnlyFilter,
                    repeated: vm.repeatedCallsFilter,
                    divisionId: vm.divisionsFilterData.division == null ? null : vm.divisionsFilterData.division.id
                }, onSuccess, onError);
            } else {
                PhoneCall.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    /*
                    sort: sort()
                    */
                    sort: sort(),
                    // search with time limits
                    startDate: vm.dateFilterData.dateFilterType == 'all' ? null : $filter('date')(vm.dateFilterData.startDate, "yyyy-MM-dd", 0),
                    endDate: vm.dateFilterData.dateFilterType == 'all' ? null : $filter('date')(vm.dateFilterData.endDate, "yyyy-MM-dd", 0),
                    statusInHide: vm.inCallsHideFilter,
                    statusOutHide: vm.outCallsHideFilter,
                    statusMissedHide: vm.missedCallsHideFilter,
                    insignificant: vm.insignificantFilter,
                    unchecked: vm.uncheckedOnlyFilter,
                    repeated: vm.repeatedCallsFilter,
                    divisionId: vm.divisionsFilterData.division == null ? null : vm.divisionsFilterData.division.id
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                /*
                if (vm.predicate !== 'id') {
                    result.push('id');
                */
                if (vm.predicate !== 'callTime') {
                    result.push('callTime,desc');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;

                // Mark editing
                data.forEach(function(item){
                    if (item.phoneCallCheck == null) {
                        var dto = PhoneCallCheckTrackerService.checkPhoneCallId(item.id)
                        if (dto != null && dto['action'] == 'edit') {
                            item.phoneCallCheck = 'editing';
                        } else if (item.phoneCallCheck == 'editing' && dto == null) { //|| dto['action'] != 'edit'
                            item.phoneCallCheck = null;
                        }
                    }
                });

                vm.phoneCalls = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            vm.dateFilterData.updateDateFilterType();
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                /*
                search: vm.currentSearch
                */
                search: vm.currentSearch,
                // search with time limits
                searchType: vm.dateFilterData.dateFilterType,
                startDate: vm.dateFilterData.dateFilterType == 'day' || vm.dateFilterData.dateFilterType == 'range' ? $filter('date')(vm.dateFilterData.startDate, "yyyy-MM-dd", 0) : null,
                endDate: vm.dateFilterData.dateFilterType == 'day' || vm.dateFilterData.dateFilterType == 'range' ? $filter('date')(vm.dateFilterData.endDate, "yyyy-MM-dd", 0) : null,
                inCallsHideFilter: vm.inCallsHideFilter,
                outCallsHideFilter: vm.outCallsHideFilter,
                missedCallsHideFilter: vm.missedCallsHideFilter,
                insignificantFilter: vm.insignificantFilter,
                uncheckedOnlyFilter: vm.uncheckedOnlyFilter,
                repeatedCallsFilter: vm.repeatedCallsFilter,
                divisionId: vm.divisionsFilterData.division == null ? null : vm.divisionsFilterData.division.id
            });
        }

        /*
        function search(searchQuery) {
            if (!searchQuery){
        */
        function search() {
            var searchQuery = vm.searchQuery;
            if (!searchQuery && vm.dateFilterData.dateFilterType == 'all'){
                return vm.clear(true);
            } else if(!searchQuery) {
                vm.currentSearch = null;
            } else {
                vm.predicate = 'callTime';
                vm.reverse = false;
                vm.currentSearch = searchQuery;
            }
            vm.links = null;
            vm.page = 1;
            /*
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            */
            vm.transition();
        }

        function clear(fromSearch) {
            vm.links = null;
            vm.page = 1;
            /*
            vm.predicate = 'id';
            vm.reverse = true;
            */
            vm.predicate = 'callTime';
            vm.reverse = false;
            vm.currentSearch = null;
            vm.dateFilterData.setFilterType('all');
            if (!fromSearch) {
                vm.divisionsFilterData.division = {id:null};
            }
            vm.transition();
        }

        function makeAction(dto, callBack) {
            if (vm.phoneCalls != null) {
                for(var i=0;i<vm.phoneCalls.length;i++) {
                    if(vm.phoneCalls[i]['id'] == dto.phoneCallId) {
                        callBack(vm.phoneCalls[i]);
                        break;
                    }
                }
            }
        }

        function infoCallBack(dto) {
            //console.log("INFO CALL BACK:");
            //console.log(dto);
            if (dto.action == 'edit') {
                makeAction(dto, function(p){
                    if (p['phoneCallCheck'] == null) {
                        p['phoneCallCheck'] = 'editing';
                    }
                });
            } else if (dto.action == 'close') {
                makeAction(dto, function(p){
                    if (p['phoneCallCheck'] == 'editing') {
                        p['phoneCallCheck'] = null;
                    }
                });
            } else if (dto.action == 'save') {
                makeAction(dto, function(p){
                    if (vm.timer == null) {
                        vm.timer = $timeout(preLoadAll, 2000);
                    }
                });
            } else if (dto.action == 'clean') {
                if (vm.timer == null) {
                    vm.timer = $timeout(preLoadAll, 2000);
                }
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('OfficePhoneDialogController', OfficePhoneDialogController);

    /* Added $filter
    OfficePhoneDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'OfficePhone'];

    function OfficePhoneDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, OfficePhone) {
    */
    OfficePhoneDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'OfficePhone', '$filter'];

    function OfficePhoneDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, OfficePhone, $filter) {
        var vm = this;

        vm.officePhone = entity;
        vm.clear = clear;
        vm.save = save;
        vm.calcProps = calcProps;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.officePhone.id !== null) {
                OfficePhone.update(vm.officePhone, onSaveSuccess, onSaveError);
            } else {
                OfficePhone.save(vm.officePhone, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('telestatApp:officePhoneUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function calcProps() {
            if (vm.officePhone.number == null || vm.officePhone.caption == null) {
                return;
            }
            var phone = $filter('phone')(vm.officePhone.number, '');
            // refers to ru.inquarta.telestat.domain.util.PropsStringUtils.DEFAULT_PHONE_CODES_STR
            phone = phone.replace(/^\+7\(861\)|\+7\(988\)/, '');
            vm.officePhone.title = vm.officePhone.caption + " " + phone;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('OfficePhoneDetailController', OfficePhoneDetailController);

    /* Added UIFormAccess
    OfficePhoneDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'OfficePhone'];

    function OfficePhoneDetailController($scope, $rootScope, $stateParams, previousState, entity, OfficePhone) {
    */
    OfficePhoneDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'OfficePhone', 'UIFormAccess'];

    function OfficePhoneDetailController($scope, $rootScope, $stateParams, previousState, entity, OfficePhone, UIFormAccess) {
        var vm = this;

        vm.officePhone = entity;
        vm.previousState = previousState.name;
        vm.UIFormAccess = UIFormAccess;

        var unsubscribe = $rootScope.$on('telestatApp:officePhoneUpdate', function(event, result) {
            vm.officePhone = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('OfficePhoneDeleteController',OfficePhoneDeleteController);

    OfficePhoneDeleteController.$inject = ['$uibModalInstance', 'entity', 'OfficePhone'];

    function OfficePhoneDeleteController($uibModalInstance, entity, OfficePhone) {
        var vm = this;

        vm.officePhone = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            OfficePhone.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('office-phone', {
            parent: 'entity',
            /*
            url: '/office-phone?page&sort&search',
            */
            url: '/office-phone?page&sort&search&actualFilter',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.officePhone.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/office-phone/office-phones.html',
                    controller: 'OfficePhoneController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                actualFilter: {
                    value: 'true',
                    squash: true
                },
                sort: {
                    /*
                    value: 'id,asc',
                    */
                    value: 'number,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        actualFilter: $stateParams.actualFilter,
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('officePhone');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('office-phone-detail', {
            parent: 'office-phone',
            url: '/office-phone/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.officePhone.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/office-phone/office-phone-detail.html',
                    controller: 'OfficePhoneDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('officePhone');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'OfficePhone', function($stateParams, OfficePhone) {
                    return OfficePhone.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'office-phone',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('office-phone-detail.edit', {
            parent: 'office-phone-detail',
            url: '/detail/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/office-phone/office-phone-dialog.html',
                    controller: 'OfficePhoneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['OfficePhone', function(OfficePhone) {
                            return OfficePhone.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('office-phone.new', {
            parent: 'office-phone',
            url: '/new',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/office-phone/office-phone-dialog.html',
                    controller: 'OfficePhoneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                name: null,
                                caption: null,
                                number: null,
                                /*
                                actual: false,
                                */
                                short_number: null,
                                actual: true,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('office-phone', null, { reload: 'office-phone' });
                }, function() {
                    $state.go('office-phone');
                });
            }]
        })
        .state('office-phone.edit', {
            parent: 'office-phone',
            url: '/{id}/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/office-phone/office-phone-dialog.html',
                    controller: 'OfficePhoneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['OfficePhone', function(OfficePhone) {
                            return OfficePhone.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('office-phone', null, { reload: 'office-phone' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('office-phone.delete', {
            parent: 'office-phone',
            url: '/{id}/delete',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/office-phone/office-phone-delete-dialog.html',
                    controller: 'OfficePhoneDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['OfficePhone', function(OfficePhone) {
                            return OfficePhone.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('office-phone', null, { reload: 'office-phone' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('OfficePhone', OfficePhone);

    OfficePhone.$inject = ['$resource'];

    function OfficePhone ($resource) {
        var resourceUrl =  'api/office-phones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('OfficePhoneSearch', OfficePhoneSearch);

    OfficePhoneSearch.$inject = ['$resource'];

    function OfficePhoneSearch($resource) {
        var resourceUrl =  'api/_search/office-phones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('OfficePhoneController', OfficePhoneController);

    /* Added UIFormAccess
    OfficePhoneController.$inject = ['$state', 'OfficePhone', 'OfficePhoneSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function OfficePhoneController($state, OfficePhone, OfficePhoneSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {
    */
    OfficePhoneController.$inject = ['$state', 'OfficePhone', 'OfficePhoneSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'UIFormAccess'];

    function OfficePhoneController($state, OfficePhone, OfficePhoneSearch, ParseLinks, AlertService, paginationConstants, pagingParams, UIFormAccess) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.actualFilter = pagingParams.actualFilter == 'true';
        vm.UIFormAccess = UIFormAccess;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                OfficePhoneSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    actual: vm.actualFilter,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                OfficePhone.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    actual: vm.actualFilter,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                /*
                if (vm.predicate !== 'id') {
                    result.push('id');
                */
                if (vm.predicate !== 'number') {
                    result.push('number');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.officePhones = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                actualFilter: vm.actualFilter,
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            /*
            vm.predicate = 'id';
            */
            vm.predicate = 'number';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('megafon-internal-phones', {
            parent: 'entity',
            url: '/megafon-internal-phones',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR', 'ROLE_MANAGER'],
                pageTitle: 'telestatApp.megafonInternalPhones.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/megafon-internal-phones/megafon-internal-phones.html',
                    controller: 'MegafonInternalPhonesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('megafonInternalPhones');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('MegafonInternalPhonesService', MegafonInternalPhonesService);

    MegafonInternalPhonesService.$inject = ['$resource'];

    function MegafonInternalPhonesService ($resource) {
        var resourceUrl =  'api/pbx/megafon';

        return $resource(resourceUrl, {}, {
            'getinternal': {
                method: 'GET',
                url: 'api/megafon-internal-phones',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
			const filteredData = [];
			for (var i = 0; i < data.length; i++) {
			    if (data[i].ri != undefined && data[i].ri.reginfo != undefined && data[i].ri.reginfo.length > 0){
				filteredData.push(data[i]);
			    }
			}
			data = filteredData;
                    }
                    return data;
                },
                isArray: true
            }/*,
            'getfreeCsv': {
                method: 'GET',
                url: 'api/pbx/megafon/getfree-csv'
            },
            'setLockTime': {
                method:'POST',
                url: 'api/pbx/megafon/set-locktime'
            },
            'moveToLocked': {
                method:'POST',
                url: 'api/pbx/megafon/move-to-locked'
            },
            'moveToSim': {
                method:'POST',
                url: 'api/pbx/megafon/move-to-sim'
            }*/
        });
    }
})();

(function() {
	'use strict';

	angular.module('telestatApp').controller('MegafonInternalPhonesController',
			MegafonInternalPhonesController);

	MegafonInternalPhonesController.$inject = [ '$state', 'AlertService',
			'UIFormAccess', 'MegafonInternalPhonesService' ];

	function MegafonInternalPhonesController($state, AlertService,
			UIFormAccess, MegafonInternalPhonesService) {

		var vm = this;

		vm.UIFormAccess = UIFormAccess;

		loadAll();
		vm.loadAll = loadAll;

		function loadAll() {
			MegafonInternalPhonesService.getinternal({}, onSuccess, onError);
			function onSuccess(data, headers) {				
				vm.accounts = data.map(function(a) {
					return {
						account : a,
						error : 0,
						msg : ''
					};
				});
			}
			function onError(error) {
				AlertService.error(error.data.message);
			}
		}

	}
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('megafon-free-numbers', {
            parent: 'dictionary',
            url: '/megafon-free-numbers',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR', 'ROLE_MANAGER'],
                pageTitle: 'telestatApp.megafonFreeNumbers.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/megafon-free-numbers/megafon-free-numbers.html',
                    controller: 'MegafonFreeNumbersController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('megafonFreeNumbers');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('megafon-free-numbers.lock', {
            parent: 'megafon-free-numbers',
            url: '/{number}/lock',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_DIRECTOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                // RIGHTS MANAGEMENT
            }]
        })
        .state('megafon-free-numbers.sim', {
            parent: 'megafon-free-numbers',
            url: '/{number}/sim',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                // RIGHTS MANAGEMENT
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('MegafonFreeNumbersService', MegafonFreeNumbersService);

    MegafonFreeNumbersService.$inject = ['$resource'];

    function MegafonFreeNumbersService ($resource) {
        var resourceUrl =  'api/pbx/megafon';

        return $resource(resourceUrl, {}, {
            'getfree': {
                method: 'GET',
                url: 'api/pbx/megafon/getfree',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                },
                isObject: true
            },
            'getfreeCsv': {
                method: 'GET',
                url: 'api/pbx/megafon/getfree-csv'
            },
            'setLockTime': {
                method:'POST',
                url: 'api/pbx/megafon/set-locktime'
            },
            'moveToLocked': {
                method:'POST',
                url: 'api/pbx/megafon/move-to-locked'
            },
            'moveToSim': {
                method:'POST',
                url: 'api/pbx/megafon/move-to-sim'
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('MegafonFreeNumbersController', MegafonFreeNumbersController);

    MegafonFreeNumbersController.$inject = ['$state', 'AlertService', 'UIFormAccess', 'MegafonFreeNumbersService'];

    function MegafonFreeNumbersController($state, AlertService, UIFormAccess, MegafonFreeNumbersService) {

        var vm = this;

        vm.UIFormAccess = UIFormAccess;

        loadAll();
        vm.loadAll = loadAll;
        vm.lock = lockNumber;
        vm.sim = simNumber;
        vm.lockVirtual = lockForTimeoutNumber;

        function loadAll () {
            MegafonFreeNumbersService.getfree({}, onSuccess, onError);
            function onSuccess(data, headers) {
                vm.numbers = [];
		for (var key in data) {
		    if (data.hasOwnProperty(key)) {
			vm.numbers.push({number:key, error:0, msg:data[key], locked:false});
		    }
		}

		// vm.numbers = data.map(function(a){
                // return {number: a, error: 0, msg: '', locked: false};
                // });
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }


        function lockNumber(a) {
            a.locked = true;
            vm.numbers.forEach(function(a){a.error=0});
            MegafonFreeNumbersService.moveToLocked(a.number, onSuccess, onError);
            function onSuccess(data, headers) {
                loadAll();
            }
            function onError(error) {
                a.locked = false;
                a.error = 1;
                AlertService.error(error.data.message);
                setTimeout(function() {
                    a.error = 0;
                }, 5000);
            }
        }

        function lockForTimeoutNumber(a) {
            a.locked = true;
            vm.numbers.forEach(function(a){a.error=0});
            MegafonFreeNumbersService.setLockTime(a.number, onSuccess, onError);
            function onSuccess(data, headers) {
                a.locked = true;
                a.number = a.number + " зарезервирован на 10 минут";
            }
            function onError(error) {
                a.locked = false;
                a.error = 1;
                AlertService.error(error.data.message);
                setTimeout(function() {
                    a.error = 0;
                }, 5000);
            }
        }

        function simNumber(a) {
            a.locked = true;
            vm.numbers.forEach(function(a){a.error=0});
            MegafonFreeNumbersService.moveToSim(a.number, onSuccess, onError);
            function onSuccess(data, headers) {
                loadAll();
            }
            function onError(error) {
                a.locked = false;
                a.error = 1;
                AlertService.error(error.data.message);
                setTimeout(function() {
                    a.error = 0;
                }, 5000);
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('ExternalResourceRunController',ExternalResourceRunController);

    ExternalResourceRunController.$inject = ['$uibModalInstance', 'entity', 'ExternalResource'];

    function ExternalResourceRunController($uibModalInstance, entity, ExternalResource) {
        var vm = this;

        vm.externalResource = entity;
        vm.clear = clear;
        vm.confirmRun = confirmRun;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmRun (id) {
            ExternalResource.run({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('external-resource.run', {
            parent: 'external-resource',
            url: '/{id}/run',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/external-resource/external-resource-run-dialog.html',
                    controller: 'ExternalResourceRunController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ExternalResource', function(ExternalResource) {
                            return ExternalResource.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('external-resource', null, { reload: 'external-resource' });
                }, function() {
                    $state.go('^');
                });
            }]
        });

    }

})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('ExternalResourceDialogController', ExternalResourceDialogController);

    ExternalResourceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ExternalResource', 'AdvertisingSource'];

    function ExternalResourceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ExternalResource, AdvertisingSource) {
        var vm = this;

        vm.externalResource = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.advertisingsources = AdvertisingSource.query();
        // Flush healthIndicator&lastModified
        vm.externalResource.healthIndicator = null;
        vm.externalResource.lastModified = null;

        // FIXME найти лучшую конфигурацию по настройке времени.
        vm.datePickerOptions = {
            enableDate: false,
            mode: 'hour',
            minMode: 'minute',
            maxMode: 'hour'
        };
        vm.updateLoadingType = updateLoadingType;
        vm.charsets = ["UTF-8", "cp1251"];
        function updateLoadingType() {
            if (vm.externalResource.loadingType == 0) {
                if (vm.externalResource.loadTime == null || vm.externalResource.loadTime == '') {
                    vm.externalResource.loadTime = 0;
                }
            } else {
                if (vm.externalResource.period == null || vm.externalResource.period == '') {
                    vm.externalResource.period = 0;
                }
            }
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.externalResource.id !== null) {
                ExternalResource.update(vm.externalResource, onSaveSuccess, onSaveError);
            } else {
                ExternalResource.save(vm.externalResource, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('telestatApp:externalResourceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.loadTime = false;
        vm.datePickerOpenStatus.lastDownload = false;
        vm.datePickerOpenStatus.lastSuccessProcessing = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('ExternalResourceDetailController', ExternalResourceDetailController);

    ExternalResourceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ExternalResource', 'AdvertisingSource'];

    function ExternalResourceDetailController($scope, $rootScope, $stateParams, previousState, entity, ExternalResource, AdvertisingSource) {
        var vm = this;

        vm.externalResource = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('telestatApp:externalResourceUpdate', function(event, result) {
            vm.externalResource = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('ExternalResourceDeleteController',ExternalResourceDeleteController);

    ExternalResourceDeleteController.$inject = ['$uibModalInstance', 'entity', 'ExternalResource'];

    function ExternalResourceDeleteController($uibModalInstance, entity, ExternalResource) {
        var vm = this;

        vm.externalResource = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ExternalResource.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('external-resource', {
            /*
            parent: 'entity',
            */
            parent: 'admin',
            url: '/external-resource?page&sort&search',
            data: {
                /*
                authorities: ['ROLE_USER'],
                */
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'telestatApp.externalResource.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/external-resource/external-resources.html',
                    controller: 'ExternalResourceController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('externalResource');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('external-resource-detail', {
            parent: 'external-resource',
            url: '/external-resource/{id}',
            data: {
                /*
                authorities: ['ROLE_USER'],
                */
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'telestatApp.externalResource.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/external-resource/external-resource-detail.html',
                    controller: 'ExternalResourceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('externalResource');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ExternalResource', function($stateParams, ExternalResource) {
                    return ExternalResource.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'external-resource',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('external-resource-detail.edit', {
            parent: 'external-resource-detail',
            url: '/detail/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/external-resource/external-resource-dialog.html',
                    controller: 'ExternalResourceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ExternalResource', function(ExternalResource) {
                            return ExternalResource.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('external-resource.new', {
            parent: 'external-resource',
            url: '/new',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/external-resource/external-resource-dialog.html',
                    controller: 'ExternalResourceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                externalUrl: null,
                                loadingType: null,
                                period: null,
                                loadTime: null,
                                lastDownload: null,
                                lastSuccessProcessing: null,
                                lastModified: null,
                                uploadFolder: null,
                                /*
                                actual: false,
                                */
                                actual: true,
                                healthIndicator: null,
                                description: null,
                                charset: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('external-resource', null, { reload: 'external-resource' });
                }, function() {
                    $state.go('external-resource');
                });
            }]
        })
        .state('external-resource.edit', {
            parent: 'external-resource',
            url: '/{id}/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/external-resource/external-resource-dialog.html',
                    controller: 'ExternalResourceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ExternalResource', function(ExternalResource) {
                            return ExternalResource.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('external-resource', null, { reload: 'external-resource' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('external-resource.delete', {
            parent: 'external-resource',
            url: '/{id}/delete',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/external-resource/external-resource-delete-dialog.html',
                    controller: 'ExternalResourceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ExternalResource', function(ExternalResource) {
                            return ExternalResource.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('external-resource', null, { reload: 'external-resource' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('ExternalResource', ExternalResource);

    ExternalResource.$inject = ['$resource', 'DateUtils'];

    function ExternalResource ($resource, DateUtils) {
        var resourceUrl =  'api/external-resources/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.loadTime = DateUtils.convertDateTimeFromServer(data.loadTime);
                        data.lastDownload = DateUtils.convertDateTimeFromServer(data.lastDownload);
                        data.lastSuccessProcessing = DateUtils.convertDateTimeFromServer(data.lastSuccessProcessing);
                    }
                    return data;
                }
            },
            'run': { method:'POST', url: 'api/external-resources/run/:id' },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('ExternalResourceSearch', ExternalResourceSearch);

    ExternalResourceSearch.$inject = ['$resource'];

    function ExternalResourceSearch($resource) {
        var resourceUrl =  'api/_search/external-resources/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('ExternalResourceController', ExternalResourceController);

    /* Added UIFormAccess
    ExternalResourceController.$inject = ['$state', 'ExternalResource', 'ExternalResourceSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function ExternalResourceController($state, ExternalResource, ExternalResourceSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {
    */
    ExternalResourceController.$inject = ['$state', 'ExternalResource', 'ExternalResourceSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'UIFormAccess'];

    function ExternalResourceController($state, ExternalResource, ExternalResourceSearch, ParseLinks, AlertService, paginationConstants, pagingParams, UIFormAccess) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.UIFormAccess = UIFormAccess;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                ExternalResourceSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ExternalResource.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.externalResources = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        }).state('dictionary', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('EmployeePhoneDialogController', EmployeePhoneDialogController);

    /* Added $locale
    EmployeePhoneDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'EmployeePhone', 'Employee', 'AdvertisingSource'];

    function EmployeePhoneDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, EmployeePhone, Employee, AdvertisingSource) {
    */
    EmployeePhoneDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'EmployeePhone', 'Employee', 'AdvertisingSource', 'PhoneType', '$locale'];

    function EmployeePhoneDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, EmployeePhone, Employee, AdvertisingSource, PhoneType, $locale) {
        var vm = this;

        vm.employeePhone = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        /*
        vm.employees = Employee.query();
        vm.advertisingsources = AdvertisingSource.query();
        */
        vm.employees = Employee.query({size: 9999, sort: 'fullname,asc', actual: false});
        vm.advertisingsources = AdvertisingSource.query({size: 9999, sort: 'name,asc', actual: false});
        vm.phonetypes = PhoneType.query({size: 9999, sort: 'name,asc', actual: false});
        vm.dateformat = $locale.DATETIME_FORMATS.short;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.employeePhone.id !== null) {
                EmployeePhone.update(vm.employeePhone, onSaveSuccess, onSaveError);
            } else {
                EmployeePhone.save(vm.employeePhone, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('telestatApp:employeePhoneUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.bindingTime = false;
        vm.datePickerOpenStatus.unbindingTime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('EmployeePhoneDetailController', EmployeePhoneDetailController);

    /* Added UIFormAccess
    EmployeePhoneDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'EmployeePhone', 'Employee', 'AdvertisingSource'];

    function EmployeePhoneDetailController($scope, $rootScope, $stateParams, previousState, entity, EmployeePhone, Employee, AdvertisingSource) {
    */
    EmployeePhoneDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'EmployeePhone', 'Employee', 'AdvertisingSource', 'PhoneType', 'UIFormAccess'];

    function EmployeePhoneDetailController($scope, $rootScope, $stateParams, previousState, entity, EmployeePhone, Employee, AdvertisingSource, PhoneType, UIFormAccess) {
        var vm = this;

        vm.employeePhone = entity;
        vm.previousState = previousState.name;
        vm.UIFormAccess = UIFormAccess;

        var unsubscribe = $rootScope.$on('telestatApp:employeePhoneUpdate', function(event, result) {
            vm.employeePhone = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('EmployeePhoneDeleteController',EmployeePhoneDeleteController);

    EmployeePhoneDeleteController.$inject = ['$uibModalInstance', 'entity', 'EmployeePhone'];

    function EmployeePhoneDeleteController($uibModalInstance, entity, EmployeePhone) {
        var vm = this;

        vm.employeePhone = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            EmployeePhone.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('employee-phone', {
            parent: 'entity',
            /*
            url: '/employee-phone?page&sort&search',
            */
            url: '/employee-phone?page&sort&search&actualFilter',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.employeePhone.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/employee-phone/employee-phones.html',
                    controller: 'EmployeePhoneController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                actualFilter: {
                    value: 'true',
                    squash: true
                },
                sort: {
                    /*
                    value: 'id,asc',
                    */
                    value: 'number,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        actualFilter: $stateParams.actualFilter,
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('employeePhone');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('employee-phone-detail', {
            parent: 'employee-phone',
            url: '/employee-phone/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.employeePhone.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/employee-phone/employee-phone-detail.html',
                    controller: 'EmployeePhoneDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('employeePhone');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'EmployeePhone', function($stateParams, EmployeePhone) {
                    return EmployeePhone.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'employee-phone',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('employee-phone-detail.edit', {
            parent: 'employee-phone-detail',
            url: '/detail/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/employee-phone/employee-phone-dialog.html',
                    controller: 'EmployeePhoneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EmployeePhone', function(EmployeePhone) {
                            return EmployeePhone.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('employee-phone.new', {
            parent: 'employee-phone',
            url: '/new',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/employee-phone/employee-phone-dialog.html',
                    controller: 'EmployeePhoneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                number: null,
                                bindingTime: null,
                                unbindingTime: null,
                                /*
                                actual: false,
                                */
                                actual: true,
                                externalId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('employee-phone', null, { reload: 'employee-phone' });
                }, function() {
                    $state.go('employee-phone');
                });
            }]
        })
        .state('employee-phone.edit', {
            parent: 'employee-phone',
            url: '/{id}/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/employee-phone/employee-phone-dialog.html',
                    controller: 'EmployeePhoneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EmployeePhone', function(EmployeePhone) {
                            return EmployeePhone.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('employee-phone', null, { reload: 'employee-phone' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('employee-phone.delete', {
            parent: 'employee-phone',
            url: '/{id}/delete',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/employee-phone/employee-phone-delete-dialog.html',
                    controller: 'EmployeePhoneDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['EmployeePhone', function(EmployeePhone) {
                            return EmployeePhone.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('employee-phone', null, { reload: 'employee-phone' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('EmployeePhone', EmployeePhone);

    EmployeePhone.$inject = ['$resource', 'DateUtils'];

    function EmployeePhone ($resource, DateUtils) {
        var resourceUrl =  'api/employee-phones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.bindingTime = DateUtils.convertDateTimeFromServer(data.bindingTime);
                        data.unbindingTime = DateUtils.convertDateTimeFromServer(data.unbindingTime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('EmployeePhoneSearch', EmployeePhoneSearch);

    EmployeePhoneSearch.$inject = ['$resource'];

    function EmployeePhoneSearch($resource) {
        var resourceUrl =  'api/_search/employee-phones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('EmployeePhoneController', EmployeePhoneController);

    /* Added UIFormAccess
    EmployeePhoneController.$inject = ['$state', 'EmployeePhone', 'EmployeePhoneSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function EmployeePhoneController($state, EmployeePhone, EmployeePhoneSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {
    */
    EmployeePhoneController.$inject = ['$state', 'EmployeePhone', 'EmployeePhoneSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'UIFormAccess'];

    function EmployeePhoneController($state, EmployeePhone, EmployeePhoneSearch, ParseLinks, AlertService, paginationConstants, pagingParams, UIFormAccess) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.actualFilter = pagingParams.actualFilter == 'true';
        vm.UIFormAccess = UIFormAccess;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                EmployeePhoneSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    actual: vm.actualFilter,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                EmployeePhone.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    actual: vm.actualFilter,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                /*
                if (vm.predicate !== 'id') {
                    result.push('id');
                */
                if (vm.predicate !== 'number') {
                    result.push('number');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.employeePhones = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                actualFilter: vm.actualFilter,
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            /*
            vm.predicate = 'id';
            */
            vm.predicate = 'number';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('EmployeeDialogController', EmployeeDialogController);

    /* Added $locale
    EmployeeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Employee', 'User', 'Division', 'EmployeePhone'];

    function EmployeeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Employee, User, Division, EmployeePhone) {
    */
    EmployeeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Employee', 'User', 'Division', 'EmployeePhone', '$locale'];

    function EmployeeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Employee, User, Division, EmployeePhone, $locale) {
        var vm = this;

        vm.employee = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        /*
        vm.users = User.query();
        vm.divisions = Division.query();
        // Лишний запрос всех телефонов
        vm.employeephones = EmployeePhone.query();
        */
        vm.users = User.query({size: 9999, sort: 'login,asc'});
        vm.divisions = Division.query({size: 9999, sort: 'title,asc', actual: false});
        vm.dateformat = $locale.DATETIME_FORMATS.shortDate;
        vm.calcProps = calcProps;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.employee.id !== null) {
                Employee.update(vm.employee, onSaveSuccess, onSaveError);
            } else {
                Employee.save(vm.employee, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('telestatApp:employeeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.birthday = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function calcProps() {
            if (vm.employee.name == null || vm.employee.surname == null || vm.employee.patronymic == null) {
                vm.employee.fullname = null;
                vm.employee.briefname = null;
                return;
            }
            var NON_BREAKING_SPACE = '\u00A0';
            vm.employee.fullname = vm.employee.surname + " " + vm.employee.name + " " + vm.employee.patronymic;
            vm.employee.briefname = vm.employee.surname + NON_BREAKING_SPACE + vm.employee.name.charAt(0) + "."
                    + NON_BREAKING_SPACE + vm.employee.patronymic.charAt(0) + ".";
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('EmployeeDetailController', EmployeeDetailController);

    /* Added UIFormAccess
    EmployeeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Employee', 'User', 'Division', 'EmployeePhone'];

    function EmployeeDetailController($scope, $rootScope, $stateParams, previousState, entity, Employee, User, Division, EmployeePhone) {
    */
    EmployeeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Employee', 'User', 'Division', 'EmployeePhone', 'UIFormAccess'];

    function EmployeeDetailController($scope, $rootScope, $stateParams, previousState, entity, Employee, User, Division, EmployeePhone, UIFormAccess) {
        var vm = this;

        vm.employee = entity;
        vm.previousState = previousState.name;
        vm.UIFormAccess = UIFormAccess;
        vm.employeePhones = EmployeePhone.query({employeeId: vm.employee.id});

        var unsubscribe = $rootScope.$on('telestatApp:employeeUpdate', function(event, result) {
            vm.employee = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('EmployeeDeleteController',EmployeeDeleteController);

    EmployeeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Employee'];

    function EmployeeDeleteController($uibModalInstance, entity, Employee) {
        var vm = this;

        vm.employee = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Employee.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('employee', {
            parent: 'entity',
            /*
            url: '/employee?page&sort&search',
            */
            url: '/employee?page&sort&search&actualFilter',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.employee.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/employee/employees.html',
                    controller: 'EmployeeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                actualFilter: {
                    value: 'true',
                    squash: true
                },
                sort: {
                    /*
                    value: 'id,asc',
                    */
                    value: 'surname,name,patronymic,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        actualFilter: $stateParams.actualFilter,
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('employee');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('employee-detail', {
            parent: 'employee',
            url: '/employee/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.employee.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/employee/employee-detail.html',
                    controller: 'EmployeeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('employee');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Employee', function($stateParams, Employee) {
                    return Employee.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'employee',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('employee-detail.edit', {
            parent: 'employee-detail',
            url: '/detail/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/employee/employee-dialog.html',
                    controller: 'EmployeeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Employee', function(Employee) {
                            return Employee.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('employee.new', {
            parent: 'employee',
            url: '/new',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/employee/employee-dialog.html',
                    controller: 'EmployeeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                surname: null,
                                name: null,
                                patronymic: null,
                                fullname: null,
                                briefname: null,
                                birthday: null,
                                /*
                                actual: false,
                                */
                                actual: true,
                                externalId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('employee', null, { reload: 'employee' });
                }, function() {
                    $state.go('employee');
                });
            }]
        })
        .state('employee.edit', {
            parent: 'employee',
            url: '/{id}/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/employee/employee-dialog.html',
                    controller: 'EmployeeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Employee', function(Employee) {
                            return Employee.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('employee', null, { reload: 'employee' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('employee.delete', {
            parent: 'employee',
            url: '/{id}/delete',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/employee/employee-delete-dialog.html',
                    controller: 'EmployeeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Employee', function(Employee) {
                            return Employee.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('employee', null, { reload: 'employee' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('Employee', Employee);

    Employee.$inject = ['$resource', 'DateUtils'];

    function Employee ($resource, DateUtils) {
        var resourceUrl =  'api/employees/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.birthday = DateUtils.convertLocalDateFromServer(data.birthday);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.birthday = DateUtils.convertLocalDateToServer(copy.birthday);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.birthday = DateUtils.convertLocalDateToServer(copy.birthday);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('EmployeeSearch', EmployeeSearch);

    EmployeeSearch.$inject = ['$resource'];

    function EmployeeSearch($resource) {
        var resourceUrl =  'api/_search/employees/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('EmployeeController', EmployeeController);

    /* Added UIFormAccess
    EmployeeController.$inject = ['$state', 'Employee', 'EmployeeSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function EmployeeController($state, Employee, EmployeeSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {
    */
    EmployeeController.$inject = ['$state', 'Employee', 'EmployeeSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'UIFormAccess'];

    function EmployeeController($state, Employee, EmployeeSearch, ParseLinks, AlertService, paginationConstants, pagingParams, UIFormAccess) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.actualFilter = pagingParams.actualFilter == 'true';
        vm.UIFormAccess = UIFormAccess;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                EmployeeSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    actual: vm.actualFilter,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Employee.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    actual: vm.actualFilter,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                /* Elasticsearch sorting problem
                if (vm.predicate !== 'id') {
                    result.push('id');
                */
                if (vm.predicate !== 'surname,name,patronymic') {
                    result.push('surname,name,patronymic,asc');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.employees = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                actualFilter: vm.actualFilter,
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            /* Elasticsearch sorting problem
            vm.predicate = '_score';
            vm.reverse = false;
            */
            vm.predicate = 'surname,name,patronymic';
            vm.reverse = true;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            /* Elasticsearch sorting problem
            vm.predicate = 'id';
            */
            vm.predicate = 'surname,name,patronymic';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('DivisionDialogController', DivisionDialogController);

    DivisionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Division', 'Employee'];

    function DivisionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Division, Employee) {
        var vm = this;

        vm.division = entity;
        vm.clear = clear;
        vm.save = save;
        /*
        vm.employees = Employee.query();
        */

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.division.id !== null) {
                Division.update(vm.division, onSaveSuccess, onSaveError);
            } else {
                Division.save(vm.division, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('telestatApp:divisionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('DivisionDetailController', DivisionDetailController);

    /* Added UIFormAccess
    DivisionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Division', 'Employee'];

    function DivisionDetailController($scope, $rootScope, $stateParams, previousState, entity, Division, Employee) {
    */
    DivisionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Division', 'Employee', 'UIFormAccess'];

    function DivisionDetailController($scope, $rootScope, $stateParams, previousState, entity, Division, Employee, UIFormAccess) {
        var vm = this;

        vm.division = entity;
        vm.previousState = previousState.name;
        vm.UIFormAccess = UIFormAccess;
        vm.employees = Employee.query({divisionId: vm.division.id});

        var unsubscribe = $rootScope.$on('telestatApp:divisionUpdate', function(event, result) {
            vm.division = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('DivisionDeleteController',DivisionDeleteController);

    DivisionDeleteController.$inject = ['$uibModalInstance', 'entity', 'Division'];

    function DivisionDeleteController($uibModalInstance, entity, Division) {
        var vm = this;

        vm.division = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Division.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('division', {
            parent: 'entity',
            /*
            url: '/division?page&sort&search',
            */
            url: '/division?page&sort&search&actualFilter',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.division.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/division/divisions.html',
                    controller: 'DivisionController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                actualFilter: {
                    value: 'true',
                    squash: true
                },
                sort: {
                    /*
                    value: 'id,asc',
                    */
                    value: 'title,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        actualFilter: $stateParams.actualFilter,
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('division');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('division-detail', {
            parent: 'division',
            url: '/division/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.division.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/division/division-detail.html',
                    controller: 'DivisionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('division');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Division', function($stateParams, Division) {
                    return Division.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'division',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('division-detail.edit', {
            parent: 'division-detail',
            url: '/detail/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/division/division-dialog.html',
                    controller: 'DivisionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Division', function(Division) {
                            return Division.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('division.new', {
            parent: 'division',
            url: '/new',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/division/division-dialog.html',
                    controller: 'DivisionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                name: null,
                                /*
                                actual: false,
                                */
                                actual: true,
                                externalId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('division', null, { reload: 'division' });
                }, function() {
                    $state.go('division');
                });
            }]
        })
        .state('division.edit', {
            parent: 'division',
            url: '/{id}/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/division/division-dialog.html',
                    controller: 'DivisionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Division', function(Division) {
                            return Division.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('division', null, { reload: 'division' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('division.delete', {
            parent: 'division',
            url: '/{id}/delete',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/division/division-delete-dialog.html',
                    controller: 'DivisionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Division', function(Division) {
                            return Division.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('division', null, { reload: 'division' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
	'use strict';
	angular.module('telestatApp').factory('Division', Division);

	Division.$inject = [ '$resource' ];

	function Division($resource) {
		var resourceUrl = 'api/divisions/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'getforselect' : {
				method : 'GET',
				url : 'api/divisionsforselect',
				isArray : true
			},
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'update' : {
				method : 'PUT'
			}
		});
	}
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('DivisionSearch', DivisionSearch);

    DivisionSearch.$inject = ['$resource'];

    function DivisionSearch($resource) {
        var resourceUrl =  'api/_search/divisions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('DivisionController', DivisionController);

    /* Added UIFormAccess
    DivisionController.$inject = ['$state', 'Division', 'DivisionSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function DivisionController($state, Division, DivisionSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {
    */
    DivisionController.$inject = ['$state', 'Division', 'DivisionSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'UIFormAccess'];

    function DivisionController($state, Division, DivisionSearch, ParseLinks, AlertService, paginationConstants, pagingParams, UIFormAccess) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.actualFilter = pagingParams.actualFilter == 'true';
        vm.UIFormAccess = UIFormAccess;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                DivisionSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    actual: vm.actualFilter,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Division.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    actual: vm.actualFilter,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                /*
                if (vm.predicate !== 'id') {
                    result.push('id');
                */
                if (vm.predicate !== 'title') {
                    result.push('title');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.divisions = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                actualFilter: vm.actualFilter,
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            /*
            vm.predicate = 'id';
            */
            vm.predicate = 'title';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('ComplainOnSmsDialogController', ComplainOnSmsDialogController);

    ComplainOnSmsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ComplainOnSms'];

    function ComplainOnSmsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ComplainOnSms) {
        var vm = this;

        vm.complainOnSms = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.complainOnSms.id !== null) {
                ComplainOnSms.update(vm.complainOnSms, onSaveSuccess, onSaveError);
            } else {
                ComplainOnSms.save(vm.complainOnSms, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('telestatApp:complainOnSmsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.complainTime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('ComplainOnSmsDetailController', ComplainOnSmsDetailController);

    ComplainOnSmsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ComplainOnSms'];

    function ComplainOnSmsDetailController($scope, $rootScope, $stateParams, previousState, entity, ComplainOnSms) {
        var vm = this;

        vm.complainOnSms = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('telestatApp:complainOnSmsUpdate', function(event, result) {
            vm.complainOnSms = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('ComplainOnSmsDeleteController',ComplainOnSmsDeleteController);

    ComplainOnSmsDeleteController.$inject = ['$uibModalInstance', 'entity', 'ComplainOnSms'];

    function ComplainOnSmsDeleteController($uibModalInstance, entity, ComplainOnSms) {
        var vm = this;

        vm.complainOnSms = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ComplainOnSms.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('complain-on-sms', {
            /*
            parent: 'entity',
            */
            parent: 'dictionary',
            url: '/complain-on-sms?page&sort&search',
            data: {
                /*
                authorities: ['ROLE_USER'],
                */
                authorities: ['ROLE_USER','ROLE_EXTERNAL_SYS'],
                pageTitle: 'telestatApp.complainOnSms.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/complain-on-sms/complain-on-sms.html',
                    controller: 'ComplainOnSmsController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('complainOnSms');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('complain-on-sms-detail', {
            parent: 'complain-on-sms',
            url: '/complain-on-sms/{id}',
            data: {
                /*
                authorities: ['ROLE_USER'],
                */
                authorities: ['ROLE_USER','ROLE_EXTERNAL_SYS'],
                pageTitle: 'telestatApp.complainOnSms.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/complain-on-sms/complain-on-sms-detail.html',
                    controller: 'ComplainOnSmsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('complainOnSms');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ComplainOnSms', function($stateParams, ComplainOnSms) {
                    return ComplainOnSms.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'complain-on-sms',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('complain-on-sms-detail.edit', {
            parent: 'complain-on-sms-detail',
            url: '/detail/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/complain-on-sms/complain-on-sms-dialog.html',
                    controller: 'ComplainOnSmsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ComplainOnSms', function(ComplainOnSms) {
                            return ComplainOnSms.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('complain-on-sms.new', {
            parent: 'complain-on-sms',
            url: '/new',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/complain-on-sms/complain-on-sms-dialog.html',
                    controller: 'ComplainOnSmsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                number: null,
                                complainTime: null,
                                comment: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('complain-on-sms', null, { reload: 'complain-on-sms' });
                }, function() {
                    $state.go('complain-on-sms');
                });
            }]
        })
        .state('complain-on-sms.edit', {
            parent: 'complain-on-sms',
            url: '/{id}/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/complain-on-sms/complain-on-sms-dialog.html',
                    controller: 'ComplainOnSmsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ComplainOnSms', function(ComplainOnSms) {
                            return ComplainOnSms.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('complain-on-sms', null, { reload: 'complain-on-sms' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('complain-on-sms.delete', {
            parent: 'complain-on-sms',
            url: '/{id}/delete',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/complain-on-sms/complain-on-sms-delete-dialog.html',
                    controller: 'ComplainOnSmsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ComplainOnSms', function(ComplainOnSms) {
                            return ComplainOnSms.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('complain-on-sms', null, { reload: 'complain-on-sms' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('ComplainOnSms', ComplainOnSms);

    ComplainOnSms.$inject = ['$resource', 'DateUtils'];

    function ComplainOnSms ($resource, DateUtils) {
        var resourceUrl =  'api/complain-on-sms/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.complainTime = DateUtils.convertDateTimeFromServer(data.complainTime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('ComplainOnSmsSearch', ComplainOnSmsSearch);

    ComplainOnSmsSearch.$inject = ['$resource'];

    function ComplainOnSmsSearch($resource) {
        var resourceUrl =  'api/_search/complain-on-sms/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('ComplainOnSmsController', ComplainOnSmsController);

    ComplainOnSmsController.$inject = ['$state', 'ComplainOnSms', 'ComplainOnSmsSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function ComplainOnSmsController($state, ComplainOnSms, ComplainOnSmsSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                ComplainOnSmsSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ComplainOnSms.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.complainOnSms = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('CloudPBXPrefixDialogController', CloudPBXPrefixDialogController);

    CloudPBXPrefixDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CloudPBXPrefix', 'CloudPBX'];

    function CloudPBXPrefixDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CloudPBXPrefix, CloudPBX) {
        var vm = this;

        vm.cloudPBXPrefix = entity;
        vm.clear = clear;
        vm.save = save;
        vm.cloudpbxes = CloudPBX.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.cloudPBXPrefix.id !== null) {
                CloudPBXPrefix.update(vm.cloudPBXPrefix, onSaveSuccess, onSaveError);
            } else {
                CloudPBXPrefix.save(vm.cloudPBXPrefix, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('telestatApp:cloudPBXPrefixUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('CloudPBXPrefixDetailController', CloudPBXPrefixDetailController);

    CloudPBXPrefixDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CloudPBXPrefix', 'CloudPBX'];

    function CloudPBXPrefixDetailController($scope, $rootScope, $stateParams, previousState, entity, CloudPBXPrefix, CloudPBX) {
        var vm = this;

        vm.cloudPBXPrefix = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('telestatApp:cloudPBXPrefixUpdate', function(event, result) {
            vm.cloudPBXPrefix = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('CloudPBXPrefixDeleteController',CloudPBXPrefixDeleteController);

    CloudPBXPrefixDeleteController.$inject = ['$uibModalInstance', 'entity', 'CloudPBXPrefix'];

    function CloudPBXPrefixDeleteController($uibModalInstance, entity, CloudPBXPrefix) {
        var vm = this;

        vm.cloudPBXPrefix = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CloudPBXPrefix.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('cloud-pbx-prefix', {
            /*
            parent: 'entity',
            */
            parent: 'dictionary',
            url: '/cloud-pbx-prefix?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.cloudPBXPrefix.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/cloud-pbx-prefix/cloud-pbx-prefixes.html',
                    controller: 'CloudPBXPrefixController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('cloudPBXPrefix');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('cloud-pbx-prefix-detail', {
            parent: 'cloud-pbx-prefix',
            url: '/cloud-pbx-prefix/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.cloudPBXPrefix.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/cloud-pbx-prefix/cloud-pbx-prefix-detail.html',
                    controller: 'CloudPBXPrefixDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('cloudPBXPrefix');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CloudPBXPrefix', function($stateParams, CloudPBXPrefix) {
                    return CloudPBXPrefix.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'cloud-pbx-prefix',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('cloud-pbx-prefix-detail.edit', {
            parent: 'cloud-pbx-prefix-detail',
            url: '/detail/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cloud-pbx-prefix/cloud-pbx-prefix-dialog.html',
                    controller: 'CloudPBXPrefixDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CloudPBXPrefix', function(CloudPBXPrefix) {
                            return CloudPBXPrefix.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('cloud-pbx-prefix.new', {
            parent: 'cloud-pbx-prefix',
            url: '/new',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cloud-pbx-prefix/cloud-pbx-prefix-dialog.html',
                    controller: 'CloudPBXPrefixDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                prefix: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('cloud-pbx-prefix', null, { reload: 'cloud-pbx-prefix' });
                }, function() {
                    $state.go('cloud-pbx-prefix');
                });
            }]
        })
        .state('cloud-pbx-prefix.edit', {
            parent: 'cloud-pbx-prefix',
            url: '/{id}/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cloud-pbx-prefix/cloud-pbx-prefix-dialog.html',
                    controller: 'CloudPBXPrefixDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CloudPBXPrefix', function(CloudPBXPrefix) {
                            return CloudPBXPrefix.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('cloud-pbx-prefix', null, { reload: 'cloud-pbx-prefix' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('cloud-pbx-prefix.delete', {
            parent: 'cloud-pbx-prefix',
            url: '/{id}/delete',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cloud-pbx-prefix/cloud-pbx-prefix-delete-dialog.html',
                    controller: 'CloudPBXPrefixDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CloudPBXPrefix', function(CloudPBXPrefix) {
                            return CloudPBXPrefix.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('cloud-pbx-prefix', null, { reload: 'cloud-pbx-prefix' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('CloudPBXPrefix', CloudPBXPrefix);

    CloudPBXPrefix.$inject = ['$resource'];

    function CloudPBXPrefix ($resource) {
        var resourceUrl =  'api/cloud-pbx-prefixes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('CloudPBXPrefixSearch', CloudPBXPrefixSearch);

    CloudPBXPrefixSearch.$inject = ['$resource'];

    function CloudPBXPrefixSearch($resource) {
        var resourceUrl =  'api/_search/cloud-pbx-prefixes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('CloudPBXPrefixController', CloudPBXPrefixController);

    CloudPBXPrefixController.$inject = ['$state', 'CloudPBXPrefix', 'CloudPBXPrefixSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CloudPBXPrefixController($state, CloudPBXPrefix, CloudPBXPrefixSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                CloudPBXPrefixSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                CloudPBXPrefix.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.cloudPBXPrefixes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('CloudPBXDialogController', CloudPBXDialogController);

    CloudPBXDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CloudPBX'];

    function CloudPBXDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CloudPBX) {
        var vm = this;

        vm.cloudPBX = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.cloudPBX.id !== null) {
                CloudPBX.update(vm.cloudPBX, onSaveSuccess, onSaveError);
            } else {
                CloudPBX.save(vm.cloudPBX, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('telestatApp:cloudPBXUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('CloudPBXDetailController', CloudPBXDetailController);

    /* Added UIFormAccess
    CloudPBXDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CloudPBX'];

    function CloudPBXDetailController($scope, $rootScope, $stateParams, previousState, entity, CloudPBX) {
    */
    CloudPBXDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CloudPBX', 'UIFormAccess'];

    function CloudPBXDetailController($scope, $rootScope, $stateParams, previousState, entity, CloudPBX, UIFormAccess) {
        var vm = this;

        vm.cloudPBX = entity;
        vm.previousState = previousState.name;
        vm.UIFormAccess = UIFormAccess;

        var unsubscribe = $rootScope.$on('telestatApp:cloudPBXUpdate', function(event, result) {
            vm.cloudPBX = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('CloudPBXDeleteController',CloudPBXDeleteController);

    CloudPBXDeleteController.$inject = ['$uibModalInstance', 'entity', 'CloudPBX'];

    function CloudPBXDeleteController($uibModalInstance, entity, CloudPBX) {
        var vm = this;

        vm.cloudPBX = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CloudPBX.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('cloud-pbx', {
            /*
            parent: 'entity',
            */
            parent: 'dictionary',
            url: '/cloud-pbx?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.cloudPBX.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/cloud-pbx/cloud-pbxes.html',
                    controller: 'CloudPBXController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    /*
                    value: 'id,asc',
                    */
                    value: 'name,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('cloudPBX');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('cloud-pbx-detail', {
            parent: 'cloud-pbx',
            url: '/cloud-pbx/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.cloudPBX.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/cloud-pbx/cloud-pbx-detail.html',
                    controller: 'CloudPBXDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('cloudPBX');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CloudPBX', function($stateParams, CloudPBX) {
                    return CloudPBX.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'cloud-pbx',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('cloud-pbx-detail.edit', {
            parent: 'cloud-pbx-detail',
            url: '/detail/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cloud-pbx/cloud-pbx-dialog.html',
                    controller: 'CloudPBXDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CloudPBX', function(CloudPBX) {
                            return CloudPBX.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('cloud-pbx.new', {
            parent: 'cloud-pbx',
            url: '/new',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cloud-pbx/cloud-pbx-dialog.html',
                    controller: 'CloudPBXDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                caption: null,
                                url: null,
                                attendantDuration: null,
                                code: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('cloud-pbx', null, { reload: 'cloud-pbx' });
                }, function() {
                    $state.go('cloud-pbx');
                });
            }]
        })
        .state('cloud-pbx.edit', {
            parent: 'cloud-pbx',
            url: '/{id}/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cloud-pbx/cloud-pbx-dialog.html',
                    controller: 'CloudPBXDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CloudPBX', function(CloudPBX) {
                            return CloudPBX.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('cloud-pbx', null, { reload: 'cloud-pbx' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('cloud-pbx.delete', {
            parent: 'cloud-pbx',
            url: '/{id}/delete',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cloud-pbx/cloud-pbx-delete-dialog.html',
                    controller: 'CloudPBXDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CloudPBX', function(CloudPBX) {
                            return CloudPBX.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('cloud-pbx', null, { reload: 'cloud-pbx' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('CloudPBX', CloudPBX);

    CloudPBX.$inject = ['$resource'];

    function CloudPBX ($resource) {
        var resourceUrl =  'api/cloud-pbxes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('CloudPBXSearch', CloudPBXSearch);

    CloudPBXSearch.$inject = ['$resource'];

    function CloudPBXSearch($resource) {
        var resourceUrl =  'api/_search/cloud-pbxes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('CloudPBXController', CloudPBXController);

    /* Added UIFormAccess
    CloudPBXController.$inject = ['$state', 'CloudPBX', 'CloudPBXSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CloudPBXController($state, CloudPBX, CloudPBXSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {
    */
    CloudPBXController.$inject = ['$state', 'CloudPBX', 'CloudPBXSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'UIFormAccess'];

    function CloudPBXController($state, CloudPBX, CloudPBXSearch, ParseLinks, AlertService, paginationConstants, pagingParams, UIFormAccess) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.UIFormAccess = UIFormAccess;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                CloudPBXSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                CloudPBX.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                /*
                if (vm.predicate !== 'id') {
                    result.push('id');
                */
                if (vm.predicate !== 'name') {
                    result.push('name');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.cloudPBXES = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            /*
            vm.predicate = 'id';
            */
            vm.predicate = 'name';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('blocked-phone.receiveNew', {
            parent: 'blocked-phone',
            url: '/receiveNew',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$state', 'AlertService', 'BlockedPhoneExtReceive', function($state, AlertService, BlockedPhoneExtReceive) {
                BlockedPhoneExtReceive.get(onSaveSuccess);
                function onSaveSuccess(result) {
                    if(result.count > 0) {
                        AlertService.warning("telestatApp.blockedPhone.newBlockedPhonesLoaded", result);
                    } else {
                        AlertService.warning("telestatApp.blockedPhone.noNewBlockedPhones");
                    }
                    $state.go('blocked-phone', null, { reload: 'blocked-phone' });
                }
            }]
        })
        .state('blocked-phone.uploadAll', {
            parent: 'blocked-phone',
            url: '/uploadAll',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$state', 'AlertService', 'BlockedPhoneExtUpload', function($state, AlertService, BlockedPhoneExtUpload) {
                BlockedPhoneExtUpload.get(onSaveSuccess);
                function onSaveSuccess(result) {
                    if(result.count > 0) {
                        AlertService.warning("telestatApp.blockedPhone.newBlockedPhonesUploaded", result);
                    } else {
                        AlertService.warning("telestatApp.blockedPhone.noNewBlockedPhonesUploaded");
                    }
                    $state.go('blocked-phone', null, { reload: 'blocked-phone' });
                }
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('BlockedPhoneExtReceive', BlockedPhoneExtReceive)
        .factory('BlockedPhoneExtUpload', BlockedPhoneExtUpload);

    BlockedPhoneExtReceive.$inject = ['$resource'];

    function BlockedPhoneExtReceive ($resource) {
        var resourceUrl =  'api/blocked-phones/receive-new/:id';

        return $resource(resourceUrl, {}, {
            'get': {method: 'GET'}
        });
    }

    BlockedPhoneExtUpload.$inject = ['$resource'];

    function BlockedPhoneExtUpload ($resource) {
        var resourceUrl =  'api/blocked-phones/upload-all/:id';

        return $resource(resourceUrl, {}, {
            'get': {method: 'GET'}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('BlockedPhoneDialogController', BlockedPhoneDialogController);

    BlockedPhoneDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'BlockedPhone', 'PhoneCallResult', 'User', 'Employee'];

    function BlockedPhoneDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, BlockedPhone, PhoneCallResult, User, Employee) {
        var vm = this;

        vm.blockedPhone = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.phonecallresults = PhoneCallResult.query();
        vm.users = User.query();
        vm.employees = Employee.query();
        vm.showAllParams = false;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.blockedPhone.id !== null) {
                BlockedPhone.update(vm.blockedPhone, onSaveSuccess, onSaveError);
            } else {
                BlockedPhone.save(vm.blockedPhone, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('telestatApp:blockedPhoneUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.lastCallTime = false;
        vm.datePickerOpenStatus.blockingTime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('BlockedPhoneDetailController', BlockedPhoneDetailController);

    /* Added UIFormAccess
    BlockedPhoneDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'BlockedPhone', 'PhoneCallResult', 'User', 'Employee'];

    function BlockedPhoneDetailController($scope, $rootScope, $stateParams, previousState, entity, BlockedPhone, PhoneCallResult, User, Employee) {
    */
    BlockedPhoneDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'BlockedPhone', 'PhoneCallResult', 'User', 'Employee', 'UIFormAccess'];

    function BlockedPhoneDetailController($scope, $rootScope, $stateParams, previousState, entity, BlockedPhone, PhoneCallResult, User, Employee, UIFormAccess) {
        var vm = this;

        vm.blockedPhone = entity;
        vm.previousState = previousState.name;
        vm.UIFormAccess = UIFormAccess;

        var unsubscribe = $rootScope.$on('telestatApp:blockedPhoneUpdate', function(event, result) {
            vm.blockedPhone = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('BlockedPhoneDeleteController',BlockedPhoneDeleteController);

    BlockedPhoneDeleteController.$inject = ['$uibModalInstance', 'entity', 'BlockedPhone'];

    function BlockedPhoneDeleteController($uibModalInstance, entity, BlockedPhone) {
        var vm = this;

        vm.blockedPhone = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            BlockedPhone.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('blocked-phone', {
            parent: 'entity',
            url: '/blocked-phone?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.blockedPhone.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/blocked-phone/blocked-phones.html',
                    controller: 'BlockedPhoneController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('blockedPhone');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('blocked-phone-detail', {
            parent: 'blocked-phone',
            url: '/blocked-phone/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.blockedPhone.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/blocked-phone/blocked-phone-detail.html',
                    controller: 'BlockedPhoneDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('blockedPhone');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'BlockedPhone', function($stateParams, BlockedPhone) {
                    return BlockedPhone.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'blocked-phone',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('blocked-phone-detail.edit', {
            parent: 'blocked-phone-detail',
            url: '/detail/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/blocked-phone/blocked-phone-dialog.html',
                    controller: 'BlockedPhoneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['BlockedPhone', function(BlockedPhone) {
                            return BlockedPhone.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('blocked-phone.new', {
            parent: 'blocked-phone',
            url: '/new',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN','ROLE_CHECKER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/blocked-phone/blocked-phone-dialog.html',
                    controller: 'BlockedPhoneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                number: null,
                                callsCount: null,
                                lastCallTime: null,
                                blockerCaption: null,
                                blockingTime: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('blocked-phone', null, { reload: 'blocked-phone' });
                }, function() {
                    $state.go('blocked-phone');
                });
            }]
        })
        .state('blocked-phone.edit', {
            parent: 'blocked-phone',
            url: '/{id}/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/blocked-phone/blocked-phone-dialog.html',
                    controller: 'BlockedPhoneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['BlockedPhone', function(BlockedPhone) {
                            return BlockedPhone.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('blocked-phone', null, { reload: 'blocked-phone' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('blocked-phone.delete', {
            parent: 'blocked-phone',
            url: '/{id}/delete',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/blocked-phone/blocked-phone-delete-dialog.html',
                    controller: 'BlockedPhoneDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['BlockedPhone', function(BlockedPhone) {
                            return BlockedPhone.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('blocked-phone', null, { reload: 'blocked-phone' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('BlockedPhone', BlockedPhone);

    BlockedPhone.$inject = ['$resource', 'DateUtils'];

    function BlockedPhone ($resource, DateUtils) {
        var resourceUrl =  'api/blocked-phones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.lastCallTime = DateUtils.convertDateTimeFromServer(data.lastCallTime);
                        data.blockingTime = DateUtils.convertDateTimeFromServer(data.blockingTime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('BlockedPhoneSearch', BlockedPhoneSearch);

    BlockedPhoneSearch.$inject = ['$resource'];

    function BlockedPhoneSearch($resource) {
        var resourceUrl =  'api/_search/blocked-phones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('BlockedPhoneController', BlockedPhoneController);

    /* Added UIFormAccess
    BlockedPhoneController.$inject = ['$state', 'BlockedPhone', 'BlockedPhoneSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function BlockedPhoneController($state, BlockedPhone, BlockedPhoneSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {
    */
    BlockedPhoneController.$inject = ['$state', 'BlockedPhone', 'BlockedPhoneSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'UIFormAccess'];

    function BlockedPhoneController($state, BlockedPhone, BlockedPhoneSearch, ParseLinks, AlertService, paginationConstants, pagingParams, UIFormAccess) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.UIFormAccess = UIFormAccess;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                BlockedPhoneSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                BlockedPhone.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.blockedPhones = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('AdvertisingSourceDialogController', AdvertisingSourceDialogController);

    AdvertisingSourceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'AdvertisingSource', 'CloudPBX'];

    function AdvertisingSourceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, AdvertisingSource, CloudPBX) {
        var vm = this;

        vm.advertisingSource = entity;
        vm.clear = clear;
        vm.save = save;
        vm.cloudpbxes = CloudPBX.query();

        vm.uploadPhoneFormats = [
            "+X(XXX)XXX-XX-XX",
            "X(XXX)XXX-XX-XX",
            "8(XXX)XXX-XX-XX",
             "(XXX)XXX-XX-XX",
           "+X-XXX-XXX-XX-XX",
            "X-XXX-XXX-XX-XX",
            "8-XXX-XXX-XX-XX",
              "XXX-XXX-XX-XX",
               "8XXX-XXXXXXX",
                   "CIANFEED"
        ];

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.advertisingSource.id !== null) {
                AdvertisingSource.update(vm.advertisingSource, onSaveSuccess, onSaveError);
            } else {
                AdvertisingSource.save(vm.advertisingSource, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('telestatApp:advertisingSourceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('AdvertisingSourceDetailController', AdvertisingSourceDetailController);

    /* Added UIFormAccess
    AdvertisingSourceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'AdvertisingSource', 'CloudPBX'];

    function AdvertisingSourceDetailController($scope, $rootScope, $stateParams, previousState, entity, AdvertisingSource, CloudPBX) {
    */
    AdvertisingSourceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'AdvertisingSource', 'CloudPBX', 'UIFormAccess'];

    function AdvertisingSourceDetailController($scope, $rootScope, $stateParams, previousState, entity, AdvertisingSource, CloudPBX, UIFormAccess) {
        var vm = this;

        vm.advertisingSource = entity;
        vm.previousState = previousState.name;
        vm.UIFormAccess = UIFormAccess;

        var unsubscribe = $rootScope.$on('telestatApp:advertisingSourceUpdate', function(event, result) {
            vm.advertisingSource = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('AdvertisingSourceDeleteController',AdvertisingSourceDeleteController);

    AdvertisingSourceDeleteController.$inject = ['$uibModalInstance', 'entity', 'AdvertisingSource'];

    function AdvertisingSourceDeleteController($uibModalInstance, entity, AdvertisingSource) {
        var vm = this;

        vm.advertisingSource = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            AdvertisingSource.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('advertising-source', {
            /*
            parent: 'entity',
            url: '/advertising-source?page&sort&search',
            */
            parent: 'dictionary',
            url: '/advertising-source?page&sort&search&actualFilter',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.advertisingSource.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/advertising-source/advertising-sources.html',
                    controller: 'AdvertisingSourceController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                actualFilter: {
                    value: 'true',
                    squash: true
                },
                sort: {
                    /*
                    value: 'id,asc',
                    */
                    value: 'name,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        actualFilter: $stateParams.actualFilter,
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('advertisingSource');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('advertising-source-detail', {
            parent: 'advertising-source',
            url: '/advertising-source/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.advertisingSource.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/advertising-source/advertising-source-detail.html',
                    controller: 'AdvertisingSourceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('advertisingSource');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'AdvertisingSource', function($stateParams, AdvertisingSource) {
                    return AdvertisingSource.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'advertising-source',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('advertising-source-detail.edit', {
            parent: 'advertising-source-detail',
            url: '/detail/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN', 'ROLE_MARKETER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/advertising-source/advertising-source-dialog.html',
                    controller: 'AdvertisingSourceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AdvertisingSource', function(AdvertisingSource) {
                            return AdvertisingSource.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('advertising-source.new', {
            parent: 'advertising-source',
            url: '/new',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/advertising-source/advertising-source-dialog.html',
                    controller: 'AdvertisingSourceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                caption: null,
                                monthBudget: null,
                                color: null,
                                uploadPhoneFormat: null,
                                /*
                                autodetect: false,
                                */
                                autodetect: true,
                                code: null,
                                /*
                                actual: false,
                                */
                                actual: true,
                                externalId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('advertising-source', null, { reload: 'advertising-source' });
                }, function() {
                    $state.go('advertising-source');
                });
            }]
        })
        .state('advertising-source.edit', {
            parent: 'advertising-source',
            url: '/{id}/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN', 'ROLE_MARKETER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/advertising-source/advertising-source-dialog.html',
                    controller: 'AdvertisingSourceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AdvertisingSource', function(AdvertisingSource) {
                            return AdvertisingSource.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('advertising-source', null, { reload: 'advertising-source' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('advertising-source.delete', {
            parent: 'advertising-source',
            url: '/{id}/delete',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/advertising-source/advertising-source-delete-dialog.html',
                    controller: 'AdvertisingSourceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['AdvertisingSource', function(AdvertisingSource) {
                            return AdvertisingSource.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('advertising-source', null, { reload: 'advertising-source' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('AdvertisingSource', AdvertisingSource);

    AdvertisingSource.$inject = ['$resource'];

    function AdvertisingSource ($resource) {
        var resourceUrl =  'api/advertising-sources/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('AdvertisingSourceSearch', AdvertisingSourceSearch);

    AdvertisingSourceSearch.$inject = ['$resource'];

    function AdvertisingSourceSearch($resource) {
        var resourceUrl =  'api/_search/advertising-sources/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('AdvertisingSourceController', AdvertisingSourceController);

    /* Added UIFormAccess
    AdvertisingSourceController.$inject = ['$state', 'AdvertisingSource', 'AdvertisingSourceSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function AdvertisingSourceController($state, AdvertisingSource, AdvertisingSourceSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {
    */
    AdvertisingSourceController.$inject = ['$state', 'AdvertisingSource', 'AdvertisingSourceSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'UIFormAccess'];

    function AdvertisingSourceController($state, AdvertisingSource, AdvertisingSourceSearch, ParseLinks, AlertService, paginationConstants, pagingParams, UIFormAccess) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.actualFilter = pagingParams.actualFilter == 'true';
        vm.UIFormAccess = UIFormAccess;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                AdvertisingSourceSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    actual: vm.actualFilter,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                AdvertisingSource.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    actual: vm.actualFilter,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                /*
                if (vm.predicate !== 'id') {
                    result.push('id');
                */
                if (vm.predicate !== 'name') {
                    result.push('name');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.advertisingSources = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                actualFilter: vm.actualFilter,
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            /*
            vm.predicate = 'id';
            */
            vm.predicate = 'name';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                /* Removed "th" for any cases
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
                */
                vm.applyClass($element.find('[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('telestatApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('telestatApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info" data-translate="global.item-count" ' +
        'translate-value-first="{{(($ctrl.page - 1) * $ctrl.itemsPerPage) === 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}}" ' +
        'translate-value-second="{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}}" ' +
        'translate-value-total="{{$ctrl.queryCount}}">' +
        'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
        '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
        'of {{$ctrl.queryCount}} items.' +
        '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('telestatApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .constant('errorConstants', (function() {
            var problemBaseUrl = 'http://www.jhipster.tech/problem';
            return {
                EMAIL_ALREADY_USED_TYPE: problemBaseUrl + '/email-already-used',
                LOGIN_ALREADY_USED_TYPE: problemBaseUrl + '/login-already-used',
                EMAIL_NOT_FOUND_TYPE: problemBaseUrl + '/email-not-found'
            }
        })());
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils($filter) {

        var service = {
            convertDateTimeFromServer: convertDateTimeFromServer,
            convertLocalDateFromServer: convertLocalDateFromServer,
            convertLocalDateToServer: convertLocalDateToServer,
            dateformat: dateformat
        };

        return service;

        function convertDateTimeFromServer(date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat() {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            var fileURL = 'data:' + type +';base64,' + data;
            var win = $window.open('', '_blank');
            win.document.write(
                '<iframe src="' +
                fileURL +
                '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
            );
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('telestatApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('telestatApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .filter('findLanguageFromKey', findLanguageFromKey)
        .filter('findLanguageRtlFromKey', findLanguageRtlFromKey);

    var languages = {
        'ru': { name: 'Русский' }
        // jhipster-needle-i18n-language-key-pipe - JHipster will add/remove languages in this object
    };

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return languages[lang].name;
        }
    }

    function findLanguageRtlFromKey() {
        return findLanguageRtlFromKeyFilter;

        function findLanguageRtlFromKeyFilter(lang) {
            return languages[lang].rtl;
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('telestatApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'ru'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .constant('paginationConstants', {
            /*
            'itemsPerPage': 20
            */
            'itemsPerPage': 30,
            'itemsPerLargePage': 50
        });
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .component('divisionsFilter', {
            templateUrl: 'app/components/divisions-filter/divisions-filter.template.html',
            controller: DivisionsFilterController,
            controllerAs: 'vm',
            bindings: {
                data: '='
            }
        });

    DivisionsFilterController.$inject = ['Principal', 'Division', '$translate'];

    function DivisionsFilterController (Principal, Division, $translate) {
        var vm = this;
        vm.search = search;
        vm.allDivisionsTranslate = $translate.instant('telestatApp.reportsCommon.allDivisions');

        if (Principal.hasAnyAuthority(['ROLE_ADMIN','ROLE_DIRECTOR','ROLE_CHECKER'])) {
            vm.data.division = {id:vm.data.pagingParams.divisionId};
            vm.data.divisions = [{id:null,actual:1,name: vm.allDivisionsTranslate}];
            vm.data.divisions[0].name = vm.allDivisionsTranslate;
            Division.getforselect({},function(data){
                vm.data.divisions = [{id:null,actual:1,name: vm.allDivisionsTranslate}].concat(makeFlatDivisionList(data, 0));
                // Найти и выставить имя для выбранного отдела, чтобы его можно было отобразить в заголовке страницы
                //data.forEach(function(d){if(d.id==vm.data.division.id){vm.data.division.name=d.name;}});
            });
        }
        function search() {
            vm.data.loadAll();
        }
        function makeFlatDivisionList(data, level) {
			var divFlatListArr = [];
			for (var i = 0; i < data.length; i++) {
				divFlatListArr.push({
					id : data[i].id,
					actual : true,
					name : ' - '.repeat(level) + data[i].name
				});
				if(data[i].id == vm.data.division.id){vm.data.division.name=data[i].name;}
				
				if (data[i].divisions !== undefined
						&& data[i].divisions.length > 0) {
					var t = makeFlatDivisionList(data[i].divisions, level + 1);
					divFlatListArr = divFlatListArr.concat(t);
				}
			}
			return divFlatListArr;
		}
    }


})();


(function() {
    'use strict';

    angular
        .module('telestatApp')
        .component('dateFilter', {
            templateUrl: 'app/components/date-filter/date-filter.template.html',
            controller: DateFilterController,
            controllerAs: 'vm',
            bindings: {
                data: '=',
            }
        });

    DateFilterController.$inject = [];

    function DateFilterController () {
        var vm = this;

        vm.dateFilterDay = false;
        vm.dateFilterReadonly = true;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;
        // Can't use $locale.DATETIME_FORMATS.shortDate due first page loading problem - $locale may be not initialized and applied "en" version.
        vm.dateformat = "dd.MM.yy";

        vm.search = search;
        vm.data.updateDateFilterType = updateDateFilterType;
        vm.dateFilterType = vm.data.pagingParams.searchType;
        vm.startDate = vm.data.pagingParams.startDate;
        vm.endDate = vm.data.pagingParams.endDate;
        vm.allActive = vm.data.allActive;
        vm.data.setFilterType = setFilterType;

        updateDateFilterType();
        vm.data.initCallBack();

        function openCalendar (date) {
            if(!vm.dateFilterReadonly) {
                vm.datePickerOpenStatus[date] = true;
            }
        }

        function search (date, oldDateFilterType) {
            if(oldDateFilterType != vm.dateFilterType) {
                vm.startDate = null;
                vm.endDate = null;
            }
            if (vm.dateFilterType == 'range' && vm.startDate != null && vm.endDate != null) {
                var startDate = new Date(vm.startDate);
                var endDate = new Date(vm.endDate);
                if (startDate.getTime() > endDate.getTime()) {
                    if (date == 'endDate') {
                        vm.startDate = endDate;
                    } else {
                        vm.endDate = startDate;
                    }
                }
            }
            vm.data.dateFilterType = vm.dateFilterType;
            vm.data.search(vm.data.searchQuery);
        }

        function setFilterType (type) {
            vm.dateFilterType = type;
        }

        // search with time limits
        function updateDateFilterType () {
            var today = new Date();
            today.setHours(0, 0, 0, 0);
            var day = today.getDay() - 1;// сколько дней прошло с понедельника
            if (day < 0) day += 7;// воскресенье 0 день.
            if (!vm.allActive && !vm.dateFilterType) {
                vm.dateFilterType = 'lastmonth';// default case
            }
            switch (vm.dateFilterType) {
                case 'day':
                    vm.dateFilterDay = true;
                    vm.dateFilterReadonly = false;
                    if (vm.startDate == null) {
                        vm.startDate = new Date();
                        vm.endDate = new Date();
                    } else {
                        vm.startDate = new Date(vm.startDate);
                        vm.endDate = new Date(vm.startDate);
                    }
                    break;
                case 'today':
                    vm.dateFilterDay = true;
                    vm.dateFilterReadonly = true;
                    vm.startDate = today;
                    vm.endDate = new Date(today);
                    break;
                case 'yesterday':
                    vm.dateFilterDay = true;
                    vm.dateFilterReadonly = true;
                    vm.startDate = new Date(today);
                    vm.startDate.setDate(vm.startDate.getDate()-1);
                    vm.endDate = vm.startDate;
                    break;
                case 'thisweek':
                    vm.dateFilterDay = false;
                    vm.dateFilterReadonly = true;
                    vm.startDate = new Date();
                    vm.startDate.setDate(vm.startDate.getDate()-day);
                    vm.endDate = new Date();
                    vm.endDate.setDate(vm.endDate.getDate()+6-day);
                    break;
                case 'lastweek':
                    vm.dateFilterDay = false;
                    vm.dateFilterReadonly = true;
                    vm.startDate = new Date();
                    vm.startDate.setDate(vm.startDate.getDate()-7-day);
                    vm.endDate = new Date();
                    vm.endDate.setDate(vm.endDate.getDate()-day-1);
                    break;
                case 'thismonth':
                    vm.dateFilterDay = false;
                    vm.dateFilterReadonly = true;
                    vm.startDate = new Date();
                    vm.startDate.setDate(1);// условие поиска >=
                    vm.endDate = new Date();
                    vm.endDate.setDate(vm.endDate.getDate());// условие поиска <=
                    break;
                case 'range':
                    vm.dateFilterDay = false;
                    vm.dateFilterReadonly = false;
                    if (vm.endDate == null) {
                        vm.endDate = new Date();
                        vm.endDate.setDate(vm.endDate.getDate()-7);// Конечная дата на неделю раньше текущей даты
                    } else {
                        vm.endDate = new Date(vm.endDate);
                    }
                    if (vm.startDate == null) {
                        vm.startDate = new Date();
                        vm.startDate.setDate(1);
                        if (vm.startDate.getTime() > vm.endDate.getTime()) {
                            vm.startDate.setMonth(vm.startDate.getMonth()-1);
                        }
                    } else {
                        vm.startDate = new Date(vm.startDate);
                    }
                    break;
                case 'lastmonth':
                    vm.dateFilterDay = false;
                    vm.dateFilterReadonly = true;
                    vm.startDate = new Date();
                    vm.endDate = new Date();
                    vm.startDate.setDate(1);
                    vm.startDate.setMonth(vm.startDate.getMonth()-1);
                    vm.endDate.setDate(1);
                    vm.endDate.setDate(vm.endDate.getDate()-1);// условие поиска <=
                    break;
                default:
                    vm.dateFilterDay = false;
                    vm.endDate = null;
                    vm.startDate = null;
                    break;
            }
            //
            vm.data.dateFilterType = vm.dateFilterType;
            vm.data.endDate = vm.endDate;
            vm.data.startDate = vm.startDate;
        }

    }


})();


(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('telestatApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('telestatApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var headers = Object.keys(httpResponse.headers()).filter(function (header) {
                    return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (angular.isString(errorHeader)) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('telestatApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('telestatApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var alertKey = response.headers(headers[0]);
            if (angular.isString(alertKey)) {
                /*
                AlertService.success(alertKey, { param : response.headers(headers[1])});
                */
                // Process our special situatiuon.
                if(response.headers(headers[1]) == 'EXISTS') {
                    AlertService.warning(alertKey, { param : response.headers(headers[1])});
                } else {
                    AlertService.success(alertKey, { param : response.headers(headers[1])});
                }
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('telestatApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector'];

    function authExpiredInterceptor($rootScope, $q, $injector) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            // If we have an unauthorized request we redirect to the login page
            // Don't do this check on the account API to avoid infinite loop
            if (response.status === 401 && angular.isDefined(response.data.path) && response.data.path.indexOf('/api/account') === -1) {
                var Auth = $injector.get('Auth');
                var to = $rootScope.toState;
                var params = $rootScope.toStateParams;
                Auth.logout();
                if (to.name !== 'accessdenied') {
                    Auth.storePreviousState(to.name, params);
                }
                var LoginService = $injector.get('LoginService');
                LoginService.open();
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }


        // update the window title using params in the following
        // precedence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('telestatApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to preferred language "ru"');
                $cookies.putObject(name, 'ru');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider', 'BUILD_TIMESTAMP'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider, BUILD_TIMESTAMP) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json' + (BUILD_TIMESTAMP ? '?build=' + BUILD_TIMESTAMP : '')
        });

        $translateProvider.preferredLanguage('ru');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

        angular.reloadWithDebugInfo();
        */
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .filter('phone', function () {
            return function (phoneNumber) {
                // TODO Константа через интернационализацию
                if (phoneNumber == 0) return "[скрытый номер]";
                var phoneStr = phoneNumber.toString();
                if (phoneStr.length > 8) {
                    var country_code = phoneStr.substr(0,1);
                    var region_code = phoneStr.substr(1,3);
                    var st_code  = phoneStr.substr(4,3);
                    var octet1 = phoneStr.substr(7,2);
                    var octet2 = phoneStr.substr(9);
                    return "+" + country_code + "(" + region_code + ")" + st_code + "‑" + octet1 + "‑" + octet2;
                } else return "+" + phoneStr;
            };
        });
})();

(function () {
    'use strict';

    angular
        .module('telestatApp')
        .directive('capitalizeFirst', ['$parse',  function($parse) {
            return {
                require: 'ngModel',
                link: function(scope, element, attrs, modelCtrl) {
                    var capitalize = function(inputValue) {
                        if (!inputValue) {
                            inputValue = '';
                        } else {
                            inputValue = inputValue.trim();
                        }
                        var capitalized = inputValue.charAt(0).toUpperCase() + inputValue.substring(1);
                        if(capitalized !== inputValue) {
                            // store current edit position
                            var start = element[0].selectionStart, end = element[0].selectionEnd;
                            modelCtrl.$setViewValue(capitalized);
                            modelCtrl.$render();
                            // restore current edit position
                            element[0].setSelectionRange(start, end);
                        }
                        return capitalized;
                    };
                    modelCtrl.$parsers.push(capitalize);
                    capitalize($parse(attrs.ngModel)(scope)); // capitalize initial value
                }
            };
         }])
         .directive('capitalizeFully', ['$parse',  function($parse) {
            return {
                require: 'ngModel',
                link: function(scope, element, attrs, modelCtrl) {
                    var capitalize = function(inputValue) {
                        if (!inputValue) {
                            inputValue = '';
                        } else {
                            inputValue = inputValue.trim();
                        }

                        function isDelimiter(ch, delimiters) {
                            if (delimiters == null) {
                                return false;
                            }
                            for (var i = 0, isize = delimiters.length; i < isize; i++) {
                                if (ch == delimiters[i]) {
                                    return true;
                                }
                            }
                            return false;
                        }
                        function capitalize(str, delimiters) {
                            var delimLen = (delimiters == null ? -1 : delimiters.length);
                            if (!str || delimLen == 0) {
                                return str;
                            }
                            var strLen = str.length;
                            var buffer = "";
                            var capitalizeNext = true;
                            for (var i = 0; i < strLen; i++) {
                                var ch = str.charAt(i);
                                if (isDelimiter(ch, delimiters)) {
                                    buffer += ch;
                                    capitalizeNext = true;
                                } else if (capitalizeNext) {
                                    buffer += ch.toUpperCase();
                                    capitalizeNext = false;
                                } else {
                                    buffer += ch.toLowerCase();
                                }
                            }
                            return buffer;
                        }

                        var delimiters = [' ', "\n", "\t", "\r", '-'];
                        var capitalized = capitalize(inputValue, delimiters);
                        if(capitalized !== inputValue) {
                            // store current edit position
                            var start = element[0].selectionStart, end = element[0].selectionEnd;
                            modelCtrl.$setViewValue(capitalized);
                            modelCtrl.$render();
                            // restore current edit position
                            element[0].setSelectionRange(start, end);
                        }
                        return capitalized;
                    };
                    modelCtrl.$parsers.push(capitalize);
                    capitalize($parse(attrs.ngModel)(scope)); // capitalize initial value
                }
            };
         }]);
})();



(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('telestatApp')
        .constant('VERSION', "2.0.3")
        .constant('DEBUG_INFO_ENABLED', false)
        .constant('BUILD_TIMESTAMP', 1765451585269)
;
})();

(function () {
    'use strict';

    angular
        .module('telestatApp')
        .config(['uibDatepickerPopupConfig', function(uibDatepickerPopupConfig) {
            uibDatepickerPopupConfig.closeText = 'Закрыть';
            uibDatepickerPopupConfig.clearText = 'Очистить';
            uibDatepickerPopupConfig.currentText = 'Сегодня';
        }]);

})();



(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PasswordUpdateByLoginController', PasswordUpdateByLoginController);

    PasswordUpdateByLoginController.$inject = ['login', '$uibModalInstance', 'PasswordUpdateByLogin', 'AlertService'];

    function PasswordUpdateByLoginController (login, $uibModalInstance, PasswordUpdateByLogin, AlertService) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.account = {login: login};
        vm.clear = clear;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                PasswordUpdateByLogin.changeUserPassword(vm.account.login, vm.password, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            console.log(result);
            $uibModalInstance.close(true);
            AlertService.success("password.messages.success");
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.error = 'ERROR';
            vm.isSaving = false;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management.pass', {
            url: '/{login}/pass',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.account.password'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-password.html',
                    controller: 'PasswordUpdateByLoginController',
                    controllerAs: 'vm',
                    //backdrop: 'static',
                    //size: 'lg',
                    size: 'md',
                    resolve: {
                        login: [ function() {
                            return $stateParams.login;
                        }],
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('password');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: 'user-management' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User, JhiLanguageService) {
        var vm = this;

        /*
        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        */
        // Role list for editing. DON'T REMOVE!
        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_EXTERNAL_SYS', 'ROLE_DIRECTOR', 'ROLE_MANAGER', 'ROLE_MAIN_CHECKER', 'ROLE_CHECKER', 'ROLE_MARKETER'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load(login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            /*
            url: '/user-management?page&sort',
            */
            // Our search in users
            url: '/user-management?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'userManagement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                // Our search in users
                search: null,
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        /*
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                        */
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        // Our search in users
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]

            }        })
        .state('user-management.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management-detail', {
            parent: 'user-management',
            url: '/{login}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'user-management.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management.delete', {
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('UserManagementController', UserManagementController);

    /* Added UserSearch
    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService) {
    */
    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService', 'UserSearch'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService, UserSearch) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;
        // For our search in users
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        vm.loadAll();
        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            /* Update to more flexible search
            User.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            */
            if (pagingParams.search) {
                UserSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    actual: vm.actualFilter,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                User.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        // Our search method
        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'login';
            vm.reverse = true;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
            // For our search method
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        // For our search method
        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                actualFilter: vm.actualFilter,
                search: vm.currentSearch
            });
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-tracker', {
            parent: 'admin',
            url: '/tracker',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'tracker.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/tracker/tracker.html',
                    controller: 'JhiTrackerController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tracker');
                    return $translate.refresh();
                }]
            },
            onEnter: ['JhiTrackerService', function(JhiTrackerService) {
                JhiTrackerService.subscribe();
            }],
            onExit: ['JhiTrackerService', function(JhiTrackerService) {
                JhiTrackerService.unsubscribe();
            }]
        });
    }
})();

(function() {
    'use strict';
    /* globals SockJS, Stomp */

    angular
        .module('telestatApp')
        .factory('JhiTrackerService', JhiTrackerService);

    JhiTrackerService.$inject = ['$rootScope', '$window', '$cookies', '$http', '$q'];

    function JhiTrackerService ($rootScope, $window, $cookies, $http, $q) {
        var stompClient = null;
        var subscriber = null;
        var listener = $q.defer();
        var connected = $q.defer();
        var alreadyConnectedOnce = false;

        var service = {
            connect: connect,
            disconnect: disconnect,
            receive: receive,
            sendActivity: sendActivity,
            subscribe: subscribe,
            unsubscribe: unsubscribe
        };

        return service;

        function connect () {
            //building absolute path so that websocket doesn't fail when deploying with a context path
            /* Disabled to save websockets alive
            var loc = $window.location;
            var url = '//' + loc.host + loc.pathname + 'websocket/tracker';
            var socket = new SockJS(url);
            stompClient = Stomp.over(socket);
            var stateChangeStart;
            var headers = {};
            headers[$http.defaults.xsrfHeaderName] = $cookies.get($http.defaults.xsrfCookieName);
            stompClient.connect(headers, function() {
                connected.resolve('success');
                sendActivity();
                if (!alreadyConnectedOnce) {
                    stateChangeStart = $rootScope.$on('$stateChangeStart', function () {
                        sendActivity();
                    });
                    alreadyConnectedOnce = true;
                }
            });
            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
            });
            */
        }

        function disconnect () {
            if (stompClient !== null) {
                stompClient.disconnect();
                stompClient = null;
            }
        }

        function receive () {
            return listener.promise;
        }

        function sendActivity() {
            if (stompClient !== null && stompClient.connected) {
                stompClient
                    .send('/topic/activity',
                    {},
                    angular.toJson({'page': $rootScope.toState.name}));
            }
        }

        function subscribe () {
            connected.promise.then(function() {
                subscriber = stompClient.subscribe('/topic/tracker', function(data) {
                    listener.notify(angular.fromJson(data.body));
                });
            }, null, null);
        }

        function unsubscribe () {
            if (subscriber !== null) {
                subscriber.unsubscribe();
            }
            listener = $q.defer();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('telestatApp')
        .controller('JhiTrackerController', JhiTrackerController);

    JhiTrackerController.$inject = ['$cookies', '$http', 'JhiTrackerService'];

    function JhiTrackerController ($cookies, $http, JhiTrackerService) {
        // This controller uses a Websocket connection to receive user activities in real-time.
        var vm = this;

        vm.activities = [];

        JhiTrackerService.receive().then(null, null, function(activity) {
            showActivity(activity);
        });

        function showActivity(activity) {
            var existingActivity = false;
            for (var index = 0; index < vm.activities.length; index++) {
                if(vm.activities[index].sessionId === activity.sessionId) {
                    existingActivity = true;
                    if (activity.page === 'logout') {
                        vm.activities.splice(index, 1);
                    } else {
                        vm.activities[index] = activity;
                    }
                }
            }
            if (!existingActivity && (activity.page !== 'logout')) {
                vm.activities.push(activity);
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.includes('web.rest') || key.includes('service')) {
                    vm.servicesStats[key] = value;
                }
            });

        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs-viewer', {
            parent: 'admin',
            url: '/logs-viewer',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs-viewer.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs-viewer/logs-viewer.html',
                    controller: 'LogsViewerController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs-viewer');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('LogsViewerService', LogsViewerService);

    LogsViewerService.$inject = ['$resource'];

    function LogsViewerService ($resource) {
        var service = $resource('api/logs-viewer/:verb/:fileName', {}, {
            'list': { method: 'GET', params: {verb:'list'}, isArray: true},
            'load': { method: 'POST', params: {verb:'load'}, isArray: true},
            'loadPartial': { method: 'POST', params: {verb:'loadPartial'}, isArray: true}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('LogsViewerController', LogsViewerController);

    LogsViewerController.$inject = ['LogsViewerService'];

    function LogsViewerController (LogsViewerService) {
        var vm = this;

        vm.changeFile = changeFile;
        vm.list = LogsViewerService.list();

        function changeFile (name) {
            LogsViewerService.load(vm.listName, onSuccess, onError);
            function onSuccess(data, headers) {
                vm.rows = data;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('telestatApp')
        .controller('HistoryLoaderRetransmissionLoadingController', HistoryLoaderRetransmissionLoadingController);

    HistoryLoaderRetransmissionLoadingController.$inject = ['entity'];

    function HistoryLoaderRetransmissionLoadingController(entity) {
        console.log("TEST 1");
        var vm = this;
        vm.historyProviderSelector = entity.historyProviderSelector;
    }

})();

(function () {
    'use strict';

    angular
        .module('telestatApp')
        .controller('HistoryLoaderRetransmissionDialogController', HistoryLoaderRetransmissionDialogController);

    HistoryLoaderRetransmissionDialogController.$inject = ['$uibModalInstance', '$filter', 'MegafonHistoryLoader', 'CianHistoryLoader', 'AlertService', 'entity', '$state'];

    function HistoryLoaderRetransmissionDialogController($uibModalInstance, $filter, MegafonHistoryLoader, CianHistoryLoader, AlertService, entity, $state) {
        console.log("TEST 8");
        var vm = this;

        vm.clear = clear;
        vm.confirmRetransmissionHistory = confirmRetransmissionHistory;
        vm.startTime = entity.startTime;
        vm.endTime = entity.endTime;
        vm.historyProviderSelector = entity.historyProviderSelector;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }


        function confirmRetransmissionHistory() {
            if(vm.historyProviderSelector == 'Megafon') {
                MegafonHistoryLoader.retransmissionHistory({
                    start:$filter('date')(vm.startTime, "yyyy-MM-ddT00:00:00.000", 0),
                    end:$filter('date')(vm.endTime, "yyyy-MM-ddT23:59:59.999", 0)},
                    onRetransmissionSaveSuccess, onRetransmissionSaveError);
                $uibModalInstance.close(true);
                console.log("TEST 5");
                $state.go('history-loader.retransmission-loading');
                console.log("TEST 6");
            } /*else if(vm.historyProviderSelector == 'Cian') {
                CianHistoryLoader.retransmissionHistory({
                    start:$filter('date')(vm.startTime, "yyyy-MM-ddT00:00:00.000", 0),
                    end:$filter('date')(vm.endTime, "yyyy-MM-ddT00:00:00.000", 0)},
                    onRetransmissionSaveSuccess, onRetransmissionSaveError);
                $uibModalInstance.close(true);
                $state.go('history-loader.retransmission-loading');
            } */else {
                console.log("TEST 7");
            }
        }

        /*function onSaveSuccess(result) {
            if(result.count > 0) {
                AlertService.warning("history-loader.newRecordsLoaded", result);
            } else {
                AlertService.warning("history-loader.noNewRecords");
            }
            $state.go('history-loader');
        }

        function onSaveError (result) {
            if(result.data) {
                if(result.data.concurrentError == true) {
                    AlertService.warning("history-loader.concurrentModificationError");
                } else if(result.data.streamError == true) {
                    AlertService.warning("history-loader.streamError", {provider: vm.retransmissionHistoryProviderSelector});
                } else {
                    AlertService.warning("history-loader.unknownError");
                }
            }
            $state.go('history-loader');
        }*/

        function onRetransmissionSaveSuccess (result) {
            AlertService.warning("history-loader.retransmissionStarted", result);
            $state.go('history-loader');
        }

        function onRetransmissionSaveError (result) {
            if(result.data) {
                if(result.data.concurrentError == true) {
                    AlertService.warning("history-loader.concurrentModificationError");
                } else if(result.data.streamError == true) {
                    AlertService.warning("history-loader.streamError", {provider: vm.historyProviderSelector});
                } else {
                    AlertService.warning("history-loader.unknownError");
                }
            }
            $state.go('history-loader');
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('telestatApp')
        .controller('HistoryLoaderLoadingController', HistoryLoaderLoadingController);

    HistoryLoaderLoadingController.$inject = ['entity'];

    function HistoryLoaderLoadingController(entity) {
        var vm = this;
        vm.historyProviderSelector = entity.historyProviderSelector;
    }

})();

(function () {
    'use strict';

    angular
        .module('telestatApp')
        .controller('HistoryLoaderDialogController', HistoryLoaderDialogController);

    HistoryLoaderDialogController.$inject = ['$uibModalInstance', '$filter', 'MegafonHistoryLoader', 'CianHistoryLoader', 'AlertService', 'entity', '$state'];

    function HistoryLoaderDialogController($uibModalInstance, $filter, MegafonHistoryLoader, CianHistoryLoader, AlertService, entity, $state) {
        var vm = this;

        vm.clear = clear;
        vm.confirmLoadHistory = confirmLoadHistory;
        vm.limit = entity.limit;
        vm.startTime = entity.startTime;
        vm.endTime = entity.endTime;
        vm.historyProviderSelector = entity.historyProviderSelector;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmLoadHistory() {
            if(vm.historyProviderSelector == 'Megafon') {
                MegafonHistoryLoader.loadHistory({
                    start:$filter('date')(vm.startTime, "yyyy-MM-ddT00:00:00.000", 0),
                    end:$filter('date')(vm.endTime, "yyyy-MM-ddT23:59:59.999", 0),
                    limit:vm.limit}, onSaveSuccess, onSaveError);
                $uibModalInstance.close(true);
                $state.go('history-loader.loading');
            } else if(vm.historyProviderSelector == 'Cian') {
                CianHistoryLoader.loadHistory({
                    start:$filter('date')(vm.startTime, "yyyy-MM-ddT00:00:00.000", 0),
                    end:$filter('date')(vm.endTime, "yyyy-MM-ddT23:59:59.999", 0),
                    limit:vm.limit}, onSaveSuccess, onSaveError);
                $uibModalInstance.close(true);
                $state.go('history-loader.loading');
            } else {
                
            }
        }

        function onSaveSuccess(result) {
            if(result.count > 0) {
                AlertService.warning("history-loader.newRecordsLoaded", result);
            } else {
                AlertService.warning("history-loader.noNewRecords");
            }
            $state.go('history-loader');
        }

        function onSaveError (result) {
            if(result.data) {
                if(result.data.concurrentError == true) {
                    AlertService.warning("history-loader.concurrentModificationError");
                } else if(result.data.streamError == true) {
                    AlertService.warning("history-loader.streamError", {provider: vm.historyProviderSelector});
                } else {
                    AlertService.warning("history-loader.unknownError");
                }
            }
            $state.go('history-loader');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('history-loader', {
            parent: 'admin',
            url: '/history-loader',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'history-loader.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/history-loader/history-loader.html',
                    controller: 'HistoryLoaderController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('history-loader');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }).state('history-loader.dialog', {
            parent: 'history-loader',
            url: '/load-history',
            params: {
                requestParams: null
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/history-loader/history-loader-dialog.html',
                    controller: 'HistoryLoaderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                        entity: $stateParams.requestParams
                    }
                }).result.then(function() {
                    $state.go('history-loader.loading');
                }, function() {
                    $state.go('^');
                });
            }]
        }).state('history-loader.loading', {
            parent: 'history-loader.dialog',
            url: '/loading-history',
            views: {
                'content@': {
                    templateUrl: 'app/admin/history-loader/history-loader-loading.html',
                    controller: 'HistoryLoaderLoadingController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', function ($stateParams) {
                    return {
                        historyProviderSelector: $stateParams.requestParams.historyProviderSelector
                    }
                }]
            }
        }).state('history-loader.retransmission-dialog', {
            parent: 'history-loader',
            url: '/loading-history-retransmission',
            params: {
                requestParams: null
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/history-loader/history-loader-retransmission-dialog.html',
                    controller: 'HistoryLoaderRetransmissionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                        entity: $stateParams.requestParams
                    }
                }).result.then(function() {
                    $state.go('history-loader.retransmission-loading');
                }, function() {
                    $state.go('^');
                });
            }]
        }).state('history-loader.retransmission-loading', {
            parent: 'history-loader.retransmission-dialog',
            url: '/loading-history-retransmission',
            views: {
                'content@': {
                    templateUrl: 'app/admin/history-loader/history-loader-retransmission-loading.html',
                    controller: 'HistoryLoaderRetransmissionLoadingController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', function ($stateParams) {
                    return {
                        historyProviderSelector: $stateParams.requestParams.historyProviderSelector
                    }
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('telestatApp')
        .factory('CianHistoryLoader', CianHistoryLoader);

    CianHistoryLoader.$inject = ['$resource', 'DateUtils'];

    function CianHistoryLoader($resource, DateUtils) {
        var service = $resource('api/pbx/cian/load-history', {}, {
            'loadHistory': {
                method: 'POST'
            },
            'retransmissionHistory': {
                method: 'POST',
                url: 'api/pbx/cian/retransmission-signals'
            }
        });

        return service;
    }

    angular
        .module('telestatApp')
        .factory('MegafonHistoryLoader', MegafonHistoryLoader);

    MegafonHistoryLoader.$inject = ['$resource', 'DateUtils'];
    
    function MegafonHistoryLoader($resource, DateUtils) {
        var service = $resource('api/pbx/megafon/load-history', {}, {
            'loadHistory': {
                method: 'POST'
            },
            'retransmissionHistory': {
                method: 'POST',
                url: 'api/pbx/megafon/retransmission-signals'
            }
        });

        return service;
    }

})();

(function () {
    'use strict';

    angular
        .module('telestatApp')
        .controller('HistoryLoaderController', HistoryLoaderController);

    HistoryLoaderController.$inject = ['$locale'];

    function HistoryLoaderController($locale) {
        var vm = this;

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.dateformat = $locale.DATETIME_FORMATS.shortDate;

        vm.startTime = new Date();
        vm.endTime = new Date();
        vm.limit = 1000;
        vm.startTime.setDate(vm.endTime.getDate()-1);
        vm.datePickerOpenStatus.startTime = false;
        vm.datePickerOpenStatus.endTime = false;
        vm.historyProviderSelector = 'Megafon';

        vm.retransmissionStartTime = new Date();
        vm.retransmissionEndTime = new Date();
        vm.retransmissionStartTime.setDate(vm.retransmissionEndTime.getDate()-1);
        vm.datePickerOpenStatus.retransmissionStartTime = false;
        vm.datePickerOpenStatus.retransmissionEndTime = false;
        vm.retransmissionHistoryProviderSelector = 'Megafon';

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('telestatApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('telestatApp')
        .controller('ElasticsearchReindexSelectedDialogController', ElasticsearchReindexSelectedDialogController);

    ElasticsearchReindexSelectedDialogController.$inject = ['$uibModalInstance', 'ElasticsearchReindex', 'entities'];

    function ElasticsearchReindexSelectedDialogController($uibModalInstance, ElasticsearchReindex, entities) {
        var vm = this;

        vm.clear = clear;
        vm.confirmReindex = confirmReindex;
        vm.entities = entities;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmReindex() {
            var postData = vm.entities;
            if (!Array.isArray(postData)) {
                postData = [postData];
            }
            ElasticsearchReindex.reindexSelected(
                    {}, postData,
                    function () {
                        $uibModalInstance.close(true);
                    }
            );
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('telestatApp')
        .controller('ElasticsearchReindexDialogController', ElasticsearchReindexDialogController);

    ElasticsearchReindexDialogController.$inject = ['$uibModalInstance', 'ElasticsearchReindex'];

    function ElasticsearchReindexDialogController($uibModalInstance, ElasticsearchReindex) {
        var vm = this;

        vm.clear = clear;
        vm.confirmReindex = confirmReindex;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmReindex() {
            ElasticsearchReindex.reindex(function () {
                $uibModalInstance.close(true);
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('elasticsearch-reindex', {
            parent: 'admin',
            url: '/elasticsearch-reindex',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'elasticsearch.reindex.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/elasticsearch-reindex/elasticsearch-reindex.html',
                    controller: 'ElasticsearchReindexController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('elasticsearch-reindex');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }).state('elasticsearch-reindex.dialog', {
            parent: 'elasticsearch-reindex',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/elasticsearch-reindex/elasticsearch-reindex-dialog.html',
                    controller: 'ElasticsearchReindexDialogController',
                    controllerAs: 'vm',
                    size: 'sm'
                }).result.finally(function () {
                    $state.go('^');
                });
            }]
        }).state('elasticsearch-reindex.selected-dialog', {
            parent: 'elasticsearch-reindex',
            url: '/selected?entities',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            params: {
                entities: null
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/elasticsearch-reindex/elasticsearch-reindex-dialog.html',
                    controller: 'ElasticsearchReindexSelectedDialogController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                        entities: function () {
                            return $stateParams.entities;
                        }
                    }
                }).result.finally(function () {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('telestatApp')
        .factory('ElasticsearchReindex', ElasticsearchReindex);

    ElasticsearchReindex.$inject = ['$resource'];

    function ElasticsearchReindex($resource) {
        var service = $resource('api/elasticsearch/index', {}, {
            'reindex': {method: 'POST'},
            'reindexSelected': {method: 'POST', url: 'api/elasticsearch/selected'}
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('telestatApp')
        .controller('ElasticsearchReindexController', ElasticsearchReindexController);

    ElasticsearchReindexController.$inject = ['$state', 'AlertService', '$translate'];

    function ElasticsearchReindexController($state, AlertService, $translate) {
        var vm = this;
        vm.reindexType = 'all';
        vm.entities = [
                'AdvertisingSource',
                'BlockedPhone',
                'CloudPBX',
                'CloudPBXPrefix',
                'ComplainOnSms',
                'Division',
                'Employee',
                'EmployeePhone',
                'ExternalResource',
                'OfficePhone',
                'PhoneCall',
                'PhoneCallCheck',
                'PhoneCallPurpose',
                'PhoneCallResult',
                'PhoneCallResultGroup',
                'PhoneCallStatus',
                'RealtyType',
                'Setting',
                'SimPhone',
                'VirtualNumber',
                'User'
              ];
        vm.checks = {};
        vm.entities.forEach(
                function(name) {
                    vm.checks[name] = false;
                }
        );
        vm.doReindex = doReindex;
        function doReindex() {
            if (vm.reindexType == 'all') {
                $state.transitionTo('elasticsearch-reindex.dialog');
            } else {
                var reindexList = vm.entities.filter(function (name) {
                    return vm.checks[name];
                });
                if (reindexList.length > 0) {
                    $state.transitionTo('elasticsearch-reindex.selected-dialog', {entities: reindexList});
                } else {
                    AlertService.error($translate.instant('elasticsearch.reindex.selectEntityAlert'));
                }
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('sessions', {
            parent: 'account',
            url: '/sessions',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.sessions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/sessions/sessions.html',
                    controller: 'SessionsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sessions');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('SessionsController', SessionsController);

    SessionsController.$inject = ['Sessions', 'Principal'];

    function SessionsController (Sessions, Principal) {
        var vm = this;

        vm.account = null;
        vm.error = null;
        vm.invalidate = invalidate;
        vm.sessions = Sessions.getAll();
        vm.success = null;


        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function invalidate (series) {
            Sessions.delete({series: encodeURIComponent(series)},
                function () {
                    vm.error = null;
                    vm.success = 'OK';
                    vm.sessions = Sessions.getAll();
                },
                function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth', 'errorConstants'];

    function RequestResetController ($timeout, Auth, errorConstants) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.EMAIL_NOT_FOUND_TYPE) {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService', 'errorConstants'];

    function RegisterController ($translate, $timeout, Auth, LoginService, errorConstants) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.LOGIN_ALREADY_USED_TYPE) {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.EMAIL_ALREADY_USED_TYPE) {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('telestatApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small data-translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){angular.module('telestatApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/home/home.html','<div ng-cloak><div class="row"><div class="col-md-4"><!--\n            <span class="hipster img-responsive img-rounded"></span>\n            --> <span ng-if="vm.firmProfile == \'default\'" class="hipster img-responsive img-rounded"></span> <span ng-if="vm.firmProfile == \'kayan\'" class="hipster-kayan img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="home.title">Welcome, Java Hipster!</h1><!--\n            <p class="lead" data-translate="home.subtitle">This is your homepage</p>\n            --><p class="lead" ng-if="vm.firmProfile == \'default\'" data-translate="home.subtitle">This is your homepage</p><p class="lead" ng-if="vm.firmProfile == \'kayan\'" data-translate="home.subtitleKayan">This is your homepage</p><div ng-switch="vm.isAuthenticated()"><div class="alert alert-success" ng-switch-when="true" data-translate="home.logged.message" translate-values="{username: \'{{vm.account.login}}\'}">You are logged in as user "{{vm.account.login}}".</div><div class="alert alert-danger" ng-switch-when="true" ng-if="vm.testResult == \'fail\'">\u0412\u041D\u0418\u041C\u0410\u041D\u0418\u0415! \u041E\u0431\u043D\u0430\u0440\u0443\u0436\u0435\u043D\u0430 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0430 \u0441 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u043E\u0439 \u0441\u043A\u0440\u0438\u043F\u0442\u043E\u0432 \u0438 \u0434\u0430\u043D\u043D\u044B\u0445.<br>\u0414\u043B\u044F \u0443\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u0438\u044F \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u044B \u043E\u0442\u043A\u043B\u044E\u0447\u0438\u0442\u0435 \u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0449\u0438\u043A \u0440\u0435\u043A\u043B\u0430\u043C\u044B \u043D\u0430 \u0434\u0430\u043D\u043D\u043E\u043C \u0441\u0430\u0439\u0442\u0435.</div><div class="alert alert-danger" ng-switch-when="true" ng-if="vm.testResult == \'offline\'">\u0412\u041D\u0418\u041C\u0410\u041D\u0418\u0415! \u0421\u0435\u0440\u0432\u0435\u0440 \u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u0435\u043D.</div><!--\n                <div class="alert alert-warning" ng-switch-when="false" data-translate="global.messages.info.authenticated" translate-compile>\n                    If you want to <a class="alert-link" href="" ng-click="vm.login()">sign in</a>, you can try the default accounts:<br/>- Administrator (login="admin" and password="admin") <br/>- User (login="user" and password="user").\n                </div>\n --><!-- Registration disabled\n                <div class="alert alert-warning" ng-switch-when="false" data-translate="global.messages.info.register" translate-compile>\n                    You don\'t have an account yet? <a class="alert-link" ui-sref="register">Register a new account</a>\n                </div>\n--></div><!--\n            <p data-translate="home.question">\n                If you have any question on JHipster:\n            </p>\n\n            <ul>\n                <li><a href="http://www.jhipster.tech/" target="_blank" rel="noopener" data-translate="home.link.homepage">JHipster homepage</a></li>\n                <li><a href="http://stackoverflow.com/tags/jhipster/info" target="_blank" rel="noopener" data-translate="home.link.stackoverflow">JHipster on Stack Overflow</a></li>\n                <li><a href="https://github.com/jhipster/generator-jhipster/issues?state=open" target="_blank" rel="noopener" data-translate="home.link.bugtracker">JHipster bug tracker</a></li>\n                <li><a href="https://gitter.im/jhipster/generator-jhipster" target="_blank" rel="noopener" data-translate="home.link.chat">JHipster public chat room</a></li>\n                <li><a href="https://twitter.com/java_hipster" target="_blank" rel="noopener" data-translate="home.link.follow">follow @java_hipster on Twitter</a></li>\n            </ul>\n\n            <p>\n             <span data-translate="home.like">If you like JHipster, don\'t forget to give us a star on </span>&nbsp;<a href="https://github.com/jhipster/generator-jhipster" target="_blank" rel="noopener" data-translate="home.github">GitHub</a>!\n            </p>\n            --></div></div></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="activate.title">Activation</h1><div class="alert alert-success" ng-show="vm.success" data-translate="activate.messages.success" translate-compile><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="activate.messages.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="password.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/register/register.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="register.title">Registration</h1><div class="alert alert-success" ng-show="vm.success" data-translate="register.messages.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="register.messages.error.fail"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="vm.errorUserExists" data-translate="register.messages.error.userexists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists" data-translate="register.messages.error.emailexists"><strong>Email is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div></div><div class="col-md-8 col-md-offset-2"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation><div class="form-group"><label class="control-label" for="login" data-translate="global.form.username">Username</label><input type="text" class="form-control" id="login" name="login" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.registerAccount.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required" data-translate="register.messages.validate.login.required">Your username is required.</p><p class="help-block" ng-show="form.login.$error.minlength" data-translate="register.messages.validate.login.minlength">Your username is required to be at least 1 character.</p><p class="help-block" ng-show="form.login.$error.maxlength" data-translate="register.messages.validate.login.maxlength">Your username cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.login.$error.pattern" data-translate="register.messages.validate.login.pattern">Your username can only contain lower-case letters and digits.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.registerAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="register.form.button">Register</button></form><p></p></div></div></div>');
$templateCache.put('app/account/sessions/sessions.html','<div><h2 data-translate="sessions.title" translate-values="{username: \'{{vm.account.login}}\'}">Active sessions for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="sessions.messages.success"><strong>Session invalidated!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="sessions.messages.error"><strong>An error has occured!</strong> The session could not be invalidated.</div><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="sessions.table.ipaddress">IP Address</th><th data-translate="sessions.table.useragent">User agent</th><th data-translate="sessions.table.date">Date</th><th></th></tr></thead><tbody><tr ng-repeat="session in vm.sessions"><td>{{session.ipAddress}}</td><td>{{session.userAgent}}</td><td>{{session.tokenDate | date:\'longDate\'}}</td><td><button type="submit" class="btn btn-primary" ng-click="vm.invalidate(session.series)" data-translate="sessions.table.button">Invalidate</button></td></tr></tbody></table></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="settings.messages.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName" data-translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" data-translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" data-translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" data-translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" data-translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" data-translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" data-translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><div class="form-group"><label for="langKey" data-translate="settings.form.language">Language</label><select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="settings.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2 data-translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 data-translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" data-translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" data-translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span data-translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span data-translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span data-translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span data-translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span data-translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2 data-translate="configuration.title">Configuration</h2><span data-translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><h3 ng-hide="filteredConfig.length === 0">Spring configuration</h3><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length === 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span data-translate="configuration.table.prefix">Prefix</span></th><th data-translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-success break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><h4 ng-hide="filtered.length === 0"><span>{{key}}</span></h4><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length === 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-success break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top" title="Swagger UI"></iframe>');
$templateCache.put('app/admin/elasticsearch-reindex/elasticsearch-reindex-dialog.html','<form name="reindexForm" ng-submit="vm.confirmReindex()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="elasticsearch.reindex.dialog.title">Confirm reindex operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="elasticsearch.reindex.dialog.question">Are you sure you want to reindex Elasticsearch? This could take a while!</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span data-translate="elasticsearch.reindex.dialog.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-exclamation-sign"></span>&nbsp; <span data-translate="elasticsearch.reindex.dialog.confirm">Reindex</span></button></div></form>');
$templateCache.put('app/admin/elasticsearch-reindex/elasticsearch-reindex.html','<div class="clearfix"><h1 data-translate="elasticsearch.reindex.title">Reindex Elasticsearch</h1><jhi-alert></jhi-alert><p data-translate="elasticsearch.reindex.instructions1">This will send a request to reindex all data from your primary datasource into Elasticsearch. This will fix missing data and mapping issues, however you will lose any ES data and mapping that was defined outside of your application. This request will return immediately and the reindexing will run in the background. You will see "Elasticsearch: Successfully performed reindexing" in your logs when this is complete.</p><p data-translate="elasticsearch.reindex.instructions2">This can take a long time and is susceptible to concurrency issues so it should be performed when the number of users is low.</p><select class="form-control selectpicker" ng-model="vm.reindexType"><option value="all">All</option><option value="selected">Selected</option></select><div ng-show="vm.reindexType != \'all\'" ng-repeat="entityName in vm.entities"><label class="checkbox-inline"><input name="{{ entityName }}" ng-model="vm.checks[entityName]" type="checkbox"> {{ entityName }}</label></div><br><button type="button" class="btn btn-primary pull-right" ng-click="vm.doReindex()"><span class="glyphicon glyphicon-exclamation-sign"></span> <span data-translate="elasticsearch.reindex.go">Go</span></button></div>');
$templateCache.put('app/admin/health/health.html','<div><h2 data-translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" data-translate="health.table.service">Service Name</th><th class="col-md-2 text-center" data-translate="health.table.status">Status</th><th class="col-md-2 text-center" data-translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 data-translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" data-translate="health.details.name">Name</th><th class="col-md-6 text-left" data-translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 data-translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/history-loader/history-loader-dialog.html','<form name="loadHistoryForm" ng-submit="vm.confirmLoadHistory()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="history-loader.dialog.title" translate-values="{provider: \'{{vm.historyProviderSelector}}\'}">Confirm load history operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="history-loader.dialog.question" translate-values="{provider: \'{{vm.historyProviderSelector}}\'}">Are you sure you want to load history from provider? This could take a while!</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span data-translate="history-loader.dialog.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-cloud-download"></span>&nbsp; <span data-translate="history-loader.dialog.confirm">Load</span></button></div></form>');
$templateCache.put('app/admin/history-loader/history-loader-loading.html','<div class="clearfix"><jhi-alert></jhi-alert><div class="text-center"><h3 data-translate="history-loader.loading.title" translate-values="{provider: \'{{vm.historyProviderSelector}}\'}">Phone call history is loading right now</h3><h4 data-translate="history-loader.loading.instructions2">Please wait...</h4></div></div>');
$templateCache.put('app/admin/history-loader/history-loader-retransmission-dialog.html','<form name="loadHistoryForm" ng-submit="vm.confirmRetransmissionHistory()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="history-loader.dialog.retransmissionTitle" translate-values="{provider: \'{{vm.historyProviderSelector}}\'}">Confirm load history operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="history-loader.dialog.retransmissionQuestion" translate-values="{provider: \'{{vm.historyProviderSelector}}\'}">Are you sure you want to forward history from provider to CRM? This may update phone call history in CRM!</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span data-translate="history-loader.dialog.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-cloud-download"></span>&nbsp; <span data-translate="history-loader.dialog.confirm">Load</span></button></div></form>');
$templateCache.put('app/admin/history-loader/history-loader-retransmission-loading.html','<div class="clearfix"><jhi-alert></jhi-alert><div class="text-center"><h3 data-translate="history-loader.loading.title" translate-values="{provider: \'{{vm.historyProviderSelector}}\'}">Phone call history is loading right now</h3><h4 data-translate="history-loader.loading.instructions2">Please wait...</h4></div></div>');
$templateCache.put('app/admin/history-loader/history-loader.html','<div class="clearfix"><h2 data-translate="history-loader.title">Provider history loading</h2><jhi-alert></jhi-alert><p data-translate="history-loader.instructions1">This will send a request to load history from provider in the specified period of time. After successful loading form will close.</p><p data-translate="history-loader.instructions2">This can take a long time.</p><div class="container-fluid"><div class="row"><div class="col-xs-4"></div><div class="col-xs-3 no-padding-left"><label class="control-label" data-translate="history-loader.historyProviderSelector" for="field_historyProviderSelector">Select history provider</label><select class="form-control selectpicker" id="field_historyProviderSelector" ng-model="vm.historyProviderSelector" name="historyProviderSelector"><option value="Megafon">Megafon</option><option value="Cian">Cian</option></select></div></div><div class="row"><div class="col-xs-4"></div><div class="form-group col-xs-3 no-padding-left"><label class="control-label" data-translate="history-loader.startTime" for="field_startTime">Start Time</label><div class="input-group"><input type="text" class="form-control" id="field_startTime" name="startTime" is-open="vm.datePickerOpenStatus.startTime" uib-datepicker-popup="{{vm.dateformat}}" ng-model="vm.startTime"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startTime\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="row"><div class="col-xs-4"></div><div class="form-group col-xs-3 no-padding-left"><label class="control-label" data-translate="history-loader.endTime" for="field_endTime">End Time</label><div class="input-group"><input type="text" class="form-control" id="field_endTime" name="endTime" is-open="vm.datePickerOpenStatus.endTime" uib-datepicker-popup="{{vm.dateformat}}" ng-model="vm.endTime"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'endTime\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="row"><div class="col-xs-4"></div><div class="form-group col-xs-3 no-padding-left"><label class="control-label" data-translate="history-loader.limit" for="field_limit">Limit</label><input type="number" class="form-control" name="limit" id="field_limit" ng-model="vm.limit" required min="1" max="10000"></div></div><button type="button" class="btn btn-primary pull-right" ui-sref="history-loader.dialog({requestParams: {limit: vm.limit, startTime: vm.startTime, endTime: vm.endTime, historyProviderSelector: vm.historyProviderSelector}})"><span class="glyphicon glyphicon-new-window"></span> <span data-translate="history-loader.loadHistory">Start</span></button></div></div><div class="clearfix"><h2 data-translate="history-loader.retransmissionTitle">Provider history retransmission</h2><p data-translate="history-loader.retransmissionInstructions1">This will send a request to load history from provider in the specified period of time. After successful loading form will close.</p><p data-translate="history-loader.retransmissionInstructions2">This can take a long time.</p><div class="container-fluid"><div class="row"><div class="col-xs-4"></div><div class="col-xs-3 no-padding-left"><label class="control-label" data-translate="history-loader.retransmissionHistoryProviderSelector" for="field_retransmissionHistoryProviderSelector">Select provider for retransmission</label><select class="form-control selectpicker" id="field_retransmissionHistoryProviderSelector" ng-model="vm.retransmissionHistoryProviderSelector" name="retransmissionHistoryProviderSelector"><option value="Megafon">Megafon</option><!-- <option value="Cian">Cian</option> --></select></div></div><div class="row"><div class="col-xs-4"></div><div class="form-group col-xs-3 no-padding-left"><label class="control-label" data-translate="history-loader.retransmissionStartTime" for="field_retransmissionStartTime">Retransmission Start Time</label><div class="input-group"><input type="text" class="form-control" id="field_retransmissionStartTime" name="startTime" is-open="vm.datePickerOpenStatus.retransmissionStartTime" uib-datepicker-popup="{{vm.dateformat}}" ng-model="vm.retransmissionStartTime"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'retransmissionStartTime\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="row"><div class="col-xs-4"></div><div class="form-group col-xs-3 no-padding-left"><label class="control-label" data-translate="history-loader.retransmissionEndTime" for="field_retransmissionEndTime">Retransmission End Time</label><div class="input-group"><input type="text" class="form-control" id="field_retransmissionEndTime" name="endTime" is-open="vm.datePickerOpenStatus.retransmissionEndTime" uib-datepicker-popup="{{vm.dateformat}}" ng-model="vm.retransmissionEndTime"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'retransmissionEndTime\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><button type="button" class="btn btn-primary pull-right" ui-sref="history-loader.retransmission-dialog({requestParams: {limit: 0, startTime: vm.retransmissionStartTime, endTime: vm.retransmissionEndTime, historyProviderSelector: vm.retransmissionHistoryProviderSelector}})"><span class="glyphicon glyphicon-new-window"></span> <span data-translate="history-loader.retransmissionHistory">Start</span></button></div></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2 data-translate="logs.title">Logs</h2><p data-translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span data-translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span data-translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span data-translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/logs-viewer/logs-viewer.html','<div class="table-responsive"><h2 data-translate="logs-viewer.title">Logs viewer</h2><select ng-model="vm.listName" ng-options="item for item in vm.list" ng-change="vm.changeFile(\'{{item}}\')"></select><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th><span data-translate="logs-viewer.table.date">Date</span></th><th><span data-translate="logs-viewer.table.type">Type</span></th><th><span data-translate="logs-viewer.table.message">Message</span></th></tr></thead><tr ng-repeat="row in vm.rows"><td><small>{{ row.date }}</small></td><td><small>{{ row.type }}</small></td><td>{{ row.message }}</td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2 data-translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="metrics.refresh.button">Refresh</span></button></p><h3 data-translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b data-translate="metrics.jvm.memory.title">Memory</b><p><span data-translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span data-translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" data-translate="metrics.updating">Updating...</div><h3 data-translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span data-translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span data-translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.jvm.http.table.code">Code</th><th data-translate="metrics.jvm.http.table.count">Count</th><th class="text-right" data-translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td data-translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" data-translate="metrics.servicesstats.table.count">Count</th><th class="text-right" data-translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" data-translate="metrics.servicesstats.table.min">Min</th><th class="text-right" data-translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" data-translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" data-translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" data-translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" data-translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 data-translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span data-translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right" data-translate="metrics.datasource.count">Count</th><th class="text-right" data-translate="metrics.datasource.mean">Mean</th><th class="text-right" data-translate="metrics.datasource.min">Min</th><th class="text-right" data-translate="metrics.datasource.p50">p50</th><th class="text-right" data-translate="metrics.datasource.p75">p75</th><th class="text-right" data-translate="metrics.datasource.p95">p95</th><th class="text-right" data-translate="metrics.datasource.p99">p99</th><th class="text-right" data-translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" data-translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" data-translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th data-translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/tracker/tracker.html','<div><h2 data-translate="tracker.title">Real-time user activities</h2><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="tracker.table.userlogin">User</th><th data-translate="tracker.table.ipaddress">IP Address</th><th data-translate="tracker.table.page">Current page</th><th data-translate="tracker.table.time">Time</th><th></th></tr></thead><tbody><tr ng-repeat="activity in vm.activities"><td>{{activity.userLogin}}</td><td>{{activity.ipAddress}}</td><td>{{activity.page}}</td><td>{{activity.time | date:\'yyyy-MM-dd HH:mm:ss\'}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span data-translate="userManagement.detail.title">User</span> [<b>{{vm.user.login}}</b>]</h2><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="userManagement.login">Login</span></dt><dd><span>{{vm.user.login}}</span> <span class="label label-danger" ng-show="!vm.user.activated" data-translate="userManagement.deactivated">Deactivated</span> <span class="label label-success" ng-show="vm.user.activated" data-translate="userManagement.activated">Activated</span></dd><dt><span data-translate="userManagement.firstName">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span data-translate="userManagement.lastName">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span data-translate="userManagement.email">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span data-translate="userManagement.langKey">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span data-translate="userManagement.createdBy">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span data-translate="userManagement.createdDate">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span data-translate="userManagement.lastModifiedBy">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span data-translate="userManagement.profiles">Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span class="label label-info">{{authority}}</span></li></ul></dd></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" data-translate="userManagement.home.createOrEditLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.user.id"><label data-translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="userManagement.login">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" required ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.firstName">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label data-translate="userManagement.lastName">Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.email">Email</label><!--\n            <input type="email" class="form-control" name="email"\n                   ng-model="vm.user.email" required ng-maxlength="100">\n            --> <input type="email" class="form-control" name="email" ng-model="vm.user.email" ng-maxlength="100"><div ng-show="editForm.email.$invalid"><!--\n                <p class="help-block"\n                   ng-show="editForm.email.$error.required" data-translate="entity.validation.required">\n                    This field is required.\n                </p>\n                --><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span data-translate="userManagement.activated">Activated</span></label></div><div class="form-group"><label data-translate="userManagement.langKey">Lang Key</label><select class="form-control" name="langKey" ng-model="vm.user.langKey" ng-options="language as language for language in vm.languages track by language"></select></div><div class="form-group"><label data-translate="userManagement.profiles">Profiles</label><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" ng-options="authority for authority in vm.authorities"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-password.html','<form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 data-translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Password for [<b>{{vm.account.login}}</b>]</h4></div><div class="modal-body"><div class="alert alert-danger" ng-show="vm.error" data-translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div></div><div class="modal-footer"><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="password.form.button">Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div><h2 data-translate="userManagement.home.title">Users</h2><jhi-alert></jhi-alert><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="user-management.new"><span class="glyphicon glyphicon-flash"></span> <span data-translate="userManagement.home.createLabel">Create a new User</span></button></div><!-- Our search block --><div class="col-md-8"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'userManagement.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="login"><span data-translate="userManagement.login">Login</span> <span class="glyphicon glyphicon-sort"></span></th><th class="hidden-xs" jh-sort-by="email"><span data-translate="userManagement.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th></th><th class="hidden-xs hidden-sm hidden-md" jh-sort-by="langKey"><span data-translate="userManagement.langKey">Lang Key</span> <span class="glyphicon glyphicon-sort"></span></th><th class="hidden-xs"><span data-translate="userManagement.profiles">Profiles</span></th><th class="hidden-xs hidden-sm hidden-md" jh-sort-by="createdDate"><span data-translate="userManagement.createdDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th class="hidden-xs hidden-sm hidden-md" jh-sort-by="lastModifiedBy"><span data-translate="userManagement.lastModifiedBy">Last Modified By</span> <span class="glyphicon glyphicon-sort"></span></th><th class="hidden-xs hidden-sm hidden-md" jh-sort-by="lastModifiedDate"><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.login}}</td><td class="hidden-xs">{{user.email}}</td><td><button class="btn btn-danger btn-xs" ng-click="vm.setActive(user, true)" ng-show="!user.activated" data-translate="userManagement.deactivated">Deactivated</button> <button class="btn btn-success btn-xs" ng-click="vm.setActive(user, false)" ng-show="user.activated" ng-disabled="vm.currentAccount.login === user.login" data-translate="userManagement.activated">Activated</button></td><td class="hidden-xs hidden-sm hidden-md">{{user.langKey}}</td><td class="hidden-xs"><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td class="hidden-xs hidden-sm hidden-md">{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="hidden-xs hidden-sm hidden-md">{{user.lastModifiedBy}}</td><td class="hidden-xs hidden-sm hidden-md">{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span><!--\n                            <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span>\n                            --></button> <button type="submit" ui-sref="user-management.edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span><!--\n                            <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span>\n                            --></button><!-- Our change pass block --> <button type="submit" ui-sref="user-management.pass({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-lock"></span></button> <button type="submit" ui-sref="user-management.delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login === user.login"><span class="glyphicon glyphicon-remove-circle"></span><!--\n                            <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span>\n                            --></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/components/date-filter/date-filter.template.html','<div class="col-xs-7 no-padding-left"><div class="pull-left"><select class="form-control selectpicker" ng-model="vm.dateFilterType" ng-change="vm.search(\'\', \'{{vm.dateFilterType}}\')"><option value="all" ng-if="vm.allActive" data-translate="datefilter.nolimits">No limits</option><option value="today" data-translate="datefilter.today">Today</option><option value="yesterday" data-translate="datefilter.yesterday">Yesterday</option><option value="day" data-translate="datefilter.day">Day</option><option value="thisweek" data-translate="datefilter.thisweek">This week</option><option value="lastweek" data-translate="datefilter.lastweek">Last week</option><option value="thismonth" data-translate="datefilter.thismonth">This month</option><option value="lastmonth" data-translate="datefilter.lastmonth">Last month</option><option value="range" data-translate="datefilter.range">Range</option></select></div><div class="col-xs-1"></div><div ng-show="vm.dateFilterType != \'all\'"><div class="col-xs-{{ vm.dateFilterDay ? \'3\' : \'7\' }} input-group date"><input type="text" class="form-control" ng-model="vm.startDate" ng-readonly="vm.dateFilterReadonly" ng-click="vm.openCalendar(\'startDate\')" ng-change="vm.search(\'startDate\', \'{{vm.dateFilterType}}\')" name="startDate" is-open="vm.datePickerOpenStatus.startDate" uib-datepicker-popup="{{vm.dateformat}}"> <span class="input-group-addon" ng-click="vm.openCalendar(\'startDate\')"><i class="glyphicon glyphicon-th"></i> </span><span ng-show="!vm.dateFilterDay" class="input-group-addon" data-translate="datefilter.to">to</span> <input type="text" class="form-control" ng-model="vm.endDate" ng-readonly="vm.dateFilterReadonly" ng-show="!vm.dateFilterDay" ng-click="vm.openCalendar(\'endDate\')" ng-change="vm.search(\'endDate\', \'{{vm.dateFilterType}}\')" name="endDate" is-open="vm.datePickerOpenStatus.endDate" uib-datepicker-popup="{{vm.dateformat}}"> <span ng-show="!vm.dateFilterDay" class="input-group-addon" ng-click="vm.openCalendar(\'endDate\')"><i class="glyphicon glyphicon-th"></i></span></div></div></div>');
$templateCache.put('app/components/divisions-filter/divisions-filter.template.html','<select class="form-control input-group pull-right" id="field_division" name="division" has-any-authority="ROLE_ADMIN, ROLE_DIRECTOR, ROLE_CHECKER" ng-model="vm.data.division" ng-change="vm.search()" ng-options="division as division.name disable when !division.actual for division in vm.data.divisions track by division.id"></select>');
$templateCache.put('app/components/login/login.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="login.title">Sign in</h4></div><div class="modal-body"><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="login.title">Sign in</h1></div><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-8 col-md-offset-2"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username" data-translate="global.form.username">Login</label><input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username"></div><div class="form-group"><label for="password" data-translate="login.form.password">Password</label><input type="password" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span data-translate="login.form.rememberme">Remember me</span></label></div><button type="submit" class="btn btn-primary" data-translate="login.form.button">Sign in</button></form><p></p><div class="alert alert-warning"><a class="alert-link" href="" ng-click="vm.requestResetPassword()" data-translate="login.password.forgot">Did you forget your password?</a></div><!-- Registration disabled\n            <div class="alert alert-warning" data-translate="global.messages.info.register" translate-compile>\n                You don\'t have an account yet? <a class="alert-link" href="" ng-click="vm.register()">Register a new account</a>\n            </div>\n --></div></div></div>');
$templateCache.put('app/entities/advertising-source/advertising-source-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.advertisingSource.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="telestatApp.advertisingSource.delete.question" translate-values="{id: \'{{vm.advertisingSource.name}}\'}">Are you sure you want to delete this Advertising Source?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/advertising-source/advertising-source-detail.html','<div><h2><span data-translate="telestatApp.advertisingSource.detail.title">Advertising Source</span>: {{vm.advertisingSource.name}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="telestatApp.advertisingSource.name">Name</span></dt><dd><span>{{vm.advertisingSource.name}}</span></dd><dt><span data-translate="telestatApp.advertisingSource.caption">Caption</span></dt><dd><span>{{vm.advertisingSource.caption}}</span></dd><dt><span data-translate="telestatApp.advertisingSource.monthBudget">Month Budget</span></dt><dd><span>{{vm.advertisingSource.monthBudget}}</span></dd><dt><span data-translate="telestatApp.advertisingSource.color">Color</span></dt><dd><span>{{vm.advertisingSource.color}}</span></dd><dt><span data-translate="telestatApp.advertisingSource.uploadPhoneFormat">Upload Phone Format</span></dt><dd><span>{{vm.advertisingSource.uploadPhoneFormat}}</span></dd><dt><span data-translate="telestatApp.advertisingSource.autodetect">Autodetect</span></dt><dd><span data-translate="global.boolValueIsNot.{{vm.advertisingSource.autodetect}}">{{vm.advertisingSource.autodetect}}</span></dd><dt><span data-translate="telestatApp.advertisingSource.code">Code</span></dt><dd><span>{{vm.advertisingSource.code}}</span></dd><dt><span data-translate="telestatApp.advertisingSource.actual">Actual</span></dt><dd><span data-translate="global.boolValueYesNo.{{vm.advertisingSource.actual}}">{{vm.advertisingSource.actual}}</span></dd><dt><span data-translate="telestatApp.advertisingSource.externalId">External Id</span></dt><dd><span>{{vm.advertisingSource.externalId}}</span></dd><dt><span data-translate="telestatApp.advertisingSource.cloudPBX">Cloud PBX</span></dt><dd><a ui-sref="cloud-pbx-detail({id:vm.advertisingSource.cloudPBX.id})">{{vm.advertisingSource.cloudPBX.name}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="advertising-source-detail.edit({id:vm.advertisingSource.id})" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'advertising-source-detail.edit\')" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/advertising-source/advertising-source-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAdvertisingSourceLabel" data-translate="telestatApp.advertisingSource.home.createOrEditLabel">Create or edit a Advertising Source</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><!--\n        <div class="form-group" ng-show="vm.advertisingSource.id">\n            <label for="id" data-translate="global.field.id">ID</label>\n            <input type="text" class="form-control" id="id" name="id"\n                    ng-model="vm.advertisingSource.id" readonly />\n        </div>\n        --><div class="form-group"><label class="control-label" data-translate="telestatApp.advertisingSource.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.advertisingSource.name" required ng-minlength="2" ng-maxlength="32"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.name.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="32">This field cannot be longer than 32 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.advertisingSource.caption" for="field_caption">Caption</label><input type="text" class="form-control" name="caption" id="field_caption" ng-model="vm.advertisingSource.caption" required ng-minlength="2" ng-maxlength="16"><div ng-show="editForm.caption.$invalid"><p class="help-block" ng-show="editForm.caption.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.caption.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.caption.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="16">This field cannot be longer than 16 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.advertisingSource.monthBudget" for="field_monthBudget">Month Budget</label><input type="number" class="form-control" name="monthBudget" id="field_monthBudget" ng-model="vm.advertisingSource.monthBudget" required min="0"><div ng-show="editForm.monthBudget.$invalid"><p class="help-block" ng-show="editForm.monthBudget.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.monthBudget.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be at least 0.</p><p class="help-block" ng-show="editForm.monthBudget.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.advertisingSource.color" for="field_color">Color</label><input type="text" class="form-control" name="color" id="field_color" ng-model="vm.advertisingSource.color" required ng-minlength="2" ng-maxlength="16"><div ng-show="editForm.color.$invalid"><p class="help-block" ng-show="editForm.color.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.color.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.color.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="16">This field cannot be longer than 16 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.advertisingSource.uploadPhoneFormat" for="field_uploadPhoneFormat">Upload Phone Format</label><!--\n            <input type="text" class="form-control" name="uploadPhoneFormat" id="field_uploadPhoneFormat"\n                    ng-model="vm.advertisingSource.uploadPhoneFormat"\n                    required ng-minlength="4" ng-maxlength="16"/>\n            --><select class="form-control" name="uploadPhoneFormat" id="field_uploadPhoneFormat" ng-model="vm.advertisingSource.uploadPhoneFormat" required ng-options="uploadPhoneFormat for uploadPhoneFormat in vm.uploadPhoneFormats track by uploadPhoneFormat"></select><div ng-show="editForm.uploadPhoneFormat.$invalid"><p class="help-block" ng-show="editForm.uploadPhoneFormat.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.uploadPhoneFormat.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="4">This field is required to be at least 4 characters.</p><p class="help-block" ng-show="editForm.uploadPhoneFormat.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="16">This field cannot be longer than 16 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.advertisingSource.autodetect" for="field_autodetect">Autodetect</label><input type="checkbox" name="autodetect" id="field_autodetect" ng-model="vm.advertisingSource.autodetect"><div ng-show="editForm.autodetect.$invalid"><p class="help-block" ng-show="editForm.autodetect.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.advertisingSource.code" for="field_code">Code</label><input type="text" class="form-control" name="code" id="field_code" ng-model="vm.advertisingSource.code" required ng-minlength="1" ng-maxlength="8"><div ng-show="editForm.code.$invalid"><p class="help-block" ng-show="editForm.code.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.code.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.code.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="8">This field cannot be longer than 8 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.advertisingSource.actual" for="field_actual">Actual</label><input type="checkbox" name="actual" id="field_actual" ng-model="vm.advertisingSource.actual"><div ng-show="editForm.actual.$invalid"><p class="help-block" ng-show="editForm.actual.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.advertisingSource.externalId" for="field_externalId">External Id</label><input type="text" class="form-control" name="externalId" id="field_externalId" ng-model="vm.advertisingSource.externalId" readonly="readonly" ng-minlength="0" ng-maxlength="16"><div ng-show="editForm.externalId.$invalid"><p class="help-block" ng-show="editForm.externalId.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.externalId.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.externalId.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="16">This field cannot be longer than 16 characters.</p></div></div><div class="form-group"><label data-translate="telestatApp.advertisingSource.cloudPBX" for="field_cloudPBX">Cloud PBX</label><select class="form-control" id="field_cloudPBX" name="cloudPBX" ng-model="vm.advertisingSource.cloudPBX" ng-options="cloudPBX as cloudPBX.name for cloudPBX in vm.cloudpbxes track by cloudPBX.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/advertising-source/advertising-sources.html','<div><h2 data-translate="telestatApp.advertisingSource.home.title">Advertising Sources</h2><!--\n    <jhi-alert></jhi-alert>\n    --><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="advertising-source.new" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'advertising-source.new\')"><!-- replace\n                <button class="btn btn-primary" ui-sref="advertising-source.new" >\n                --> <span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="telestatApp.advertisingSource.home.createLabel">Create new Advertising Source</span></button></div><div class="col-xs-2"><label class="checkbox-inline"><input name="actualFilter" ng-model="vm.actualFilter" type="checkbox" ng-change="vm.search(vm.searchQuery)"> <span data-translate="global.actualFilter">Show actual</span></label></div><div class="col-xs-6 no-padding-right"><!-- replace\n            <div class="col-xs-8 no-padding-right">\n            --><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'telestatApp.advertisingSource.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><jhi-alert></jhi-alert><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><!-- skip\n                    <th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th>\n                    --><th jh-sort-by="name"><span data-translate="telestatApp.advertisingSource.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="caption"><span data-translate="telestatApp.advertisingSource.caption">Caption</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="monthBudget"><span data-translate="telestatApp.advertisingSource.monthBudget">Month Budget</span> <span class="glyphicon glyphicon-sort"></span></th><!-- skip\n                    <th jh-sort-by="color"><span data-translate="telestatApp.advertisingSource.color">Color</span> <span class="glyphicon glyphicon-sort"></span></th>\n                    <th jh-sort-by="uploadPhoneFormat"><span data-translate="telestatApp.advertisingSource.uploadPhoneFormat">Upload Phone Format</span> <span class="glyphicon glyphicon-sort"></span></th>\n                    <th jh-sort-by="autodetect"><span data-translate="telestatApp.advertisingSource.autodetect">Autodetect</span> <span class="glyphicon glyphicon-sort"></span></th>\n                    --><th jh-sort-by="code"><span data-translate="telestatApp.advertisingSource.code">Code</span> <span class="glyphicon glyphicon-sort"></span></th><!-- skip\n                    <th jh-sort-by="actual"><span data-translate="telestatApp.advertisingSource.actual">Actual</span> <span class="glyphicon glyphicon-sort"></span></th>\n                    <th jh-sort-by="externalId"><span data-translate="telestatApp.advertisingSource.externalId">External Id</span> <span class="glyphicon glyphicon-sort"></span></th>\n                    --><th jh-sort-by="cloudPBX.name"><span data-translate="telestatApp.advertisingSource.cloudPBX">Cloud PBX</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><!-- skip\n                <tr ng-repeat="advertisingSource in vm.advertisingSources track by advertisingSource.id">\n                --><tr ng-repeat="advertisingSource in vm.advertisingSources track by advertisingSource.id" ng-class="{\'inactive-entity\': !advertisingSource.actual}"><!-- skip\n                    <td><a ui-sref="advertising-source-detail({id:advertisingSource.id})">{{advertisingSource.id}}</a></td>\n                    <td>{{advertisingSource.name}}</td>\n                    --><td><a ui-sref="advertising-source-detail({id:advertisingSource.id})">{{advertisingSource.name}}</a></td><td>{{advertisingSource.caption}}</td><td>{{advertisingSource.monthBudget}}</td><!-- skip\n                    <td>{{advertisingSource.color}}</td>\n                    <td>{{advertisingSource.uploadPhoneFormat}}</td>\n                    <td>{{advertisingSource.autodetect}}</td>\n                    --><td>{{advertisingSource.code}}</td><!-- skip\n                    <td>{{advertisingSource.actual}}</td>\n                    <td>{{advertisingSource.externalId}}</td>\n                    --><td><a ui-sref="cloud-pbx-detail({id:advertisingSource.cloudPBX.id})">{{advertisingSource.cloudPBX.name}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="advertising-source-detail({id:advertisingSource.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="advertising-source.edit({id:advertisingSource.id})" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'advertising-source.edit\')" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="advertising-source.delete({id:advertisingSource.id})" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'advertising-source.delete\')" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/blocked-phone/blocked-phone-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.blockedPhone.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="telestatApp.blockedPhone.delete.question" translate-values="{id: \'{{vm.blockedPhone.id}}\'}">Are you sure you want to delete this Blocked Phone?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/blocked-phone/blocked-phone-detail.html','<div><h2><span data-translate="telestatApp.blockedPhone.detail.title">Blocked Phone</span> {{vm.blockedPhone.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="telestatApp.blockedPhone.number">Number</span></dt><dd><!--\n            <span>{{vm.blockedPhone.number}}</span>\n            --> <span>{{vm.blockedPhone.number | phone}}</span></dd><dt><span data-translate="telestatApp.blockedPhone.callsCount">Calls Count</span></dt><dd><span>{{vm.blockedPhone.callsCount}}</span></dd><dt><span data-translate="telestatApp.blockedPhone.lastCallTime">Last Call Time</span></dt><dd><span>{{vm.blockedPhone.lastCallTime | date:\'medium\'}}</span></dd><dt><span data-translate="telestatApp.blockedPhone.blockerCaption">Blocker Caption</span></dt><dd><span>{{vm.blockedPhone.blockerCaption}}</span></dd><dt><span data-translate="telestatApp.blockedPhone.blockingTime">Blocking Time</span></dt><dd><span>{{vm.blockedPhone.blockingTime | date:\'medium\'}}</span></dd><dt><span data-translate="telestatApp.blockedPhone.phoneCallResult">Phone Call Result</span></dt><dd><a ui-sref="phone-call-result-detail({id:vm.blockedPhone.phoneCallResult.id})">{{vm.blockedPhone.phoneCallResult.name}}</a></dd><dt><span data-translate="telestatApp.blockedPhone.blockerAccount">Blocker Account</span></dt><dd>{{vm.blockedPhone.blockerAccount.login}}</dd><dt><span data-translate="telestatApp.blockedPhone.blocker">Blocker</span></dt><dd><a ui-sref="employee-detail({id:vm.blockedPhone.blocker.id})">{{vm.blockedPhone.blocker.fullname}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button><!--\n    <button type="button" ui-sref="blocked-phone-detail.edit({id:vm.blockedPhone.id})" class="btn btn-primary">\n    --> <button type="button" ui-sref="blocked-phone-detail.edit({id:vm.blockedPhone.id})" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'blocked-phone-detail.edit\')" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/blocked-phone/blocked-phone-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myBlockedPhoneLabel" data-translate="telestatApp.blockedPhone.home.createOrEditLabel">Create or edit a Blocked Phone</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.blockedPhone.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.blockedPhone.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="telestatApp.blockedPhone.number" for="field_number">Number</label><input type="number" class="form-control" name="number" id="field_number" ng-model="vm.blockedPhone.number" required min="1"><div ng-show="editForm.number.$invalid"><p class="help-block" ng-show="editForm.number.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.number.$error.min" data-translate="entity.validation.min" translate-value-min="1">This field should be at least 1.</p><p class="help-block" ng-show="editForm.number.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div><label class="control-label" data-translate="telestatApp.blockedPhone.showAllParams" for="field_showAllParams">Show all params</label><input ng-model="vm.showAllParams" type="checkbox" id="field_showAllParams"></div><ng-content ng-if="vm.showAllParams"><div class="form-group"><label class="control-label" data-translate="telestatApp.blockedPhone.callsCount" for="field_callsCount">Calls Count</label><input type="number" class="form-control" name="callsCount" id="field_callsCount" ng-model="vm.blockedPhone.callsCount" min="1"><div ng-show="editForm.callsCount.$invalid"><p class="help-block" ng-show="editForm.callsCount.$error.min" data-translate="entity.validation.min" translate-value-min="1">This field should be at least 1.</p><p class="help-block" ng-show="editForm.callsCount.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.blockedPhone.lastCallTime" for="field_lastCallTime">Last Call Time</label><div class="input-group"><input id="field_lastCallTime" type="text" class="form-control" name="lastCallTime" datetime-picker="{{dateformat}}" ng-model="vm.blockedPhone.lastCallTime" is-open="vm.datePickerOpenStatus.lastCallTime"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'lastCallTime\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.blockedPhone.blockerCaption" for="field_blockerCaption">Blocker Caption</label><input type="text" class="form-control" name="blockerCaption" id="field_blockerCaption" ng-model="vm.blockedPhone.blockerCaption" ng-minlength="5" ng-maxlength="101"><div ng-show="editForm.blockerCaption.$invalid"><p class="help-block" ng-show="editForm.blockerCaption.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="5">This field is required to be at least 5 characters.</p><p class="help-block" ng-show="editForm.blockerCaption.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="101">This field cannot be longer than 101 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.blockedPhone.blockingTime" for="field_blockingTime">Blocking Time</label><div class="input-group"><input id="field_blockingTime" type="text" class="form-control" name="blockingTime" datetime-picker="{{dateformat}}" ng-model="vm.blockedPhone.blockingTime" is-open="vm.datePickerOpenStatus.blockingTime"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'blockingTime\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label data-translate="telestatApp.blockedPhone.phoneCallResult" for="field_phoneCallResult">Phone Call Result</label><select class="form-control" id="field_phoneCallResult" name="phoneCallResult" ng-model="vm.blockedPhone.phoneCallResult" ng-options="phoneCallResult as phoneCallResult.name for phoneCallResult in vm.phonecallresults track by phoneCallResult.id"><option value=""></option></select></div><div class="form-group"><label data-translate="telestatApp.blockedPhone.blockerAccount" for="field_blockerAccount">Blocker Account</label><select class="form-control" id="field_blockerAccount" name="blockerAccount" ng-model="vm.blockedPhone.blockerAccount" ng-options="user as user.login for user in vm.users track by user.id"><option value=""></option></select></div><div class="form-group"><label data-translate="telestatApp.blockedPhone.blocker" for="field_blocker">Blocker</label><select class="form-control" id="field_blocker" name="blocker" ng-model="vm.blockedPhone.blocker" ng-options="employee as employee.fullname for employee in vm.employees track by employee.id"><option value=""></option></select></div></ng-content></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/blocked-phone/blocked-phones.html','<div><h2 data-translate="telestatApp.blockedPhone.home.title">Blocked Phones</h2><!--\n    <jhi-alert></jhi-alert>\n    --><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><!--\n                <button class="btn btn-primary" ui-sref="blocked-phone.new" >\n                --> <button class="btn btn-primary" ui-sref="blocked-phone.new" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'blocked-phone.new\')"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="telestatApp.blockedPhone.home.createLabel">Create new Blocked Phone</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'telestatApp.blockedPhone.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div><div class="row">&nbsp;</div><div class="row"><div class="col-xs-6 no-padding-left"><button class="btn btn-primary" ui-sref="blocked-phone.receiveNew" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'blocked-phone.receiveNew\')"><span class="glyphicon glyphicon-cloud-download"></span> <span class="hidden-xs-down" data-translate="telestatApp.blockedPhone.home.receiveNew">Receive new Blocked Phones from Megafon PBX</span></button> <button class="btn btn-primary" ui-sref="blocked-phone.uploadAll" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'blocked-phone.uploadAll\')"><span class="glyphicon glyphicon-cloud-upload"></span> <span class="hidden-xs-down" data-translate="telestatApp.blockedPhone.home.uploadAll">Upload new Blocked Phones to Megafon PBX</span></button></div></div></div><br><jhi-alert></jhi-alert><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th class="hidden-xs hidden-sm hidden-md" jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="number"><span data-translate="telestatApp.blockedPhone.number">Number</span> <span class="glyphicon glyphicon-sort"></span></th><th class="hidden-xs hidden-sm hidden-md" jh-sort-by="callsCount"><span data-translate="telestatApp.blockedPhone.callsCount">Calls Count</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastCallTime"><span data-translate="telestatApp.blockedPhone.lastCallTime">Last Call Time</span> <span class="glyphicon glyphicon-sort"></span></th><th class="hidden-xs hidden-sm hidden-md" jh-sort-by="blockerCaption"><span data-translate="telestatApp.blockedPhone.blockerCaption">Blocker Caption</span> <span class="glyphicon glyphicon-sort"></span></th><th class="hidden-xs hidden-sm hidden-md" jh-sort-by="blockingTime"><span data-translate="telestatApp.blockedPhone.blockingTime">Blocking Time</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="phoneCallResult.name"><span data-translate="telestatApp.blockedPhone.phoneCallResult">Phone Call Result</span> <span class="glyphicon glyphicon-sort"></span></th><th class="hidden-xs hidden-sm hidden-md" jh-sort-by="blockerAccount.login"><span data-translate="telestatApp.blockedPhone.blockerAccount">Blocker Account</span> <span class="glyphicon glyphicon-sort"></span></th><th class="hidden-xs hidden-sm hidden-md" jh-sort-by="blocker.fullname"><span data-translate="telestatApp.blockedPhone.blocker">Blocker</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="blockedPhone in vm.blockedPhones track by blockedPhone.id"><td class="hidden-xs hidden-sm hidden-md"><a ui-sref="blocked-phone-detail({id:blockedPhone.id})">{{blockedPhone.id}}</a></td><!--\n                    <td>{{blockedPhone.number}}</td>\n                    --><td>{{blockedPhone.number | phone}}</td><td class="hidden-xs hidden-sm hidden-md">{{blockedPhone.callsCount}}</td><td>{{blockedPhone.lastCallTime | date:\'medium\'}}</td><td class="hidden-xs hidden-sm hidden-md">{{blockedPhone.blockerCaption}}</td><td class="hidden-xs hidden-sm hidden-md">{{blockedPhone.blockingTime | date:\'medium\'}}</td><td><a ui-sref="phone-call-result-detail({id:blockedPhone.phoneCallResult.id})">{{blockedPhone.phoneCallResult.name}}</a></td><td class="hidden-xs hidden-sm hidden-md">{{blockedPhone.blockerAccount.login}}</td><td class="hidden-xs hidden-sm hidden-md"><a ui-sref="employee-detail({id:blockedPhone.blocker.id})">{{blockedPhone.blocker.fullname}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="blocked-phone-detail({id:blockedPhone.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="blocked-phone.edit({id:blockedPhone.id})" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'blocked-phone.edit\')" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="blocked-phone.delete({id:blockedPhone.id})" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'blocked-phone.delete\')" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/cloud-pbx/cloud-pbx-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.cloudPBX.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><!--\n        <p data-translate="telestatApp.cloudPBX.delete.question" translate-values="{id: \'{{vm.cloudPBX.id}}\'}">Are you sure you want to delete this Cloud PBX?</p>\n        --><p data-translate="telestatApp.cloudPBX.delete.question" translate-values="{id: \'{{vm.cloudPBX.name}}\'}">Are you sure you want to delete this Cloud PBX?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/cloud-pbx/cloud-pbx-detail.html','<div><!--\n    <h2><span data-translate="telestatApp.cloudPBX.detail.title">Cloud PBX</span> {{vm.cloudPBX.id}}</h2>\n    --><h2><span data-translate="telestatApp.cloudPBX.detail.title">Cloud PBX</span>: {{vm.cloudPBX.name}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="telestatApp.cloudPBX.name">Name</span></dt><dd><span>{{vm.cloudPBX.name}}</span></dd><dt><span data-translate="telestatApp.cloudPBX.caption">Caption</span></dt><dd><span>{{vm.cloudPBX.caption}}</span></dd><dt><span data-translate="telestatApp.cloudPBX.url">Url</span></dt><dd><span>{{vm.cloudPBX.url}}</span></dd><dt><span data-translate="telestatApp.cloudPBX.attendantDuration">Attendant Duration</span></dt><dd><span>{{vm.cloudPBX.attendantDuration}}</span></dd><dt><span data-translate="telestatApp.cloudPBX.code">Code</span></dt><dd><span>{{vm.cloudPBX.code}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button><!--\n    <button type="button" ui-sref="cloud-pbx-detail.edit({id:vm.cloudPBX.id})" class="btn btn-primary">\n    --> <button type="button" ui-sref="cloud-pbx-detail.edit({id:vm.cloudPBX.id})" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'cloud-pbx-detail.edit\')" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/cloud-pbx/cloud-pbx-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCloudPBXLabel" data-translate="telestatApp.cloudPBX.home.createOrEditLabel">Create or edit a Cloud PBX</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><!--\n        <div class="form-group" ng-show="vm.cloudPBX.id">\n            <label for="id" data-translate="global.field.id">ID</label>\n            <input type="text" class="form-control" id="id" name="id"\n                    ng-model="vm.cloudPBX.id" readonly />\n        </div>\n        --><div class="form-group"><label class="control-label" data-translate="telestatApp.cloudPBX.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.cloudPBX.name" required ng-minlength="2" ng-maxlength="32"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.name.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="32">This field cannot be longer than 32 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.cloudPBX.caption" for="field_caption">Caption</label><input type="text" class="form-control" name="caption" id="field_caption" ng-model="vm.cloudPBX.caption" required ng-minlength="2" ng-maxlength="16"><div ng-show="editForm.caption.$invalid"><p class="help-block" ng-show="editForm.caption.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.caption.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.caption.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="16">This field cannot be longer than 16 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.cloudPBX.url" for="field_url">Url</label><input type="text" class="form-control" name="url" id="field_url" ng-model="vm.cloudPBX.url" required ng-minlength="4" ng-maxlength="256"><div ng-show="editForm.url.$invalid"><p class="help-block" ng-show="editForm.url.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.url.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="4">This field is required to be at least 4 characters.</p><p class="help-block" ng-show="editForm.url.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="256">This field cannot be longer than 256 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.cloudPBX.attendantDuration" for="field_attendantDuration">Attendant Duration</label><input type="number" class="form-control" name="attendantDuration" id="field_attendantDuration" ng-model="vm.cloudPBX.attendantDuration" required min="0" max="300"><div ng-show="editForm.attendantDuration.$invalid"><p class="help-block" ng-show="editForm.attendantDuration.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.attendantDuration.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be at least 0.</p><p class="help-block" ng-show="editForm.attendantDuration.$error.max" data-translate="entity.validation.max" translate-value-max="300">This field cannot be more than 300.</p><p class="help-block" ng-show="editForm.attendantDuration.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.cloudPBX.code" for="field_code">Code</label><input type="text" class="form-control" name="code" id="field_code" ng-model="vm.cloudPBX.code" readonly="readonly" required ng-minlength="1" ng-maxlength="8"><div ng-show="editForm.code.$invalid"><p class="help-block" ng-show="editForm.code.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.code.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.code.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="8">This field cannot be longer than 8 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/cloud-pbx/cloud-pbxes.html','<div><h2 data-translate="telestatApp.cloudPBX.home.title">Cloud PBXES</h2><!--\n    <jhi-alert></jhi-alert>\n    --><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><!--\n                <button class="btn btn-primary" ui-sref="cloud-pbx.new" >\n                --> <button class="btn btn-primary" ui-sref="cloud-pbx.new" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'cloud-pbx.new\')"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="telestatApp.cloudPBX.home.createLabel">Create new Cloud PBX</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'telestatApp.cloudPBX.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><jhi-alert></jhi-alert><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><!--\n                    <th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th>\n                    --><th jh-sort-by="name"><span data-translate="telestatApp.cloudPBX.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="caption"><span data-translate="telestatApp.cloudPBX.caption">Caption</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="url"><span data-translate="telestatApp.cloudPBX.url">Url</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="attendantDuration"><span data-translate="telestatApp.cloudPBX.attendantDuration">Attendant Duration</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="code"><span data-translate="telestatApp.cloudPBX.code">Code</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="cloudPBX in vm.cloudPBXES track by cloudPBX.id"><!--\n                    <td><a ui-sref="cloud-pbx-detail({id:cloudPBX.id})">{{cloudPBX.id}}</a></td>\n                    <td>{{cloudPBX.name}}</td>\n                    --><td><a ui-sref="cloud-pbx-detail({id:cloudPBX.id})">{{cloudPBX.name}}</a></td><td>{{cloudPBX.caption}}</td><td>{{cloudPBX.url}}</td><td>{{cloudPBX.attendantDuration}}</td><td>{{cloudPBX.code}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="cloud-pbx-detail({id:cloudPBX.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="cloud-pbx.edit({id:cloudPBX.id})" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'cloud-pbx.edit\')" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="cloud-pbx.delete({id:cloudPBX.id})" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'cloud-pbx.delete\')" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/cloud-pbx-prefix/cloud-pbx-prefix-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.cloudPBXPrefix.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="telestatApp.cloudPBXPrefix.delete.question" translate-values="{id: \'{{vm.cloudPBXPrefix.id}}\'}">Are you sure you want to delete this Cloud PBX Prefix?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/cloud-pbx-prefix/cloud-pbx-prefix-detail.html','<div><h2><span data-translate="telestatApp.cloudPBXPrefix.detail.title">Cloud PBX Prefix</span> {{vm.cloudPBXPrefix.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="telestatApp.cloudPBXPrefix.prefix" uib-tooltip="{{\'telestatApp.cloudPBXPrefix.help.prefix\' | translate}}">Prefix</span></dt><dd><span>{{vm.cloudPBXPrefix.prefix}}</span></dd><dt><span data-translate="telestatApp.cloudPBXPrefix.cloudPBX">Cloud PBX</span></dt><dd><a ui-sref="cloud-pbx-detail({id:vm.cloudPBXPrefix.cloudPBX.id})">{{vm.cloudPBXPrefix.cloudPBX.name}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="cloud-pbx-prefix-detail.edit({id:vm.cloudPBXPrefix.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/cloud-pbx-prefix/cloud-pbx-prefix-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCloudPBXPrefixLabel" data-translate="telestatApp.cloudPBXPrefix.home.createOrEditLabel">Create or edit a Cloud PBX Prefix</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.cloudPBXPrefix.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.cloudPBXPrefix.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="telestatApp.cloudPBXPrefix.prefix" for="field_prefix" uib-tooltip="{{\'telestatApp.cloudPBXPrefix.help.prefix\' | translate}}">Prefix</label><input type="text" class="form-control" name="prefix" id="field_prefix" ng-model="vm.cloudPBXPrefix.prefix" required ng-minlength="1" ng-maxlength="12"><div ng-show="editForm.prefix.$invalid"><p class="help-block" ng-show="editForm.prefix.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.prefix.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.prefix.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="12">This field cannot be longer than 12 characters.</p></div></div><div class="form-group"><label data-translate="telestatApp.cloudPBXPrefix.cloudPBX" for="field_cloudPBX">Cloud PBX</label><select class="form-control" id="field_cloudPBX" name="cloudPBX" ng-model="vm.cloudPBXPrefix.cloudPBX" ng-options="cloudPBX as cloudPBX.name for cloudPBX in vm.cloudpbxes track by cloudPBX.id" required></select></div><div ng-show="editForm.cloudPBX.$invalid"><p class="help-block" ng-show="editForm.cloudPBX.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/cloud-pbx-prefix/cloud-pbx-prefixes.html','<div><h2 data-translate="telestatApp.cloudPBXPrefix.home.title">Cloud PBX Prefixes</h2><!--\n    <jhi-alert></jhi-alert>\n    --><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="cloud-pbx-prefix.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="telestatApp.cloudPBXPrefix.home.createLabel">Create new Cloud PBX Prefix</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'telestatApp.cloudPBXPrefix.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><jhi-alert></jhi-alert><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="prefix"><span data-translate="telestatApp.cloudPBXPrefix.prefix">Prefix</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cloudPBX.name"><span data-translate="telestatApp.cloudPBXPrefix.cloudPBX">Cloud PBX</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="cloudPBXPrefix in vm.cloudPBXPrefixes track by cloudPBXPrefix.id"><td><a ui-sref="cloud-pbx-prefix-detail({id:cloudPBXPrefix.id})">{{cloudPBXPrefix.id}}</a></td><td>{{cloudPBXPrefix.prefix}}</td><td><a ui-sref="cloud-pbx-detail({id:cloudPBXPrefix.cloudPBX.id})">{{cloudPBXPrefix.cloudPBX.name}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="cloud-pbx-prefix-detail({id:cloudPBXPrefix.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="cloud-pbx-prefix.edit({id:cloudPBXPrefix.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="cloud-pbx-prefix.delete({id:cloudPBXPrefix.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/complain-on-sms/complain-on-sms-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.complainOnSms.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="telestatApp.complainOnSms.delete.question" translate-values="{id: \'{{vm.complainOnSms.id}}\'}">Are you sure you want to delete this Complain On Sms?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/complain-on-sms/complain-on-sms-detail.html','<div><h2><span data-translate="telestatApp.complainOnSms.detail.title">Complain On Sms</span> {{vm.complainOnSms.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="telestatApp.complainOnSms.number" uib-tooltip="{{\'telestatApp.complainOnSms.help.number\' | translate}}">Number</span></dt><dd><span>{{vm.complainOnSms.number}}</span></dd><dt><span data-translate="telestatApp.complainOnSms.complainTime" uib-tooltip="{{\'telestatApp.complainOnSms.help.complainTime\' | translate}}">Complain Time</span></dt><dd><span>{{vm.complainOnSms.complainTime | date:\'medium\'}}</span></dd><dt><span data-translate="telestatApp.complainOnSms.comment" uib-tooltip="{{\'telestatApp.complainOnSms.help.comment\' | translate}}">Comment</span></dt><dd><span>{{vm.complainOnSms.comment}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="complain-on-sms-detail.edit({id:vm.complainOnSms.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/complain-on-sms/complain-on-sms-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myComplainOnSmsLabel" data-translate="telestatApp.complainOnSms.home.createOrEditLabel">Create or edit a Complain On Sms</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.complainOnSms.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.complainOnSms.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="telestatApp.complainOnSms.number" for="field_number" uib-tooltip="{{\'telestatApp.complainOnSms.help.number\' | translate}}">Number</label><input type="number" class="form-control" name="number" id="field_number" ng-model="vm.complainOnSms.number"></div><div class="form-group"><label class="control-label" data-translate="telestatApp.complainOnSms.complainTime" for="field_complainTime" uib-tooltip="{{\'telestatApp.complainOnSms.help.complainTime\' | translate}}">Complain Time</label><div class="input-group"><input id="field_complainTime" type="text" class="form-control" name="complainTime" datetime-picker="{{dateformat}}" ng-model="vm.complainOnSms.complainTime" is-open="vm.datePickerOpenStatus.complainTime"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'complainTime\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.complainOnSms.comment" for="field_comment" uib-tooltip="{{\'telestatApp.complainOnSms.help.comment\' | translate}}">Comment</label><input type="text" class="form-control" name="comment" id="field_comment" ng-model="vm.complainOnSms.comment" ng-maxlength="256"><div ng-show="editForm.comment.$invalid"><p class="help-block" ng-show="editForm.comment.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="256">This field cannot be longer than 256 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/complain-on-sms/complain-on-sms.html','<div><h2 data-translate="telestatApp.complainOnSms.home.title">Complain On Sms</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="complain-on-sms.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="telestatApp.complainOnSms.home.createLabel">Create new Complain On Sms</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'telestatApp.complainOnSms.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="number"><span data-translate="telestatApp.complainOnSms.number">Number</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="complainTime"><span data-translate="telestatApp.complainOnSms.complainTime">Complain Time</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="comment"><span data-translate="telestatApp.complainOnSms.comment">Comment</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="complainOnSms in vm.complainOnSms track by complainOnSms.id"><td><a ui-sref="complain-on-sms-detail({id:complainOnSms.id})">{{complainOnSms.id}}</a></td><td>{{complainOnSms.number}}</td><td>{{complainOnSms.complainTime | date:\'medium\'}}</td><td>{{complainOnSms.comment}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="complain-on-sms-detail({id:complainOnSms.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="complain-on-sms.edit({id:complainOnSms.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="complain-on-sms.delete({id:complainOnSms.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/division/division-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.division.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="telestatApp.division.delete.question" translate-values="{id: \'{{vm.division.title}}\'}">Are you sure you want to delete this Division?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/division/division-detail.html','<div><h2><span data-translate="telestatApp.division.detail.title">Division</span>: {{vm.division.title}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><!--\n        <dt><span data-translate="telestatApp.division.title" uib-tooltip="{{\'telestatApp.division.help.title\' | translate}}">Title</span></dt>\n        <dd>\n            <span>{{vm.division.title}}</span>\n        </dd>\n        --><dt><span data-translate="telestatApp.division.name" uib-tooltip="{{\'telestatApp.division.help.name\' | translate}}">Name</span></dt><dd><span>{{vm.division.name}}</span></dd><dt><span data-translate="telestatApp.division.employees">Employees</span></dt><dd><span ng-repeat="employee in vm.employees"><a ui-sref="employee-detail({id: employee.id})" ng-class="{\'employee-manager\' : employee.managedDivisionsCount > 0,\n                               \'employee-director\' : employee.managedDivisionsCount > 2,\n                               \'inactive-entity\': !employee.actual}">{{employee.briefname}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt><span data-translate="telestatApp.division.actual" uib-tooltip="{{\'telestatApp.division.help.actual\' | translate}}">Actual</span></dt><dd><span data-translate="global.boolValueYesNo.{{vm.division.actual}}">{{vm.division.actual}}</span></dd><dt><span data-translate="telestatApp.division.externalId" uib-tooltip="{{\'telestatApp.division.help.externalId\' | translate}}">External Id</span></dt><dd><span>{{vm.division.externalId}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="division-detail.edit({id:vm.division.id})" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'division-detail.edit\')" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/division/division-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDivisionLabel" data-translate="telestatApp.division.home.createOrEditLabel">Create or edit a Division</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><!--\n        <div class="form-group" ng-show="vm.division.id">\n            <label for="id" data-translate="global.field.id">ID</label>\n            <input type="text" class="form-control" id="id" name="id"\n                    ng-model="vm.division.id" readonly />\n        </div>\n        --><div class="form-group"><label class="control-label" data-translate="telestatApp.division.title" for="field_title" uib-tooltip="{{\'telestatApp.division.help.title\' | translate}}">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.division.title" required ng-minlength="2" ng-maxlength="128"><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.title.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.title.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="128">This field cannot be longer than 128 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.division.name" for="field_name" uib-tooltip="{{\'telestatApp.division.help.name\' | translate}}">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.division.name" required ng-minlength="2" ng-maxlength="64"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.name.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.division.actual" for="field_actual" uib-tooltip="{{\'telestatApp.division.help.actual\' | translate}}">Actual</label><input type="checkbox" name="actual" id="field_actual" ng-model="vm.division.actual"><div ng-show="editForm.actual.$invalid"><p class="help-block" ng-show="editForm.actual.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.division.externalId" for="field_externalId" uib-tooltip="{{\'telestatApp.division.help.externalId\' | translate}}">External Id</label><input type="text" class="form-control" name="externalId" id="field_externalId" ng-model="vm.division.externalId" readonly="readonly" ng-minlength="0" ng-maxlength="16"><div ng-show="editForm.externalId.$invalid"><p class="help-block" ng-show="editForm.externalId.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.externalId.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="0">This field is required to be at least 0 characters.</p><p class="help-block" ng-show="editForm.externalId.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="16">This field cannot be longer than 16 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/division/divisions.html','<div><h2 data-translate="telestatApp.division.home.title">Divisions</h2><!--\n    <jhi-alert></jhi-alert>\n    --><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="division.new" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'division.new\')"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="telestatApp.division.home.createLabel">Create new Division</span></button></div><div class="col-xs-2"><label class="checkbox-inline"><input name="actualFilter" ng-model="vm.actualFilter" type="checkbox" ng-change="vm.search(vm.searchQuery)"> <span data-translate="global.actualFilter">Show actual</span></label></div><div class="col-xs-6 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'telestatApp.division.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><jhi-alert></jhi-alert><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="title"><span data-translate="telestatApp.division.title">Title</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="telestatApp.division.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="division in vm.divisions track by division.id" ng-class="{\'inactive-entity\': !division.actual}"><td><a ui-sref="division-detail({id:division.id})">{{division.title}}</a></td><td>{{division.name}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="division-detail({id:division.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="division.edit({id:division.id})" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'division.edit\')" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="division.delete({id:division.id})" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'division.delete\')" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/employee-phone/employee-phone-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.employeePhone.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="telestatApp.employeePhone.delete.question" translate-values="{id: \'{{vm.employeePhone.number | phone}} {{vm.employeePhone.employee.briefname}}\'}">Are you sure you want to delete this Employee Phone?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/employee-phone/employee-phone-detail.html','<div><h2><span data-translate="telestatApp.employeePhone.detail.title">Employee Phone</span>: {{vm.employeePhone.number | phone}} {{vm.employeePhone.employee.briefname}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="telestatApp.employeePhone.number" uib-tooltip="{{\'telestatApp.employeePhone.help.number\' | translate}}">Number</span></dt><dd><span>{{vm.employeePhone.number | phone}}</span></dd><dt><span data-translate="telestatApp.employeePhone.employee">Employee</span></dt><dd><a ui-sref="employee-detail({id:vm.employeePhone.employee.id})" ng-class="{\'employee-manager\' : vm.employeePhone.employee.managedDivisionsCount > 0,\n                            \'employee-director\' : vm.employeePhone.employee.managedDivisionsCount > 2,\n                            \'inactive-entity\': !vm.employeePhone.employee.actual}">{{vm.employeePhone.employee.fullname}}</a></dd><dt><span data-translate="telestatApp.employeePhone.advertisingSource">Info Source</span></dt><dd><a ui-sref="advertising-source-detail({id:vm.employeePhone.advertisingSource.id})" ng-class="{\'inactive-entity\': !vm.employeePhone.advertisingSource.actual}">{{vm.employeePhone.advertisingSource.name}}</a></dd><dt><span data-translate="telestatApp.employeePhone.phoneType">Phone Type</span></dt><dd><a ui-sref="phone-type-detail({id:vm.employeePhone.phoneType.id})" ng-class="{\'inactive-entity\': !vm.employeePhone.phoneType.actual}">{{vm.employeePhone.phoneType.name}}</a></dd><dt><span data-translate="telestatApp.employeePhone.bindingTime" uib-tooltip="{{\'telestatApp.employeePhone.help.bindingTime\' | translate}}">Binding Time</span></dt><dd><span>{{vm.employeePhone.bindingTime | date:\'medium\'}}</span></dd><dt><span data-translate="telestatApp.employeePhone.unbindingTime" uib-tooltip="{{\'telestatApp.employeePhone.help.unbindingTime\' | translate}}">Unbinding Time</span></dt><dd><span>{{vm.employeePhone.unbindingTime | date:\'medium\'}}</span></dd><dt><span data-translate="telestatApp.employeePhone.actual" uib-tooltip="{{\'telestatApp.employeePhone.help.actual\' | translate}}">Actual</span></dt><dd><span data-translate="global.boolValueYesNo.{{vm.employeePhone.actual}}">{{vm.employeePhone.actual}}</span></dd><dt><span data-translate="telestatApp.employeePhone.externalId" uib-tooltip="{{\'telestatApp.employeePhone.help.externalId\' | translate}}">External Id</span></dt><dd><span>{{vm.employeePhone.externalId}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="employee-phone-detail.edit({id:vm.employeePhone.id})" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'employee-phone-detail.edit\')" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/employee-phone/employee-phone-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myEmployeePhoneLabel" data-translate="telestatApp.employeePhone.home.createOrEditLabel">Create or edit a Employee Phone</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><!--\n        <div class="form-group" ng-show="vm.employeePhone.id">\n            <label for="id" data-translate="global.field.id">ID</label>\n            <input type="text" class="form-control" id="id" name="id"\n                    ng-model="vm.employeePhone.id" readonly />\n        </div>\n        --><div class="form-group"><label class="control-label" data-translate="telestatApp.employeePhone.number" for="field_number" uib-tooltip="{{\'telestatApp.employeePhone.help.number\' | translate}}">Number</label><input type="number" class="form-control" name="number" id="field_number" ng-model="vm.employeePhone.number" required min="70000000000" max="79999999999"><div ng-show="editForm.number.$invalid"><p class="help-block" ng-show="editForm.number.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.number.$error.min" data-translate="entity.validation.min" translate-value-min="70000000000">This field should be at least 70000000000.</p><p class="help-block" ng-show="editForm.number.$error.max" data-translate="entity.validation.max" translate-value-max="79999999999">This field cannot be more than 79999999999.</p><p class="help-block" ng-show="editForm.number.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label data-translate="telestatApp.employeePhone.employee" for="field_employee">Employee</label><select class="form-control not-actual-options" id="field_employee" name="employee" ng-model="vm.employeePhone.employee" ng-options="employee as employee.fullname disable when !employee.actual for employee in vm.employees track by employee.id" required></select></div><div ng-show="editForm.employee.$invalid"><p class="help-block" ng-show="editForm.employee.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="telestatApp.employeePhone.advertisingSource" for="field_advertisingSource">Info Source</label><select class="form-control not-actual-options" id="field_advertisingSource" name="advertisingSource" ng-model="vm.employeePhone.advertisingSource" ng-options="advertisingSource as advertisingSource.name disable when !advertisingSource.actual for advertisingSource in vm.advertisingsources track by advertisingSource.id"><option value=""></option></select></div><div class="form-group"><label data-translate="telestatApp.employeePhone.phoneType" for="field_phoneType">Phone Type</label><select class="form-control not-actual-options" id="field_phoneType" name="phoneType" ng-model="vm.employeePhone.phoneType" ng-options="phoneType as phoneType.name for phoneType in vm.phonetypes track by phoneType.id"><option value=""></option></select></div><div class="form-group"><label class="control-label" data-translate="telestatApp.employeePhone.bindingTime" for="field_bindingTime" uib-tooltip="{{\'telestatApp.employeePhone.help.bindingTime\' | translate}}">Binding Time</label><div class="input-group"><input id="field_bindingTime" type="text" class="form-control" name="bindingTime" datetime-picker="{{vm.dateformat}}" ng-model="vm.employeePhone.bindingTime" is-open="vm.datePickerOpenStatus.bindingTime" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'bindingTime\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.bindingTime.$invalid"><p class="help-block" ng-show="editForm.bindingTime.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.bindingTime.$error.ZonedDateTimelocal" data-translate="entity.validation.ZonedDateTimelocal">This field should be a date and time.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.employeePhone.unbindingTime" for="field_unbindingTime" uib-tooltip="{{\'telestatApp.employeePhone.help.unbindingTime\' | translate}}">Unbinding Time</label><div class="input-group"><input id="field_unbindingTime" type="text" class="form-control" name="unbindingTime" datetime-picker="{{dateformat}}" ng-model="vm.employeePhone.unbindingTime" is-open="vm.datePickerOpenStatus.unbindingTime"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'unbindingTime\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.employeePhone.actual" for="field_actual" uib-tooltip="{{\'telestatApp.employeePhone.help.actual\' | translate}}">Actual</label><input type="checkbox" name="actual" id="field_actual" readonly="readonly" ng-model="vm.employeePhone.actual"><div ng-show="editForm.actual.$invalid"><p class="help-block" ng-show="editForm.actual.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.employeePhone.externalId" for="field_externalId" uib-tooltip="{{\'telestatApp.employeePhone.help.externalId\' | translate}}">External Id</label><input type="text" class="form-control" name="externalId" id="field_externalId" ng-model="vm.employeePhone.externalId" readonly="readonly" ng-minlength="0" ng-maxlength="16"><div ng-show="editForm.externalId.$invalid"><p class="help-block" ng-show="editForm.externalId.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.externalId.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="0">This field is required to be at least 0 characters.</p><p class="help-block" ng-show="editForm.externalId.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="16">This field cannot be longer than 16 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/employee-phone/employee-phones.html','<div><h2 data-translate="telestatApp.employeePhone.home.title">Employee Phones</h2><!--\n    <jhi-alert></jhi-alert>\n    --><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="employee-phone.new" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'employee-phone.new\')"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="telestatApp.employeePhone.home.createLabel">Create new Employee Phone</span></button></div><div class="col-xs-2"><label class="checkbox-inline"><input name="actualFilter" ng-model="vm.actualFilter" type="checkbox" ng-change="vm.search(vm.searchQuery)"> <span data-translate="global.actualFilter">Show actual</span></label></div><div class="col-xs-4 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'telestatApp.employeePhone.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><jhi-alert></jhi-alert><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="number"><span data-translate="telestatApp.employeePhone.number">Number</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="employee.surname,employee.name,employee.patronymic"><span data-translate="telestatApp.employeePhone.employee">Employee</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="advertisingSource.caption"><span data-translate="telestatApp.employeePhone.advertisingSource">Info Source</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="phoneType.caption"><span data-translate="telestatApp.employeePhone.phoneType">Phone Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="bindingTime"><span data-translate="telestatApp.employeePhone.bindingTime">Binding Time</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="unbindingTime"><span data-translate="telestatApp.employeePhone.unbindingTime">Unbinding Time</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="employeePhone in vm.employeePhones track by employeePhone.id"><td><a ui-sref="employee-phone-detail({id:employeePhone.id})" ng-class="{\'inactive-entity\': !employeePhone.actual}">{{employeePhone.number | phone}}</a></td><td><a ui-sref="employee-detail({id:employeePhone.employee.id})" ng-class="{\'employee-manager\' : employeePhone.employee.managedDivisionsCount > 0,\n                                        \'employee-director\' : employeePhone.employee.managedDivisionsCount > 2,\n                                        \'inactive-entity\': !employeePhone.employee.actual}">{{employeePhone.employee.fullname}}</a></td><td><a ui-sref="advertising-source-detail({id:employeePhone.advertisingSource.id})" ng-class="{\'inactive-entity\': !employeePhone.advertisingSource.actual}">{{employeePhone.advertisingSource.caption}}</a></td><td><a ui-sref="phone-type-detail({id:employeePhone.phoneType.id})" ng-class="{\'inactive-entity\': !employeePhone.phoneType.actual}">{{employeePhone.phoneType.caption}}</a></td><td>{{employeePhone.bindingTime | date:\'short\'}}</td><td>{{employeePhone.unbindingTime | date:\'short\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="employee-phone-detail({id:employeePhone.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="employee-phone.edit({id:employeePhone.id})" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'employee-phone.edit\')" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="employee-phone.delete({id:employeePhone.id})" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'employee-phone.delete\')" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/employee/employee-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.employee.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="telestatApp.employee.delete.question" translate-values="{id: \'{{vm.employee.fullname}}\'}">Are you sure you want to delete this Employee?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/employee/employee-detail.html','<div><h2><span data-translate="telestatApp.employee.detail.title">Employee</span>: {{vm.employee.fullname}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="telestatApp.employee.surname" uib-tooltip="{{\'telestatApp.employee.help.surname\' | translate}}">Surname</span></dt><dd><span>{{vm.employee.surname}}</span></dd><dt><span data-translate="telestatApp.employee.name" uib-tooltip="{{\'telestatApp.employee.help.name\' | translate}}">Name</span></dt><dd><span>{{vm.employee.name}}</span></dd><dt><span data-translate="telestatApp.employee.patronymic" uib-tooltip="{{\'telestatApp.employee.help.patronymic\' | translate}}">Patronymic</span></dt><dd><span>{{vm.employee.patronymic}}</span></dd><dt><span data-translate="telestatApp.employee.fullname" uib-tooltip="{{\'telestatApp.employee.help.fullname\' | translate}}">Fullname</span></dt><dd><span>{{vm.employee.fullname}}</span></dd><dt><span data-translate="telestatApp.employee.briefname" uib-tooltip="{{\'telestatApp.employee.help.briefname\' | translate}}">Briefname</span></dt><dd><span>{{vm.employee.briefname}}</span></dd><dt><span data-translate="telestatApp.employee.birthday" uib-tooltip="{{\'telestatApp.employee.help.birthday\' | translate}}">Birthday</span></dt><dd><span>{{vm.employee.birthday | date:\'mediumDate\'}}</span></dd><dt><span data-translate="telestatApp.employee.phones">Phones</span></dt><dd><span ng-repeat="employeePhone in vm.employeePhones"><a ui-sref="employee-phone-detail({id: employeePhone.id})" ng-class="{\'inactive-entity\': !employeePhone.actual}">{{employeePhone.number | phone}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt><span data-translate="telestatApp.employee.division">Division</span></dt><dd><a ui-sref="division-detail({id:vm.employee.division.id})" ng-class="{\'inactive-entity\': !vm.employee.division.actual}">{{vm.employee.division.title}}</a></dd><dt><span data-translate="telestatApp.employee.manageableDivisionCaption">Manageable Division</span></dt><dd><span ng-repeat="manageableDivision in vm.employee.manageableDivisions"><a ui-sref="division-detail({id: manageableDivision.id})" ng-class="{\'inactive-entity\': !manageableDivision.actual}">{{manageableDivision.title}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt><span data-translate="telestatApp.employee.userAccount">User Account</span></dt><dd><a ui-sref="user-management-detail({login:vm.employee.userAccount.login})">{{vm.employee.userAccount.login}}</a></dd><dt><span data-translate="telestatApp.employee.actual" uib-tooltip="{{\'telestatApp.employee.help.actual\' | translate}}">Actual</span></dt><dd><span data-translate="global.boolValueYesNo.{{vm.employee.actual}}">{{vm.employee.actual}}</span></dd><dt><span data-translate="telestatApp.employee.externalId" uib-tooltip="{{\'telestatApp.employee.help.externalId\' | translate}}">External Id</span></dt><dd><span>{{vm.employee.externalId}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="employee-detail.edit({id:vm.employee.id})" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'employee-detail.edit\')" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/employee/employee-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myEmployeeLabel" data-translate="telestatApp.employee.home.createOrEditLabel">Create or edit a Employee</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><!--\n        <div class="form-group" ng-show="vm.employee.id">\n            <label for="id" data-translate="global.field.id">ID</label>\n            <input type="text" class="form-control" id="id" name="id"\n                    ng-model="vm.employee.id" readonly />\n        </div>\n        --><div class="form-group"><label class="control-label" data-translate="telestatApp.employee.surname" for="field_surname" uib-tooltip="{{\'telestatApp.employee.help.surname\' | translate}}">Surname</label><input type="text" class="form-control" name="surname" id="field_surname" ng-model="vm.employee.surname" ng-change="vm.calcProps()" capitalize-fully required ng-minlength="2" ng-maxlength="35"><div ng-show="editForm.surname.$invalid"><p class="help-block" ng-show="editForm.surname.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.surname.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.surname.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="35">This field cannot be longer than 35 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.employee.name" for="field_name" uib-tooltip="{{\'telestatApp.employee.help.name\' | translate}}">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.employee.name" ng-change="vm.calcProps()" capitalize-fully required ng-minlength="2" ng-maxlength="25"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.name.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="25">This field cannot be longer than 25 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.employee.patronymic" for="field_patronymic" uib-tooltip="{{\'telestatApp.employee.help.patronymic\' | translate}}">Patronymic</label><input type="text" class="form-control" name="patronymic" id="field_patronymic" ng-model="vm.employee.patronymic" ng-change="vm.calcProps()" capitalize-fully required ng-minlength="2" ng-maxlength="35"><div ng-show="editForm.patronymic.$invalid"><p class="help-block" ng-show="editForm.patronymic.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.patronymic.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.patronymic.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="35">This field cannot be longer than 35 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.employee.fullname" for="field_fullname" uib-tooltip="{{\'telestatApp.employee.help.fullname\' | translate}}">Fullname</label><input type="text" class="form-control" name="fullname" id="field_fullname" ng-model="vm.employee.fullname" readonly="readonly" required ng-minlength="8" ng-maxlength="95"><div ng-show="editForm.fullname.$invalid"><p class="help-block" ng-show="editForm.fullname.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.fullname.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="8">This field is required to be at least 8 characters.</p><p class="help-block" ng-show="editForm.fullname.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="95">This field cannot be longer than 95 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.employee.briefname" for="field_briefname" uib-tooltip="{{\'telestatApp.employee.help.briefname\' | translate}}">Briefname</label><input type="text" class="form-control" name="briefname" id="field_briefname" ng-model="vm.employee.briefname" readonly="readonly" required ng-minlength="8" ng-maxlength="41"><div ng-show="editForm.briefname.$invalid"><p class="help-block" ng-show="editForm.briefname.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.briefname.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="8">This field is required to be at least 8 characters.</p><p class="help-block" ng-show="editForm.briefname.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="41">This field cannot be longer than 41 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.employee.birthday" for="field_birthday" uib-tooltip="{{\'telestatApp.employee.help.birthday\' | translate}}">Birthday</label><div class="input-group"><input id="field_birthday" type="text" class="form-control" name="birthday" uib-datepicker-popup="{{vm.dateformat}}" ng-model="vm.employee.birthday" is-open="vm.datePickerOpenStatus.birthday"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'birthday\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label data-translate="telestatApp.employee.division" for="field_division">Division</label><select class="form-control not-actual-options" id="field_division" name="division" ng-model="vm.employee.division" ng-options="division as division.title disable when !division.actual for division in vm.divisions track by division.id" required></select></div><div ng-show="editForm.division.$invalid"><p class="help-block" ng-show="editForm.division.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="telestatApp.employee.manageableDivision" for="field_manageableDivision">Manageable Division</label><select class="form-control not-actual-options" id="field_manageableDivision" multiple="multiple" name="manageableDivision" ng-model="vm.employee.manageableDivisions" ng-options="division as division.title disable when !division.actual for division in vm.divisions track by division.id"></select></div><div class="form-group"><label data-translate="telestatApp.employee.userAccount" for="field_userAccount">User Account</label><select class="form-control" id="field_userAccount" name="userAccount" ng-model="vm.employee.userAccount" ng-options="user as user.login for user in vm.users track by user.id"><option value=""></option></select></div><div class="form-group"><label class="control-label" data-translate="telestatApp.employee.actual" for="field_actual" uib-tooltip="{{\'telestatApp.employee.help.actual\' | translate}}">Actual</label><input type="checkbox" name="actual" id="field_actual" ng-model="vm.employee.actual"><div ng-show="editForm.actual.$invalid"><p class="help-block" ng-show="editForm.actual.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.employee.externalId" for="field_externalId" uib-tooltip="{{\'telestatApp.employee.help.externalId\' | translate}}">External Id</label><input type="text" class="form-control" name="externalId" id="field_externalId" ng-model="vm.employee.externalId" readonly="readonly" ng-minlength="0" ng-maxlength="16"><div ng-show="editForm.externalId.$invalid"><p class="help-block" ng-show="editForm.externalId.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.externalId.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="0">This field is required to be at least 0 characters.</p><p class="help-block" ng-show="editForm.externalId.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="16">This field cannot be longer than 16 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/employee/employees.html','<div><h2 data-translate="telestatApp.employee.home.title">Employees</h2><!--\n    <jhi-alert></jhi-alert>\n    --><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="employee.new" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'employee.new\')"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="telestatApp.employee.home.createLabel">Create new Employee</span></button></div><div class="col-xs-2"><label class="checkbox-inline"><input name="actualFilter" ng-model="vm.actualFilter" type="checkbox" ng-change="vm.search(vm.searchQuery)"> <span data-translate="global.actualFilter">Show actual</span></label></div><div class="col-xs-6 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'telestatApp.employee.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><jhi-alert></jhi-alert><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="surname,name,patronymic"><span data-translate="telestatApp.employee.fullname">Fullname</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="division.title"><span data-translate="telestatApp.employee.division">Division</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="birthday"><span data-translate="telestatApp.employee.birthday">Birthday</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="userAccount.login"><span data-translate="telestatApp.employee.userAccount">User Account</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="employee in vm.employees track by employee.id" ng-class="{\'inactive-entity\': !employee.actual}"><td><a ui-sref="employee-detail({id:employee.id})" ng-class="{\'employee-manager\' : employee.managedDivisionsCount > 0,\n                                         \'employee-director\' : employee.managedDivisionsCount > 2}">{{employee.fullname}}</a></td><td><a ui-sref="division-detail({id:employee.division.id})" ng-class="{\'inactive-entity\': !employee.division.actual}">{{employee.division.title}}</a></td><td>{{employee.birthday | date:\'mediumDate\'}}</td><td><a ui-sref="user-management-detail({login:employee.userAccount.login})">{{employee.userAccount.login}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="employee-detail({id:employee.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span><!--\n                                <span class="hidden-sm-down" data-translate="entity.action.view"></span>\n                                --></button> <button type="submit" ui-sref="employee.edit({id:employee.id})" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'employee.edit\')" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span><!--\n                                <span class="hidden-sm-down" data-translate="entity.action.edit"></span>\n                                --></button> <button type="submit" ui-sref="employee.delete({id:employee.id})" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'employee.delete\')" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span><!--\n                                <span class="hidden-sm-down" data-translate="entity.action.delete"></span>\n                                --></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/external-resource/external-resource-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.externalResource.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="telestatApp.externalResource.delete.question" translate-values="{id: \'{{vm.externalResource.id}}\'}">Are you sure you want to delete this External Resource?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/external-resource/external-resource-detail.html','<div><h2><span data-translate="telestatApp.externalResource.detail.title">External Resource</span> {{vm.externalResource.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="telestatApp.externalResource.name" uib-tooltip="{{\'telestatApp.externalResource.help.name\' | translate}}">Name</span></dt><dd><span>{{vm.externalResource.name}}</span></dd><dt><span data-translate="telestatApp.externalResource.externalUrl" uib-tooltip="{{\'telestatApp.externalResource.help.externalUrl\' | translate}}">External Url</span></dt><dd><span>{{vm.externalResource.externalUrl}}</span></dd><!--\n        <dt><span data-translate="telestatApp.externalResource.loadingType" uib-tooltip="{{\'telestatApp.externalResource.help.loadingType\' | translate}}">Loading Type</span></dt>\n        <dd>\n            <span>{{vm.externalResource.loadingType}}</span>\n        </dd>\n        <dt><span data-translate="telestatApp.externalResource.period" uib-tooltip="{{\'telestatApp.externalResource.help.period\' | translate}}">Period</span></dt>\n        --><dt ng-if="vm.externalResource.loadingType == 0"><span data-translate="telestatApp.externalResource.period" uib-tooltip="{{\'telestatApp.externalResource.help.period\' | translate}}">Period</span></dt><dd ng-if="vm.externalResource.loadingType == 0"><span>{{vm.externalResource.period}}</span></dd><!--\n        <dt><span data-translate="telestatApp.externalResource.loadTime" uib-tooltip="{{\'telestatApp.externalResource.help.loadTime\' | translate}}">Load Time</span></dt>\n        --><dt ng-if="vm.externalResource.loadingType == 1"><span data-translate="telestatApp.externalResource.loadTime" uib-tooltip="{{\'telestatApp.externalResource.help.loadTime\' | translate}}">Load Time</span></dt><dd ng-if="vm.externalResource.loadingType == 1"><!--\n            <span>{{vm.externalResource.loadTime | date:\'medium\'}}</span>\n            --> <span>{{vm.externalResource.loadTime | date:\'shortTime\'}}</span></dd><dt><span data-translate="telestatApp.externalResource.lastDownload" uib-tooltip="{{\'telestatApp.externalResource.help.lastDownload\' | translate}}">Last Download</span></dt><dd><span>{{vm.externalResource.lastDownload | date:\'medium\'}}</span></dd><dt><span data-translate="telestatApp.externalResource.lastSuccessProcessing" uib-tooltip="{{\'telestatApp.externalResource.help.lastSuccessProcessing\' | translate}}">Last Success Processing</span></dt><dd><span>{{vm.externalResource.lastSuccessProcessing | date:\'medium\'}}</span></dd><dt><span data-translate="telestatApp.externalResource.lastModified" uib-tooltip="{{\'telestatApp.externalResource.help.lastModified\' | translate}}">Last Modified</span></dt><dd><span>{{vm.externalResource.lastModified}}</span></dd><dt><span data-translate="telestatApp.externalResource.uploadFolder" uib-tooltip="{{\'telestatApp.externalResource.help.uploadFolder\' | translate}}">Upload Folder</span></dt><dd><span>{{vm.externalResource.uploadFolder}}</span></dd><dt><span data-translate="telestatApp.externalResource.actual" uib-tooltip="{{\'telestatApp.externalResource.help.actual\' | translate}}">Actual</span></dt><dd><!--\n            <span>{{vm.externalResource.actual}}</span>\n            --> <span data-translate="global.boolValueYesNo.{{vm.externalResource.actual}}">{{vm.externalResource.actual}}</span></dd><!--\n        <dt><span data-translate="telestatApp.externalResource.healthIndicator" uib-tooltip="{{\'telestatApp.externalResource.help.healthIndicator\' | translate}}">Health Indicator</span></dt>\n        <dd>\n            <span>{{vm.externalResource.healthIndicator}}</span>\n        </dd>\n        --><dt><span data-translate="telestatApp.externalResource.description" uib-tooltip="{{\'telestatApp.externalResource.help.description\' | translate}}">Description</span></dt><dd><span>{{vm.externalResource.description}}</span></dd><dt><span data-translate="telestatApp.externalResource.charset" uib-tooltip="{{\'telestatApp.externalResource.help.charset\' | translate}}">Charset</span></dt><dd><span>{{vm.externalResource.charset}}</span></dd><dt><span data-translate="telestatApp.externalResource.advertisingSource">Advertising Source</span></dt><dd><a ui-sref="advertising-source-detail({id:vm.externalResource.advertisingSource.id})">{{vm.externalResource.advertisingSource.name}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="external-resource-detail.edit({id:vm.externalResource.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/external-resource/external-resource-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myExternalResourceLabel" data-translate="telestatApp.externalResource.home.createOrEditLabel">Create or edit a External Resource</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.externalResource.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.externalResource.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="telestatApp.externalResource.name" for="field_name" uib-tooltip="{{\'telestatApp.externalResource.help.name\' | translate}}">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.externalResource.name" required ng-minlength="2" ng-maxlength="32"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.name.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="32">This field cannot be longer than 32 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.externalResource.externalUrl" for="field_externalUrl" uib-tooltip="{{\'telestatApp.externalResource.help.externalUrl\' | translate}}">External Url</label><input type="text" class="form-control" name="externalUrl" id="field_externalUrl" ng-model="vm.externalResource.externalUrl" required ng-minlength="7" ng-maxlength="1024"><div ng-show="editForm.externalUrl.$invalid"><p class="help-block" ng-show="editForm.externalUrl.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.externalUrl.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="7">This field is required to be at least 7 characters.</p><p class="help-block" ng-show="editForm.externalUrl.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="1024">This field cannot be longer than 1024 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.externalResource.loadingType" for="field_loadingType" uib-tooltip="{{\'telestatApp.externalResource.help.loadingType\' | translate}}">Loading Type</label><!--\n            <input type="number" class="form-control" name="loadingType" id="field_loadingType"\n                    ng-model="vm.externalResource.loadingType"\n                    />\n            --><select class="form-control" name="loadingType" id="field_loadingType" ng-model="vm.externalResource.loadingType" required ng-change="vm.updateLoadingType()"><option value="0" ng-selected="vm.externalResource.loadingType == 0" data-translate="telestatApp.externalResource.period">Period</option><option value="1" ng-selected="vm.externalResource.loadingType == 1" data-translate="telestatApp.externalResource.loadTime">Load time</option></select><div ng-show="editForm.loadingType.$invalid"><p class="help-block" ng-show="editForm.loadingType.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.loadingType.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><!--\n        <div class="form-group">\n        --><div class="form-group" ng-hide="vm.externalResource.loadingType != \'0\'"><label class="control-label" data-translate="telestatApp.externalResource.period" for="field_period" uib-tooltip="{{\'telestatApp.externalResource.help.period\' | translate}}">Period</label><input type="number" class="form-control" name="period" id="field_period" ng-model="vm.externalResource.period"><div ng-show="editForm.period.$invalid"><p class="help-block" ng-show="editForm.period.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.period.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><!--\n        <div class="form-group">\n        --><div class="form-group" ng-hide="vm.externalResource.loadingType != \'1\'"><label class="control-label" data-translate="telestatApp.externalResource.loadTime" for="field_loadTime" uib-tooltip="{{\'telestatApp.externalResource.help.loadTime\' | translate}}">Load Time</label><div class="input-group"><!--\n                    <input id="field_loadTime" type="text" class="form-control" name="loadTime" datetime-picker="{{dateformat}}" ng-model="vm.externalResource.loadTime" is-open="vm.datePickerOpenStatus.loadTime"\n                    --> <input id="field_loadTime" type="text" class="form-control" name="loadTime" datetime-picker="shortTime" datepicker-options="vm.datePickerOptions" ng-model="vm.externalResource.loadTime" is-open="vm.datePickerOpenStatus.loadTime"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'loadTime\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.externalResource.lastDownload" for="field_lastDownload" uib-tooltip="{{\'telestatApp.externalResource.help.lastDownload\' | translate}}">Last Download</label><div class="input-group"><input id="field_lastDownload" type="text" class="form-control" name="lastDownload" datetime-picker="{{dateformat}}" ng-model="vm.externalResource.lastDownload" is-open="vm.datePickerOpenStatus.lastDownload"> <span class="input-group-btn"><!--\n                        <button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'lastDownload\')"><i class="glyphicon glyphicon-calendar"></i></button>\n                        --> <button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'lastDownload\')" disabled="disabled"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.externalResource.lastSuccessProcessing" for="field_lastSuccessProcessing" uib-tooltip="{{\'telestatApp.externalResource.help.lastSuccessProcessing\' | translate}}">Last Success Processing</label><div class="input-group"><input id="field_lastSuccessProcessing" type="text" class="form-control" name="lastSuccessProcessing" datetime-picker="{{dateformat}}" ng-model="vm.externalResource.lastSuccessProcessing" is-open="vm.datePickerOpenStatus.lastSuccessProcessing" readonly="readonly"> <span class="input-group-btn"><!--\n                        <button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'lastSuccessProcessing\')"><i class="glyphicon glyphicon-calendar"></i></button>\n                        --> <button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'lastSuccessProcessing\')" disabled="disabled"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><!--\n        <div class="form-group">\n            <label class="control-label" data-translate="telestatApp.externalResource.lastModified" for="field_lastModified" uib-tooltip="{{\'telestatApp.externalResource.help.lastModified\' | translate}}">Last Modified</label>\n            <input type="text" class="form-control" name="lastModified" id="field_lastModified"\n                    ng-model="vm.externalResource.lastModified"\n                    ng-maxlength="32"/>\n            <div ng-show="editForm.lastModified.$invalid">\n                <p class="help-block"\n                    ng-show="editForm.lastModified.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="32">\n                    This field cannot be longer than 32 characters.\n                </p>\n            </div>\n        </div>\n        --><div class="form-group"><label class="control-label" data-translate="telestatApp.externalResource.uploadFolder" for="field_uploadFolder" uib-tooltip="{{\'telestatApp.externalResource.help.uploadFolder\' | translate}}">Upload Folder</label><input type="text" class="form-control" name="uploadFolder" id="field_uploadFolder" ng-model="vm.externalResource.uploadFolder" required ng-minlength="1" ng-maxlength="256"><div ng-show="editForm.uploadFolder.$invalid"><p class="help-block" ng-show="editForm.uploadFolder.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.uploadFolder.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.uploadFolder.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="256">This field cannot be longer than 256 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.externalResource.actual" for="field_actual" uib-tooltip="{{\'telestatApp.externalResource.help.actual\' | translate}}">Actual</label><input type="checkbox" name="actual" id="field_actual" ng-model="vm.externalResource.actual"><div ng-show="editForm.actual.$invalid"><p class="help-block" ng-show="editForm.actual.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><!--\n        <div class="form-group">\n            <label class="control-label" data-translate="telestatApp.externalResource.healthIndicator" for="field_healthIndicator" uib-tooltip="{{\'telestatApp.externalResource.help.healthIndicator\' | translate}}">Health Indicator</label>\n                <input type="checkbox" name="healthIndicator" id="field_healthIndicator"\n                          ng-model="vm.externalResource.healthIndicator"/>\n        </div>\n        --><div class="form-group"><label class="control-label" data-translate="telestatApp.externalResource.description" for="field_description" uib-tooltip="{{\'telestatApp.externalResource.help.description\' | translate}}">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.externalResource.description" ng-maxlength="256"><div ng-show="editForm.description.$invalid"><p class="help-block" ng-show="editForm.description.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="256">This field cannot be longer than 256 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.externalResource.charset" for="field_charset" uib-tooltip="{{\'telestatApp.externalResource.help.charset\' | translate}}">Charset</label><!--\n            <input type="text" class="form-control" name="charset" id="field_charset"\n                    ng-model="vm.externalResource.charset"\n                    required ng-minlength="1" ng-maxlength="16"/>\n            --><select class="form-control" name="charset" id="field_charset" ng-model="vm.externalResource.charset" required ng-options="charset for charset in vm.charsets track by charset"></select><div ng-show="editForm.charset.$invalid"><p class="help-block" ng-show="editForm.charset.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.charset.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.charset.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="16">This field cannot be longer than 16 characters.</p></div></div><div class="form-group"><label data-translate="telestatApp.externalResource.advertisingSource" for="field_advertisingSource">Advertising Source</label><select class="form-control" id="field_advertisingSource" name="advertisingSource" ng-model="vm.externalResource.advertisingSource" ng-options="advertisingSource as advertisingSource.name for advertisingSource in vm.advertisingsources track by advertisingSource.id" required></select></div><div ng-show="editForm.advertisingSource.$invalid"><p class="help-block" ng-show="editForm.advertisingSource.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/external-resource/external-resource-run-dialog.html','<form name="runForm" ng-submit="vm.confirmRun(vm.externalResource.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="telestatApp.externalResource.run.title">Confirm run operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="telestatApp.externalResource.run.question" translate-values="{param: \'{{vm.externalResource.name}}\'}">Are you sure you want to run this External Resource?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="runForm.$invalid" class="btn btn-success"><span class="glyphicon glyphicon-run-circle"></span>&nbsp;<span data-translate="telestatApp.externalResource.run.action">Run</span></button></div></form>');
$templateCache.put('app/entities/external-resource/external-resources.html','<div><h2 data-translate="telestatApp.externalResource.home.title">External Resources</h2><!--\n    <jhi-alert></jhi-alert>\n    --><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><!--\n                <button class="btn btn-primary" ui-sref="external-resource.new" >\n                --> <button class="btn btn-primary" ui-sref="external-resource.new" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'external-resource.new\')"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="telestatApp.externalResource.home.createLabel">Create new External Resource</span></button></div><div class="col-xs-2 no-padding-left"><button type="button" class="btn btn-primary" ng-click="vm.loadAll()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="entity.action.refresh">Refresh</span></button></div><!--\n            <div class="col-xs-8 no-padding-right">\n            --><div class="col-xs-6 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'telestatApp.externalResource.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><jhi-alert></jhi-alert><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th></th><!--\n                    <th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th>\n                    --><th jh-sort-by="name"><span data-translate="telestatApp.externalResource.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><!--\n                    <th jh-sort-by="externalUrl"><span data-translate="telestatApp.externalResource.externalUrl">External Url</span> <span class="glyphicon glyphicon-sort"></span></th>\n                    <th jh-sort-by="loadingType"><span data-translate="telestatApp.externalResource.loadingType">Loading Type</span> <span class="glyphicon glyphicon-sort"></span></th>\n                    <th jh-sort-by="period"><span data-translate="telestatApp.externalResource.period">Period</span> <span class="glyphicon glyphicon-sort"></span></th>\n                    <th jh-sort-by="loadTime"><span data-translate="telestatApp.externalResource.loadTime">Load Time</span> <span class="glyphicon glyphicon-sort"></span></th>\n                    --><th jh-sort-by="lastDownload"><span data-translate="telestatApp.externalResource.lastDownload">Last Download</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastSuccessProcessing"><span data-translate="telestatApp.externalResource.lastSuccessProcessing">Last Success Processing</span> <span class="glyphicon glyphicon-sort"></span></th><!--\n                    <th jh-sort-by="lastModified"><span data-translate="telestatApp.externalResource.lastModified">Last Modified</span> <span class="glyphicon glyphicon-sort"></span></th>\n                    <th jh-sort-by="uploadFolder"><span data-translate="telestatApp.externalResource.uploadFolder">Upload Folder</span> <span class="glyphicon glyphicon-sort"></span></th>\n                    <th jh-sort-by="actual"><span data-translate="telestatApp.externalResource.actual">Actual</span> <span class="glyphicon glyphicon-sort"></span></th>\n                    <th jh-sort-by="healthIndicator"><span data-translate="telestatApp.externalResource.healthIndicator">Health Indicator</span> <span class="glyphicon glyphicon-sort"></span></th>\n                    --><th jh-sort-by="description"><span data-translate="telestatApp.externalResource.description">Description</span> <span class="glyphicon glyphicon-sort"></span></th><!--\n                    <th jh-sort-by="charset"><span data-translate="telestatApp.externalResource.charset">Charset</span> <span class="glyphicon glyphicon-sort"></span></th>\n                    --><th jh-sort-by="advertisingSource.name"><span data-translate="telestatApp.externalResource.advertisingSource">Info Source</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="externalResource in vm.externalResources track by externalResource.id"><td><button class="btn btn-success btn-circle" ng-if="externalResource.healthIndicator"><i class="glyphicon glyphicon-ok"></i></button> <button class="btn btn-danger btn-circle" ng-if="!externalResource.healthIndicator"><i class="glyphicon glyphicon-remove"></i></button></td><!--\n                    <td><a ui-sref="external-resource-detail({id:externalResource.id})">{{externalResource.id}}</a></td>\n                    <td>{{externalResource.name}}</td>\n                    --><td><a ui-sref="external-resource-detail({id:externalResource.id})" ng-class="{\'inactive-entity\': !externalResource.actual}">{{externalResource.name}}</a></td><!--\n                    <td>{{externalResource.externalUrl}}</td>\n                    <td>{{externalResource.loadingType}}</td>\n                    <td>{{externalResource.period}}</td>\n                    <td>{{externalResource.loadTime | date:\'medium\'}}</td>\n                    --><td>{{externalResource.lastDownload | date:\'medium\'}}</td><td>{{externalResource.lastSuccessProcessing | date:\'medium\'}}</td><!--\n                    <td>{{externalResource.lastModified}}</td>\n                    <td>{{externalResource.uploadFolder}}</td>\n                    <td>{{externalResource.actual}}</td>\n                    <td>{{externalResource.healthIndicator}}</td>\n                    --><td>{{externalResource.description}}</td><!--\n                    <td>{{externalResource.charset}}</td>\n                    --><td><a ui-sref="advertising-source-detail({id:externalResource.advertisingSource.id})">{{externalResource.advertisingSource.name}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="external-resource-detail({id:externalResource.id})" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'external-resource-detail\')" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="external-resource.run({id:externalResource.id})" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'external-resource.run\')" class="btn btn-success btn-sm"><span class="glyphicon glyphicon-play"></span> <span class="hidden-sm-down" data-translate="telestatApp.externalResource.run.action"></span></button> <button type="submit" ui-sref="external-resource.edit({id:externalResource.id})" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'external-resource.edit\')" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="external-resource.delete({id:externalResource.id})" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'external-resource.delete\')" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/megafon-free-numbers/megafon-free-numbers.html','<div><h2 data-translate="telestatApp.megafonFreeNumbers.home.title">Megafon Free Numbers</h2><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ng-click="vm.loadAll()"><span class="glyphicon glyphicon-refresh"></span> <span class="hidden-xs-down" data-translate="telestatApp.megafonFreeNumbers.home.update">Refresh</span></button> <a target="_blank" class="btn btn-primary" ng-href="/api/pbx/megafon/getfree-csv" title="{{ \'global.export.XLS\' | translate}}" download="megafon-free-numbers.csv"><span class="glyphicon glyphicon-download-alt"></span></a></div><div class="col-xs-2"></div><div class="col-xs-6 no-padding-right"></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="telestatApp.megafonFreeNumbers.number">Number</span></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="a in vm.numbers"><td>{{a.number}}</td><td>{{a.msg}}</td><td><jhi-alert ng-show="a.error == 1"></jhi-alert></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'megafon-free-numbers.lock\') || a.locked" ng-click="vm.lock(a)" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-cloud-upload"></span> <span class="hidden-sm-down" data-translate="telestatApp.megafonFreeNumbers.lock"></span></button> <button type="submit" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'megafon-free-numbers.sim\') || a.locked" ng-click="vm.lockVirtual(a)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-phone"></span> <span class="hidden-sm-down" data-translate="telestatApp.megafonFreeNumbers.lockVirtual"></span></button> <button type="submit" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'megafon-free-numbers.sim\') || a.locked" ng-click="vm.sim(a)" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-phone"></span> <span class="hidden-sm-down" data-translate="telestatApp.megafonFreeNumbers.sim"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/megafon-internal-phones/megafon-internal-phones.html','<div><h2 data-translate="telestatApp.megafonInternalPhones.home.title">Megafon Internal Phones</h2><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ng-click="vm.loadAll()"><span class="glyphicon glyphicon-refresh"></span> <span class="hidden-xs-down" data-translate="telestatApp.megafonInternalPhones.home.update">Refresh</span></button> <a target="_blank" class="btn btn-primary" ng-href="/api/megafon-internal-phones-csv" title="{{ \'global.export.XLS\' | translate}}" download="megafon-internal-phones.csv"><span class="glyphicon glyphicon-download-alt"></span></a></div><div class="col-xs-2"></div><div class="col-xs-6 no-padding-right"></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="telestatApp.megafonInternalPhones.fio">Employee</span></th><th><span data-translate="telestatApp.megafonInternalPhones.number">Number</span></th></tr></thead><tbody><tr ng-repeat="a in vm.accounts"><td>{{a.account.n}}</td><td><span>{{intnums=a.account.ext; intnums.join(", ")}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/office-phone/office-phone-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.officePhone.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="telestatApp.officePhone.delete.question" translate-values="{id: \'{{vm.officePhone.title}}\'}">Are you sure you want to delete this Office Phone?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/office-phone/office-phone-detail.html','<div><h2><span data-translate="telestatApp.officePhone.detail.title">Office Phone</span>: {{vm.officePhone.title}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><!--\n        <dt><span data-translate="telestatApp.officePhone.title" uib-tooltip="{{\'telestatApp.officePhone.help.title\' | translate}}">Title</span></dt>\n        <dd>\n            <span>{{vm.officePhone.title}}</span>\n        </dd>\n        --><dt><span data-translate="telestatApp.officePhone.name" uib-tooltip="{{\'telestatApp.officePhone.help.name\' | translate}}">Name</span></dt><dd><span>{{vm.officePhone.name}}</span></dd><dt><span data-translate="telestatApp.officePhone.caption" uib-tooltip="{{\'telestatApp.officePhone.help.caption\' | translate}}">Caption</span></dt><dd><span>{{vm.officePhone.caption}}</span></dd><dt><span data-translate="telestatApp.officePhone.number" uib-tooltip="{{\'telestatApp.officePhone.help.number\' | translate}}">Number</span></dt><dd><span>{{vm.officePhone.number | phone}}</span></dd><dt><span data-translate="telestatApp.officePhone.short_number" uib-tooltip="{{\'telestatApp.officePhone.help.short_number\' | translate}}">Short Number</span></dt><dd><span>{{vm.officePhone.short_number}}</span></dd><dt><span data-translate="telestatApp.officePhone.actual" uib-tooltip="{{\'telestatApp.officePhone.help.actual\' | translate}}">Actual</span></dt><dd><span data-translate="global.boolValueYesNo.{{vm.officePhone.actual}}">{{vm.officePhone.actual}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="office-phone-detail.edit({id:vm.officePhone.id})" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'office-phone-detail.edit\')" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/office-phone/office-phone-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myOfficePhoneLabel" data-translate="telestatApp.officePhone.home.createOrEditLabel">Create or edit a Office Phone</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><!--\n        <div class="form-group" ng-show="vm.officePhone.id">\n            <label for="id" data-translate="global.field.id">ID</label>\n            <input type="text" class="form-control" id="id" name="id"\n                    ng-model="vm.officePhone.id" readonly />\n        </div>\n        --><div class="form-group"><label class="control-label" data-translate="telestatApp.officePhone.title" for="field_title" uib-tooltip="{{\'telestatApp.officePhone.help.title\' | translate}}">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.officePhone.title" readonly="readonly" required ng-minlength="5" ng-maxlength="51"><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.title.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="5">This field is required to be at least 5 characters.</p><p class="help-block" ng-show="editForm.title.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="51">This field cannot be longer than 51 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.officePhone.name" for="field_name" uib-tooltip="{{\'telestatApp.officePhone.help.name\' | translate}}">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.officePhone.name" capitalize-first required ng-minlength="2" ng-maxlength="32"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.name.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="32">This field cannot be longer than 32 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.officePhone.caption" for="field_caption" uib-tooltip="{{\'telestatApp.officePhone.help.caption\' | translate}}">Caption</label><input type="text" class="form-control" name="caption" id="field_caption" ng-model="vm.officePhone.caption" ng-change="vm.calcProps()" capitalize-first required ng-minlength="3" ng-maxlength="16"><div ng-show="editForm.caption.$invalid"><p class="help-block" ng-show="editForm.caption.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.caption.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="3">This field is required to be at least 3 characters.</p><p class="help-block" ng-show="editForm.caption.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="16">This field cannot be longer than 16 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.officePhone.number" for="field_number" uib-tooltip="{{\'telestatApp.officePhone.help.number\' | translate}}">Number</label><input type="number" class="form-control" name="number" id="field_number" ng-model="vm.officePhone.number" ng-change="vm.calcProps()" required min="70000000000" max="79999999999"><div ng-show="editForm.number.$invalid"><p class="help-block" ng-show="editForm.number.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.number.$error.min" data-translate="entity.validation.min" translate-value-min="70000000000">This field should be at least 70000000000.</p><p class="help-block" ng-show="editForm.number.$error.max" data-translate="entity.validation.max" translate-value-max="79999999999">This field cannot be more than 79999999999.</p><p class="help-block" ng-show="editForm.number.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.officePhone.short_number" for="field_short_number">Short Number</label><input type="text" class="form-control" name="short_number" id="field_short_number" ng-minlength="1" ng-maxlength="4" ng-model="vm.officePhone.short_number"><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.title.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="4">This field cannot be longer than 4 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.officePhone.actual" for="field_actual" uib-tooltip="{{\'telestatApp.officePhone.help.actual\' | translate}}">Actual</label><input type="checkbox" name="actual" id="field_actual" ng-model="vm.officePhone.actual"><div ng-show="editForm.actual.$invalid"><p class="help-block" ng-show="editForm.actual.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/office-phone/office-phones.html','<div><h2 data-translate="telestatApp.officePhone.home.title">Office Phones</h2><!--\n    <jhi-alert></jhi-alert>\n    --><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="office-phone.new" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'office-phone.new\')"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="telestatApp.officePhone.home.createLabel">Create new Office Phone</span></button></div><div class="col-xs-2"><label class="checkbox-inline"><input name="actualFilter" ng-model="vm.actualFilter" type="checkbox" ng-change="vm.search(vm.searchQuery)"> <span data-translate="global.actualFilter">Show actual</span></label></div><div class="col-xs-6 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'telestatApp.officePhone.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><jhi-alert></jhi-alert><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="number"><span data-translate="telestatApp.officePhone.number">Number</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="short_number"><span data-translate="telestatApp.officePhone.short_number">Short Number</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="telestatApp.officePhone.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="caption"><span data-translate="telestatApp.officePhone.caption">Caption</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="officePhone in vm.officePhones track by officePhone.id" ng-class="{\'inactive-entity\': !officePhone.actual}"><td><a ui-sref="office-phone-detail({id:officePhone.id})">{{officePhone.number | phone}}</a></td><td>{{officePhone.short_number}}</td><td>{{officePhone.name}}</td><td>{{officePhone.caption}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="office-phone-detail({id:officePhone.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="office-phone.edit({id:officePhone.id})" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'office-phone.edit\')" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="office-phone.delete({id:officePhone.id})" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'office-phone.delete\')" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/phone-call/phone-call-check-ext-detail.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4><span data-translate="telestatApp.phoneCallCheck.detail.title">Phone Call Check</span>: {{vm.phoneCallCheck.phoneCall.title}}</h4></div><div class="modal-body modal-body_ext"><dl class="dl-horizontal jh-entity-details jh-entity-details_ext"><dt><span data-translate="telestatApp.phoneCallCheck.phoneCallResult">Phone Call Result</span></dt><dd>{{vm.phoneCallCheck.phoneCallResult.name}}</dd><dt><span data-translate="telestatApp.phoneCallCheck.phoneCallPurpose">Phone Call Purpose</span></dt><dd><span ng-repeat="phoneCallPurpose in vm.phoneCallCheck.phoneCallPurposes">{{phoneCallPurpose.name + \' [\' + phoneCallPurpose.worth + \']\'}} {{$last ? \'\' : \', \'}}</span></dd><dt><span data-translate="telestatApp.phoneCallCheck.assessment">Assessment</span></dt><dd><span>{{vm.phoneCallCheck.assessment}}</span></dd><!-- Begin Checker --><dt><span data-translate="telestatApp.phoneCallCheck.checkerCaption">Checker Caption</span></dt><dd ng-if="vm.phoneCallCheck.checker != null"><span>{{vm.phoneCallCheck.checker.fullname}}</span></dd><dd ng-if="vm.phoneCallCheck.checker == null"><span>{{vm.phoneCallCheck.checkerCaption}}</span></dd><!-- End Checker --><dt><span data-translate="telestatApp.phoneCallCheck.checkTime">Check Time</span></dt><dd><span>{{vm.phoneCallCheck.checkTime | date:\'medium\'}}</span></dd></dl></div><div class="modal-footer modal-footer_ext"><button type="submit" ng-click="vm.clear()" class="btn btn-info pull-left"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/entities/phone-call/phone-call-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.phoneCall.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="telestatApp.phoneCall.delete.question" translate-values="{id: \'{{vm.phoneCall.title}}\'}">Are you sure you want to delete this Phone Call?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/phone-call/phone-call-detail.html','<div><h2><span data-translate="telestatApp.phoneCall.detail.title">Phone Call</span>: {{vm.phoneCall.title}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><!--\n        <dt><span data-translate="telestatApp.phoneCall.title">Title</span></dt>\n        <dd>\n            <span>{{vm.phoneCall.title}}</span>\n        </dd>\n        --><dt><span data-translate="telestatApp.phoneCall.cloudPBX">Cloud PBX</span></dt><dd><a ui-sref="cloud-pbx-detail({id:vm.phoneCall.cloudPBX.id})">{{vm.phoneCall.cloudPBX.name}}</a></dd><!--\n        <dt><span data-translate="telestatApp.phoneCall.callId" uib-tooltip="{{\'telestatApp.phoneCall.help.callId\' | translate}}">Call Id</span></dt>\n        <dd>\n            <span>{{vm.phoneCall.callId}}</span>\n        </dd>\n        --><dt><span data-translate="telestatApp.phoneCall.callTime" uib-tooltip="{{\'telestatApp.phoneCall.help.callTime\' | translate}}">Call Time</span></dt><dd><span>{{vm.phoneCall.callTime | date:\'medium\'}}</span><!-- TODO \u0411\u0435\u0437 \u0441\u043E\u043A\u0440\u0430\u0449\u0435\u043D\u0438\u0439 \u043A\u0430\u043A \u0432\u044B\u0432\u0435\u0441\u0442\u0438??? --></dd><!--\n        <dt><span data-translate="telestatApp.phoneCall.callingNumber" uib-tooltip="{{\'telestatApp.phoneCall.help.callingNumber\' | translate}}">Calling Number</span></dt>\n        <dd>\n            <span>{{vm.phoneCall.callingNumber}}</span>\n        </dd>\n        --><!--\n        <dt><span data-translate="telestatApp.phoneCall.user" uib-tooltip="{{\'telestatApp.phoneCall.help.user\' | translate}}">User</span></dt>\n        <dd>\n            <span>{{vm.phoneCall.user}}</span>\n        </dd>\n        --><!--\n        <dt><span data-translate="telestatApp.phoneCall.calledNumber" uib-tooltip="{{\'telestatApp.phoneCall.help.calledNumber\' | translate}}">Called Number</span></dt>\n        <dd>\n            <span>{{vm.phoneCall.calledNumber}}</span>\n        </dd>\n        --><!-- Begin Calling --><dt><span data-translate="telestatApp.phoneCall.callingCaption" uib-tooltip="{{\'telestatApp.phoneCall.help.callingCaption\' | translate}}">Calling Caption</span></dt><dd ng-if="vm.phoneCall.callingEmployee != null"><a ui-sref="employee-detail({id:vm.phoneCall.callingEmployee.id})" ng-class="{\'inactive-entity\': !vm.phoneCall.callingEmployee.actual}"><span>{{vm.phoneCall.callingEmployee.fullname}}</span></a></dd><dd ng-if="vm.phoneCall.officePhone != null"><a ui-sref="office-phone-detail({id:vm.phoneCall.officePhone.id})" ng-class="{\'inactive-entity\': !vm.phoneCall.officePhone.actual}"><span>{{vm.phoneCall.officePhone.title}}</span></a></dd><dd ng-if="vm.phoneCall.callingEmployee == null && vm.phoneCall.officePhone == null"><span>{{vm.phoneCall.callingCaption}}</span></dd><!-- End Calling --><!-- Begin Called--><dt><span data-translate="telestatApp.phoneCall.calledCaption" uib-tooltip="{{\'telestatApp.phoneCall.help.calledCaption\' | translate}}">Called Caption</span></dt><dd ng-if="vm.phoneCall.calledEmployee != null"><a ui-sref="employee-detail({id:vm.phoneCall.calledEmployee.id})" ng-class="{\'inactive-entity\': !vm.phoneCall.calledEmployee.actual}"><span>{{vm.phoneCall.calledEmployee.fullname}} {{vm.phoneCall.calledNumber | phone}}</span></a></dd><dd ng-if="vm.phoneCall.calledEmployee == null"><span>{{vm.phoneCall.calledCaption}}</span></dd><!-- End Called --><dt><span data-translate="telestatApp.phoneCall.division">Division</span></dt><dd><a ui-sref="division-detail({id:vm.phoneCall.division.id})" ng-class="{\'inactive-entity\': !vm.phoneCall.division.actual}">{{vm.phoneCall.division.title}}</a></dd><dt><span data-translate="telestatApp.phoneCall.waitDuration" uib-tooltip="{{\'telestatApp.phoneCall.help.waitDuration\' | translate}}">Wait Duration</span></dt><dd><span>{{vm.phoneCall.waitDuration | MMss}}</span></dd><dt><span data-translate="telestatApp.phoneCall.phoneCallStatus">Phone Call Status</span></dt><dd><a ui-sref="phone-call-status-detail({id:vm.phoneCall.phoneCallStatus.id})">{{vm.phoneCall.phoneCallStatus.name}}</a></dd><dt><span data-translate="telestatApp.phoneCall.talkDuration" uib-tooltip="{{\'telestatApp.phoneCall.help.talkDuration\' | translate}}">Talk Duration</span></dt><dd><span ng-hide="vm.phoneCall.phoneCallStatus.code == \'missed\'">{{vm.phoneCall.talkDuration | MMss}}</span></dd><dt><span data-translate="telestatApp.phoneCall.record">Record</span></dt><dd><div class="download-record-url" ng-hide="vm.phoneCall.phoneCallStatus.code == \'missed\' || vm.phoneCall.recordURL == null"><!-- Don\'t shorten audio tag! It makes "<a>" child of "<audio>". --><audio class="download-record-url" controls ng-src="{{vm.phoneCall.recordURL|trusted}}"></audio><a class="btn btn-primary download-record-url" href="{{vm.phoneCall.recordURL}}" download="record.mp3"><span class="glyphicon glyphicon-download-alt"></span></a></div><span ng-show="vm.phoneCall.phoneCallStatus.code != \'missed\' && vm.phoneCall.recordURL == null" data-translate="telestatApp.phoneCall.recordNotAvailable">Record not available</span></dd><dt><span data-translate="telestatApp.phoneCall.advertisingSource">Info Source</span></dt><dd><a ui-sref="advertising-source-detail({id:vm.phoneCall.advertisingSource.id})" ng-class="{\'inactive-entity\': !vm.phoneCall.advertisingSource.actual}">{{vm.phoneCall.advertisingSource.name}}</a></dd><!--\n        <dt><span data-translate="telestatApp.phoneCall.callingEmployeeCaption">Calling Employee</span></dt>\n        <dd>\n            <a ui-sref="employee-detail({id:vm.phoneCall.callingEmployee.id})">{{vm.phoneCall.callingEmployee.fullname}}</a>\n        </dd>\n        --><!--\n        <dt><span data-translate="telestatApp.phoneCall.officePhoneCaption">Office Phone</span></dt>\n        <dd>\n            <a ui-sref="office-phone-detail({id:vm.phoneCall.officePhone.id})">{{vm.phoneCall.officePhone.title}}</a>\n        </dd>\n        --><!--\n        <dt><span data-translate="telestatApp.phoneCall.calledEmployee">Called Employee</span></dt>\n        <dd>\n            <a ui-sref="employee-detail({id:vm.phoneCall.calledEmployee.id})">{{vm.phoneCall.calledEmployee.fullname}}</a>\n        </dd>\n        --><!--\n        <dt><span data-translate="telestatApp.phoneCall.modifierAccount">Modifier Account</span></dt>\n        <dd>\n            {{vm.phoneCall.modifierAccount.login}}\n        </dd>\n        --><!--\n        <dt><span data-translate="telestatApp.phoneCall.modifier">Modifier</span></dt>\n        <dd>\n            <a ui-sref="employee-detail({id:vm.phoneCall.modifier.id})">{{vm.phoneCall.modifier.fullname}}</a>\n        </dd>\n        --><!-- Begin Modifier --><dt><span data-translate="telestatApp.phoneCall.modifierCaption" uib-tooltip="{{\'telestatApp.phoneCall.help.modifierCaption\' | translate}}">Modifier Caption</span></dt><dd ng-if="vm.phoneCall.modifier != null"><a ui-sref="employee-detail({id:vm.phoneCall.modifier.id})"><span>{{vm.phoneCall.modifier.fullname}}</span></a></dd><dd ng-if="vm.phoneCall.modifier == null"><a ui-sref="user-management-detail({login:vm.phoneCall.modifierAccount.login})"><span>{{vm.phoneCall.modifierCaption}}</span></a></dd><!-- End Modifier --><dt><span data-translate="telestatApp.phoneCall.createTime" uib-tooltip="{{\'telestatApp.phoneCall.help.createTime\' | translate}}">Create Time</span></dt><dd><span>{{vm.phoneCall.createTime | date:\'medium\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="phone-call-detail.edit({id:vm.phoneCall.id})" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'phone-call-detail.edit\')" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/phone-call/phone-call-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPhoneCallLabel" data-translate="telestatApp.phoneCall.home.createOrEditLabel">Create or edit a Phone Call</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><!--\n        <div class="form-group" ng-show="vm.phoneCall.id">\n            <label for="id" data-translate="global.field.id">ID</label>\n            <input type="text" class="form-control" id="id" name="id"\n                    ng-model="vm.phoneCall.id" readonly />\n        </div>\n        --><div class="form-group"><label class="control-label" data-translate="telestatApp.phoneCall.title" for="field_title" uib-tooltip="{{\'telestatApp.phoneCall.help.title\' | translate}}">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.phoneCall.title" readonly="readonly" required ng-minlength="15" ng-maxlength="224"><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.title.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="15">This field is required to be at least 15 characters.</p><p class="help-block" ng-show="editForm.title.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="224">This field cannot be longer than 224 characters.</p></div></div><div class="form-group"><label data-translate="telestatApp.phoneCall.cloudPBX" for="field_cloudPBX">Cloud PBX</label><select class="form-control" id="field_cloudPBX" name="cloudPBX" ng-model="vm.phoneCall.cloudPBX" ng-options="cloudPBX as cloudPBX.name for cloudPBX in vm.cloudpbxes track by cloudPBX.id" required readonly="readonly"></select></div><div ng-show="editForm.cloudPBX.$invalid"><p class="help-block" ng-show="editForm.cloudPBX.$error.required" data-translate="entity.validation.required">This field is required.</p></div><!--\n        <div class="form-group">\n            <label class="control-label" data-translate="telestatApp.phoneCall.callId" for="field_callId" uib-tooltip="{{\'telestatApp.phoneCall.help.callId\' | translate}}">Call Id</label>\n            <input type="text" class="form-control" name="callId" id="field_callId"\n                    ng-model="vm.phoneCall.callId"\n                    readonly\n                    required ng-minlength="6" ng-maxlength="64"/>\n            <div ng-show="editForm.callId.$invalid">\n                <p class="help-block"\n                    ng-show="editForm.callId.$error.required" data-translate="entity.validation.required">\n                    This field is required.\n                </p>\n                <p class="help-block"\n                    ng-show="editForm.callId.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="6">\n                    This field is required to be at least 6 characters.\n                </p>\n                <p class="help-block"\n                    ng-show="editForm.callId.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="64">\n                    This field cannot be longer than 64 characters.\n                </p>\n            </div>\n        </div>\n        --><div class="form-group"><label class="control-label" data-translate="telestatApp.phoneCall.callTime" for="field_callTime" uib-tooltip="{{\'telestatApp.phoneCall.help.callTime\' | translate}}">Call Time</label><div class="input-group"><input id="field_callTime" type="text" class="form-control" name="callTime" datetime-picker="{{vm.dateformat}}" ng-model="vm.phoneCall.callTime" is-open="vm.datePickerOpenStatus.callTime" readonly="readonly" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'callTime\')" disabled="disabled"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.callTime.$invalid"><p class="help-block" ng-show="editForm.callTime.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.callTime.$error.ZonedDateTimelocal" data-translate="entity.validation.ZonedDateTimelocal">This field should be a date and time.</p></div></div><!--\n        <div class="form-group">\n            <label class="control-label" data-translate="telestatApp.phoneCall.callingNumber" for="field_callingNumber" uib-tooltip="{{\'telestatApp.phoneCall.help.callingNumber\' | translate}}">Calling Number</label>\n            <input type="number" class="form-control" name="callingNumber" id="field_callingNumber"\n                    ng-model="vm.phoneCall.callingNumber"\n                    required min="0"/>\n            <div ng-show="editForm.callingNumber.$invalid">\n                <p class="help-block"\n                    ng-show="editForm.callingNumber.$error.required" data-translate="entity.validation.required">\n                    This field is required.\n                </p>\n                <p class="help-block"\n                    ng-show="editForm.callingNumber.$error.min" data-translate="entity.validation.min" translate-value-min="0">\n                    This field should be at least 0.\n                </p>\n                <p class="help-block"\n                    ng-show="editForm.callingNumber.$error.number" data-translate="entity.validation.number">\n                    This field should be a number.\n                </p>\n            </div>\n        </div>\n        --><!--\n        <div class="form-group">\n            <label class="control-label" data-translate="telestatApp.phoneCall.user" for="field_user" uib-tooltip="{{\'telestatApp.phoneCall.help.user\' | translate}}">User</label>\n            <input type="text" class="form-control" name="user" id="field_user"\n                    ng-model="vm.phoneCall.user"\n                    readonly\n                    required ng-minlength="2" ng-maxlength="128"/>\n            <div ng-show="editForm.user.$invalid">\n                <p class="help-block"\n                    ng-show="editForm.user.$error.required" data-translate="entity.validation.required">\n                    This field is required.\n                </p>\n                <p class="help-block"\n                    ng-show="editForm.user.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">\n                    This field is required to be at least 2 characters.\n                </p>\n                <p class="help-block"\n                    ng-show="editForm.user.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="128">\n                    This field cannot be longer than 128 characters.\n                </p>\n            </div>\n        </div>\n        --><!--\n        <div class="form-group">\n            <label class="control-label" data-translate="telestatApp.phoneCall.calledNumber" for="field_calledNumber" uib-tooltip="{{\'telestatApp.phoneCall.help.calledNumber\' | translate}}">Called Number</label>\n            <input type="number" class="form-control" name="calledNumber" id="field_calledNumber"\n                    ng-model="vm.phoneCall.calledNumber"\n                    readonly\n                    required min="1"/>\n            <div ng-show="editForm.calledNumber.$invalid">\n                <p class="help-block"\n                    ng-show="editForm.calledNumber.$error.required" data-translate="entity.validation.required">\n                    This field is required.\n                </p>\n                <p class="help-block"\n                    ng-show="editForm.calledNumber.$error.min" data-translate="entity.validation.min" translate-value-min="1">\n                    This field should be at least 1.\n                </p>\n                <p class="help-block"\n                    ng-show="editForm.calledNumber.$error.number" data-translate="entity.validation.number">\n                    This field should be a number.\n                </p>\n            </div>\n        </div>\n        --><div class="form-group"><label class="control-label" data-translate="telestatApp.phoneCall.callingCaption" for="field_callingCaption" uib-tooltip="{{\'telestatApp.phoneCall.help.callingCaption\' | translate}}">Calling Caption</label><input type="text" class="form-control" name="callingCaption" id="field_callingCaption" ng-model="vm.phoneCall.callingCaption" readonly="readonly" required ng-minlength="2" ng-maxlength="64"><div ng-show="editForm.callingCaption.$invalid"><p class="help-block" ng-show="editForm.callingCaption.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.callingCaption.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.callingCaption.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.phoneCall.calledCaption" for="field_calledCaption" uib-tooltip="{{\'telestatApp.phoneCall.help.calledCaption\' | translate}}">Called Caption</label><input type="text" class="form-control" name="calledCaption" id="field_calledCaption" ng-model="vm.phoneCall.calledCaption" readonly="readonly" required ng-minlength="2" ng-maxlength="64"><div ng-show="editForm.calledCaption.$invalid"><p class="help-block" ng-show="editForm.calledCaption.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.calledCaption.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.calledCaption.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div><div class="form-group"><label data-translate="telestatApp.phoneCall.division" for="field_division">Division</label><select class="form-control not-actual-options" id="field_division" name="division" ng-model="vm.phoneCall.division" ng-options="division as division.title disable when !division.actual for division in vm.divisions track by division.id" readonly="readonly"><option value=""></option></select></div><div class="form-group"><label class="control-label" data-translate="telestatApp.phoneCall.waitDuration" for="field_waitDuration" uib-tooltip="{{\'telestatApp.phoneCall.help.waitDuration\' | translate}}">Wait Duration</label><input type="number" class="form-control" name="waitDuration" id="field_waitDuration" ng-model="vm.phoneCall.waitDuration" readonly="readonly" min="0" max="840"><div ng-show="editForm.waitDuration.$invalid"><p class="help-block" ng-show="editForm.waitDuration.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be at least 0.</p><p class="help-block" ng-show="editForm.waitDuration.$error.max" data-translate="entity.validation.max" translate-value-max="840">This field cannot be more than 840.</p><p class="help-block" ng-show="editForm.waitDuration.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label data-translate="telestatApp.phoneCall.phoneCallStatus" for="field_phoneCallStatus">Phone Call Status</label><select class="form-control" id="field_phoneCallStatus" name="phoneCallStatus" ng-model="vm.phoneCall.phoneCallStatus" ng-options="phoneCallStatus as phoneCallStatus.name for phoneCallStatus in vm.phonecallstatuses track by phoneCallStatus.id" required readonly="readonly"></select></div><div ng-show="editForm.phoneCallStatus.$invalid"><p class="help-block" ng-show="editForm.phoneCallStatus.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label class="control-label" data-translate="telestatApp.phoneCall.talkDuration" for="field_talkDuration" uib-tooltip="{{\'telestatApp.phoneCall.help.talkDuration\' | translate}}">Talk Duration</label><input type="number" class="form-control" name="talkDuration" id="field_talkDuration" ng-model="vm.phoneCall.talkDuration" readonly="readonly" required min="0" max="7200"><div ng-show="editForm.talkDuration.$invalid"><p class="help-block" ng-show="editForm.talkDuration.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.talkDuration.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be at least 0.</p><p class="help-block" ng-show="editForm.talkDuration.$error.max" data-translate="entity.validation.max" translate-value-max="7200">This field cannot be more than 7200.</p><p class="help-block" ng-show="editForm.talkDuration.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.phoneCall.recordURL" for="field_recordURL" uib-tooltip="{{\'telestatApp.phoneCall.help.recordURL\' | translate}}">Record URL</label><input type="text" class="form-control" name="recordURL" id="field_recordURL" ng-model="vm.phoneCall.recordURL" readonly="readonly" ng-minlength="10" ng-maxlength="256"><div ng-show="editForm.recordURL.$invalid"><p class="help-block" ng-show="editForm.recordURL.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="10">This field is required to be at least 10 characters.</p><p class="help-block" ng-show="editForm.recordURL.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="256">This field cannot be longer than 256 characters.</p></div></div><div class="form-group"><label data-translate="telestatApp.phoneCall.advertisingSource" for="field_advertisingSource">Info Source</label><select class="form-control not-actual-options" id="field_advertisingSource" name="advertisingSource" ng-model="vm.phoneCall.advertisingSource" ng-options="advertisingSource as advertisingSource.name disable when !advertisingSource.actual for advertisingSource in vm.advertisingsources track by advertisingSource.id"><option value=""></option></select></div><!--\n        <div class="form-group">\n            <label data-translate="telestatApp.phoneCall.callingEmployee" for="field_callingEmployee">Calling Employee</label>\n            <select class="form-control" id="field_callingEmployee" name="callingEmployee" ng-model="vm.phoneCall.callingEmployee" ng-options="employee as employee.fullname for employee in vm.employees track by employee.id">\n                <option value=""></option>\n            </select>\n        </div>\n        --><!--\n        <div class="form-group">\n            <label data-translate="telestatApp.phoneCall.officePhone" for="field_officePhone">Office Phone</label>\n            <select class="form-control" id="field_officePhone" name="officePhone" ng-model="vm.phoneCall.officePhone" ng-options="officePhone as officePhone.title for officePhone in vm.officephones track by officePhone.id">\n                <option value=""></option>\n            </select>\n        </div>\n        --><!--\n        <div class="form-group">\n            <label data-translate="telestatApp.phoneCall.calledEmployee" for="field_calledEmployee">Called Employee</label>\n            <select class="form-control" id="field_calledEmployee" name="calledEmployee" ng-model="vm.phoneCall.calledEmployee" ng-options="employee as employee.fullname for employee in vm.employees track by employee.id">\n                <option value=""></option>\n            </select>\n        </div>\n        --><!--\n        <div class="form-group">\n            <label data-translate="telestatApp.phoneCall.modifierAccount" for="field_modifierAccount">Modifier Account</label>\n            <select class="form-control" id="field_modifierAccount" name="modifierAccount" ng-model="vm.phoneCall.modifierAccount" ng-options="user as user.login for user in vm.users track by user.id" required>\n            </select>\n        </div>\n        <div ng-show="editForm.modifierAccount.$invalid">\n            <p class="help-block"\n                ng-show="editForm.modifierAccount.$error.required" data-translate="entity.validation.required">\n                This field is required.\n            </p>\n        </div>\n        --><!--\n        <div class="form-group">\n            <label data-translate="telestatApp.phoneCall.modifier" for="field_modifier">Modifier</label>\n            <select class="form-control" id="field_modifier" name="modifier" ng-model="vm.phoneCall.modifier" ng-options="employee as employee.fullname for employee in vm.employees track by employee.id">\n                <option value=""></option>\n            </select>\n        </div>\n        --><div class="form-group"><label class="control-label" data-translate="telestatApp.phoneCall.modifierCaption" for="field_modifierCaption" uib-tooltip="{{\'telestatApp.phoneCall.help.modifierCaption\' | translate}}">Modifier Caption</label><input type="text" class="form-control" name="modifierCaption" id="field_modifierCaption" ng-model="vm.phoneCall.modifierCaption" readonly="readonly" required ng-minlength="2" ng-maxlength="101"><div ng-show="editForm.modifierCaption.$invalid"><p class="help-block" ng-show="editForm.modifierCaption.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.modifierCaption.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.modifierCaption.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="101">This field cannot be longer than 101 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.phoneCall.createTime" for="field_createTime" uib-tooltip="{{\'telestatApp.phoneCall.help.createTime\' | translate}}">Create Time</label><div class="input-group"><input id="field_createTime" type="text" class="form-control" name="createTime" datetime-picker="{{vm.dateformat}}" ng-model="vm.phoneCall.createTime" is-open="vm.datePickerOpenStatus.createTime" readonly="readonly" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'createTime\')" disabled="disabled"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.createTime.$invalid"><p class="help-block" ng-show="editForm.createTime.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.createTime.$error.ZonedDateTimelocal" data-translate="entity.validation.ZonedDateTimelocal">This field should be a date and time.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/phone-call/phone-calls.html','<div><!--\n    <h2 data-translate="telestatApp.phoneCall.home.title">Phone Calls</h2>\n     --><h2 data-translate="telestatApp.phoneCall.home.title" ng-if="vm.divisionsFilterData.division.id == null">Phone Calls</h2><h2 ng-if="vm.divisionsFilterData.division.id != null">{{ \'telestatApp.phoneCall.home.titleWithParam\' | translate:{division: vm.divisionsFilterData.division.name } }}</h2><!--\n    <jhi-alert></jhi-alert>\n    --><div class="container-fluid"><!-- Don\'t remove form element! Need for search with Enter key! --><form name="searchForm" class="form-inline"><div class="row"><div class="col-xs-2 no-padding-left rounded-left pull-left"><!--\n                    <button class="btn btn-primary" ui-sref="phone-call.new"\n                            ng-disabled="!vm.UIFormAccess.checkStateAccess(\'phone-call.new\')">\n                        <span class="glyphicon glyphicon-plus"></span>\n                        <span class="hidden-xs-down"  data-translate="telestatApp.phoneCall.home.createLabel">\n                            Create new Phone Call\n                        </span>\n                    </button>\n                    --><div class="input-group pull-left"><span class="input-group-btn width-min"><button class="btn btn-primary" type="button" ng-click="vm.loadAll()" title="{{ \'entity.action.refresh\' | translate }}"><span class="glyphicon glyphicon-refresh"></span></button></span><divisions-filter class="input-group pull-right" data="vm.divisionsFilterData"></divisions-filter></div></div><date-filter data="vm.dateFilterData"></date-filter><div class="col-xs-3 no-padding-right pull-right"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'telestatApp.phoneCall.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> <button class="btn btn-info" ng-click="vm.clear()" ng-if="vm.currentSearch || vm.dateFilterData.dateFilterType != \'all\' || vm.division.id"><span class="glyphicon glyphicon-trash"></span></button></span></div></div></div></form></div><br><jhi-alert></jhi-alert><div class="table-responsive"><script type="text/ng-template" id="popoverTemplateId"><div>\n\t\t\u0421\u043A\u043E\u0440\u043E\u0441\u0442\u044C:\n\t\t<span class="player-speed" ng-click="playerSetSpeed(phoneCall.id, 1);">1x</span>\n\t\t<span class="player-speed" ng-click="playerSetSpeed(phoneCall.id, 1.5);">1.5x</span>\n\t\t<span class="player-speed" ng-click="playerSetSpeed(phoneCall.id, 1.75);">1.75x</span>\n\t\t<span class="player-speed" ng-click="playerSetSpeed(phoneCall.id, 2);">2x</span>\n\t    </div>\n            <audio autoplay controls ng-attr-id="{{ \'audio-\' + phoneCall.id }}" ng-src="{{ phoneCall.recordURL | trusted }}" ng-click="openPlayer(phoneCall, false);" ontimeupdate="this.click();" onplay="this.click();" onpause="this.click();" onerror="this.click();"></audio></script><table class="jh-table table table-responsive"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="callTime" class="phone-call-date-time"><span data-translate="telestatApp.phoneCall.callTimeCaption">Call Time</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="callingCaption"><span data-translate="telestatApp.phoneCall.callingCaption">Calling Caption</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="calledCaption"><span data-translate="telestatApp.phoneCall.calledCaption">Called Caption</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="waitDuration"><span data-translate="telestatApp.phoneCall.waitDurationCaption">Wait Duration</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="phoneCallStatus.caption"><span data-translate="telestatApp.phoneCall.phoneCallStatus">Phone Call Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="talkDuration"><span data-translate="telestatApp.phoneCall.talkDurationCaption">Talk Duration</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="advertisingSource.caption"><span data-translate="telestatApp.phoneCall.advertisingSourceCaption">Info Source</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="division.name"><span data-translate="telestatApp.phoneCall.division">Division</span> <span class="glyphicon glyphicon-sort"></span></th><!--\n                    <th jh-sort-by="cloudPBX.id"><span data-translate="telestatApp.phoneCall.cloudPBX">Cloud PBX</span> <span class="glyphicon glyphicon-sort"></span></th>\n                    --><th></th></tr></thead><tbody><tr ng-repeat="phoneCall in vm.phoneCalls track by phoneCall.id" ng-class="phoneCall.phoneCallCheck.phoneCallResult.phoneCallResultGroup.style"><td><a ui-sref="phone-call-detail({id:phoneCall.id})">{{ ::phoneCall.callTime | date:\'short\' }}</a></td><!-- Begin Calling --><td ng-if="phoneCall.callingEmployee != null"><a ui-sref="employee-detail({id:phoneCall.callingEmployee.id})" ng-class="{\'employee-manager\' : phoneCall.callingEmployee.managedDivisionsCount > 0,\n                                        \'employee-director\' : phoneCall.callingEmployee.managedDivisionsCount > 2,\n                                        \'inactive-entity\': !phoneCall.callingEmployee.actual}">{{ ::phoneCall.callingCaption }}</a></td><td ng-if="phoneCall.officePhone != null"><a ui-sref="office-phone-detail({id:phoneCall.officePhone.id})">{{ ::phoneCall.callingCaption }}</a></td><td ng-if="phoneCall.callingEmployee == null && phoneCall.officePhone == null">{{ ::phoneCall.callingCaption }} <span style="display:inline-block;background:red;color:white;padding:2px 5px;border-radius:5px;line-height:1em;font-size:13px;font-weight:bold;font-family:arial" ng-if="phoneCall.blockedPhone != null">\u0421\u043F\u0430\u043C</span></td><!-- End Calling --><!-- Begin Called --><td ng-if="phoneCall.calledEmployee != null"><a title="{{ ::phoneCall.calledNumber | phone }}" ui-sref="employee-detail({id:phoneCall.calledEmployee.id})" ng-class="{\'employee-manager\' : phoneCall.calledEmployee.managedDivisionsCount > 0,\n                                        \'employee-director\' : phoneCall.calledEmployee.managedDivisionsCount > 2,\n                                        \'inactive-entity\': !phoneCall.calledEmployee.actual}">{{ ::phoneCall.calledCaption }}</a></td><td ng-if="phoneCall.calledEmployee == null">{{ ::phoneCall.calledCaption }}</td><!-- End Called --><td ng-if="phoneCall.notFinal">{{ phoneCall.realWaitDuration | MMss }}</td><td ng-if="!phoneCall.notFinal">{{ phoneCall.waitDuration | MMss }}</td><td><a ui-sref="phone-call-status-detail({id:phoneCall.phoneCallStatus.id})" ng-class="{\'status-missed\' : phoneCall.phoneCallStatus.code == \'missed\', \'status-accepted\' : phoneCall.phoneCallStatus.code == \'in\'}">{{ ::phoneCall.phoneCallStatus.caption }}</a></td><td><a ng-show="phoneCall.phoneCallStatus.code != \'missed\' && phoneCall.recordURL != null" uib-popover-template="dynamicPopover.templateUrl" popover-title="\u0417\u0430\u043F\u0438\u0441\u044C \u0440\u0430\u0437\u0433\u043E\u0432\u043E\u0440\u0430" popover-animation="false" popover-trigger="outsideClick" popover-is-open="phoneCall.isPopoverOpen" ng-click="openPlayer(phoneCall, true)">{{ ::phoneCall.talkDuration | MMss }} <span ng-class="\'glyphicon \'+(phoneCall.isPopoverOpen && phoneCall.isPopoverPlaying ? \'glyphicon-play glyphicon-pause\' : \'glyphicon-play\')"></span></a><div ng-show="phoneCall.phoneCallStatus.code != \'missed\' && phoneCall.recordURL == null">{{ ::phoneCall.talkDuration | MMss }}<br><span data-translate="telestatApp.phoneCall.recordNotAvailable">Record not available</span></div></td><td><a ui-sref="advertising-source-detail({id:phoneCall.advertisingSource.id})" ng-class="{\'inactive-entity\': !phoneCall.advertisingSource.actual}">{{ ::phoneCall.advertisingSource.caption }}</a></td><td><a ui-sref="division-detail({id:phoneCall.division.id})" ng-class="{\'inactive-entity\': !phoneCall.division.actual}">{{ ::phoneCall.division.name }}</a></td><!--\n                    <td>\n                        <a ui-sref="cloud-pbx-detail({id:phoneCall.cloudPBX.id})">{{phoneCall.cloudPBX.caption}}</a>\n                    </td>\n                    --><td class="text-right"><div class="btn-group flex-btn-group-container"><button ng-if="phoneCall.phoneCallCheck != null && phoneCall.phoneCallCheck.id != null" type="submit" ui-sref="phone-call.{{ vm.PrincipalIsAdmin\n                                                            || vm.accessToStateEditPhoneCallCheck\n                                                            && !phoneCall.phoneCallCheck.systemic\n                                                         ? \'editPhoneCallCheck\' : \'viewPhoneCallCheck\' }}({id:phoneCall.phoneCallCheck.id,phoneCallId:phoneCall.id})" class="btn btn-sm" ng-class="{\'btn-success\' : phoneCall.phoneCallCheck.assessment > 66,\n                                        \'btn-warning\' : phoneCall.phoneCallCheck.assessment <= 66 && phoneCall.phoneCallCheck.assessment > 33,\n                                        \'btn-danger\' : phoneCall.phoneCallCheck.assessment != null && phoneCall.phoneCallCheck.assessment <= 33}"><span ng-if="phoneCall.phoneCallCheck.assessment == null" class="glyphicon glyphicon-check"></span> <span ng-if="phoneCall.phoneCallCheck.assessment != null" class="text-center"><strong>{{ ::phoneCall.phoneCallCheck.assessment }}</strong></span></button> <button ng-if="phoneCall.phoneCallCheck == null" type="submit" ui-sref="phone-call.newPhoneCallCheck({id:phoneCall.id})" ng-disabled="!vm.accessToStateNewPhoneCallCheck" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-edit"></span></button> <button ng-if="phoneCall.phoneCallCheck == \'editing\'" type="submit" ui-sref="phone-call.newPhoneCallCheck({id:phoneCall.id})" ng-disabled="!vm.accessToStateNewPhoneCallCheck" class="btn btn-success btn-sm"><span class="glyphicon glyphicon-edit"></span></button> <button type="submit" ui-sref="phone-call-detail({id:phoneCall.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span><!--\n                                <span class="hidden-sm-down" data-translate="entity.action.view"></span>\n                                --></button> <button type="submit" ui-sref="phone-call.edit({id:phoneCall.id})" ng-disabled="!vm.accessToStateEdit" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span><!--\n                                <span class="hidden-sm-down" data-translate="entity.action.edit"></span>\n                                --></button><!--\n                            <button type="submit"\n                                    ui-sref="phone-call.delete({id:phoneCall.id})"\n                                    ng-disabled="!vm.UIFormAccess.checkStateAccess(\'phone-call.delete\')"\n                                    class="btn btn-danger btn-sm">\n                                <span class="glyphicon glyphicon-remove-circle"></span>\n                                <span class="hidden-sm-down" data-translate="entity.action.delete"></span>\n                            </button>\n                            --></div></td></tr></tbody></table></div><div class="text-center paginator"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination><div class="paginator-unchecked-filter" has-any-authority="ROLE_ADMIN, ROLE_DIRECTOR, ROLE_MANAGER, ROLE_CHECKER"><label class="checkbox-inline"><input name="uncheckedOnlyFilter" ng-model="vm.uncheckedOnlyFilter" type="checkbox" ng-click="vm.search(vm.searchQuery)"> <span data-translate="telestatApp.phoneCall.uncheckedOnlyFilter">Show unchecked only</span></label></div><div class="paginator-insignificant-filter" has-any-authority="ROLE_ADMIN, ROLE_DIRECTOR"><label class="checkbox-inline"><input name="insignificantFilter" ng-model="vm.insignificantFilter" type="checkbox" ng-click="vm.search(vm.searchQuery)"> <span data-translate="telestatApp.phoneCall.insignificantFilter">Hide insignificant calls</span></label></div><div class="paginator-repeated-filter" has-any-authority="ROLE_ADMIN"><label class="checkbox-inline"><input name="repeatedCallsFilter" ng-model="vm.repeatedCallsFilter" type="checkbox" ng-click="vm.search(vm.searchQuery)"> <span data-translate="telestatApp.phoneCall.repeatedCallsFilter">Hide repeated calls</span></label></div><div class="paginator-status-x-hide-filter"><div class="paginator-status_in-hide-filter"><label class="checkbox-inline"><input name="inCallsHideFilter" ng-model="vm.inCallsHideFilter" type="checkbox" ng-click="vm.search(vm.searchQuery)"> <span data-translate="telestatApp.phoneCall.inCallsHideFilter">Hide IN calls</span></label></div><div class="paginator-status-out-hide-filter"><label class="checkbox-inline"><input name="outCallsHideFilter" ng-model="vm.outCallsHideFilter" type="checkbox" ng-click="vm.search(vm.searchQuery)"> <span data-translate="telestatApp.phoneCall.outCallsHideFilter">Hide OUT calls</span></label></div><div class="paginator-status-missed-hide-filter"><label class="checkbox-inline"><input name="missedCallsHideFilter" ng-model="vm.missedCallsHideFilter" type="checkbox" ng-click="vm.search(vm.searchQuery)"> <span data-translate="telestatApp.phoneCall.missedCallsHideFilter">Hide MISSED calls</span></label></div></div></div></div>');
$templateCache.put('app/entities/phone-call-check/phone-call-check-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.phoneCallCheck.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="telestatApp.phoneCallCheck.delete.question" translate-values="{id: \'{{vm.phoneCallCheck.phoneCall.title}}\'}">Are you sure you want to delete this Phone Call Check?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/phone-call-check/phone-call-check-detail.html','<div><h2><span data-translate="telestatApp.phoneCallCheck.detail.title">Phone Call Check</span>: {{vm.phoneCallCheck.phoneCall.title}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="telestatApp.phoneCallCheck.realtyType">Realty Type</span></dt><dd><a ui-sref="realty-type-detail({id:vm.phoneCallCheck.realtyType.id})">{{vm.phoneCallCheck.realtyType.name}}</a></dd><dt><span data-translate="telestatApp.phoneCallCheck.dummy">Dummy</span></dt><dd><span data-translate="global.boolValueYesNo.{{vm.phoneCallCheck.dummy}}" uib-tooltip="{{\'telestatApp.phoneCallCheck.help.dummy\' | translate}}">{{vm.phoneCallCheck.dummy}}</span></dd><dt><span data-translate="telestatApp.phoneCallCheck.phoneCallPurpose">Phone Call Purpose</span></dt><dd><span ng-repeat="phoneCallPurpose in vm.phoneCallCheck.phoneCallPurposes"><a ui-sref="phone-call-purpose-detail({id: phoneCallPurpose.id})">{{phoneCallPurpose.name}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt><span data-translate="telestatApp.phoneCallCheck.assessment" uib-tooltip="{{\'telestatApp.phoneCallCheck.help.assessment\' | translate}}">Assessment</span></dt><dd><span>{{vm.phoneCallCheck.assessment}}</span></dd><dt><span data-translate="telestatApp.phoneCallCheck.phoneCallResult">Phone Call Result</span></dt><dd><a ui-sref="phone-call-result-detail({id:vm.phoneCallCheck.phoneCallResult.id})">{{vm.phoneCallCheck.phoneCallResult.name}}</a></dd><dt><span data-translate="telestatApp.phoneCallCheck.comment" uib-tooltip="{{\'telestatApp.phoneCallCheck.help.comment\' | translate}}">Comment</span></dt><dd><span>{{vm.phoneCallCheck.comment}}</span></dd><!--\n        <dt><span data-translate="telestatApp.phoneCallCheck.phoneCall">Phone Call</span></dt>\n        <dd>\n            <a ui-sref="phone-call-detail({id:vm.phoneCallCheck.phoneCall.id})">{{vm.phoneCallCheck.phoneCall.title}}</a>\n        </dd>\n        --><!--\n        <dt><span data-translate="telestatApp.phoneCallCheck.checkerAccount">Checker Account</span></dt>\n        <dd>\n            {{vm.phoneCallCheck.checkerAccount.login}}\n        </dd>\n        --><!--\n        <dt><span data-translate="telestatApp.phoneCallCheck.checker">Checker</span></dt>\n        <dd>\n            <a ui-sref="employee-detail({id:vm.phoneCallCheck.checker.id})">{{vm.phoneCallCheck.checker.fullName}}</a>\n        </dd>\n        --><!-- Begin Checker --><dt><span data-translate="telestatApp.phoneCallCheck.checkerCaption" uib-tooltip="{{\'telestatApp.phoneCallCheck.help.checkerCaption\' | translate}}">Checker Caption</span></dt><dd ng-if="vm.phoneCallCheck.checker != null"><a ui-sref="employee-detail({id:vm.phoneCallCheck.checker.id})"><span>{{vm.phoneCallCheck.checker.fullname}}</span></a></dd><dd ng-if="vm.phoneCallCheck.checker == null"><a ui-sref="user-management-detail({login:vm.phoneCallCheck.checkerAccount.login})"><span>{{vm.phoneCallCheck.checkerCaption}}</span></a></dd><!-- End Checker --><dt><span data-translate="telestatApp.phoneCallCheck.checkTime" uib-tooltip="{{\'telestatApp.phoneCallCheck.help.checkTime\' | translate}}">Check Time</span></dt><dd><span>{{vm.phoneCallCheck.checkTime | date:\'medium\'}}</span></dd><!--\n        <dt><span data-translate="telestatApp.phoneCallCheck.systemic" uib-tooltip="{{\'telestatApp.phoneCallCheck.help.systemic\' | translate}}">Systemic</span></dt>\n        <dd>\n            <span>{{vm.phoneCallCheck.systemic}}</span>\n        </dd>\n        --></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="phone-call-check-detail.edit({id:vm.phoneCallCheck.id})" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'phone-call-check-detail.edit\')" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/phone-call-check/phone-call-check-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPhoneCallCheckLabel" data-translate="telestatApp.phoneCallCheck.home.createOrEditLabel">Create or edit a Phone Call Check</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><!--\n        <div class="form-group" ng-show="vm.phoneCallCheck.id">\n            <label for="id" data-translate="global.field.id">ID</label>\n            <input type="text" class="form-control" id="id" name="id"\n                    ng-model="vm.phoneCallCheck.id" readonly />\n        </div>\n        --><div class="alert alert-warning" ng-show="!vm.fatalInfo && vm.otherInfo">{{vm.otherInfo}}</div><div class="alert alert-danger" ng-show="vm.fatalInfo">{{vm.fatalInfo}}</div><div class="form-group"><label data-translate="telestatApp.phoneCallCheck.phoneCall" for="field_phoneCall">Phone Call</label><!--\n            <select class="form-control" id="field_phoneCall" name="phoneCall" ng-model="vm.phoneCallCheck.phoneCall" ng-options="phoneCall as phoneCall.title for phoneCall in vm.phonecalls | orderBy:\'id\' track by phoneCall.id" required>\n            </select>\n            --> <input type="text" class="form-control" id="field_phoneCall" name="phoneCall" ng-model="vm.phoneCallCheck.phoneCall.title" readonly="readonly"></div><!--\n        <div ng-show="editForm.phoneCall.$invalid">\n            <p class="help-block"\n                ng-show="editForm.phoneCall.$error.required" data-translate="entity.validation.required">\n                This field is required.\n            </p>\n        </div>\n        --><div class="form-group"><label data-translate="telestatApp.phoneCall.record">Record</label><div class="download-record-url" ng-hide="vm.phoneCallCheck.phoneCall.phoneCallStatus.code != \'missed\'"><span data-translate="telestatApp.phoneCallCheck.noPhoneCallRecord">No phone call record</span></div><div class="download-record-url" ng-show="vm.phoneCallCheck.phoneCall.phoneCallStatus.code != \'missed\' && vm.phoneCallCheck.phoneCall.recordURL != null"><!-- Don\'t shorten audio tag! It makes "<a>" child of "<audio>". --><audio class="download-record-url" controls ng-src="{{vm.phoneCallCheck.phoneCall.recordURL|trusted}}" id="audiorecord"></audio><a target="_blank" class="btn btn-primary download-record-url" href="{{vm.phoneCallCheck.phoneCall.recordURL}}" download="record.mp3"><span class="glyphicon glyphicon-download-alt"></span></a><div>\u0421\u043A\u043E\u0440\u043E\u0441\u0442\u044C: <span class="player-speed" ng-click="vm.playerSetSpeed(\'audiorecord\', 1);">1x</span> <span class="player-speed" ng-click="vm.playerSetSpeed(\'audiorecord\', 1.5);">1.5x</span> <span class="player-speed" ng-click="vm.playerSetSpeed(\'audiorecord\', 1.75);">1.75x</span> <span class="player-speed" ng-click="vm.playerSetSpeed(\'audiorecord\', 2);">2x</span></div></div><div ng-show="vm.phoneCallCheck.phoneCall.phoneCallStatus.code != \'missed\' && vm.phoneCallCheck.phoneCall.recordURL == null" data-translate="telestatApp.phoneCall.recordNotAvailable">Record not available</div></div><div class="form-group"><label data-translate="telestatApp.phoneCallCheck.realtyType" for="field_realtyType">Realty Type</label><select class="form-control" id="field_realtyType" name="realtyType" ng-model="vm.phoneCallCheck.realtyType" ng-options="realtyType as realtyType.name for realtyType in vm.realtytypes track by realtyType.id"><option value=""></option></select></div><div class="form-group"><label class="control-label" data-translate="telestatApp.phoneCallCheck.dummy" for="field_dummy" uib-tooltip="{{\'telestatApp.phoneCallCheck.help.dummy\' | translate}}">Dummy</label><input type="checkbox" name="dummy" id="field_dummy" ng-model="vm.phoneCallCheck.dummy"><div ng-show="editForm.dummy.$invalid"><p class="help-block" ng-show="editForm.dummy.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="telestatApp.phoneCallCheck.phoneCallPurpose" for="field_phoneCallPurpose">Phone Call Purpose</label><!--\n            <select class="form-control" id="field_phoneCallPurpose" multiple name="phoneCallPurpose" ng-model="vm.phoneCallCheck.phoneCallPurposes" ng-options="phoneCallPurpose as phoneCallPurpose.name for phoneCallPurpose in vm.phonecallpurposes track by phoneCallPurpose.id"></select>\n            --><div class="form-control" style="height: 100%"><div class="row"><div class="col-sm-6" ng-repeat="phoneCallPurpose in vm.phonecallpurposes"><label class="checkbox-inline"><input type="checkbox" checklist-model="vm.phoneCallCheck.phoneCallPurposes" checklist-value="phoneCallPurpose" checklist-change="vm.calcProps()"> {{phoneCallPurpose.name + \' [\' + phoneCallPurpose.worth + \']\'}}</label></div></div></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.phoneCallCheck.assessment" for="field_assessment" uib-tooltip="{{\'telestatApp.phoneCallCheck.help.assessment\' | translate}}">Assessment</label><input type="number" class="form-control" name="assessment" id="field_assessment" ng-model="vm.phoneCallCheck.assessment" readonly="readonly" min="0" max="100"><div ng-show="editForm.assessment.$invalid"><p class="help-block" ng-show="editForm.assessment.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be at least 0.</p><p class="help-block" ng-show="editForm.assessment.$error.max" data-translate="entity.validation.max" translate-value-max="100">This field cannot be more than 100.</p><p class="help-block" ng-show="editForm.assessment.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label data-translate="telestatApp.phoneCall.advertisingSource" for="field_advertisingSource">Info Source</label><select class="form-control not-actual-options" id="field_advertisingSource" name="advertisingSource" ng-model="vm.phoneCallCheck.phoneCall.advertisingSource" ng-options="advertisingSource as advertisingSource.name disable when !advertisingSource.actual for advertisingSource in vm.advertisingsources track by advertisingSource.id"><option value=""></option></select></div><div class="form-group"><label data-translate="telestatApp.phoneCallCheck.phoneCallResult" for="field_phoneCallResult">Phone Call Result</label><select class="form-control" id="field_phoneCallResult" name="phoneCallResult" ng-model="vm.phoneCallCheck.phoneCallResult" ng-change="vm.calcProps()" ng-options="phoneCallResult as phoneCallResult.name disable when phoneCallResult.systemic==1 for phoneCallResult in vm.phonecallresults track by phoneCallResult.id" required></select></div><div ng-show="editForm.phoneCallResult.$invalid"><p class="help-block" ng-show="editForm.phoneCallResult.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label class="control-label" data-translate="telestatApp.phoneCallCheck.comment" for="field_comment" uib-tooltip="{{\'telestatApp.phoneCallCheck.help.comment\' | translate}}">Comment</label><input type="text" class="form-control" name="comment" id="field_comment" ng-model="vm.phoneCallCheck.comment" ng-maxlength="256"><div ng-show="editForm.comment.$invalid"><p class="help-block" ng-show="editForm.comment.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="256">This field cannot be longer than 256 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.phoneCallCheck.checkerCaption" for="field_checkerCaption" uib-tooltip="{{\'telestatApp.phoneCallCheck.help.checkerCaption\' | translate}}">Checker Caption</label><input type="text" class="form-control" name="checkerCaption" id="field_checkerCaption" ng-model="vm.phoneCallCheck.checkerCaption" readonly="readonly" required ng-minlength="5" ng-maxlength="101"><div ng-show="editForm.checkerCaption.$invalid"><p class="help-block" ng-show="editForm.checkerCaption.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.checkerCaption.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="5">This field is required to be at least 5 characters.</p><p class="help-block" ng-show="editForm.checkerCaption.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="101">This field cannot be longer than 101 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.phoneCallCheck.checkTime" for="field_checkTime" uib-tooltip="{{\'telestatApp.phoneCallCheck.help.checkTime\' | translate}}">Check Time</label><div class="input-group"><input id="field_checkTime" type="text" class="form-control" name="checkTime" datetime-picker="{{vm.dateformat}}" ng-model="vm.phoneCallCheck.checkTime" is-open="vm.datePickerOpenStatus.checkTime" readonly="readonly" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'checkTime\')" disabled="disabled"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.checkTime.$invalid"><p class="help-block" ng-show="editForm.checkTime.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.checkTime.$error.ZonedDateTimelocal" data-translate="entity.validation.ZonedDateTimelocal">This field should be a date and time.</p></div></div><!--\n        <div class="form-group">\n            <label class="control-label" data-translate="telestatApp.phoneCallCheck.systemic" for="field_systemic" uib-tooltip="{{\'telestatApp.phoneCallCheck.help.systemic\' | translate}}">Systemic</label>\n                <input type="checkbox" name="systemic" id="field_systemic"\n                          ng-model="vm.phoneCallCheck.systemic"/>\n            <div ng-show="editForm.systemic.$invalid">\n                <p class="help-block"\n                    ng-show="editForm.systemic.$error.required" data-translate="entity.validation.required">\n                    This field is required.\n                </p>\n            </div>\n        </div>\n        --><!--\n        <div class="form-group">\n            <label data-translate="telestatApp.phoneCallCheck.checkerAccount" for="field_checkerAccount">Checker Account</label>\n            <select class="form-control" id="field_checkerAccount" name="checkerAccount" ng-model="vm.phoneCallCheck.checkerAccount" ng-options="user as user.login for user in vm.users track by user.id" required>\n            </select>\n        </div>\n        <div ng-show="editForm.checkerAccount.$invalid">\n            <p class="help-block"\n                ng-show="editForm.checkerAccount.$error.required" data-translate="entity.validation.required">\n                This field is required.\n            </p>\n        </div>\n        --><!--\n        <div class="form-group">\n            <label data-translate="telestatApp.phoneCallCheck.checker" for="field_checker">Checker</label>\n            <select class="form-control" id="field_checker" name="checker" ng-model="vm.phoneCallCheck.checker" ng-options="employee as employee.fullName for employee in vm.employees track by employee.id">\n                <option value=""></option>\n            </select>\n        </div>\n        --></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving || vm.fatalInfo" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/phone-call-check/phone-call-checks.html','<div><h2 data-translate="telestatApp.phoneCallCheck.home.title">Phone Call Checks</h2><!--\n    <jhi-alert></jhi-alert>\n    --><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><!--\n                <button class="btn btn-primary" ui-sref="phone-call-check.new"\n                        ng-disabled="!vm.UIFormAccess.checkStateAccess(\'phone-call-check.new\')">\n                    <span class="glyphicon glyphicon-plus"></span>\n                    <span class="hidden-xs-down"  data-translate="telestatApp.phoneCallCheck.home.createLabel">\n                        Create new Phone Call Check\n                    </span>\n                </button>\n                --></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'telestatApp.phoneCallCheck.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><jhi-alert></jhi-alert><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="checkTime"><span data-translate="telestatApp.phoneCallCheck.checkTime">Check Time</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="phoneCall.title"><span data-translate="telestatApp.phoneCallCheck.phoneCall">Phone Call</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="phoneCall.phoneCallStatus.id"><span data-translate="telestatApp.phoneCallCheck.phoneCallStatus">Phone Call Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="phoneCallResult.caption"><span data-translate="telestatApp.phoneCallCheck.phoneCallResult">Phone Call Result</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="assessment"><span data-translate="telestatApp.phoneCallCheck.assessment">Assessment</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="checkerCaption"><span data-translate="telestatApp.phoneCallCheck.checkerCaption">Checker Caption</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="realtyType.name"><span data-translate="telestatApp.phoneCallCheck.realtyType">Realty Type</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="phoneCallCheck in vm.phoneCallChecks track by phoneCallCheck.id"><td><a ui-sref="phone-call-check-detail({id:phoneCallCheck.id})">{{phoneCallCheck.checkTime | date:\'short\'}}</a></td><td><a ui-sref="phone-call-detail({id:phoneCallCheck.phoneCall.id})">{{phoneCallCheck.phoneCall.title}}</a></td><td><a ui-sref="phone-call-detail({id:phoneCallCheck.phoneCall.id})">{{phoneCallCheck.phoneCall.phoneCallStatus.name.substr(0,4)}}</a></td><td><a ui-sref="phone-call-result-detail({id:phoneCallCheck.phoneCallResult.id})">{{phoneCallCheck.phoneCallResult.caption}}</a></td><td>{{phoneCallCheck.assessment}}</td><!-- Begin Checker --><td ng-if="phoneCallCheck.checker != null"><a ui-sref="employee-detail({id:phoneCallCheck.checker.id})">{{phoneCallCheck.checkerCaption}}</a></td><td ng-if="phoneCallCheck.checker == null"><a ui-sref="user-management-detail({login:phoneCallCheck.checkerAccount.login})">{{phoneCallCheck.checkerCaption}}</a></td><!-- End Checker --><td><a ui-sref="realty-type-detail({id:phoneCallCheck.realtyType.id})">{{phoneCallCheck.realtyType.name}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="phone-call-check-detail({id:phoneCallCheck.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="phone-call-check.edit({id:phoneCallCheck.id})" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'phone-call-check.edit\')" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="phone-call-check.delete({id:phoneCallCheck.id})" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'phone-call-check.delete\')" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/phone-call-purpose/phone-call-purpose-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.phoneCallPurpose.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="telestatApp.phoneCallPurpose.delete.question" translate-values="{id: \'{{vm.phoneCallPurpose.name}}\'}">Are you sure you want to delete this Phone Call Purpose?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/phone-call-purpose/phone-call-purpose-detail.html','<div><h2><span data-translate="telestatApp.phoneCallPurpose.detail.title">Phone Call Purpose</span>: {{vm.phoneCallPurpose.name}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="telestatApp.phoneCallPurpose.checkOrder" uib-tooltip="{{\'telestatApp.phoneCallPurpose.help.checkOrder\' | translate}}">Check Order</span></dt><dd><span>{{vm.phoneCallPurpose.checkOrder}}</span></dd><dt><span data-translate="telestatApp.phoneCallPurpose.name" uib-tooltip="{{\'telestatApp.phoneCallPurpose.help.name\' | translate}}">Name</span></dt><dd><span>{{vm.phoneCallPurpose.name}}</span></dd><dt><span data-translate="telestatApp.phoneCallPurpose.caption" uib-tooltip="{{\'telestatApp.phoneCallPurpose.help.caption\' | translate}}">Caption</span></dt><dd><span>{{vm.phoneCallPurpose.caption}}</span></dd><dt><span data-translate="telestatApp.phoneCallPurpose.worth" uib-tooltip="{{\'telestatApp.phoneCallPurpose.help.worth\' | translate}}">Worth</span></dt><dd><span>{{vm.phoneCallPurpose.worth}}</span></dd><dt><span data-translate="telestatApp.phoneCallPurpose.code" uib-tooltip="{{\'telestatApp.phoneCallPurpose.help.code\' | translate}}">Code</span></dt><dd><span>{{vm.phoneCallPurpose.code}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="phone-call-purpose-detail.edit({id:vm.phoneCallPurpose.id})" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'phone-call-purpose-detail.edit\')" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/phone-call-purpose/phone-call-purpose-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPhoneCallPurposeLabel" data-translate="telestatApp.phoneCallPurpose.home.createOrEditLabel">Create or edit a Phone Call Purpose</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><!--\n        <div class="form-group" ng-show="vm.phoneCallPurpose.id">\n            <label for="id" data-translate="global.field.id">ID</label>\n            <input type="text" class="form-control" id="id" name="id"\n                    ng-model="vm.phoneCallPurpose.id" readonly />\n        </div>\n        --><div class="form-group"><label class="control-label" data-translate="telestatApp.phoneCallPurpose.checkOrder" for="field_checkOrder">Check Order</label><input type="number" class="form-control" name="checkOrder" id="field_checkOrder" ng-model="vm.phoneCallPurpose.checkOrder" required min="1" max="20"><div ng-show="editForm.checkOrder.$invalid"><p class="help-block" ng-show="editForm.checkOrder.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.checkOrder.$error.min" data-translate="entity.validation.min" translate-value-min="1">This field should be at least 1.</p><p class="help-block" ng-show="editForm.checkOrder.$error.max" data-translate="entity.validation.max" translate-value-max="20">This field cannot be more than 20.</p><p class="help-block" ng-show="editForm.checkOrder.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.phoneCallPurpose.name" for="field_name" uib-tooltip="{{\'telestatApp.phoneCallPurpose.help.name\' | translate}}">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.phoneCallPurpose.name" required ng-minlength="2" ng-maxlength="32"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.name.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="32">This field cannot be longer than 32 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.phoneCallPurpose.caption" for="field_caption" uib-tooltip="{{\'telestatApp.phoneCallPurpose.help.caption\' | translate}}">Caption</label><input type="text" class="form-control" name="caption" id="field_caption" ng-model="vm.phoneCallPurpose.caption" required ng-minlength="2" ng-maxlength="16"><div ng-show="editForm.caption.$invalid"><p class="help-block" ng-show="editForm.caption.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.caption.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.caption.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="16">This field cannot be longer than 16 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.phoneCallPurpose.worth" for="field_worth" uib-tooltip="{{\'telestatApp.phoneCallPurpose.help.worth\' | translate}}">Worth</label><input type="number" class="form-control" name="worth" id="field_worth" ng-model="vm.phoneCallPurpose.worth" required min="0" max="100"><div ng-show="editForm.worth.$invalid"><p class="help-block" ng-show="editForm.worth.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.worth.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be at least 0.</p><p class="help-block" ng-show="editForm.worth.$error.max" data-translate="entity.validation.max" translate-value-max="100">This field cannot be more than 100.</p><p class="help-block" ng-show="editForm.worth.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.phoneCallPurpose.code" for="field_code" uib-tooltip="{{\'telestatApp.phoneCallPurpose.help.code\' | translate}}">Code</label><input type="text" class="form-control" name="code" id="field_code" ng-model="vm.phoneCallPurpose.code" required ng-minlength="1" ng-maxlength="8"><div ng-show="editForm.code.$invalid"><p class="help-block" ng-show="editForm.code.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.code.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.code.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="8">This field cannot be longer than 8 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/phone-call-purpose/phone-call-purposes.html','<div><h2 data-translate="telestatApp.phoneCallPurpose.home.title">Phone Call Purposes</h2><!--\n    <jhi-alert></jhi-alert>\n    --><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="phone-call-purpose.new" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'phone-call-purpose.new\')"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="telestatApp.phoneCallPurpose.home.createLabel">Create new Phone Call Purpose</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'telestatApp.phoneCallPurpose.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><jhi-alert></jhi-alert><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="checkOrder"><span data-translate="telestatApp.phoneCallPurpose.checkOrder">Check Order</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="telestatApp.phoneCallPurpose.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="caption"><span data-translate="telestatApp.phoneCallPurpose.caption">Caption</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="worth"><span data-translate="telestatApp.phoneCallPurpose.worth">Worth</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="code"><span data-translate="telestatApp.phoneCallPurpose.code">Code</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="phoneCallPurpose in vm.phoneCallPurposes track by phoneCallPurpose.id"><td>{{phoneCallPurpose.checkOrder}}</td><td><a ui-sref="phone-call-purpose-detail({id:phoneCallPurpose.id})">{{phoneCallPurpose.name}}</a></td><td>{{phoneCallPurpose.caption}}</td><td>{{phoneCallPurpose.worth}}</td><td>{{phoneCallPurpose.code}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="phone-call-purpose-detail({id:phoneCallPurpose.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="phone-call-purpose.edit({id:phoneCallPurpose.id})" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'phone-call-purpose.edit\')" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="phone-call-purpose.delete({id:phoneCallPurpose.id})" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'phone-call-purpose.delete\')" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/phone-call-result/phone-call-result-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.phoneCallResult.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="telestatApp.phoneCallResult.delete.question" translate-values="{id: \'{{vm.phoneCallResult.name}}\'}">Are you sure you want to delete this Phone Call Result?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/phone-call-result/phone-call-result-detail.html','<div><h2><span data-translate="telestatApp.phoneCallResult.detail.title">Phone Call Result</span>: {{vm.phoneCallResult.name}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="telestatApp.phoneCallResult.name" uib-tooltip="{{\'telestatApp.phoneCallResult.help.name\' | translate}}">Name</span></dt><dd><span>{{vm.phoneCallResult.name}}</span></dd><dt><span data-translate="telestatApp.phoneCallResult.caption" uib-tooltip="{{\'telestatApp.phoneCallResult.help.caption\' | translate}}">Caption</span></dt><dd><span>{{vm.phoneCallResult.caption}}</span></dd><dt><span data-translate="telestatApp.phoneCallResult.phoneCallResultGroup">Phone Call Result Group</span></dt><dd><a ui-sref="phone-call-result-group-detail({id:vm.phoneCallResult.phoneCallResultGroup.id})">{{vm.phoneCallResult.phoneCallResultGroup.name}}</a></dd><dt><span data-translate="telestatApp.phoneCallResult.blockingCount" uib-tooltip="{{\'telestatApp.phoneCallResult.help.blockingCount\' | translate}}">Blocking Count</span></dt><dd><span>{{vm.phoneCallResult.blockingCount}}</span></dd><dt><span data-translate="telestatApp.phoneCallResult.systemic" uib-tooltip="{{\'telestatApp.phoneCallResult.help.systemic\' | translate}}">Systemic</span></dt><dd><span data-translate="global.boolValueYesNo.{{vm.phoneCallResult.systemic}}">{{vm.phoneCallResult.systemic}}</span></dd><dt><span data-translate="telestatApp.phoneCallResult.code" uib-tooltip="{{\'telestatApp.phoneCallResult.help.code\' | translate}}">Code</span></dt><dd><span>{{vm.phoneCallResult.code}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="phone-call-result-detail.edit({id:vm.phoneCallResult.id})" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'phone-call-result-detail.edit\')" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/phone-call-result/phone-call-result-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPhoneCallResultLabel" data-translate="telestatApp.phoneCallResult.home.createOrEditLabel">Create or edit a Phone Call Result</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><!--\n        <div class="form-group" ng-show="vm.phoneCallResult.id">\n            <label for="id" data-translate="global.field.id">ID</label>\n            <input type="text" class="form-control" id="id" name="id"\n                    ng-model="vm.phoneCallResult.id" readonly />\n        </div>\n        --><div class="form-group"><label class="control-label" data-translate="telestatApp.phoneCallResult.name" for="field_name" uib-tooltip="{{\'telestatApp.phoneCallResult.help.name\' | translate}}">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.phoneCallResult.name" required ng-minlength="2" ng-maxlength="32"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.name.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="32">This field cannot be longer than 32 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.phoneCallResult.caption" for="field_caption" uib-tooltip="{{\'telestatApp.phoneCallResult.help.caption\' | translate}}">Caption</label><input type="text" class="form-control" name="caption" id="field_caption" ng-model="vm.phoneCallResult.caption" required ng-minlength="2" ng-maxlength="16"><div ng-show="editForm.caption.$invalid"><p class="help-block" ng-show="editForm.caption.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.caption.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.caption.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="16">This field cannot be longer than 16 characters.</p></div></div><div class="form-group"><label data-translate="telestatApp.phoneCallResult.phoneCallResultGroup" for="field_phoneCallResultGroup">Phone Call Result Group</label><select class="form-control" id="field_phoneCallResultGroup" name="phoneCallResultGroup" ng-model="vm.phoneCallResult.phoneCallResultGroup" ng-options="phoneCallResultGroup as phoneCallResultGroup.name for phoneCallResultGroup in vm.phonecallresultgroups track by phoneCallResultGroup.id" required></select></div><div ng-show="editForm.phoneCallResultGroup.$invalid"><p class="help-block" ng-show="editForm.phoneCallResultGroup.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label class="control-label" data-translate="telestatApp.phoneCallResult.blockingCount" for="field_blockingCount" uib-tooltip="{{\'telestatApp.phoneCallResult.help.blockingCount\' | translate}}">Blocking Count</label><input type="number" class="form-control" name="blockingCount" id="field_blockingCount" ng-model="vm.phoneCallResult.blockingCount" required min="0" max="30"><div ng-show="editForm.blockingCount.$invalid"><p class="help-block" ng-show="editForm.blockingCount.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.blockingCount.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be at least 0.</p><p class="help-block" ng-show="editForm.blockingCount.$error.max" data-translate="entity.validation.max" translate-value-max="30">This field cannot be more than 30.</p><p class="help-block" ng-show="editForm.blockingCount.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.phoneCallResult.systemic" for="field_systemic" uib-tooltip="{{\'telestatApp.phoneCallResult.help.systemic\' | translate}}">Systemic</label><input type="checkbox" name="systemic" id="field_systemic" ng-model="vm.phoneCallResult.systemic"><div ng-show="editForm.systemic.$invalid"><p class="help-block" ng-show="editForm.systemic.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.phoneCallResult.code" for="field_code" uib-tooltip="{{\'telestatApp.phoneCallResult.help.code\' | translate}}">Code</label><input type="text" class="form-control" name="code" id="field_code" ng-model="vm.phoneCallResult.code" required ng-minlength="1" ng-maxlength="8"><div ng-show="editForm.code.$invalid"><p class="help-block" ng-show="editForm.code.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.code.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.code.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="8">This field cannot be longer than 8 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/phone-call-result/phone-call-results.html','<div><h2 data-translate="telestatApp.phoneCallResult.home.title">Phone Call Results</h2><!--\n    <jhi-alert></jhi-alert>\n    --><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="phone-call-result.new" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'phone-call-result.new\')"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="telestatApp.phoneCallResult.home.createLabel">Create new Phone Call Result</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'telestatApp.phoneCallResult.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><jhi-alert></jhi-alert><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="name"><span data-translate="telestatApp.phoneCallResult.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="caption"><span data-translate="telestatApp.phoneCallResult.caption">Caption</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="phoneCallResultGroup.name"><span data-translate="telestatApp.phoneCallResult.phoneCallResultGroup">Phone Call Result Group</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="blockingCount"><span data-translate="telestatApp.phoneCallResult.blockingCount">Blocking Count</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="systemic"><span data-translate="telestatApp.phoneCallResult.systemic">Systemic</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="code"><span data-translate="telestatApp.phoneCallResult.code">Code</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="phoneCallResult in vm.phoneCallResults track by phoneCallResult.id"><td><a ui-sref="phone-call-result-detail({id:phoneCallResult.id})">{{phoneCallResult.name}}</a></td><td>{{phoneCallResult.caption}}</td><td><a ui-sref="phone-call-result-group-detail({id:phoneCallResult.phoneCallResultGroup.id})">{{phoneCallResult.phoneCallResultGroup.name}}</a></td><td>{{phoneCallResult.blockingCount}}</td><td><span data-translate="global.boolValueYesNo.{{phoneCallResult.systemic}}">{{phoneCallResult.systemic}}</span></td><td>{{phoneCallResult.code}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="phone-call-result-detail({id:phoneCallResult.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="phone-call-result.edit({id:phoneCallResult.id})" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'phone-call-result.edit\')" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="phone-call-result.delete({id:phoneCallResult.id})" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'phone-call-result.delete\')" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/phone-call-result-group/phone-call-result-group-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.phoneCallResultGroup.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="telestatApp.phoneCallResultGroup.delete.question" translate-values="{id: \'{{vm.phoneCallResultGroup.name}}\'}">Are you sure you want to delete this Phone Call Result Group?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/phone-call-result-group/phone-call-result-group-detail.html','<div><h2><span data-translate="telestatApp.phoneCallResultGroup.detail.title">Phone Call Result Group</span>: {{vm.phoneCallResultGroup.name}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="telestatApp.phoneCallResultGroup.name" uib-tooltip="{{\'telestatApp.phoneCallResultGroup.help.name\' | translate}}">Name</span></dt><dd><span>{{vm.phoneCallResultGroup.name}}</span></dd><dt><span data-translate="telestatApp.phoneCallResultGroup.caption" uib-tooltip="{{\'telestatApp.phoneCallResultGroup.help.caption\' | translate}}">Caption</span></dt><dd><span>{{vm.phoneCallResultGroup.caption}}</span></dd><dt><span data-translate="telestatApp.phoneCallResultGroup.purposeful" uib-tooltip="{{\'telestatApp.phoneCallResultGroup.help.purposeful\' | translate}}">Purposeful</span></dt><dd><span data-translate="global.boolValueYesNo.{{vm.phoneCallResultGroup.purposeful}}">{{vm.phoneCallResultGroup.purposeful}}</span></dd><dt><span data-translate="telestatApp.phoneCallResultGroup.effect" uib-tooltip="{{\'telestatApp.phoneCallResultGroup.help.effect\' | translate}}">Effect</span></dt><dd><span>{{vm.phoneCallResultGroup.effect}}</span></dd><dt><span data-translate="telestatApp.phoneCallResultGroup.style" uib-tooltip="{{\'telestatApp.phoneCallResultGroup.help.style\' | translate}}">Style</span></dt><dd><span>{{vm.phoneCallResultGroup.style}}</span></dd><dt><span data-translate="telestatApp.phoneCallResultGroup.code" uib-tooltip="{{\'telestatApp.phoneCallResultGroup.help.code\' | translate}}">Code</span></dt><dd><span>{{vm.phoneCallResultGroup.code}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="phone-call-result-group-detail.edit({id:vm.phoneCallResultGroup.id})" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'phone-call-result-group-detail.edit\')" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/phone-call-result-group/phone-call-result-group-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPhoneCallResultGroupLabel" data-translate="telestatApp.phoneCallResultGroup.home.createOrEditLabel">Create or edit a Phone Call Result Group</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><!--\n        <div class="form-group" ng-show="vm.phoneCallResultGroup.id">\n            <label for="id" data-translate="global.field.id">ID</label>\n            <input type="text" class="form-control" id="id" name="id"\n                    ng-model="vm.phoneCallResultGroup.id" readonly />\n        </div>\n        --><div class="form-group"><label class="control-label" data-translate="telestatApp.phoneCallResultGroup.name" for="field_name" uib-tooltip="{{\'telestatApp.phoneCallResultGroup.help.name\' | translate}}">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.phoneCallResultGroup.name" required ng-minlength="2" ng-maxlength="32"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.name.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="32">This field cannot be longer than 32 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.phoneCallResultGroup.caption" for="field_caption" uib-tooltip="{{\'telestatApp.phoneCallResultGroup.help.caption\' | translate}}">Caption</label><input type="text" class="form-control" name="caption" id="field_caption" ng-model="vm.phoneCallResultGroup.caption" required ng-minlength="2" ng-maxlength="16"><div ng-show="editForm.caption.$invalid"><p class="help-block" ng-show="editForm.caption.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.caption.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.caption.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="16">This field cannot be longer than 16 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.phoneCallResultGroup.purposeful" for="field_purposeful" uib-tooltip="{{\'telestatApp.phoneCallResultGroup.help.purposeful\' | translate}}">Purposeful</label><input type="checkbox" name="purposeful" id="field_purposeful" ng-model="vm.phoneCallResultGroup.purposeful"><div ng-show="editForm.purposeful.$invalid"><p class="help-block" ng-show="editForm.purposeful.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.phoneCallResultGroup.effect" for="field_effect" uib-tooltip="{{\'telestatApp.phoneCallResultGroup.help.effect\' | translate}}">Effect</label><input type="number" class="form-control" name="effect" id="field_effect" ng-model="vm.phoneCallResultGroup.effect" required><div ng-show="editForm.effect.$invalid"><p class="help-block" ng-show="editForm.effect.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.effect.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.phoneCallResultGroup.style" for="field_style" uib-tooltip="{{\'telestatApp.phoneCallResultGroup.help.style\' | translate}}">Style</label><input type="text" class="form-control" name="style" id="field_style" ng-model="vm.phoneCallResultGroup.style" required ng-minlength="2" ng-maxlength="16"><div ng-show="editForm.style.$invalid"><p class="help-block" ng-show="editForm.style.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.style.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.style.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="16">This field cannot be longer than 16 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.phoneCallResultGroup.code" for="field_code" uib-tooltip="{{\'telestatApp.phoneCallResultGroup.help.code\' | translate}}">Code</label><input type="text" class="form-control" name="code" id="field_code" ng-model="vm.phoneCallResultGroup.code" readonly="readonly" required ng-minlength="1" ng-maxlength="8"><div ng-show="editForm.code.$invalid"><p class="help-block" ng-show="editForm.code.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.code.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.code.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="8">This field cannot be longer than 8 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/phone-call-result-group/phone-call-result-groups.html','<div><h2 data-translate="telestatApp.phoneCallResultGroup.home.title">Phone Call Result Groups</h2><!--\n    <jhi-alert></jhi-alert>\n    --><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="phone-call-result-group.new" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'phone-call-result-group.new\')"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="telestatApp.phoneCallResultGroup.home.createLabel">Create new Phone Call Result Group</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'telestatApp.phoneCallResultGroup.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><jhi-alert></jhi-alert><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="name"><span data-translate="telestatApp.phoneCallResultGroup.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="caption"><span data-translate="telestatApp.phoneCallResultGroup.caption">Caption</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="purposeful"><span data-translate="telestatApp.phoneCallResultGroup.purposeful">Purposeful</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="effect"><span data-translate="telestatApp.phoneCallResultGroup.effect">Effect</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="style"><span data-translate="telestatApp.phoneCallResultGroup.style">Style</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="code"><span data-translate="telestatApp.phoneCallResultGroup.code">Code</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="phoneCallResultGroup in vm.phoneCallResultGroups track by phoneCallResultGroup.id"><td><a ui-sref="phone-call-result-group-detail({id:phoneCallResultGroup.id})">{{phoneCallResultGroup.name}}</a></td><td>{{phoneCallResultGroup.caption}}</td><td><span data-translate="global.boolValueYesNo.{{phoneCallResultGroup.purposeful}}">{{phoneCallResultGroup.purposeful}}</span></td><td>{{phoneCallResultGroup.effect}}</td><td>{{phoneCallResultGroup.style}}</td><td>{{phoneCallResultGroup.code}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="phone-call-result-group-detail({id:phoneCallResultGroup.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="phone-call-result-group.edit({id:phoneCallResultGroup.id})" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'phone-call-result-group.edit\')" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="phone-call-result-group.delete({id:phoneCallResultGroup.id})" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'phone-call-result-group.delete\')" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/phone-call-status/phone-call-status-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.phoneCallStatus.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="telestatApp.phoneCallStatus.delete.question" translate-values="{id: \'{{vm.phoneCallStatus.name}}\'}">Are you sure you want to delete this Phone Call Status?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/phone-call-status/phone-call-status-detail.html','<div><h2><span data-translate="telestatApp.phoneCallStatus.detail.title">Phone Call Status</span>: {{vm.phoneCallStatus.name}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="telestatApp.phoneCallStatus.name" uib-tooltip="{{\'telestatApp.phoneCallStatus.help.name\' | translate}}">Name</span></dt><dd><span>{{vm.phoneCallStatus.name}}</span></dd><dt><span data-translate="telestatApp.phoneCallStatus.caption" uib-tooltip="{{\'telestatApp.phoneCallStatus.help.caption\' | translate}}">Caption</span></dt><dd><span>{{vm.phoneCallStatus.caption}}</span></dd><dt><span data-translate="telestatApp.phoneCallStatus.code" uib-tooltip="{{\'telestatApp.phoneCallStatus.help.code\' | translate}}">Code</span></dt><dd><span>{{vm.phoneCallStatus.code}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="phone-call-status-detail.edit({id:vm.phoneCallStatus.id})" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'phone-call-status-detail.edit\')" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/phone-call-status/phone-call-status-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPhoneCallStatusLabel" data-translate="telestatApp.phoneCallStatus.home.createOrEditLabel">Create or edit a Phone Call Status</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><!--\n        <div class="form-group" ng-show="vm.phoneCallStatus.id">\n            <label for="id" data-translate="global.field.id">ID</label>\n            <input type="text" class="form-control" id="id" name="id"\n                    ng-model="vm.phoneCallStatus.id" readonly />\n        </div>\n        --><div class="form-group"><label class="control-label" data-translate="telestatApp.phoneCallStatus.name" for="field_name" uib-tooltip="{{\'telestatApp.phoneCallStatus.help.name\' | translate}}">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.phoneCallStatus.name" required ng-minlength="2" ng-maxlength="32"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.name.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="32">This field cannot be longer than 32 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.phoneCallStatus.caption" for="field_caption" uib-tooltip="{{\'telestatApp.phoneCallStatus.help.caption\' | translate}}">Caption</label><input type="text" class="form-control" name="caption" id="field_caption" ng-model="vm.phoneCallStatus.caption" required ng-minlength="2" ng-maxlength="16"><div ng-show="editForm.caption.$invalid"><p class="help-block" ng-show="editForm.caption.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.caption.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.caption.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="16">This field cannot be longer than 16 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.phoneCallStatus.code" for="field_code" uib-tooltip="{{\'telestatApp.phoneCallStatus.help.code\' | translate}}">Code</label><input type="text" class="form-control" name="code" id="field_code" ng-model="vm.phoneCallStatus.code" readonly="readonly" required ng-minlength="1" ng-maxlength="8"><div ng-show="editForm.code.$invalid"><p class="help-block" ng-show="editForm.code.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.code.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.code.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="8">This field cannot be longer than 8 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/phone-call-status/phone-call-statuses.html','<div><h2 data-translate="telestatApp.phoneCallStatus.home.title">Phone Call Statuses</h2><!--\n    <jhi-alert></jhi-alert>\n    --><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="phone-call-status.new" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'phone-call-status.new\')"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="telestatApp.phoneCallStatus.home.createLabel">Create new Phone Call Status</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'telestatApp.phoneCallStatus.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><jhi-alert></jhi-alert><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="name"><span data-translate="telestatApp.phoneCallStatus.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="caption"><span data-translate="telestatApp.phoneCallStatus.caption">Caption</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="code"><span data-translate="telestatApp.phoneCallStatus.code">Code</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="phoneCallStatus in vm.phoneCallStatuses track by phoneCallStatus.id"><td><a ui-sref="phone-call-status-detail({id:phoneCallStatus.id})">{{phoneCallStatus.name}}</a></td><td>{{phoneCallStatus.caption}}</td><td>{{phoneCallStatus.code}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="phone-call-status-detail({id:phoneCallStatus.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="phone-call-status.edit({id:phoneCallStatus.id})" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'phone-call-status.edit\')" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="phone-call-status.delete({id:phoneCallStatus.id})" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'phone-call-status.delete\')" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/phone-type/phone-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.phoneType.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="telestatApp.phoneType.delete.question" translate-values="{id: \'{{vm.phoneType.id}}\'}">Are you sure you want to delete this Phone Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/phone-type/phone-type-detail.html','<div><h2><span data-translate="telestatApp.phoneType.detail.title">Phone Type</span> {{vm.phoneType.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="telestatApp.phoneType.name">Name</span></dt><dd><span>{{vm.phoneType.name}}</span></dd><dt><span data-translate="telestatApp.phoneType.caption">Caption</span></dt><dd><span>{{vm.phoneType.caption}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="phone-type-detail.edit({id:vm.phoneType.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/phone-type/phone-type-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPhoneTypeLabel" data-translate="telestatApp.phoneType.home.createOrEditLabel">Create or edit a Phone Type</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.phoneType.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.phoneType.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="telestatApp.phoneType.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.phoneType.name"></div><div class="form-group"><label class="control-label" data-translate="telestatApp.phoneType.caption" for="field_caption">Caption</label><input type="text" class="form-control" name="caption" id="field_caption" ng-model="vm.phoneType.caption"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/phone-type/phone-types.html','<div><h2 data-translate="telestatApp.phoneType.home.title">Phone Types</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="phone-type.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="telestatApp.phoneType.home.createLabel">Create new Phone Type</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'telestatApp.phoneType.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="telestatApp.phoneType.name">Name</span></th><th><span data-translate="telestatApp.phoneType.caption">Caption</span></th><th></th></tr></thead><tbody><tr ng-repeat="phoneType in vm.phoneTypes track by phoneType.id"><td><a ui-sref="phone-type-detail({id:phoneType.id})">{{phoneType.id}}</a></td><td>{{phoneType.name}}</td><td>{{phoneType.caption}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="phone-type-detail({id:phoneType.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="phone-type.edit({id:phoneType.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="phone-type.delete({id:phoneType.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/setting/setting-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.setting.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="telestatApp.setting.delete.question" translate-values="{id: \'{{vm.setting.id}}\'}">Are you sure you want to delete this Setting?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/setting/setting-detail.html','<div><h2><span data-translate="telestatApp.setting.detail.title">Setting</span> {{vm.setting.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="telestatApp.setting.code" uib-tooltip="{{\'telestatApp.setting.help.code\' | translate}}">Code</span></dt><dd><span>{{vm.setting.code}}</span></dd><dt><span data-translate="telestatApp.setting.name" uib-tooltip="{{\'telestatApp.setting.help.name\' | translate}}">Name</span></dt><dd><span>{{vm.setting.name}}</span></dd><dt><span data-translate="telestatApp.setting.value" uib-tooltip="{{\'telestatApp.setting.help.value\' | translate}}">Value</span></dt><dd><div style="word-wrap: break-word">{{vm.setting.value}}</div></dd><dt><span data-translate="telestatApp.setting.unit" uib-tooltip="{{\'telestatApp.setting.help.unit\' | translate}}">Unit</span></dt><dd><span>{{vm.setting.unit}}</span></dd><dt><span data-translate="telestatApp.setting.description" uib-tooltip="{{\'telestatApp.setting.help.description\' | translate}}">Description</span></dt><dd><span>{{vm.setting.description}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="setting-detail.edit({id:vm.setting.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/setting/setting-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySettingLabel" data-translate="telestatApp.setting.home.createOrEditLabel">Create or edit a Setting</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.setting.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.setting.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="telestatApp.setting.code" for="field_code" uib-tooltip="{{\'telestatApp.setting.help.code\' | translate}}">Code</label><input type="text" class="form-control" name="code" id="field_code" ng-model="vm.setting.code" required ng-minlength="2" ng-maxlength="128"><div ng-show="editForm.code.$invalid"><p class="help-block" ng-show="editForm.code.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.code.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.code.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="128">This field cannot be longer than 128 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.setting.name" for="field_name" uib-tooltip="{{\'telestatApp.setting.help.name\' | translate}}">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.setting.name" required ng-minlength="2" ng-maxlength="32"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.name.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="32">This field cannot be longer than 32 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.setting.value" for="field_value" uib-tooltip="{{\'telestatApp.setting.help.value\' | translate}}">Value</label><input type="text" class="form-control" name="value" id="field_value" ng-model="vm.setting.value" required ng-minlength="1" ng-maxlength="1024"><div ng-show="editForm.value.$invalid"><p class="help-block" ng-show="editForm.value.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.value.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.value.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="1024">This field cannot be longer than 1024 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.setting.unit" for="field_unit" uib-tooltip="{{\'telestatApp.setting.help.unit\' | translate}}">Unit</label><input type="text" class="form-control" name="unit" id="field_unit" ng-model="vm.setting.unit" required ng-minlength="1" ng-maxlength="16"><div ng-show="editForm.unit.$invalid"><p class="help-block" ng-show="editForm.unit.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.unit.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.unit.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="16">This field cannot be longer than 16 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.setting.description" for="field_description" uib-tooltip="{{\'telestatApp.setting.help.description\' | translate}}">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.setting.description" required ng-minlength="2" ng-maxlength="256"><div ng-show="editForm.description.$invalid"><p class="help-block" ng-show="editForm.description.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.description.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.description.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="256">This field cannot be longer than 256 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/setting/settings.html','<div><h2 data-translate="telestatApp.setting.home.title">Settings</h2><!--\n    <jhi-alert></jhi-alert>\n    --><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="setting.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="telestatApp.setting.home.createLabel">Create new Setting</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'telestatApp.setting.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><jhi-alert></jhi-alert><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="code"><span data-translate="telestatApp.setting.code">Code</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="telestatApp.setting.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="value"><span data-translate="telestatApp.setting.value">Value</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="unit"><span data-translate="telestatApp.setting.unit">Unit</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="description"><span data-translate="telestatApp.setting.description">Description</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="setting in vm.settings track by setting.id"><td><a ui-sref="setting-detail({id:setting.id})">{{setting.id}}</a></td><td><p style="width: 140px; word-wrap: break-word">{{setting.code}}</p></td><td><p style="width: 100px; word-wrap: break-word">{{setting.name}}</p></td><td><p style="width: 200px; word-wrap: break-word">{{setting.value}}</p></td><td>{{setting.unit}}</td><td>{{setting.description}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="setting-detail({id:setting.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="setting.edit({id:setting.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="setting.delete({id:setting.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/realty-type/realty-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.realtyType.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="telestatApp.realtyType.delete.question" translate-values="{id: \'{{vm.realtyType.id}}\'}">Are you sure you want to delete this Realty Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/realty-type/realty-type-detail.html','<div><h2><span data-translate="telestatApp.realtyType.detail.title">Realty Type</span> {{vm.realtyType.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="telestatApp.realtyType.name" uib-tooltip="{{\'telestatApp.realtyType.help.name\' | translate}}">Name</span></dt><dd><span>{{vm.realtyType.name}}</span></dd><dt><span data-translate="telestatApp.realtyType.caption" uib-tooltip="{{\'telestatApp.realtyType.help.caption\' | translate}}">Caption</span></dt><dd><span>{{vm.realtyType.caption}}</span></dd><dt><span data-translate="telestatApp.realtyType.code" uib-tooltip="{{\'telestatApp.realtyType.help.code\' | translate}}">Code</span></dt><dd><span>{{vm.realtyType.code}}</span></dd><dt><span data-translate="telestatApp.realtyType.externalId" uib-tooltip="{{\'telestatApp.realtyType.help.externalId\' | translate}}">External Id</span></dt><dd><span>{{vm.realtyType.externalId}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="realty-type-detail.edit({id:vm.realtyType.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/realty-type/realty-type-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myRealtyTypeLabel" data-translate="telestatApp.realtyType.home.createOrEditLabel">Create or edit a Realty Type</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.realtyType.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.realtyType.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="telestatApp.realtyType.name" for="field_name" uib-tooltip="{{\'telestatApp.realtyType.help.name\' | translate}}">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.realtyType.name" required ng-minlength="2" ng-maxlength="32"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.name.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="32">This field cannot be longer than 32 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.realtyType.caption" for="field_caption" uib-tooltip="{{\'telestatApp.realtyType.help.caption\' | translate}}">Caption</label><input type="text" class="form-control" name="caption" id="field_caption" ng-model="vm.realtyType.caption" required ng-minlength="2" ng-maxlength="16"><div ng-show="editForm.caption.$invalid"><p class="help-block" ng-show="editForm.caption.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.caption.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.caption.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="16">This field cannot be longer than 16 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.realtyType.code" for="field_code" uib-tooltip="{{\'telestatApp.realtyType.help.code\' | translate}}">Code</label><input type="text" class="form-control" name="code" id="field_code" ng-model="vm.realtyType.code" required ng-minlength="1" ng-maxlength="8"><div ng-show="editForm.code.$invalid"><p class="help-block" ng-show="editForm.code.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.code.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.code.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="8">This field cannot be longer than 8 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.realtyType.externalId" for="field_externalId" uib-tooltip="{{\'telestatApp.realtyType.help.externalId\' | translate}}">External Id</label><input type="text" class="form-control" name="externalId" id="field_externalId" ng-model="vm.realtyType.externalId" required ng-minlength="1" ng-maxlength="16"><div ng-show="editForm.externalId.$invalid"><p class="help-block" ng-show="editForm.externalId.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.externalId.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.externalId.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="16">This field cannot be longer than 16 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/realty-type/realty-types.html','<div><h2 data-translate="telestatApp.realtyType.home.title">Realty Types</h2><!--\n    <jhi-alert></jhi-alert>\n    --><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="realty-type.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="telestatApp.realtyType.home.createLabel">Create new Realty Type</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'telestatApp.realtyType.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><jhi-alert></jhi-alert><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="telestatApp.realtyType.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="caption"><span data-translate="telestatApp.realtyType.caption">Caption</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="code"><span data-translate="telestatApp.realtyType.code">Code</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="externalId"><span data-translate="telestatApp.realtyType.externalId">External Id</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="realtyType in vm.realtyTypes track by realtyType.id"><td><a ui-sref="realty-type-detail({id:realtyType.id})">{{realtyType.id}}</a></td><td>{{realtyType.name}}</td><td>{{realtyType.caption}}</td><td>{{realtyType.code}}</td><td>{{realtyType.externalId}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="realty-type-detail({id:realtyType.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="realty-type.edit({id:realtyType.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="realty-type.delete({id:realtyType.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/sim-phone/sim-phone-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.simPhone.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><!--\n        <p data-translate="telestatApp.simPhone.delete.question" translate-values="{id: \'{{vm.simPhone.id}}\'}">Are you sure you want to delete this Sim Phone?</p>\n        --><p data-translate="telestatApp.simPhone.delete.question" translate-values="{id: \'{{vm.simPhone.number | phone}}\'}">Are you sure you want to delete this Sim Phone?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/sim-phone/sim-phone-detail.html','<div><h2><span data-translate="telestatApp.simPhone.detail.title">Sim Phone</span> {{vm.simPhone.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="telestatApp.simPhone.number" uib-tooltip="{{\'telestatApp.simPhone.help.number\' | translate}}">Number</span></dt><dd><!--\n            <span>{{vm.simPhone.number}}</span>\n            --> <span>{{vm.simPhone.number | phone}}</span></dd><dt><span data-translate="telestatApp.simPhone.actual" uib-tooltip="{{\'telestatApp.simPhone.help.actual\' | translate}}">Actual</span></dt><dd><!--\n            <span>{{vm.simPhone.actual}}</span>\n            --> <span data-translate="global.boolValueYesNo.{{vm.simPhone.actual}}">{{vm.simPhone.actual}}</span></dd><dt><span data-translate="telestatApp.simPhone.cloudPBX">Cloud PBX</span></dt><dd><a ui-sref="cloud-pbx-detail({id:vm.simPhone.cloudPBX.id})">{{vm.simPhone.cloudPBX.name}}</a></dd><dt><span data-translate="telestatApp.simPhone.employees">Employee Phones</span></dt><dd><span ng-repeat="employeePhone in vm.employeePhones track by employeePhone.id"><a ng-class="{\'inactive-entity\': !employeePhone.actual}" ui-sref="employee-phone-detail({id:employeePhone.id})">{{employeePhone.employee.briefname}}</a>{{$last ? \'\' : \', \'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button><!--\n    <button type="button" ui-sref="sim-phone-detail.edit({id:vm.simPhone.id})" class="btn btn-primary">\n    --> <button type="button" ui-sref="sim-phone-detail.edit({id:vm.simPhone.id})" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'sim-phone-detail.edit\')" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/sim-phone/sim-phone-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySimPhoneLabel" data-translate="telestatApp.simPhone.home.createOrEditLabel">Create or edit a Sim Phone</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.simPhone.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.simPhone.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="telestatApp.simPhone.number" for="field_number" uib-tooltip="{{\'telestatApp.simPhone.help.number\' | translate}}">Number</label><input type="number" class="form-control" name="number" id="field_number" ng-model="vm.simPhone.number" required min="70000000000" max="79999999999"><div ng-show="editForm.number.$invalid"><p class="help-block" ng-show="editForm.number.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.number.$error.min" data-translate="entity.validation.min" translate-value-min="70000000000">This field should be at least 70000000000.</p><p class="help-block" ng-show="editForm.number.$error.max" data-translate="entity.validation.max" translate-value-max="79999999999">This field cannot be more than 79999999999.</p><p class="help-block" ng-show="editForm.number.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.simPhone.actual" for="field_actual" uib-tooltip="{{\'telestatApp.simPhone.help.actual\' | translate}}">Actual</label><input type="checkbox" name="actual" id="field_actual" ng-model="vm.simPhone.actual"><div ng-show="editForm.actual.$invalid"><p class="help-block" ng-show="editForm.actual.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="telestatApp.simPhone.cloudPBX" for="field_cloudPBX">Cloud PBX</label><select class="form-control" id="field_cloudPBX" name="cloudPBX" ng-model="vm.simPhone.cloudPBX" ng-options="cloudPBX as cloudPBX.name for cloudPBX in vm.cloudpbxes track by cloudPBX.id" required></select></div><div ng-show="editForm.cloudPBX.$invalid"><p class="help-block" ng-show="editForm.cloudPBX.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/sim-phone/sim-phones.html','<div><h2 data-translate="telestatApp.simPhone.home.title">Sim Phones</h2><!--\n    <jhi-alert></jhi-alert>\n    --><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><!--\n                <button class="btn btn-primary" ui-sref="sim-phone.new" >\n                --> <button class="btn btn-primary" ui-sref="sim-phone.new" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'sim-phone.new\')"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="telestatApp.simPhone.home.createLabel">Create new Sim Phone</span></button></div><!--\n            <div class="col-xs-8 no-padding-right">\n            --><div class="col-xs-2"><label class="checkbox-inline"><input name="actualFilter" ng-model="vm.actualFilter" type="checkbox" ng-change="vm.search(vm.searchQuery)"> <span data-translate="global.actualFilter">Show actual</span></label></div><div class="col-xs-6 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'telestatApp.simPhone.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><jhi-alert></jhi-alert><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="number"><span data-translate="telestatApp.simPhone.number">Number</span> <span class="glyphicon glyphicon-sort"></span></th><!--\n                    <th jh-sort-by="actual"><span data-translate="telestatApp.simPhone.actual">Actual</span> <span class="glyphicon glyphicon-sort"></span></th>\n                    --><th jh-sort-by="cloudPBX.name"><span data-translate="telestatApp.simPhone.cloudPBX">Cloud PBX</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="simPhone in vm.simPhones track by simPhone.id"><!--\n                    <td><a ui-sref="sim-phone-detail({id:simPhone.id})">{{simPhone.id}}</a></td>\n                    <td>{{simPhone.number}}</td>\n                    --><td><a ui-sref="sim-phone-detail({id:simPhone.id})" ng-class="{\'inactive-entity\': !simPhone.actual}">{{simPhone.id}}</a></td><td ng-class="{\'inactive-entity\': !simPhone.actual}">{{simPhone.number | phone}}</td><!--\n                    <td>{{simPhone.actual}}</td>\n                    <td>\n                    --><td ng-class="{\'inactive-entity\': !simPhone.actual}"><a ui-sref="cloud-pbx-detail({id:simPhone.cloudPBX.id})">{{simPhone.cloudPBX.name}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="sim-phone-detail({id:simPhone.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="sim-phone.edit({id:simPhone.id})" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'sim-phone.edit\')" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="sim-phone.delete({id:simPhone.id})" ng-disabled="!vm.UIFormAccess.checkStateAccess(\'sim-phone.delete\')" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/virtual-number/virtual-number-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.virtualNumber.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="telestatApp.virtualNumber.delete.question" translate-values="{id: \'{{vm.virtualNumber.id}}\'}">Are you sure you want to delete this Virtual Number?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/virtual-number/virtual-number-detail.html','<div><h2><span data-translate="telestatApp.virtualNumber.detail.title">Virtual Number</span> {{vm.virtualNumber.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="telestatApp.virtualNumber.locked" uib-tooltip="{{\'telestatApp.virtualNumber.help.locked\' | translate}}">Locked</span></dt><dd><span data-translate="global.boolValueYesNo.{{vm.virtualNumber.locked}}">{{vm.virtualNumber.locked}}</span></dd><dt><span data-translate="telestatApp.virtualNumber.number" uib-tooltip="{{\'telestatApp.virtualNumber.help.number\' | translate}}">Number</span></dt><dd><span>{{vm.virtualNumber.number}}</span></dd><dt><span data-translate="telestatApp.virtualNumber.source" uib-tooltip="{{\'telestatApp.virtualNumber.help.source\' | translate}}">Source</span></dt><dd><span>{{vm.virtualNumber.source}}</span></dd><dt><span data-translate="telestatApp.virtualNumber.lastActionTime" uib-tooltip="{{\'telestatApp.virtualNumber.help.lastActionTime\' | translate}}">Last Action Time</span></dt><dd><span>{{vm.virtualNumber.lastActionTime | date:\'medium\'}}</span></dd><dt><span data-translate="telestatApp.virtualNumber.cloudPBX">Cloud PBX</span></dt><dd><a ui-sref="cloud-pbx-detail({id:vm.virtualNumber.cloudPBXId})">{{vm.virtualNumber.cloudPBXName}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="virtual-number-detail.edit({id:vm.virtualNumber.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/virtual-number/virtual-number-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myVirtualNumberLabel" data-translate="telestatApp.virtualNumber.home.createOrEditLabel">Create or edit a Virtual Number</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.virtualNumber.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.virtualNumber.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="telestatApp.virtualNumber.locked" for="field_locked" uib-tooltip="{{\'telestatApp.virtualNumber.help.locked\' | translate}}">Locked</label><input type="checkbox" name="locked" id="field_locked" ng-model="vm.virtualNumber.locked"><div ng-show="editForm.locked.$invalid"><p class="help-block" ng-show="editForm.locked.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.virtualNumber.number" for="field_number" uib-tooltip="{{\'telestatApp.virtualNumber.help.number\' | translate}}">Number</label><input type="number" class="form-control" name="number" id="field_number" ng-model="vm.virtualNumber.number" required min="1"><div ng-show="editForm.number.$invalid"><p class="help-block" ng-show="editForm.number.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.number.$error.min" data-translate="entity.validation.min" translate-value-min="1">This field should be at least 1.</p><p class="help-block" ng-show="editForm.number.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="telestatApp.virtualNumber.source" for="field_source" uib-tooltip="{{\'telestatApp.virtualNumber.help.source\' | translate}}">Source</label><input type="text" class="form-control" name="source" id="field_source" ng-model="vm.virtualNumber.source"></div><div class="form-group"><label class="control-label" data-translate="telestatApp.virtualNumber.lastActionTime" for="field_lastActionTime" uib-tooltip="{{\'telestatApp.virtualNumber.help.lastActionTime\' | translate}}">Last Action Time</label><div class="input-group"><input id="field_lastActionTime" type="text" class="form-control" name="lastActionTime" datetime-picker="{{dateformat}}" ng-model="vm.virtualNumber.lastActionTime" is-open="vm.datePickerOpenStatus.lastActionTime"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'lastActionTime\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label data-translate="telestatApp.virtualNumber.cloudPBX" for="field_cloudPBX">Cloud PBX</label><select class="form-control" id="field_cloudPBX" name="cloudPBX" ng-model="vm.virtualNumber.cloudPBXId" ng-options="cloudPBX.id as cloudPBX.name for cloudPBX in vm.cloudpbxes" required></select></div><div ng-show="editForm.cloudPBX.$invalid"><p class="help-block" ng-show="editForm.cloudPBX.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/virtual-number/virtual-numbers.html','<div><h2 data-translate="telestatApp.virtualNumber.home.title">Virtual Numbers</h2><div style="display: block; min-height: 70px"><jhi-alert></jhi-alert></div><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="virtual-number.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="telestatApp.virtualNumber.home.createLabel">Create new Virtual Number</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'telestatApp.virtualNumber.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="locked"><span data-translate="telestatApp.virtualNumber.locked">Locked</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="number"><span data-translate="telestatApp.virtualNumber.number">Number</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="source"><span data-translate="telestatApp.virtualNumber.source">Source</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastActionTime"><span data-translate="telestatApp.virtualNumber.lastActionTime">Last Action Time</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cloudPBXName"><span data-translate="telestatApp.virtualNumber.cloudPBX">Cloud PBX</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="virtualNumber in vm.virtualNumbers track by virtualNumber.id"><td><a ui-sref="virtual-number-detail({id:virtualNumber.id})">{{virtualNumber.id}}</a></td><td><span data-translate="global.boolValueYesNo.{{virtualNumber.locked}}">{{virtualNumber.locked}}</span></td><td>{{virtualNumber.number}}</td><td>{{virtualNumber.source}}</td><td>{{virtualNumber.lastActionTime | date:\'medium\'}}</td><td><a ui-sref="cloud-pbx-detail({id:virtualNumber.cloudPBXId})">{{virtualNumber.cloudPBXName}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="virtual-number-detail({id:virtualNumber.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="virtual-number.edit({id:virtualNumber.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ng-disabled="virtualNumber.disabledInList" ng-click="vm.activate(virtualNumber)" class="btn btn-sm" ng-class="{\'btn-danger\': !virtualNumber.disabledInList, \'btn-success\': virtualNumber.disabledInList}"><span class="glyphicon glyphicon-cloud-upload"></span> <span ng-show="!virtualNumber.disabledInList" class="hidden-sm-down" data-translate="telestatApp.virtualNumber.activate"></span> <span ng-show="virtualNumber.disabledInList" class="hidden-sm-down" data-translate="telestatApp.virtualNumber.activated"></span></button> <button type="submit" ui-sref="virtual-number.delete({id:virtualNumber.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div class="alert alert-danger" data-translate="error.http.403">You are not authorized to access this page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-default" role="navigation"><div class="container"><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="navbar-brand logo" href="#/" ng-click="vm.collapseNavbar()"><img class="logo-img" src="content/images/logo-jhipster.png" alt="logo"> <span data-translate="global.title">Telestat</span> <span class="navbar-version">v{{VERSION}}</span></a></div><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-right"><li ui-sref-active="active"><a ui-sref="home" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-home"></span> <span class="hidden-sm" data-translate="global.menu.home">Home</span></a></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><li ng-class="{active: vm.$state.includes(\'entity\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu"><span><span class="glyphicon glyphicon-th-list"></span> <span class="hidden-sm" data-translate="global.menu.entities.main">Entities </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="phone-call" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-earphone"></span>&nbsp; <span data-translate="global.menu.entities.phoneCall">Phone Call</span></a></li><li ui-sref-active="active"><a ui-sref="phone-call-check" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-check"></span>&nbsp; <span data-translate="global.menu.entities.phoneCallCheck">Phone Call Check</span></a></li><li ui-sref-active="active"><a ui-sref="division" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-th-large"></span>&nbsp; <span data-translate="global.menu.entities.division">Division</span></a></li><li ui-sref-active="active"><a ui-sref="employee" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span data-translate="global.menu.entities.employee">Employee</span></a></li><li ui-sref-active="active"><a ui-sref="employee-phone" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-phone"></span>&nbsp; <span data-translate="global.menu.entities.employeePhone">Employee Phone</span></a></li><li ui-sref-active="active"><a ui-sref="office-phone" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-phone-alt"></span>&nbsp; <span data-translate="global.menu.entities.officePhone">Office Phone</span></a></li><li ui-sref-active="active"><a ui-sref="blocked-phone" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.blockedPhone">Blocked Phone</span></a></li><li ui-sref-active="active"><a ui-sref="megafon-internal-phones" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.megafonInternalPhones">Megafon Internal Phones</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-class="{active: vm.$state.includes(\'dictionary\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer" has-any-authority="ROLE_ADMIN, ROLE_DIRECTOR, ROLE_MARKETER"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="dictionary-menu"><span><span class="glyphicon glyphicon-book"></span> <span class="hidden-sm" data-translate="global.menu.dictionaries.main">Dictionaries </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="cloud-pbx" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.dictionaries.cloudPbx">Cloud Pbx</span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="cloud-pbx-prefix" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.dictionaries.cloudPBXPrefix">Cloud PBX Prefixes</span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="phone-call-status" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.dictionaries.phoneCallStatus">Phone Call Status</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN, ROLE_MARKETER"><a ui-sref="advertising-source" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.dictionaries.advertisingSource">Advertising Source</span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="phone-call-result-group" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.dictionaries.phoneCallResultGroup">Phone Call Result Group</span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="phone-call-result" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.dictionaries.phoneCallResult">Phone Call Result</span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="phone-call-purpose" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.dictionaries.phoneCallPurpose">Phone Call Purpose</span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="realty-type" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.dictionaries.realtyType">Realty Type</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN, ROLE_MANAGER, ROLE_DIRECTOR"><a ui-sref="sim-phone" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.dictionaries.simPhone">Sim Phone</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN, ROLE_MANAGER, ROLE_DIRECTOR"><a ui-sref="virtual-number" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.virtualNumber">Virtual Number</span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="complain-on-sms" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.complainOnSmsNumber">Complain On Sms Number</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN, ROLE_MANAGER, ROLE_DIRECTOR"><a ui-sref="megafon-free-numbers" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.dictionaries.megafonFreeNumbers">Free Virtual Numbers</span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="phone-type" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.dictionaries.phoneType">Phone Type</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'report\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer" has-any-authority="ROLE_ADMIN, ROLE_DIRECTOR, ROLE_MANAGER, ROLE_CHECKER"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="reports-menu"><span><span class="glyphicon glyphicon-stats"></span> <span class="hidden-sm" data-translate="global.menu.reports.main">Reports </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="advertising-source-conversion-report" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.reports.advertisingSourceConversionReport">Info source-conversion report</span></a></li><li ui-sref-active="active"><a ui-sref="division-conversion-report" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-th-large"></span>&nbsp; <span data-translate="global.menu.reports.divisionConversionReport">Division conversion report</span></a></li><li ui-sref-active="active"><a ui-sref="division-conversion-dynamic-report" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-th-large"></span>&nbsp; <span data-translate="global.menu.reports.divisionConversionDynamicReport">Division conversion dynamic report</span></a></li><li ng-if="vm.unlockKayanReports" ui-sref-active="active"><a ui-sref="employee-conversion-report-in-period" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span data-translate="global.menu.reports.employeeConversionReportInPeriod">Employee conversion report in period</span></a></li><li ui-sref-active="active"><a ui-sref="employee-conversion-report" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span data-translate="global.menu.reports.employeeConversionReport">Employee conversion report</span></a></li><li ui-sref-active="active"><a ui-sref="advertising-source-financial-report" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.reports.advertisingSourceFinancialReport">Info source financial report</span></a></li><li ui-sref-active="active"><a ui-sref="employee-advertising-source-report" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.reports.employeeAdvertisingSourceReport">Employee info source report</span></a></li><li ui-sref-active="active"><a ui-sref="checker-statistics-report" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.reports.checkerStatisticsReport">Phone call checks by checker report</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><span><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm" data-translate="global.menu.account.main">Account </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="settings" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-wrench"></span>&nbsp; <span data-translate="global.menu.account.settings">Settings</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="password" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-lock"></span>&nbsp; <span data-translate="global.menu.account.password">Password</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="sessions" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-cloud"></span>&nbsp; <span data-translate="global.menu.account.sessions">Sessions</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span data-translate="global.menu.account.logout">Sign out</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a href="" ng-click="vm.login()" id="login"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span data-translate="global.menu.account.login">Sign in</span></a></li><!-- Registration disabled\n                        <li ui-sref-active="active" ng-switch-when="false">\n                            <a ui-sref="register" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-plus-sign"></span>&nbsp;\n                                <span data-translate="global.menu.account.register">Register</span>\n                            </a>\n                        </li>\n--></ul></li><li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu"><span><span class="glyphicon glyphicon-tower"></span> <span class="hidden-sm" data-translate="global.menu.admin.main">Administration</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="user-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span data-translate="global.menu.admin.userManagement">User management</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-tracker" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-eye-open"></span>&nbsp; <span data-translate="global.menu.admin.tracker">User tracker</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span data-translate="global.menu.admin.metrics">Metrics</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-health" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-heart"></span>&nbsp; <span data-translate="global.menu.admin.health">Health</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span data-translate="global.menu.admin.configuration">Configuration</span></a></li><li ui-sref-active="active"><a ui-sref="audits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span data-translate="global.menu.admin.audits">Audits</span></a></li><li ui-sref-active="active"><a ui-sref="logs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span data-translate="global.menu.admin.logs">Logs</span></a></li><li ui-sref-active="active"><a ui-sref="logs-viewer" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span data-translate="global.menu.admin.logs-viewer">Logs viewer</span></a></li><li ng-show="vm.swaggerEnabled" ui-sref-active="active"><a ui-sref="docs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span data-translate="global.menu.admin.apidocs">API</span></a></li><li ui-sref-active="active"><a ui-sref="elasticsearch-reindex" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-refresh"></span>&nbsp; <span data-translate="global.menu.admin.elasticsearch-reindex">Elasticsearch Reindex</span></a></li><li ui-sref-active="active"><a ui-sref="history-loader" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-cloud-download"></span>&nbsp; <span data-translate="global.menu.admin.history-loader">Providers history loading</span></a></li><li ui-sref-active="active"><a ui-sref="setting" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.admin.setting">Setting</span></a></li><li ui-sref-active="active"><a ui-sref="external-resource" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.admin.externalResource">External Resource</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --></ul></li><li ui-sref-active="active" uib-dropdown class="dropdown pointer" ng-controller="JhiLanguageController as languageVm"><a class="dropdown-toggle" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1"><span><span class="glyphicon glyphicon-flag"></span> <span class="hidden-sm" data-translate="global.menu.language">Language</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1"><li active-menu="{{language}}" ng-repeat="language in languageVm.languages"><a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language | findLanguageFromKey}}</a></li></ul></li></ul></div></div></nav>');
$templateCache.put('app/reports/advertising-source-conversion-report/advertising-source-conversion-report.html','<div><h2 data-translate="telestatApp.advertisingSourcesConversionReport.title">Information sources conversion report</h2><div class="container-fluid"><div class="row"><date-filter data="vm.dateFilterData"></date-filter><div class="col-xs-4 no-padding-right"><select class="form-control" id="field_division" name="division" ng-model="vm.division" ng-change="vm.search(vm.searchQuery)" ng-options="division as division.title disable when !division.actual for division in vm.divisions track by division.id"></select></div><div class="col-xs-1 no-padding-right"><a target="_blank" class="btn btn-primary" ng-href="/api/export/advertising-source-conversion/?{{vm.exportLink}}" title="{{ \'global.export.XLS\' | translate}}" download="report.xls"><span class="glyphicon glyphicon-download-alt"></span></a></div></div></div><br><jhi-alert></jhi-alert><div class="table-responsive"><table class="jh-table table table-responsive"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th ng-repeat="col in ::vm.columns"><span jh-sort-by="{{ ::col }}"><span data-translate="telestatApp.reportsCommon.tablesHeaders.{{ ::col }}">{{ ::col }}</span> <span class="glyphicon glyphicon-sort"></span> </span><span ng-if="vm.addcolumns[col]" jh-sort-by="{{ ::vm.addcolumns[col] }}">/ <span data-translate="telestatApp.reportsCommon.tablesHeaders.{{ ::vm.addcolumns[col] }}">{{ ::vm.addcolumns[col] }}</span> <span class="glyphicon glyphicon-sort"></span></span></th></tr></thead><tbody><tr ng-repeat="row in vm.report" ng-class="{info: row[vm.mainIdColumn] == -1, \'bold-total-row\': row[vm.mainIdColumn] == -1}"><td ng-repeat="col in ::vm.columns" ng-class="{\n                                        \'text-center\': col != vm.mainColumn,\n                                        \'bad-report-value\': row[vm.mainIdColumn] != null &&\n                                                                        ((vm.addcolumns[col] && row[vm.addcolumns[col]] == vm.minData[vm.addcolumns[col]]) ||\n                                                                        (!vm.addcolumns[col] && row[col] == vm.minData[col])),\n                                        \'good-report-value\': row[vm.mainIdColumn] != null &&\n                                                                        ((vm.addcolumns[col] && row[vm.addcolumns[col]] == vm.maxData[vm.addcolumns[col]]) ||\n                                                                        (!vm.addcolumns[col] && row[col] == vm.maxData[col])),\n                                        \'report-0-20\':   vm.pColumn[col] && row[vm.mainIdColumn] != -1 &&\n                                                            (vm.inverseColumns[col] !== 1 && row[vm.pColumn[col]] <  20 ||\n                                                            vm.inverseColumns[col] === 1 && row[vm.pColumn[col]] >= 80),\n                                        \'report-20-40\':  vm.pColumn[col] && row[vm.mainIdColumn] != -1 &&\n                                                            (vm.inverseColumns[col] !== 1 && row[vm.pColumn[col]] >= 20 && row[vm.pColumn[col]] < 40 ||\n                                                            vm.inverseColumns[col] === 1 && row[vm.pColumn[col]] >= 60 && row[vm.pColumn[col]] < 80),\n                                        \'report-40-60\':  vm.pColumn[col] && row[vm.mainIdColumn] != -1 && row[vm.pColumn[col]] >= 40 && row[vm.pColumn[col]] < 60,\n                                        \'report-60-80\':  vm.pColumn[col] && row[vm.mainIdColumn] != -1 &&\n                                                            (vm.inverseColumns[col] !== 1 && row[vm.pColumn[col]] >= 60 && row[vm.pColumn[col]] < 80 ||\n                                                            vm.inverseColumns[col] === 1 && row[vm.pColumn[col]] >= 20 && row[vm.pColumn[col]] < 40),\n                                        \'report-80-100\': vm.pColumn[col] && row[vm.mainIdColumn] != -1 &&\n                                                            (vm.inverseColumns[col] !== 1 && row[vm.pColumn[col]] >= 80 ||\n                                                            vm.inverseColumns[col] === 1 && row[vm.pColumn[col]] <  20)\n                                        }"><span>{{ ::row[col] }} </span><span ng-if="vm.addcolumns[col]">/ {{ ::row[vm.addcolumns[col]] }}%</span></td></tr></tbody></table></div><div class="row"><div class="col-sm-6 no-padding-left no-padding-right"><div class="panel panel-default"><div class="panel-heading"><span data-translate="telestatApp.reportsCommon.tablesHeaders.uniqueLeadCount">Unique lead count</span></div><div class="panel-body"><nvd3 options="vm.diagramOptions" data="vm.reportClean"></nvd3></div></div></div><div class="col-sm-6 no-padding-left no-padding-right"><div class="panel panel-default"><div class="panel-heading"><span data-translate="telestatApp.reportsCommon.tablesHeaders.targetedCount">Targeted count</span></div><div class="panel-body"><nvd3 options="vm.diagramOptionsTarg" data="vm.reportClean"></nvd3></div></div></div></div><div class="row"><div class="col-sm-6 no-padding-left no-padding-right"><div class="panel panel-default"><div class="panel-heading"><span data-translate="telestatApp.reportsCommon.tablesHeaders.missedCount">Missed count</span></div><div class="panel-body"><nvd3 options="vm.diagramOptionsMissed" data="vm.reportClean"></nvd3></div></div></div><div class="col-sm-6 no-padding-left no-padding-right"><div class="panel panel-default"><div class="panel-heading"><span data-translate="telestatApp.reportsCommon.tablesHeaders.productCount">Productive count</span></div><div class="panel-body"><nvd3 options="vm.diagramOptionsProd" data="vm.reportClean"></nvd3></div></div></div></div><div><h3>\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u043F\u043E\u043B\u0435\u0439 \u043E\u0442\u0447\u0435\u0442\u0430 - \u041A\u043E\u043D\u0432\u0435\u0440\u0441\u0438\u044F \u043F\u043E \u0440\u0435\u043A\u043B\u0430\u043C\u043D\u044B\u043C \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0430\u043C</h3><table class="report-doc" border="1"><tbody><tr><td>\u0417\u0432\u043E\u043D\u043A\u0438</td><td><p>\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0437\u0432\u043E\u043D\u043A\u043E\u0432 \u043F\u043E \u0418\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0443.</p><i>\u041F\u0440\u0438\u0447\u0435\u043C, \u0435\u0441\u043B\u0438 \u043A\u043B\u0438\u0435\u043D\u0442 \u043F\u0435\u0440\u0435\u0437\u0432\u0430\u043D\u0438\u0432\u0430\u043B \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0440\u0430\u0437 \u0441 \u0438\u043D\u0442\u0435\u0440\u0432\u0430\u043B\u043E\u043C \u043D\u0435 \u0431\u043E\u043B\u0435\u0435 3 \u0441\u0435\u043A\u0443\u043D\u0434 - \u044D\u0442\u043E \u043E\u0434\u0438\u043D \u0437\u0432\u043E\u043D\u043E\u043A</i></td></tr><tr><td>\u0423\u043D.\u043A\u043E\u043D\u0442\u0430\u043A\u0442\u044B / % \u043E\u0442 \u0417\u0432\u043E\u043D\u043A\u043E\u0432</td><td><p>\u0423\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0439 \u043A\u043E\u043D\u0442\u0430\u043A\u0442 - \u043E\u0434\u0438\u043D \u043D\u043E\u043C\u0435\u0440 \u043A\u043B\u0438\u0435\u043D\u0442\u0430, \u043F\u043E\u0437\u0432\u043E\u043D\u0438\u0432\u0448\u0438\u0439 \u043E\u0434\u043D\u043E\u043C\u0443 \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u0443 \u0441 \u043E\u0434\u043D\u043E\u0433\u043E \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0430.</p><i>\u0415\u0441\u043B\u0438 \u043A\u043B\u0438\u0435\u043D\u0442 \u0441 \u043E\u0434\u043D\u043E\u0433\u043E \u043D\u043E\u043C\u0435\u0440\u0430 \u043F\u043E\u0437\u0432\u043E\u043D\u0438\u043B \u0442\u0440\u0435\u043C \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u0430\u043C - \u044D\u0442\u043E \u0442\u0440\u0438 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0445 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u0430.</i> <i>\u0415\u0441\u043B\u0438 \u043A\u043B\u0438\u0435\u043D\u0442 \u0441 \u043E\u0434\u043D\u043E\u0433\u043E \u043D\u043E\u043C\u0435\u0440\u0430 \u043F\u043E\u0437\u0432\u043E\u043D\u0438\u043B \u0441 \u0434\u0432\u0443\u0445 \u0440\u0430\u0437\u043D\u044B\u0445 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u043E\u0432 - \u044D\u0442\u043E \u0434\u0432\u0430 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0445 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u0430.</i></td></tr><tr><td>\u041D\u0435\u043E\u043F\u0440\u0435\u0434. / % \u043E\u0442 \u0423\u043D.\u043A\u043E\u043D\u0442.</td><td><b>\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0437\u0432\u043E\u043D\u043A\u043E\u0432 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0445 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043E\u0432 \u0441 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u043C \u0438\u0437 \u0433\u0440\u0443\u043F\u043F\u044B \u201C\u041D\u0435\u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0435\u201D</b>: \u041D\u0435 \u043C\u043E\u0436\u0435\u0442 \u043E\u0431\u0449\u0430\u0442\u044C\u0441\u044F, \u043F\u0435\u0440\u0435\u0437\u0432\u043E\u043D\u0438\u0442, \u041E\u0442\u043A\u0430\u0437\u0430\u043B\u0441\u044F \u043E\u0431\u0449\u0430\u0442\u044C\u0441\u044F \u0441 \u0430\u0433\u0435\u043D\u0442\u043E\u043C, \u041F\u043B\u043E\u0445\u0430\u044F \u0441\u0432\u044F\u0437\u044C, \u043E\u0431\u0440\u044B\u0432 \u0437\u0432\u043E\u043D\u043A\u0430, \u0421\u0438\u043C\u0443\u043B\u044F\u0446\u0438\u044F \u043F\u043B\u043E\u0445\u043E\u0439 \u0441\u0432\u044F\u0437\u0438 \u0430\u0433\u0435\u043D\u0442\u043E\u043C</td></tr><tr><td>\u041D\u0435\u0437\u043D\u0430\u0447\u0438\u0442. / % \u043E\u0442 \u0423\u043D.\u043A\u043E\u043D\u0442.</td><td><b>\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0437\u0432\u043E\u043D\u043A\u043E\u0432 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0445 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043E\u0432 \u0441 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u043C \u0438\u0437 \u0433\u0440\u0443\u043F\u043F\u044B \u201C\u041D\u0435\u0437\u043D\u0430\u0447\u0438\u043C\u044B\u0435\u201D</b></td></tr><tr><td>\u0426\u0435\u043B\u0435\u0432\u044B\u0435 / % \u043E\u0442 \u0423\u043D.\u043A\u043E\u043D\u0442.</td><td><b>\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0437\u0432\u043E\u043D\u043A\u043E\u0432 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0445 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043E\u0432 \u0441 \u043F\u0440\u0438\u0437\u043D\u0430\u043A\u043E\u043C \u201C\u0426\u0435\u043B\u0435\u0432\u043E\u0439\u201D \u0432 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0438 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0430</b> (\u0431\u0435\u0437\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043D\u044B\u0435, \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0438\u0432\u043D\u044B\u0435, \u0443\u043F\u0443\u0449\u0435\u043D\u043D\u044B\u0435)</td></tr><tr><td>\u0423\u043F\u0443\u0449. / % \u043E\u0442 \u0426\u0435\u043B\u0435\u0432\u044B\u0445</td><td><b>\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0437\u0432\u043E\u043D\u043A\u043E\u0432 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0445 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043E\u0432 \u0441 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u043C \u0438\u0437 \u0433\u0440\u0443\u043F\u043F\u044B \u201C\u0423\u043F\u0443\u0449\u0435\u043D\u043D\u044B\u0435\u201D</b></td></tr><tr><td>\u0411\u0435\u0437\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442. / % \u043E\u0442 \u0426\u0435\u043B\u0435\u0432\u044B\u0445</td><td><b>\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0437\u0432\u043E\u043D\u043A\u043E\u0432 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0445 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043E\u0432 \u0441 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u043C \u0438\u0437 \u0433\u0440\u0443\u043F\u043F\u044B \u201C\u0411\u0435\u0437\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043D\u044B\u0435\u201D</b></td></tr><tr><td>\u041F\u0440\u043E\u0434\u0443\u043A\u0442\u0438\u0432. / % \u043E\u0442 \u0426\u0435\u043B\u0435\u0432\u044B\u0445</td><td><b>\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0437\u0432\u043E\u043D\u043A\u043E\u0432 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0445 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043E\u0432 \u0441 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u043C \u0438\u0437 \u0433\u0440\u0443\u043F\u043F\u044B \u201C\u041F\u0440\u043E\u0434\u0443\u043A\u0442\u0438\u0432\u043D\u044B\u0435\u201D</b></td></tr><tr><td>\u041A\u0430\u0447-\u0432\u043E \u043F\u0435\u0440\u0435\u0433., %</td><td><p><b>\u0421\u0440\u0435\u0434\u043D\u0435\u0435 \u0430\u0440\u0438\u0444\u043C\u0435\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u044B\u0445 \u043E\u0446\u0435\u043D\u043E\u043A \u0437\u0432\u043E\u043D\u043A\u043E\u0432 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0445 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043E\u0432 \u0438\u0437 \u0433\u0440\u0443\u043F\u043F: \u041F\u0440\u043E\u0434\u0443\u043A\u0442\u0438\u0432\u043D\u044B\u0439</b> (\u0414\u043E\u0433\u043E\u0432\u043E\u0440\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u043E \u043F\u0435\u0440\u0435\u0437\u0432\u043E\u043D\u0435, \u0414\u043E\u0433\u043E\u0432\u043E\u0440\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u043E \u0432\u0441\u0442\u0440\u0435\u0447\u0435) <b>\u0438 \u0411\u0435\u0437\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043D\u044B\u0439</b> (\u0412\u0432\u0435\u0434\u0435\u043D\u0438\u0435 \u043A\u043B\u0438\u0435\u043D\u0442\u0430 \u0432 \u0437\u0430\u0431\u043B\u0443\u0436\u0434\u0435\u043D\u0438\u0435, \u0411\u0435\u0437\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043D\u044B\u0435 \u043F\u0435\u0440\u0435\u0433\u043E\u0432\u043E\u0440\u044B)</p></td></tr><tr><td>\u041A\u0430\u0447-\u0432\u043E \u043E\u0431\u0441\u043B\u0443\u0436., %</td><td><b>\u0421\u0440\u0435\u0434\u043D\u0435\u0435 \u0430\u0440\u0438\u0444\u043C\u0435\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u044B\u0445 \u043E\u0446\u0435\u043D\u043E\u043A \u0437\u0432\u043E\u043D\u043A\u043E\u0432 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0445 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043E\u0432</b></td></tr></tbody></table></div></div>');
$templateCache.put('app/reports/advertising-source-financial-report/advertising-source-financial-report.html','<div><h2 data-translate="telestatApp.advertisingSourcesFinancialReport.title">Employee conversion report</h2><div class="container-fluid"><div class="row"><date-filter data="vm.dateFilterData"></date-filter><div class="col-xs-4 no-padding-right"></div><div class="col-xs-1 no-padding-right"><a target="_blank" class="btn btn-primary" ng-href="/api/export/advertising-source-financial/?{{vm.exportLink}}" title="{{ \'global.export.XLS\' | translate}}" download="report.xls"><span class="glyphicon glyphicon-download-alt"></span></a></div></div></div><br><jhi-alert></jhi-alert><div class="table-responsive"><table class="jh-table table table-responsive"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th ng-repeat="col in ::vm.columns"><span jh-sort-by="{{ col }}"><span data-translate="telestatApp.reportsCommon.tablesHeaders.{{ ::col }}">{{ ::col }}</span> <span class="glyphicon glyphicon-sort"></span> </span><span ng-if="vm.addcolumns[col]" jh-sort-by="{{ ::vm.addcolumns[col] }}">/ <span data-translate="telestatApp.reportsCommon.tablesHeaders.{{ ::vm.addcolumns[col] }}">{{ ::vm.addcolumns[col] }}</span> <span class="glyphicon glyphicon-sort"></span></span></th></tr></thead><tbody><tr ng-repeat="row in vm.report" ng-class="{info: row[vm.mainIdColumn] == -1, \'bold-total-row\': row[vm.mainIdColumn] == -1}"><td ng-repeat="col in ::vm.columns" ng-class="{\n                                        \'text-center\': col != vm.mainColumn,\n                                        \'bg-danger\': row[vm.mainIdColumn] != null &&\n                                                                        ((vm.addcolumns[col] && row[vm.addcolumns[col]] == vm.minData[vm.addcolumns[col]]) ||\n                                                                        (!vm.addcolumns[col] && row[col] == vm.minData[col])),\n                                        \'bg-success\': row[vm.mainIdColumn] != null &&\n                                                                        ((vm.addcolumns[col] && row[vm.addcolumns[col]] == vm.maxData[vm.addcolumns[col]]) ||\n                                                                        (!vm.addcolumns[col] && row[col] == vm.maxData[col]))}"><span>{{ ::row[col] }} </span><span ng-if="vm.addcolumns[col]">/ {{ ::row[vm.addcolumns[col]] }}%</span></td></tr></tbody></table></div><div class="row"><div class="col-sm-6 no-padding-left no-padding-right"><div class="panel panel-default"><div class="panel-heading"><span data-translate="telestatApp.reportsCommon.tablesHeaders.callPrice">Call price</span> / <span data-translate="telestatApp.reportsCommon.tablesHeaders.contactPrice">Contact price</span> / <span data-translate="telestatApp.reportsCommon.tablesHeaders.productPrice">Product price</span></div><div class="panel-body"><nvd3 options="vm.diagram3" data="vm.reportCleanForMultiBarChart"></nvd3></div></div></div><div class="col-sm-6 no-padding-left no-padding-right"><div class="panel panel-default"><div class="panel-heading"><span data-translate="telestatApp.reportsCommon.tablesHeaders.lossesPercent">Losses percent</span></div><div class="panel-body"><nvd3 options="vm.diagram4" data="vm.reportCleanForBarChart"></nvd3></div></div></div></div><div><h3>\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u043F\u043E\u043B\u0435\u0439 \u043E\u0442\u0447\u0435\u0442\u0430 - \u0424\u0438\u043D\u0430\u043D\u0441\u043E\u0432\u044B\u0439 \u043F\u043E \u0440\u0435\u043A\u043B\u0430\u043C\u043D\u044B\u043C \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0430\u043C</h3><table class="report-doc" border="1"><tbody><tr><td>\u0411\u044E\u0434\u0436\u0435\u0442</td><td><b>\u0411\u044E\u0434\u0436\u0435\u0442, \u043F\u0435\u0440\u0435\u0441\u0447\u0438\u0442\u0430\u043D\u043D\u044B\u0439 \u043D\u0430 \u0442\u0435\u043A\u0443\u0449\u0438\u0439 \u043F\u0435\u0440\u0438\u043E\u0434</b></td></tr><tr><td>\u0417\u0432\u043E\u043D\u043A\u0438</td><td><p>\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0437\u0432\u043E\u043D\u043A\u043E\u0432 \u043F\u043E \u0418\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0443.</p><i>\u041F\u0440\u0438\u0447\u0435\u043C, \u0435\u0441\u043B\u0438 \u043A\u043B\u0438\u0435\u043D\u0442 \u043F\u0435\u0440\u0435\u0437\u0432\u0430\u043D\u0438\u0432\u0430\u043B \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0440\u0430\u0437 \u0441 \u0438\u043D\u0442\u0435\u0440\u0432\u0430\u043B\u043E\u043C \u043D\u0435 \u0431\u043E\u043B\u0435\u0435 3 \u0441\u0435\u043A\u0443\u043D\u0434 - \u044D\u0442\u043E \u043E\u0434\u0438\u043D \u0437\u0432\u043E\u043D\u043E\u043A</i></td></tr><tr><td>\u0426\u0435\u043D\u0430 \u0437\u0432\u043E\u043D\u043A\u0430</td><td><b>= \u0411\u044E\u0434\u0436\u0435\u0442 / \u0417\u0432\u043E\u043D\u043A\u0438</b></td></tr><tr><td>\u0423\u043D.\u043A\u043E\u043D\u0442\u0430\u043A\u0442\u044B / % \u043E\u0442 \u0417\u0432\u043E\u043D\u043A\u043E\u0432</td><td><p>\u0423\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0439 \u043A\u043E\u043D\u0442\u0430\u043A\u0442 - \u043E\u0434\u0438\u043D \u043D\u043E\u043C\u0435\u0440 \u043A\u043B\u0438\u0435\u043D\u0442\u0430, \u043F\u043E\u0437\u0432\u043E\u043D\u0438\u0432\u0448\u0438\u0439 \u043E\u0434\u043D\u043E\u043C\u0443 \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u0443 \u0441 \u043E\u0434\u043D\u043E\u0433\u043E \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0430.</p><i>\u0415\u0441\u043B\u0438 \u043A\u043B\u0438\u0435\u043D\u0442 \u0441 \u043E\u0434\u043D\u043E\u0433\u043E \u043D\u043E\u043C\u0435\u0440\u0430 \u043F\u043E\u0437\u0432\u043E\u043D\u0438\u043B \u0442\u0440\u0435\u043C \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u0430\u043C - \u044D\u0442\u043E \u0442\u0440\u0438 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0445 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u0430.</i> <i>\u0415\u0441\u043B\u0438 \u043A\u043B\u0438\u0435\u043D\u0442 \u0441 \u043E\u0434\u043D\u043E\u0433\u043E \u043D\u043E\u043C\u0435\u0440\u0430 \u043F\u043E\u0437\u0432\u043E\u043D\u0438\u043B \u0441 \u0434\u0432\u0443\u0445 \u0440\u0430\u0437\u043D\u044B\u0445 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u043E\u0432 - \u044D\u0442\u043E \u0434\u0432\u0430 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0445 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u0430.</i></td></tr><tr><td>\u0426\u0435\u043D\u0430 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u0430</td><td><b>= \u0411\u044E\u0434\u0436\u0435\u0442 / \u0423\u043D. \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u044B</b></td></tr><tr><td>\u0426\u0435\u043B\u0435\u0432\u044B\u0435 / % \u043E\u0442 \u0423\u043D.\u043A\u043E\u043D\u0442.</td><td><b>\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0437\u0432\u043E\u043D\u043A\u043E\u0432 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0445 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043E\u0432 \u0441 \u043F\u0440\u0438\u0437\u043D\u0430\u043A\u043E\u043C \u201C\u0426\u0435\u043B\u0435\u0432\u043E\u0439\u201D \u0432 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0438 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0430</b> (\u0431\u0435\u0437\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043D\u044B\u0435, \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0438\u0432\u043D\u044B\u0435, \u0443\u043F\u0443\u0449\u0435\u043D\u043D\u044B\u0435)</td></tr><tr><td>\u0426\u0435\u043D\u0430 \u0446\u0435\u043B\u0435\u0432\u043E\u0433\u043E</td><td><b>= \u0411\u044E\u0434\u0436\u0435\u0442 / \u0426\u0435\u043B\u0435\u0432\u044B\u0435</b></td></tr><tr><td>\u041F\u0440\u043E\u0434\u0443\u043A\u0442\u0438\u0432. / % \u043E\u0442 \u0426\u0435\u043B\u0435\u0432\u044B\u0445</td><td><b>\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0437\u0432\u043E\u043D\u043A\u043E\u0432 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0445 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043E\u0432 \u0441 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u043C \u0438\u0437 \u0433\u0440\u0443\u043F\u043F\u044B \u201C\u041F\u0440\u043E\u0434\u0443\u043A\u0442\u0438\u0432\u043D\u044B\u0435\u201D</b></td></tr><tr><td>\u0426\u0435\u043D\u0430 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0438\u0432\u043D.</td><td><b>= \u0411\u044E\u0434\u0436\u0435\u0442 / \u041F\u0440\u043E\u0434\u0443\u043A\u0442\u0438\u0432.</b></td></tr><tr><td>\u041A\u0430\u0447-\u0432\u043E \u043E\u0431\u0441\u043B\u0443\u0436., %</td><td><b>\u0421\u0440\u0435\u0434\u043D\u0435\u0435 \u0430\u0440\u0438\u0444\u043C\u0435\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u044B\u0445 \u043E\u0446\u0435\u043D\u043E\u043A \u0437\u0432\u043E\u043D\u043A\u043E\u0432 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0445 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043E\u0432</b></td></tr><tr><td>\u041F\u043E\u0442\u0435\u0440\u0438, %</td><td><p>\u0415\u0441\u043B\u0438 \u0437\u0432\u043E\u043D\u043E\u043A - \u0446\u0435\u043B\u0435\u0432\u043E\u0439 \u0438 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0438\u0432\u043D\u044B\u0439, \u0442\u043E \u043F\u043E\u0442\u0435\u0440\u0438 = 0</p><p>\u0415\u0441\u043B\u0438 \u0437\u0432\u043E\u043D\u043E\u043A - \u0446\u0435\u043B\u0435\u0432\u043E\u0439, \u043D\u043E \u0443\u043F\u0443\u0449\u0435\u043D\u043D\u044B\u0439 \u0438\u043B\u0438 \u0431\u0435\u0437\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043D\u044B\u0439, \u0442\u043E \u043F\u043E\u0442\u0435\u0440\u0438 = ( 100 - \u041C\u0430\u043A\u0441.\u041E\u0446\u0435\u043D\u043A\u0430 )</p></td></tr><tr><td>\u041F\u043E\u0442\u0435\u0440\u0438, \u0420\u0443\u0431.</td><td><b>= \u0411\u044E\u0434\u0436\u0435\u0442 * (\u041F\u043E\u0442\u0435\u0440\u0438, % / 100)</b></td></tr></tbody></table></div></div>');
$templateCache.put('app/reports/checker-statistics-report/checker-statistics-report.html','<div><h2 data-translate="telestatApp.checkersStatisticReport.title">Phone call checks count by checkers report</h2><div class="container-fluid"><div class="row"><date-filter data="vm.dateFilterData"></date-filter><div class="col-xs-4 no-padding-right"></div><div class="col-xs-1 no-padding-right"><a target="_blank" class="btn btn-primary" ng-href="/api/export/phone-call-checks-checker-statistics/?{{vm.exportLink}}" title="{{ \'global.export.XLS\' | translate}}" download="report.xls"><span class="glyphicon glyphicon-download-alt"></span></a></div></div></div><br><jhi-alert></jhi-alert><div class="table-responsive"><table class="jh-table table table-responsive"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th ng-repeat="col in ::vm.columns" ng-class="{\'text-center\': col != vm.mainColumn}"><span jh-sort-by="{{ ::col }}"><span data-translate="telestatApp.reportsCommon.tablesHeaders.{{ ::col }}">{{ ::col }}</span> <span class="glyphicon glyphicon-sort"></span> </span><span ng-if="vm.addcolumns[col]" jh-sort-by="{{ ::vm.addcolumns[col] }}">/ <span data-translate="telestatApp.reportsCommon.tablesHeaders.{{ ::vm.addcolumns[col] }}">{{ ::vm.addcolumns[col] }}</span> <span class="glyphicon glyphicon-sort"></span></span></th></tr></thead><tbody><tr ng-repeat="row in vm.report" ng-class="{info: row[vm.mainIdColumn] == -1, \'bold-total-row\': row[vm.mainIdColumn] == -1}"><td ng-repeat="col in ::vm.columns" ng-class="{\n                                        \'text-center\': col != vm.mainColumn,\n                                        \'bg-danger\': row[vm.mainIdColumn] != null &&\n                                                                        ((vm.addcolumns[col] && row[vm.addcolumns[col]] == vm.minData[vm.addcolumns[col]]) ||\n                                                                        (!vm.addcolumns[col] && row[col] == vm.minData[col])),\n                                        \'bg-success\': row[vm.mainIdColumn] != null &&\n                                                                        ((vm.addcolumns[col] && row[vm.addcolumns[col]] == vm.maxData[vm.addcolumns[col]]) ||\n                                                                        (!vm.addcolumns[col] && row[col] == vm.maxData[col]))}"><span ng-if="vm.columnsFilter[col] == \'HHHMM\'">{{ ::row[col] | HHHMM }} </span><span ng-if="vm.columnsFilter[col] != \'HHHMM\'">{{ ::row[col] }} </span><span ng-if="vm.addcolumns[col]">/ {{ ::row[vm.addcolumns[col]] }}%</span></td></tr></tbody></table></div><div class="row"><div class="col-sm-12 no-padding-left no-padding-right"><div class="panel panel-default"><div class="panel-heading"><span data-translate="telestatApp.reportsCommon.tablesHeaders.checksCount">Checks count</span></div><div class="panel-body"><nvd3 options="vm.diagramOptions" data="vm.reportClean"></nvd3></div></div></div></div></div>');
$templateCache.put('app/reports/division-conversion-report/division-conversion-dynamic-report.html','<div><h2 data-translate="telestatApp.divisionsConversionDynamicReport.title">Divisions conversion dynamic report</h2><div class="container-fluid"><div class="row"><date-filter data="vm.dateFilterData"></date-filter><div class="col-xs-4 no-padding-right"></div><div class="col-xs-1 no-padding-right"><a target="_blank" class="btn btn-primary" ng-click="vm.resetLegends()" title="{{ \'entity.action.revert\' | translate}}"><span class="glyphicon glyphicon-refresh"></span></a></div></div></div><br><jhi-alert></jhi-alert><div class="row"><div class="col-sm-12 no-padding-left no-padding-right"><div class="panel panel-default"><div class="panel-heading"><span data-translate="telestatApp.reportsCommon.tablesHeaders.divisionConversionDynamic">Division conversion dynamic</span></div><div class="panel-body"><nvd3 options="vm.diagramOptions" data="vm.report1" api="vm.api"></nvd3></div></div></div></div><div><h3>\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u043F\u043E\u043B\u0435\u0439 \u043E\u0442\u0447\u0435\u0442\u0430 - \u0414\u0438\u043D\u0430\u043C\u0438\u043A\u0430 \u0440\u0430\u0431\u043E\u0442\u044B \u043E\u0442\u0434\u0435\u043B\u043E\u0432</h3><table class="report-doc" border="1"><tbody><tr><td>\u041F\u043E \u043E\u0441\u0438 Y</td><td>\u041A\u0430\u0447-\u0432\u043E \u043E\u0431\u0441\u043B\u0443\u0436. \u0438\u0437 \u041A\u043E\u043D\u0432\u0435\u0440\u0441\u0438\u0438 \u043F\u043E \u043E\u0442\u0434\u0435\u043B\u0430\u043C</td></tr></tbody></table><br><div>\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u044E\u0442\u0441\u044F 4 \u043B\u0443\u0447\u0448\u0438\u0445 \u043E\u0442\u0434\u0435\u043B\u0430. \u0412 \u0424\u0438\u043B\u044C\u0442\u0440\u0435 \u043D\u0430\u0434 \u0433\u0440\u0430\u0444\u0438\u043A\u043E\u043C \u043C\u043E\u0436\u043D\u043E \u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043D\u0430 \u0433\u0440\u0430\u0444\u0438\u043A \u0434\u0440\u0443\u0433\u0438\u0435 \u043E\u0442\u0434\u0435\u043B\u044B, \u043D\u0430\u0436\u0430\u0432 \u043D\u0430 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043E\u0442\u0434\u0435\u043B\u0430.</div></div></div>');
$templateCache.put('app/reports/division-conversion-report/division-conversion-report.html','<div><h2 data-translate="telestatApp.divisionsConversionReport.title">Divisions conversion report</h2><div class="container-fluid"><div class="row"><date-filter data="vm.dateFilterData"></date-filter><div class="col-xs-4 no-padding-right"></div><div class="col-xs-1 no-padding-right"><a target="_blank" class="btn btn-primary" ng-href="/api/export/division-conversion/?{{vm.exportLink}}" title="{{ \'global.export.XLS\' | translate}}" download="report.xls"><span class="glyphicon glyphicon-download-alt"></span></a></div></div></div><br><jhi-alert></jhi-alert><div class="table-responsive"><table class="jh-table table table-responsive"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th ng-repeat="col in ::vm.columns"><span jh-sort-by="{{ ::col }}"><span data-translate="telestatApp.reportsCommon.tablesHeaders.{{ ::col }}">{{ ::col }}</span> <span class="glyphicon glyphicon-sort"></span> </span><span ng-if="vm.addcolumns[col]" jh-sort-by="{{ ::vm.addcolumns[col] }}">/ <span data-translate="telestatApp.reportsCommon.tablesHeaders.{{ ::vm.addcolumns[col] }}">{{ ::vm.addcolumns[col] }}</span> <span class="glyphicon glyphicon-sort"></span></span></th></tr></thead><tbody><tr ng-repeat="row in vm.report" ng-class="{info: row[vm.mainIdColumn] == -1, \'bold-total-row\': row[vm.mainIdColumn] == -1}"><td ng-repeat="col in ::vm.columns" ng-class="{\n                                        \'text-center\': col != vm.mainColumn,\n                                        \'bg-danger\': row[vm.mainIdColumn] != null &&\n                                                                        ((vm.addcolumns[col] && row[vm.addcolumns[col]] == vm.minData[vm.addcolumns[col]]) ||\n                                                                        (!vm.addcolumns[col] && row[col] == vm.minData[col])),\n                                        \'bg-success\': row[vm.mainIdColumn] != null &&\n                                                                        ((vm.addcolumns[col] && row[vm.addcolumns[col]] == vm.maxData[vm.addcolumns[col]]) ||\n                                                                        (!vm.addcolumns[col] && row[col] == vm.maxData[col]))}"><span>{{ ::row[col] }} </span><span ng-if="vm.addcolumns[col]">/ {{ ::row[vm.addcolumns[col]] }}%</span></td></tr></tbody></table></div><div class="row"><div class="col-sm-6 no-padding-left no-padding-right"><div class="panel panel-default"><div class="panel-heading"><span data-translate="telestatApp.reportsCommon.tablesHeaders.uniqueLeadCount">Unique leads count</span></div><div class="panel-body"><nvd3 options="vm.diagramOptions" data="vm.reportClean"></nvd3></div></div></div><div class="col-sm-6 no-padding-left no-padding-right"><div class="panel panel-default"><div class="panel-heading"><span data-translate="telestatApp.reportsCommon.tablesHeaders.targetedCount">Targeted count</span></div><div class="panel-body"><nvd3 options="vm.diagramOptionsTarg" data="vm.reportClean"></nvd3></div></div></div></div><div class="row"><div class="col-sm-6 no-padding-left no-padding-right"><div class="panel panel-default"><div class="panel-heading"><span data-translate="telestatApp.reportsCommon.tablesHeaders.missedCount">Missed count</span></div><div class="panel-body"><nvd3 options="vm.diagramOptionsMissed" data="vm.reportClean"></nvd3></div></div></div><div class="col-sm-6 no-padding-left no-padding-right"><div class="panel panel-default"><div class="panel-heading"><span data-translate="telestatApp.reportsCommon.tablesHeaders.productCount">Productive count</span></div><div class="panel-body"><nvd3 options="vm.diagramOptionsProd" data="vm.reportClean"></nvd3></div></div></div></div><div><h3>\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u043F\u043E\u043B\u0435\u0439 \u043E\u0442\u0447\u0435\u0442\u0430 - \u041A\u043E\u043D\u0432\u0435\u0440\u0441\u0438\u044F \u043F\u043E \u043E\u0442\u0434\u0435\u043B\u0430\u043C</h3><table class="report-doc" border="1"><tbody><tr><td>\u0417\u0432\u043E\u043D\u043A\u0438</td><td><b>\u0412\u0441\u0435\u0433\u043E \u043B\u044E\u0431\u044B\u0445 \u0437\u0432\u043E\u043D\u043A\u043E\u0432</b> <i>(\u0435\u0441\u043B\u0438 \u043A\u043B\u0438\u0435\u043D\u0442 \u043F\u0435\u0440\u0435\u0437\u0432\u0430\u043D\u0438\u0432\u0430\u043B \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0440\u0430\u0437 \u0441 \u0438\u043D\u0442\u0435\u0440\u0432\u0430\u043B\u043E\u043C \u043D\u0435 \u0431\u043E\u043B\u0435\u0435 3 \u0441\u0435\u043A\u0443\u043D\u0434 - \u044D\u0442\u043E \u043E\u0434\u0438\u043D \u0437\u0432\u043E\u043D\u043E\u043A)</i></td></tr><tr><td>\u0423\u043D.\u043A\u043E\u043D\u0442\u0430\u043A\u0442\u044B / % \u043E\u0442 \u0417\u0432\u043E\u043D\u043A\u043E\u0432</td><td><b>\u0423\u043D.\u043A\u043E\u043D\u0442\u0430\u043A\u0442 - \u043E\u0434\u0438\u043D \u043D\u043E\u043C\u0435\u0440 \u043A\u043B\u0438\u0435\u043D\u0442\u0430, \u043F\u043E\u0437\u0432\u043E\u043D\u0438\u0432\u0448\u0438\u0439 \u043E\u0434\u043D\u043E\u043C\u0443 \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u0443 \u0441 \u043E\u0434\u043D\u043E\u0433\u043E \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0430.</b> <i>\u0415\u0441\u043B\u0438 \u043A\u043B\u0438\u0435\u043D\u0442 \u0441 \u043E\u0434\u043D\u043E\u0433\u043E \u043D\u043E\u043C\u0435\u0440\u0430 \u043F\u043E\u0437\u0432\u043E\u043D\u0438\u043B \u0442\u0440\u0435\u043C \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u0430\u043C - \u044D\u0442\u043E \u0442\u0440\u0438 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0445 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u0430.</i> <i>\u0415\u0441\u043B\u0438 \u043A\u043B\u0438\u0435\u043D\u0442 \u0441 \u043E\u0434\u043D\u043E\u0433\u043E \u043D\u043E\u043C\u0435\u0440\u0430 \u043F\u043E\u0437\u0432\u043E\u043D\u0438\u043B \u0441 \u0434\u0432\u0443\u0445 \u0440\u0430\u0437\u043D\u044B\u0445 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u043E\u0432 - \u044D\u0442\u043E \u0434\u0432\u0430 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0445 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u0430.</i></td></tr><tr><td>\u0426\u0435\u043B\u0435\u0432\u044B\u0435 / % \u043E\u0442 \u0423\u043D.\u043A\u043E\u043D\u0442.</td><td><b>\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0437\u0432\u043E\u043D\u043A\u043E\u0432 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0445 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043E\u0432 \u0441 \u043F\u0440\u0438\u0437\u043D\u0430\u043A\u043E\u043C \u201C\u0426\u0435\u043B\u0435\u0432\u043E\u0439\u201D \u0432 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0438 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0430</b> (\u0431\u0435\u0437\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043D\u044B\u0435, \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0438\u0432\u043D\u044B\u0435, \u0443\u043F\u0443\u0449\u0435\u043D\u043D\u044B\u0435)</td></tr><tr><td>\u0421\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u043E\u0432</td><td><b>\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0430\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u044B\u0445 \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u043E\u0432</b></td></tr><tr><td>\u0426\u0435\u043B\u0435\u0432\u044B\u0445 \u043D\u0430 \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u0430</td><td><b>= (\u0426\u0435\u043B\u0435\u0432\u044B\u0435 / \u0421\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u043E\u0432)</b></td></tr><tr><td>\u0423\u043F\u0443\u0449. / % \u043E\u0442 \u0426\u0435\u043B\u0435\u0432\u044B\u0445</td><td><b>\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0437\u0432\u043E\u043D\u043A\u043E\u0432 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0445 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043E\u0432 \u0441 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u043C \u0438\u0437 \u0433\u0440\u0443\u043F\u043F\u044B \u201C\u0423\u043F\u0443\u0449\u0435\u043D\u043D\u044B\u0435\u201D</b></td></tr><tr><td>\u0411\u0435\u0437\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442. / % \u043E\u0442 \u0426\u0435\u043B\u0435\u0432\u044B\u0445</td><td><b>\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0437\u0432\u043E\u043D\u043A\u043E\u0432 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0445 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043E\u0432 \u0441 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u043C \u0438\u0437 \u0433\u0440\u0443\u043F\u043F\u044B \u201C\u0411\u0435\u0437\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043D\u044B\u0435\u201D</b></td></tr><tr><td>\u041F\u0440\u043E\u0434\u0443\u043A\u0442\u0438\u0432. / % \u043E\u0442 \u0426\u0435\u043B\u0435\u0432\u044B\u0445</td><td><b>\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0437\u0432\u043E\u043D\u043A\u043E\u0432 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0445 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043E\u0432 \u0441 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u043C \u0438\u0437 \u0433\u0440\u0443\u043F\u043F\u044B \u201C\u041F\u0440\u043E\u0434\u0443\u043A\u0442\u0438\u0432\u043D\u044B\u0435\u201D</b></td></tr><tr><td>\u041A\u0430\u0447-\u0432\u043E \u043F\u0435\u0440\u0435\u0433., %</td><td><p><b>\u0421\u0440\u0435\u0434\u043D\u0435\u0435 \u0430\u0440\u0438\u0444\u043C\u0435\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u044B\u0445 \u043E\u0446\u0435\u043D\u043E\u043A \u0437\u0432\u043E\u043D\u043A\u043E\u0432 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0445 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043E\u0432 \u0438\u0437 \u0433\u0440\u0443\u043F\u043F: \u041F\u0440\u043E\u0434\u0443\u043A\u0442\u0438\u0432\u043D\u044B\u0439</b> (\u0414\u043E\u0433\u043E\u0432\u043E\u0440\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u043E \u043F\u0435\u0440\u0435\u0437\u0432\u043E\u043D\u0435, \u0414\u043E\u0433\u043E\u0432\u043E\u0440\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u043E \u0432\u0441\u0442\u0440\u0435\u0447\u0435) <b>\u0438 \u0411\u0435\u0437\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043D\u044B\u0439</b> (\u0412\u0432\u0435\u0434\u0435\u043D\u0438\u0435 \u043A\u043B\u0438\u0435\u043D\u0442\u0430 \u0432 \u0437\u0430\u0431\u043B\u0443\u0436\u0434\u0435\u043D\u0438\u0435, \u0411\u0435\u0437\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043D\u044B\u0435 \u043F\u0435\u0440\u0435\u0433\u043E\u0432\u043E\u0440\u044B)</p></td></tr><tr><td>\u041A\u0430\u0447-\u0432\u043E \u043E\u0431\u0441\u043B\u0443\u0436., %</td><td><b>\u0421\u0440\u0435\u0434\u043D\u0435\u0435 \u0430\u0440\u0438\u0444\u043C\u0435\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u044B\u0445 \u043E\u0446\u0435\u043D\u043E\u043A \u0437\u0432\u043E\u043D\u043A\u043E\u0432 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0445 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043E\u0432</b></td></tr></tbody></table></div></div>');
$templateCache.put('app/reports/employee-advertising-source-report/employee-advertising-source-report.html','<div><h2 data-translate="telestatApp.employeesAdvertisingSourcesReport.title">Employees information sources report</h2><div class="container-fluid"><div class="row"><date-filter data="vm.dateFilterData"></date-filter><div class="col-xs-4 no-padding-right"><select class="form-control" id="field_division" name="division" ng-model="vm.division" ng-change="vm.search(vm.searchQuery)" ng-options="division as division.title disable when !division.actual for division in vm.divisions track by division.id"></select></div><div class="col-xs-1 no-padding-right"><a target="_blank" class="btn btn-primary" ng-href="/api/export/employee-advertising-source/?{{vm.exportLink}}" title="{{ \'global.export.XLS\' | translate}}" download="report.xls"><span class="glyphicon glyphicon-download-alt"></span></a></div></div></div><br><jhi-alert></jhi-alert><div class="table-responsive"><table class="jh-table table table-responsive"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th ng-repeat="col in ::vm.columns" ng-class="{\'text-center\': vm.mainColumn[col] == 1}"><span jh-sort-by="{{ ::col }}"><span data-translate="telestatApp.reportsCommon.tablesHeaders.{{ ::col }}">{{ ::col }}</span> <span class="glyphicon glyphicon-sort"></span> </span><span ng-if="vm.addcolumns[col]" jh-sort-by="{{ ::vm.addcolumns[col] }}">/ <span data-translate="telestatApp.reportsCommon.tablesHeaders.{{ ::vm.addcolumns[col] }}">{{ ::vm.addcolumns[col] }}</span> <span class="glyphicon glyphicon-sort"></span></span></th></tr></thead><tbody><tr ng-repeat="row in vm.report" ng-class="{info: row[vm.mainIdColumn] == -1, \'bold-total-row\': row[vm.mainIdColumn] == -1}"><td ng-if="row.rowspan != \'X\'" ng-repeat="col in ::vm.columns" rowspan="{{col == \'employeeName\' || col == \'divisionName\' ? row.rowspan : 1}}" ng-class="{\n                                        \'boldtop-row\': vm.enableGroupping,\n                                        \'text-center\': vm.mainColumn[col] == 1,\n                                        \'bg-danger\': row[vm.mainIdColumn] != null &&\n                                                                        ((vm.addcolumns[col] && row[vm.addcolumns[col]] == vm.minData[vm.addcolumns[col]]) ||\n                                                                        (!vm.addcolumns[col] && row[col] == vm.minData[col])),\n                                        \'bg-success\': row[vm.mainIdColumn] != null &&\n                                                                        ((vm.addcolumns[col] && row[vm.addcolumns[col]] == vm.maxData[vm.addcolumns[col]]) ||\n                                                                        (!vm.addcolumns[col] && row[col] == vm.maxData[col]))}"><span>{{ ::row[col] }} </span><span ng-if="vm.addcolumns[col]">/ {{ ::row[vm.addcolumns[col]] }}%</span></td><td ng-if="row.rowspan == \'X\'" ng-repeat="col in ::vm.columnsRowSpan" ng-class="{\n                                        \'text-center\': vm.mainColumn[col] == 1,\n                                        \'bg-danger\': row[vm.mainIdColumn] != null &&\n                                                                        ((vm.addcolumns[col] && row[vm.addcolumns[col]] == vm.minData[vm.addcolumns[col]]) ||\n                                                                        (!vm.addcolumns[col] && row[col] == vm.minData[col])),\n                                        \'bg-success\': row[vm.mainIdColumn] != null &&\n                                                                        ((vm.addcolumns[col] && row[vm.addcolumns[col]] == vm.maxData[vm.addcolumns[col]]) ||\n                                                                        (!vm.addcolumns[col] && row[col] == vm.maxData[col]))}"><span>{{ ::row[col] }} </span><span ng-if="vm.addcolumns[col]">/ {{ ::row[vm.addcolumns[col]] }}%</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/reports/employee-conversion-report/employee-conversion-report.html','<div><h2 data-translate="telestatApp.employeesConversionReport.title">Employees conversion report</h2><div class="container-fluid"><div class="row"><date-filter data="vm.dateFilterData"></date-filter><div class="col-xs-4 no-padding-right"><select class="form-control" id="field_division" name="division" ng-model="vm.division" ng-change="vm.search(vm.searchQuery)" ng-options="division as division.title disable when !division.actual for division in vm.divisions track by division.id"></select></div><div class="col-xs-1 no-padding-right"><a target="_blank" class="btn btn-primary" ng-href="/api/export/employee-conversion/?{{vm.exportLink}}" title="{{ \'global.export.XLS\' | translate}}" download="report.xls"><span class="glyphicon glyphicon-download-alt"></span></a></div></div></div><br><jhi-alert></jhi-alert><div class="table-responsive"><table class="jh-table table table-responsive"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th ng-repeat="col in ::vm.columns"><span jh-sort-by="{{ ::col }}"><span data-translate="telestatApp.reportsCommon.tablesHeaders.{{ ::col }}">{{ ::col }}</span> <span class="glyphicon glyphicon-sort"></span> </span><span ng-if="vm.addcolumns[col]" jh-sort-by="{{ ::vm.addcolumns[col] }}">/ <span data-translate="telestatApp.reportsCommon.tablesHeaders.{{ ::vm.addcolumns[col] }}">{{ ::vm.addcolumns[col] }}</span> <span class="glyphicon glyphicon-sort"></span></span></th></tr></thead><tbody><tr ng-repeat="row in vm.report" ng-class="{info: row[vm.mainIdColumn] == null, \'bold-total-row\': row[vm.mainIdColumn] == null}"><td ng-repeat="col in ::vm.columns" ng-class="{\n                                        \'text-center\': col != vm.mainColumn,\n                                        \'bg-danger\': row[vm.mainIdColumn] != null &&\n                                                                        ((vm.addcolumns[col] && row[vm.addcolumns[col]] == vm.minData[vm.addcolumns[col]]) ||\n                                                                        (!vm.addcolumns[col] && row[col] == vm.minData[col])),\n                                        \'bg-success\': row[vm.mainIdColumn] != null &&\n                                                                        ((vm.addcolumns[col] && row[vm.addcolumns[col]] == vm.maxData[vm.addcolumns[col]]) ||\n                                                                        (!vm.addcolumns[col] && row[col] == vm.maxData[col]))}"><span>{{ ::row[col] }} </span><span ng-if="vm.addcolumns[col]">/ {{ ::row[vm.addcolumns[col]] }}%</span></td></tr></tbody></table></div><div class="row"><div class="col-sm-6 no-padding-left no-padding-right"><div class="panel panel-default"><div class="panel-heading"><span data-translate="telestatApp.reportsCommon.tablesHeaders.uniqueLeadCount">Unique leads count</span></div><div class="panel-body"><nvd3 options="vm.diagramOptions" data="vm.reportClean"></nvd3></div></div></div><div class="col-sm-6 no-padding-left no-padding-right"><div class="panel panel-default"><div class="panel-heading"><span data-translate="telestatApp.reportsCommon.tablesHeaders.targetedCount">Targeted count</span></div><div class="panel-body"><nvd3 options="vm.diagramOptionsTarg" data="vm.reportClean"></nvd3></div></div></div></div><div class="row"><div class="col-sm-6 no-padding-left no-padding-right"><div class="panel panel-default"><div class="panel-heading"><span data-translate="telestatApp.reportsCommon.tablesHeaders.missedCount">Missed count</span></div><div class="panel-body"><nvd3 options="vm.diagramOptionsMissed" data="vm.reportClean"></nvd3></div></div></div><div class="col-sm-6 no-padding-left no-padding-right"><div class="panel panel-default"><div class="panel-heading"><span data-translate="telestatApp.reportsCommon.tablesHeaders.productCount">Productive count</span></div><div class="panel-body"><nvd3 options="vm.diagramOptionsProd" data="vm.reportClean"></nvd3></div></div></div></div><div><h3>\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u043F\u043E\u043B\u0435\u0439 \u043E\u0442\u0447\u0435\u0442\u0430 - \u041A\u043E\u043D\u0432\u0435\u0440\u0441\u0438\u044F \u043F\u043E \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u0430\u043C</h3><table class="report-doc" border="1"><tbody><tr><td>\u0417\u0432\u043E\u043D\u043A\u0438</td><td><p>\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0432\u0441\u0435\u0445 \u043F\u043E\u0434\u0440\u044F\u0434 \u0437\u0432\u043E\u043D\u043A\u043E\u0432 \u0421\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u0443</p><i>\u041F\u0440\u0438\u0447\u0435\u043C, \u0435\u0441\u043B\u0438 \u043A\u043B\u0438\u0435\u043D\u0442 \u043F\u0435\u0440\u0435\u0437\u0432\u0430\u043D\u0438\u0432\u0430\u043B \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0440\u0430\u0437 \u0441 \u0438\u043D\u0442\u0435\u0440\u0432\u0430\u043B\u043E\u043C \u043D\u0435 \u0431\u043E\u043B\u0435\u0435 3 \u0441\u0435\u043A\u0443\u043D\u0434 - \u044D\u0442\u043E \u043E\u0434\u0438\u043D \u0437\u0432\u043E\u043D\u043E\u043A</i></td></tr><tr><td>\u0423\u043D.\u043A\u043E\u043D\u0442\u0430\u043A\u0442\u044B</td><td><p>\u0423\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0439 \u043A\u043E\u043D\u0442\u0430\u043A\u0442 - \u043E\u0434\u0438\u043D \u043D\u043E\u043C\u0435\u0440 \u043A\u043B\u0438\u0435\u043D\u0442\u0430, \u043F\u043E\u0437\u0432\u043E\u043D\u0438\u0432\u0448\u0438\u0439 \u043E\u0434\u043D\u043E\u043C\u0443 \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u0443</p><i>\u0415\u0441\u043B\u0438 \u043A\u043B\u0438\u0435\u043D\u0442 \u0441 \u043E\u0434\u043D\u043E\u0433\u043E \u043D\u043E\u043C\u0435\u0440\u0430 \u043F\u043E\u0437\u0432\u043E\u043D\u0438\u043B \u0442\u0440\u0435\u043C \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u0430\u043C - \u044D\u0442\u043E \u0442\u0440\u0438 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0445 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u0430.</i></td></tr><tr><td>\u0426\u0435\u043B\u0435\u0432\u044B\u0435</td><td><b>\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0437\u0432\u043E\u043D\u043A\u043E\u0432 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0445 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043E\u0432 \u0441 \u043F\u0440\u0438\u0437\u043D\u0430\u043A\u043E\u043C \u201C\u0426\u0435\u043B\u0435\u0432\u043E\u0439\u201D \u0432 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0438 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0430</b> (\u0431\u0435\u0437\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043D\u044B\u0435, \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0438\u0432\u043D\u044B\u0435, \u0443\u043F\u0443\u0449\u0435\u043D\u043D\u044B\u0435)</td></tr><tr><td>\u0423\u043F\u0443\u0449. / % \u043E\u0442 \u0426\u0435\u043B\u0435\u0432\u044B\u0445</td><td><b>\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0437\u0432\u043E\u043D\u043A\u043E\u0432 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0445 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043E\u0432 \u0441 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u043C \u0438\u0437 \u0433\u0440\u0443\u043F\u043F\u044B \u201C\u0423\u043F\u0443\u0449\u0435\u043D\u043D\u044B\u0435\u201D</b></td></tr><tr><td>\u0411\u0435\u0437\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442. / % \u043E\u0442 \u0426\u0435\u043B\u0435\u0432\u044B\u0445</td><td><b>\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0437\u0432\u043E\u043D\u043A\u043E\u0432 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0445 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043E\u0432 \u0441 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u043C \u0438\u0437 \u0433\u0440\u0443\u043F\u043F\u044B \u201C\u0411\u0435\u0437\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043D\u044B\u0435\u201D</b></td></tr><tr><td>\u041F\u0440\u043E\u0434\u0443\u043A\u0442\u0438\u0432. / % \u043E\u0442 \u0426\u0435\u043B\u0435\u0432\u044B\u0445</td><td><b>\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0437\u0432\u043E\u043D\u043A\u043E\u0432 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0445 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043E\u0432 \u0441 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u043C \u0438\u0437 \u0433\u0440\u0443\u043F\u043F\u044B \u201C\u041F\u0440\u043E\u0434\u0443\u043A\u0442\u0438\u0432\u043D\u044B\u0435\u201D</b></td></tr><tr><td>\u041A\u0430\u0447-\u0432\u043E \u043F\u0435\u0440\u0435\u0433., %</td><td><p><b>\u0421\u0440\u0435\u0434\u043D\u0435\u0435 \u0430\u0440\u0438\u0444\u043C\u0435\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u044B\u0445 \u043E\u0446\u0435\u043D\u043E\u043A \u0437\u0432\u043E\u043D\u043A\u043E\u0432 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0445 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043E\u0432 \u0438\u0437 \u0433\u0440\u0443\u043F\u043F: \u041F\u0440\u043E\u0434\u0443\u043A\u0442\u0438\u0432\u043D\u044B\u0439</b> (\u0414\u043E\u0433\u043E\u0432\u043E\u0440\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u043E \u043F\u0435\u0440\u0435\u0437\u0432\u043E\u043D\u0435, \u0414\u043E\u0433\u043E\u0432\u043E\u0440\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u043E \u0432\u0441\u0442\u0440\u0435\u0447\u0435) <b>\u0438 \u0411\u0435\u0437\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043D\u044B\u0439</b> (\u0412\u0432\u0435\u0434\u0435\u043D\u0438\u0435 \u043A\u043B\u0438\u0435\u043D\u0442\u0430 \u0432 \u0437\u0430\u0431\u043B\u0443\u0436\u0434\u0435\u043D\u0438\u0435, \u0411\u0435\u0437\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043D\u044B\u0435 \u043F\u0435\u0440\u0435\u0433\u043E\u0432\u043E\u0440\u044B)</p></td></tr><tr><td>\u041A\u0430\u0447-\u0432\u043E \u043E\u0431\u0441\u043B\u0443\u0436., %</td><td><b>\u0421\u0440\u0435\u0434\u043D\u0435\u0435 \u0430\u0440\u0438\u0444\u043C\u0435\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u044B\u0445 \u043E\u0446\u0435\u043D\u043E\u043A \u0437\u0432\u043E\u043D\u043A\u043E\u0432 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0445 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043E\u0432</b></td></tr></tbody></table></div></div>');
$templateCache.put('app/reports/employee-conversion-report-in-period/employee-conversion-report-in-period.html','<div><h2 data-translate="telestatApp.employeesConversionReportInPeriod.title">Employees conversion report in period</h2><div class="container-fluid"><div class="row"><date-filter data="vm.dateFilterData"></date-filter><div class="col-xs-4 no-padding-right"><select class="form-control" id="field_division" name="division" ng-model="vm.division" ng-change="vm.search(vm.searchQuery)" ng-options="division as division.title disable when !division.actual for division in vm.divisions track by division.id"></select></div><div class="col-xs-1 no-padding-right"><a target="_blank" class="btn btn-primary" ng-href="/api/export/employee-conversion-in-period/?{{vm.exportLink}}" title="{{ \'global.export.XLS\' | translate}}" download="report.xls"><span class="glyphicon glyphicon-download-alt"></span></a></div></div></div><br><jhi-alert></jhi-alert><div class="table-responsive"><table class="jh-table table table-responsive"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th ng-repeat="col in ::vm.columns"><span jh-sort-by="{{ ::col }}"><span data-translate="telestatApp.reportsCommon.tablesHeaders.{{ ::col }}">{{ ::col }}</span> <span class="glyphicon glyphicon-sort"></span> </span><span ng-if="vm.addcolumns[col]" jh-sort-by="{{ ::vm.addcolumns[col] }}">/ <span data-translate="telestatApp.reportsCommon.tablesHeaders.{{ ::vm.addcolumns[col] }}">{{ ::vm.addcolumns[col] }}</span> <span class="glyphicon glyphicon-sort"></span></span></th></tr></thead><tbody><tr ng-repeat="row in vm.report" ng-class="{info: row[vm.mainIdColumn] == null, \'bold-total-row\': row[vm.mainIdColumn] == null}"><td ng-repeat="col in ::vm.columns" ng-class="{\n                                        \'text-center\': col != vm.mainColumn,\n                                        \'bg-danger\': row[vm.mainIdColumn] != null &&\n                                                                        ((vm.addcolumns[col] && row[vm.addcolumns[col]] == vm.minData[vm.addcolumns[col]]) ||\n                                                                        (!vm.addcolumns[col] && row[col] == vm.minData[col])),\n                                        \'bg-success\': row[vm.mainIdColumn] != null &&\n                                                                        ((vm.addcolumns[col] && row[vm.addcolumns[col]] == vm.maxData[vm.addcolumns[col]]) ||\n                                                                        (!vm.addcolumns[col] && row[col] == vm.maxData[col]))}"><span>{{ ::row[col] }} </span><span ng-if="vm.addcolumns[col]">/ {{ ::row[vm.addcolumns[col]] }}%</span></td></tr></tbody></table></div><div class="row"><div class="col-sm-6 no-padding-left no-padding-right"><div class="panel panel-default"><div class="panel-heading"><span data-translate="telestatApp.reportsCommon.tablesHeaders.targetedCount">Targeted count</span></div><div class="panel-body"><nvd3 options="vm.diagramOptionsTarg" data="vm.reportClean"></nvd3></div></div></div><div class="col-sm-6 no-padding-left no-padding-right"><div class="panel panel-default"><div class="panel-heading"><span data-translate="telestatApp.reportsCommon.tablesHeaders.missedCount">Missed count</span></div><div class="panel-body"><nvd3 options="vm.diagramOptionsMissed" data="vm.reportClean"></nvd3></div></div></div></div><div class="row"><div class="col-sm-6 no-padding-left no-padding-right"><div class="panel panel-default"><div class="panel-heading"><span data-translate="telestatApp.reportsCommon.tablesHeaders.productCount">Productive count</span></div><div class="panel-body"><nvd3 options="vm.diagramOptionsProd" data="vm.reportClean"></nvd3></div></div></div><div class="col-sm-6 no-padding-left no-padding-right"><div class="panel panel-default"><div class="panel-heading"></div><div class="panel-body"></div></div></div></div><div><h3>\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u043F\u043E\u043B\u0435\u0439 \u043E\u0442\u0447\u0435\u0442\u0430 - \u041E\u0442\u0447\u0435\u0442 \u043F\u043E \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u0430\u043C \u0437\u0430 \u043F\u0435\u0440\u0438\u043E\u0434</h3><table class="report-doc" border="1"><tbody><tr><td>\u0417\u0432\u043E\u043D\u043A\u0438</td><td><b>\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0432\u0441\u0435\u0445 \u043F\u043E\u0434\u0440\u044F\u0434 \u0437\u0432\u043E\u043D\u043A\u043E\u0432 \u0421\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u0443</b></td></tr><tr><td>\u0426\u0435\u043B\u0435\u0432\u044B\u0435 / % \u043E\u0442 \u0423\u043D.\u043A\u043E\u043D\u0442.</td><td><b>\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0437\u0432\u043E\u043D\u043A\u043E\u0432 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0445 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043E\u0432 \u0441 \u043F\u0440\u0438\u0437\u043D\u0430\u043A\u043E\u043C \u201C\u0426\u0435\u043B\u0435\u0432\u043E\u0439\u201D \u0432 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0438 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0430</b> (\u0431\u0435\u0437\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043D\u044B\u0435, \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0438\u0432\u043D\u044B\u0435, \u0443\u043F\u0443\u0449\u0435\u043D\u043D\u044B\u0435)</td></tr><tr><td>\u0423\u043F\u0443\u0449. / % \u043E\u0442 \u0426\u0435\u043B\u0435\u0432\u044B\u0445</td><td><b>\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0437\u0432\u043E\u043D\u043A\u043E\u0432 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0445 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043E\u0432 \u0441 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u043C \u0438\u0437 \u0433\u0440\u0443\u043F\u043F\u044B \u201C\u0423\u043F\u0443\u0449\u0435\u043D\u043D\u044B\u0435\u201D</b></td></tr><tr><td>\u0411\u0435\u0437\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442. / % \u043E\u0442 \u0426\u0435\u043B\u0435\u0432\u044B\u0445</td><td><b>\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0437\u0432\u043E\u043D\u043A\u043E\u0432 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0445 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043E\u0432 \u0441 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u043C \u0438\u0437 \u0433\u0440\u0443\u043F\u043F\u044B \u201C\u0411\u0435\u0437\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043D\u044B\u0435\u201D</b></td></tr><tr><td>\u041F\u0440\u043E\u0434\u0443\u043A\u0442\u0438\u0432. / % \u043E\u0442 \u0426\u0435\u043B\u0435\u0432\u044B\u0445</td><td><b>\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0437\u0432\u043E\u043D\u043A\u043E\u0432 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0445 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043E\u0432 \u0441 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u043C \u0438\u0437 \u0433\u0440\u0443\u043F\u043F\u044B \u201C\u041F\u0440\u043E\u0434\u0443\u043A\u0442\u0438\u0432\u043D\u044B\u0435\u201D</b></td></tr><tr><td>\u041A\u0430\u0447-\u0432\u043E \u043F\u0435\u0440\u0435\u0433., %</td><td><p><b>\u0421\u0440\u0435\u0434\u043D\u0435\u0435 \u0430\u0440\u0438\u0444\u043C\u0435\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u044B\u0445 \u043E\u0446\u0435\u043D\u043E\u043A \u0437\u0432\u043E\u043D\u043A\u043E\u0432 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0445 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043E\u0432 \u0438\u0437 \u0433\u0440\u0443\u043F\u043F: \u041F\u0440\u043E\u0434\u0443\u043A\u0442\u0438\u0432\u043D\u044B\u0439</b> (\u0414\u043E\u0433\u043E\u0432\u043E\u0440\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u043E \u043F\u0435\u0440\u0435\u0437\u0432\u043E\u043D\u0435, \u0414\u043E\u0433\u043E\u0432\u043E\u0440\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u043E \u0432\u0441\u0442\u0440\u0435\u0447\u0435) <b>\u0438 \u0411\u0435\u0437\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043D\u044B\u0439</b> (\u0412\u0432\u0435\u0434\u0435\u043D\u0438\u0435 \u043A\u043B\u0438\u0435\u043D\u0442\u0430 \u0432 \u0437\u0430\u0431\u043B\u0443\u0436\u0434\u0435\u043D\u0438\u0435, \u0411\u0435\u0437\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043D\u044B\u0435 \u043F\u0435\u0440\u0435\u0433\u043E\u0432\u043E\u0440\u044B)</p></td></tr><tr><td>\u041A\u0430\u0447-\u0432\u043E \u043E\u0431\u0441\u043B\u0443\u0436., %</td><td><b>\u0421\u0440\u0435\u0434\u043D\u0435\u0435 \u0430\u0440\u0438\u0444\u043C\u0435\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u044B\u0445 \u043E\u0446\u0435\u043D\u043E\u043A \u0437\u0432\u043E\u043D\u043A\u043E\u0432 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0445 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043E\u0432</b></td></tr></tbody></table></div></div>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="reset.finish.title">Reset password</h1><div class="alert alert-danger" data-translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p data-translate="reset.finish.messages.info">Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p data-translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p data-translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.finish.form.button">Reset Password</button></form></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="reset.request.title">Reset your password</h1><div class="alert alert-danger" data-translate="reset.request.messages.notfound" ng-show="vm.errorEmailNotExists"><strong>Email address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="vm.success"><p data-translate="reset.request.messages.info">Enter the email address you used to register.</p></div><div class="alert alert-success" ng-show="vm.success === \'OK\'"><p data-translate="reset.request.messages.success">Check your emails for details on how to reset your password.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.request.form.button">Reset</button></form></div></div></div>');}]);})();